import { Translations } from "../types/translations";

const resources: Translations = {
    "en-GB": {
        translation: {
            main: {
                currentPassword: "Current password",
                newPassword: "New password",
                newPasswordRepeat: "New password (repeat)",
                password: "Password",
                palletConditionId00: "Info",
                palletConditionId01: "Produced – Not in Warehouse",
                palletConditionId02: "In Warehouse",
                palletConditionId03: "Resorted",
                palletConditionId04: "Picked",
                palletConditionId05: "Delivered",
                palletConditionId06: "Scrapped",
                palletConditionId07: "Put-Away via Storage UnitList",
                palletConditionId08: "Lost",
                palletConditionId09: "Deleted",
                palletConditionId10: "Stock Transfer",
                palletConditionId11: "Intermediate Pallet",
                palletConditionId12: "Quality Inspection",
                palletConditionId13: "Blocked Resort",
                palletConditionId94: "Allocated for Delivery",
                palletConditionId99: "Label Printed",
                palletStatusId00: "Label Printing",
                palletStatusId01: "Label Printed",
                palletStatusId02: "Label Printed_NIU",
                palletStatusId03: "Cus. Incubation",
                palletStatusId04: "Good",
                palletStatusId05: "Blocked",
                palletStatusId06: "Resorted",
                palletStatusId07: "Scrap",
                palletStatusId08: "Test Pallet",
                palletStatusId09: "Customer Return",
                palletStatusId10: "Blocked QI",
                palletStatusId11: "Saleable restricted",
                palletStatusId12: "Blocked Packaging",
                palletStatusId13: "Issued",
                palletStatusId14: "Consumed",
                palletStatusId15: "Returned",
                palletStatusId16: "Stock Received",
                palletStatusId17: "Good",
                palletStatusId18: "Deleted",
                palletStatusId19: "Repacking",
                palletStatusId20: "Loaded",
                palletStatusId21: "Shipped",
                palletStatusId22: "Scrap Warehouse",
                palletStatusId30: "PreBilled",
                palletStatusId90: "WIP",
                offlineCons: "Offline Consumption",
                operator: "Operator",
                openedWO: "Opened GPOs",
                litEANGTAN: "EAN/Gtin",
                noWorkOrderOnLabelingAndOneRunningOnConsum: "No GPO on labeling and one running on consumption. Error# w0015:",
                deliveryTextPurchaseOrderLine: "Customer Purchase Order Line",
                woSSuspended: "Suspended",
                passFirst: "Select Pass Number",
                woMPallQty: "Quantity X Pallet",
                rxg_Label_paramters_save_successfully_: "Label paramters save successfully ",
                rxg_Please_enter_the_quantity_remaining_on_the_previous_pallet__input__APL00031:
                    "Please enter the quantity remaining on the previous pallet. input# APL00001",
                lblFailSSCC: "This SSCC {0} doesn't exist on this site.",
                lblErrOI: "Return Quantity must be greater than 0! error# w0026",
                x0OfX1PaletsBlocked: "{0} of {1} pallets blocked.",
                chkInPRogresse: "Get only Print Request in wait time",
                inBoundDxDescription1: "Decription",
                batchMissing: "Batch Missing",
                popMaxcatonLimit: "the total number of carton can not exceed",
                printJSSequenceNumber: "Next Seq No.",
                litUserUpdate: "Changed by operator",
                inValidWorkOrderId: "InValid WorkOrderId/LineId!!Please check your database.",
                scrapped: "Scrapped",
                rxg_Could_not_assign__0__to__1__Error____2_: "Could not assign {0} to {1} Error#: {2}",
                emptyRowDelivery: "No data found with those parameters!",
                rxg_Please_select_a_defect: "Please select a defect",
                cartonCreateLastDate: "Last Production Date",
                offlinePrint: "Offline Print",
                noWorkOrderOnConsumptionAndOneRunningForLa: "No GPO on consumption and one running for Labeling. Error# w0014:  ",
                litCartonLabel: "Carton Label",
                printDate: "Print Date",
                printDown: "System.Drawing.Bitmap",
                batchNr: "Batch Nr",
                printSuccessful: "Print Successful",
                barcode: "Barcode",
                litNameCust: "Name",
                womTitle: "Workorder Management",
                mouldNo: "Moulds",
                noDefectIdSelected: "Blank DefectId selected",
                differentWOOnConsumptionAndLabeling: "Different GPO on Consumption and Labeling. Error# w0010",
                operation: "Operation",
                btnUpdateWoM: "Update",
                lotNotWhole: "The value for Lot is not whole a number.  Insert Cancelled.",
                unableToAddOpenItemToLineX0X1ErrorX2: "Unable to Add open item to Line {0} {1} error#: {2}",
                batchStart: "Batch Start",
                deleteLastOne: "Delete Last One",
                lblErrbtnConsumeClick: "Wrong date. You can t consume pallet in the future. Change the date please!",
                labelImSwitchQty: "Switch Quantity between full and Small",
                conditionID: "ConditionID",
                toolTipchkRaw: "Press update button to apply your filter(s)",
                offlinePrintingFailedException:
                    "The printer is not ready, printing has been paused, please select a new printer and press BEGIN PRINTING to continue.Restart printing using the selected printer from the drop down.",
                palletStatusDialogText: "The pallet you are going to issue is blocked. Do you want to continue anyway?",
                inBoundDxMaterialCode: "Material Code",
                consumptionNbPallet: "Nb Pallet",
                palletsQty: "Pallets (Qty)",
                palletRank: "Pallet Rank",
                inBoundDxTransactionDate: "Date",
                cannotConsumeInTheFuture: "Cannot consume in the future. error# w0001 ",
                palletDetail: "Pallet Details",
                linePrintAll: "Print all Labels",
                deliveryNote: "Delivery Note",
                btnCartonDeleteConfirmation: "Are you sure you want to delete this carton ?",
                inBoundLitLabelName: "Label Type : ",
                printResultSuccess: "{0} copy(s) of Sequence {1} sent to printer {2} at {3}.",
                scheduledOrders: "Scheduled GPOs",
                dicoJsPalletDate: "you can&apos;&apos;t create pallet in the future",
                openItems: "Open Items",
                actQty: "Act Qty",
                rxg_SSCC___0___was_not_found___error__00001: "SSCC ({0}) was not found.  error#:#w0024",
                chkDetails: "Print informations",
                lotExists: "The value for Lot already exists on this work order. Insert Cancelled.",
                assign: "Assign",
                dicoRepackSummary: "Repack Summary",
                cartonDeleteLastDate: "Delete Last one",
                labellingPrintingComplete: "Printing Complete",
                inBoundErrorQtyLabel: "The QtyxLAbel must be a numeric.",
                noDefectsPassed: "At least one defect required for blocking",
                woMPallTxtFullQty: "Standard",
                palletsProduced: "pallets prod.",
                dicoHtmlSelectMat: "Select this material",
                goBack: "Go Back",
                addMultipleBatches: "Add Multiple Batches",
                btnDeleteLastOne: "Delete last carton",
                litMessWarn:
                    "The quantity on the pallet exceed the max quantity schedule on work order. Do you want to change the current quantity on the pallet?",
                dateIn: "Date In",
                delete: "Delete",
                detail: "Detail",
                deleteConsumption: "Delete Consumption",
                newValue: "New Value",
                lotNumber: "Lot",
                inBoundTotalLabelCreation: "Total",
                inBoundTxtTanDateError: "A valid Date is required",
                rxg_No_Department_specified__Error__w0007: "No Department specified. Error# w0025",
                previous: "Previous",
                checkDateslater: "Start date is later than end date",
                dicoHtmlQuantityUsed: "Quantity used : ",
                consumptionCurrentActivity: "Consumption Current Activity",
                inputLine: "Input Line",
                batchManagement: "Batch Management",
                inBoundErrorReceiptDate: "The Expiry Date must be a valide date and time.",
                columnName: "Column Name",
                txtQuantityErr: "Invalide quantity",
                consumptionParameters: "Consumption Parameters",
                btnPrintPalletAndClose: "Print Pallet Label and Close it",
                failedToConsumeSsccInDbX0: "Failed to consume sscc in db. Error# w0012:  {0} ",
                inBoundIntQtyLabel: "Qty x Label",
                rxg_Could_not_assign_Work_Order___Error___0_: "Could not assign Work Order.  Error: {0}",
                blockQi: "Block QI",
                blocked: "Blocked",
                unableToAddOpenItemToLineX0ErrorX1: "Unable to Add open item to Line {0} error#: {1}",
                noOfSheets: "No. of Sheets",
                cancel: "Cancel",
                pickingLblNumCopy: "Number of Copy :",
                workOrder: "GPO",
                wantToUseAlternatePrinter: "The selected printer is not ready!!  Click YES to use alternate printer {0} for printing?",
                x0OfX1PaletsApprovedStoppedAtErrorForPalletX21: "{0} of {1} pallets Approved. Stopped at error for PalletId:{2} -{3}",
                inBoundBtnConfirm: "Confirm",
                inboundNo: "No",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheck:
                    "SSCC {0} is open on the following line(s). Please check lines you wish to close.",
                inLine: "In Line",
                lineIn: "Line In",
                insert: "Insert",
                inBoundTxtwareError: "The field warhouse cannot be empty and cannot have more than 2 characters",
                lblErrbtnConsumeClickMissing: "Could not find SSCC. error# W0006",
                rxg_PrintDefect: "Print Defect",
                workOrderOp: "GPO / OPE",
                batchNotWhole: "The value for Batch is not whole a number.  Insert Cancelled.",
                inBoundBtnCancel: "Cancel",
                inBoundBtnCancel2: "Finish",
                noData: "There is no data to show for this Line!!",
                noDays: "No Days",
                changeCloseJob: "Change / Close Job",
                inValidUser: "Not a Valid User!Please try logging again..",
                inValidTime: "Invalid Time!!Please enter valid Time(hh:mm).",
                woSPlanned: "Planned",
                inValidDate: "Invalid Date!!Please enter valid date(dd/MM/yyyy).",
                inBoundErrorDate: "the date is not Correct",
                palletCreated: "Pallet {0} ({1}) successfully created.",
                x0OfX1PaletsUnblockedStoppedAtErrorForPalletX21: "{0} of {1} pallets Unblocked.  Stopped at error for PalletId:{2} -{3}",
                inBoundDxColSeqNumber: "Seq",
                litPalLabel4: "Pallet Label 4",
                litPalLabel3: "Pallet Label 3",
                litWoS: "Current work order status : ",
                printAbort: "Printing failed for rank {0}.  The server did not respond. Error# w0017.",
                labels: "Labels",
                layers: "Layers",
                logout: "Log Out",
                length: "Length",
                btnYesReturnDetail: "I close this \\n because i return 0 in quantity",
                finalPalletRank: "Final Pallet Rank",
                update: "Update",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheckReturn:
                    "SSCC {0} is open on the following line(s). Please check lines you wish to return.",
                printfailedselectanotherprinter: "Print failed, select another printer or try again. Error# w0019 ",
                batchLot: "Batch\\Lot",
                batchEnd: "Batch End",
                prodDate: "Prod Date",
                litAllInOne: "all in one shot",
                couldNotScrapPalletErrorX0X1: "Could Not scrap pallet. Error#{0}:{1}",
                lblDefaultSetting: "Quantity for Carton {0}",
                rxg_Labeling_Pass_Number: "Labeling Pass Number",
                lblErrbtnConsumptionClick1Else: "Could not consume SSCC invalid quantity. error# W0008.",
                btnBack: "Finish",
                dicoHtmlSapcode: "Material SAP Code",
                cartonSumQty: "Number of Carton",
                rxg_Unable_to_consume_pallet__0____1__Error____2__: "Unable to consume pallet {0}: {1} error#: {2} ",
                dicoTotalQuantity: "Total Quantity",
                priority: "Priority",
                printMod: "Print Mod",
                thisMethodRequiresAConfirmationAndNoneIsDe: "This method requires a confirmation and none is defined.",
                litTitre: "Inbound Label",
                qtyReq: "Qty Req.",
                litWoOpe: "Work Order Operation",
                litWoMan: "Work order information",
                standard: "Standard",
                noWorkorder: "No GPO",
                thereIsNoWorkOrderConfiguredForThisLine: "There is no GPO configured for this line",
                dicoHtmlRepackResult: "Repack Result",
                tableName: "Table Name",
                woMPallMinQty: "Small",
                inBoundLitTranDate: "Tansaction Date",
                materialMissing: "Material Missing",
                quality: "Quality",
                allPallets: "All pallets",
                pleaseSelectaPrinter: "Please select a printer to print the new label to?",
                rxg_ThereIsNoWorksOrderAssignedForThisLine: "There is no GPOs assigned for this line",
                palletStatus: "Pallet Status",
                cuttedSheetsBlocked: "Cutted Sheets Blocked",
                litByProduct2: "ByProduct 2 Material",
                tracDialogText: "Traceability batch is missing. Do you want to continue anyway?",
                sqlTranslation: "SQL Translation",
                rxg_Back_to_offline_consumption: "Back to offline consumption",
                woSInUse: "In use (On line)",
                rxg_Open_SSCC__0__on_the_following_line_s__: "Open SSCC {0} on the following line(s).",
                thislinehasajobassignedClosethejob: "This line has a job assigned. Close the job?",
                palletWeight: "Pallet Weight",
                articleWeight: "Article Weight",
                interlayer: "Interlayer",
                pallet: "Pallet",
                carton: "Carton",
                rxg_Work_Order_Enquiry: "GPO Enquiry",
                partDesc2: "Part Desc. 2",
                litQtyReq: "Quantity Requested",
                dicoHtmlMaterial: "Material",
                timeIn: "Time In",
                startDateNotGood: "The value for Start Date is not a correctly formatted date.  Insert Cancelled.",
                labelPalletCount: "Number of Pallet Procuced :&lt;br/&gt; &lt;b&gt;{0}&lt;/b&gt;",
                numberOfCopies: "No. of Copies",
                inBoundLitDescription: "Description",
                ckBoxCartonSave: "With Carton",
                palletsScheduled: "pallets sched.",
                cartonQty: "Carton Qty",
                return: "Return",
                inBoundStrVendorBatch: "Vendor Batch",
                inBoundErrorNbrPallet: "The field Nbr*OF LAbel must be a numeric greater than 0",
                scrapProduction: "Scrap Production",
                mouldAndNonMouldSameDefectId: "Unable to add mould and non-mould related with the same defect ID",
                overProdHeader: "Overproduction",
                btnUnderstoodBack: "Back",
                defaultActivityLabeling: "Labeling",
                sumQty: "Sum Qty",
                status: "Status",
                palSatEditSelectPrinter: "Select printer to reprint to?",
                inBoundLitInfosTrans: "Blank = All,or OO,U,UC, UT, UR, RT ",
                search: "Search",
                select: "Select",
                timeEnd: "Time End",
                prompt: "Prompt",
                addDefect: "Add Defect",
                couldNotLoadWorkOrderPleaseCheckTheOrderCo:
                    "Could not load Work Order. Please check the Order Code and try again. error# w0008",
                pieces: "Pcs",
                couldNotIssueConsumtionX0ErrorX1: "Could not issue consumtion. {0} Error# {1}",
                startingPalletRank: "Starting Pallet Rank",
                movementDescription11: "Label Printed - Pallet Produced",
                movementDescription10: "Return Pallet off line",
                movementDescription13: "Change pallet status from SAP",
                movementDescription12: "Label Printed - Pallet Produced (offline)",
                movementDescription15: "Block pallet QI",
                movementDescription14: "Change pallet Birth Date/Condition in APL from PLC ",
                movementDescription17: "Scrap pallet",
                movementDescription16: "Release pallet",
                movementDescription19: "User connection",
                movementDescription18: "Delete/Cancel pallet",
                movementDescription01: "Start WorkOrder Front End Line",
                movementDescription02: "Stop Workorder Front End line",
                movementDescription03: "Start Workorder Back End Line",
                movementDescription04: "Stop Workorder Back End line",
                movementDescription05: "Issue Pallet on line ",
                movementDescription06: "Consumed Pallet on line ",
                movementDescription07: "Return Pallet on line",
                movementDescription08: "Delete Consumption",
                movementDescription09: "Consumed Pallet off line ",
                movementDescription33: "Block pallet for Scrap",
                movementDescription32: "Pallet quantity change",
                movementDescription35: "Scrap in Warehouse",
                movementDescription34: "Block Pallet for Packaging",
                movementDescription22: "Open Item Return ",
                movementDescription23: "Block pallet for resorting",
                movementDescription20: "Open Item Issuing",
                movementDescription21: "Open Item Consumption",
                movementDescription26: "Remove defect on a pallet",
                movementDescription27: "Defect found",
                movementDescription24: "Open Item delete",
                movementDescription25: "Add Defects to Pallet",
                movementDescription28: "Defect not found",
                movementDescription55: "SU defect removed from SAP",
                movementDescription54: "SU defect added from SAP",
                movementDescription51: "SU Updated from SAP",
                movementDescription50: "SU Created from SAP",
                movementDescription53: "SU condition Updated from SAP",
                movementDescription52: "SU status Updated from SAP",
                movementDescription44: "Approve Pallet",
                movementDescription40: "Pallet Scanned for Repack",
                movementDescription41: "Remove Pallet from Repack",
                movementDescription42: "Pallet Splitting",
                movementDescription43: "Create pallet from other",
                movementDescription60: "Pallet Locked",
                movementDescription61: "Pallet Unlocked",
                movementDescription99: "SU Imported for Go Live",
                inBoundErrorQuantity: "The field Label*Qty must be a numeric greater than 0",
                couldNotDeleteConsumtionX0ErrorX1: "Could not delete consumtion. {0} Error# {1}",
                rxg_Consumption: "Consumption",
                toolTipEnter: "Press Enter to apply your filter(s)",
                inBoundErrorAmount: "Error in the total amount. Please check the values and correct them",
                litSearch: "Search a new Workorder",
                currentPalletRank: "Current Pallet Rank -",
                rxg__0__units_returned_on_SSCC__1___When_all_pallets_are_consumed_returned__click_OK_again_to_close_the_job__dialog_w0005:
                    "{0} units returned on SSCC {1}. When all pallets are consumed/returned, click OK again to close the job. dialog#w0001",
                passNumber: "Pass Number",
                printer: "Printer",
                printUp: "System.Drawing.Bitmap",
                bpQuantity: "Quantity",
                unblock: "Unblock",
                deliverySelected: "Selected",
                couldNotScrapPalletErrorX0: "Could Not scrap pallet. Error# w0009: {0}",
                quantityScrapped: "Quantity Scrapped",
                dicoHtmlLine: "Line",
                multipleSelectionError: "Status does not match for selected rows.Please select again rows with same status!!",
                deliveryTitle: "Printing  - JWO Delivery Label",
                dateCreate: "Date Create",
                btnCloseOff: "Aboard",
                areyousureyouwanttoclosethejob: "Are you sure you want to close the job?",
                traceabilityInfo: "Traceability Info",
                baseProduct: "Base Product",
                litPalLabel: "Pallet Label",
                rxg_You_must_enter_your_initials_to_add_a_defect: "You must enter your initials to add a defect",
                itemClass: "Item Class",
                inBoundErrorPalletCreation: "Error during the pallet creation. Please chech your values.",
                inBoundConfirmDelete: "are you sure you want to delete this line?",
                currentActivity: "Current Activity",
                backToCurrentActivity: "Back to Current Activity",
                confirm: "Confirm",
                consume: "Consume",
                comment: "Comment",
                rxg_Select_work_order_for_labeling: "Select GPO for labeling",
                specialText: "Special Text",
                selectLines: "Select Lines",
                printJSWorksOrder: "Works Order",
                palletStatusDialogHeader: "Blocked Pallet",
                backToOfflineHome: "Back to Offline home",
                consumptionPageTitle: "Consumption Declaration",
                rxg_Could_not_assign_Work_Order_Error___0____1_: "Could not assign Work Order Error#:{0}: {1}",
                noOfCoils: "No. of Coils",
                x0OfX1PaletsBlockedStoppedAtErrorForSSCCX2: "{0} of {1} pallets blocked.  Stopped at error for SSCC:{2} -{3}",
                coilCutting: "CoilCutting",
                popLabelErrorCartonQty: "wrong Quantity for this carton. must be greater than 0 and less than final quantity pallet",
                adminView: "Get The Admin View",
                startDate: "Start Date",
                inBoundDxSelTranType: "Transaction Type",
                partCode: "FP",
                partDesc: "Part Desc",
                headerTextUser: "User",
                rxg_PrintBoth: "Print Both",
                userNotRecognised: "User not recognised",
                dicoHtmlWo: "WorkOrder",
                mainDetails: "Main Details",
                saveChanges: "Save Changes",
                inBoundStrWorkOrder: "WorkOrder ref",
                rxg_BeginPrint: "Begin Printing",
                litQuantityProd: "quantity produced",
                centralServer: "On Central Server",
                blockPallet: "Block Pallet",
                litActQty: "Actual Quantity",
                byProduct: "ByProduct",
                woSApproved: "Approved",
                rxg_Title: "Offline Printing",
                synoptic: "Synoptic",
                printSucceeded: "Print Succeeded",
                rxg_Print: "Print",
                btnNoWarn: "No",
                pleaseSelectaLine: "Please select a line.",
                lblConfirmRepackCondition: "&lt;br /&gt;The curent selection in RePacking will be changed",
                litsearchWomField: "Search a new Workorder",
                consumptionUnit: "Unit",
                dateEnd: "Date End",
                reprintFailed:
                    "Reprint failed for rank {0} Error# w0022. Only {1} of {2} labels were printed. Do you want to try to reprint the missing labels?.",
                quantityProduced: "Quantity Produced(Pallet Consumed)",
                customerCode: "Customer Code",
                customerGTIN: "CustomerGTIN",
                customerDesc: "Customer Description",
                rxg_Quantity: "Quantity",
                offLineMetalSSCCAway: "This SSCC Doesn t exist.",
                pallets: "Pallets",
                printFailedAbr: "Print Failed. Error# w0018",
                rxg_Defect_Added: "Status Changed but no defects added!!",
                declarationOPENITEMS: "Declaration - OPEN ITEMS",
                noCopiesNumeric1to10: "No. Copies must be an integer between 1 and 10",
                inBoundLitRecap: "Summary of the label creation. Label(s) Created and Printed : ",
                inBoundLitPrint: "Print",
                inBoundLitTrans: "Transaction",
                inBoundLitTitre: "Inbound Label",
                workCenter: "WorkCenter",
                blockFailedWithError: "Block failed with error: ",
                baseLineNotRecognised: "Line not Recognised.",
                inBoundTransactionQuantity: "Qty.",
                rxg_Scrap_Pallet: "Scrap Pallet",
                changesNotSaved: "Changes will not be saved.",
                quantityConsumed: "Quantity Consumed",
                defects: "Defects",
                dateScheduleFuture: "You are going to assign a job scheduled for a future date.",
                showRawMaterial: "Show External Pallet",
                areYouSureDelete1: "Are you sure you want to delete this pallet?",
                inBoundBtnOk: "Ok",
                scrapWarehouse: "Scrap Warehouse",
                cuttedSheetsScrapped: "Cutted Sheets Scrapped",
                blockResort: "Block Resort",
                rxg_defectsTable_Comment: "Comment",
                mouldNotParsed: "Problem parsing mould numbers",
                inBoundDateExpiryDate: "Expiry Date",
                areyousureyouwishtoassignworkorder01toline3: "Are you sure you wish to assign work order {0}({1}-{2}) to line {3}",
                byProductDuplicate:
                    "You cannot set a byproduct to the same material as the main material or have two of the same byproduct",
                couldNotBlockPalletErrorX0X1: "Could Not block pallet. Error#{0}:{1}",
                chkEdit: "Edit",
                initials: "Initials",
                rxg_Defects_Added: "Defects Added",
                rxg_Could_not_assign__0__to__1___Error___2___3_: "Could not assign {0} to {1}, Error#:{2}-{3}",
                dicoJsPalletquantity2: "with those quantity you are over the quantity aviable. you have ",
                dicobtnCreatePallet: "Create New Pallet",
                scanExternalTag: "Orig/Ext Tag Identifier",
                rxg_DeleteFailedWithError: "Delete Failed With Error:{0}",
                consumptionQty: "Quantity",
                lblConfirmRepack: "Do you confirm the Repack of the selected Material?",
                created: "Created",
                inBoundErrorUpdate: "An Error occurred during the update. Please check the values and if it persist ask apl team.",
                btnNoReturn: "No i don&apos;t consume anything",
                woMButton1: "Manage this work order",
                printerName: "Printer Name",
                deliveryPalletLoaded: "Nr.Pallets Loaded",
                invalideQuantity: "the return quantity set for the return pallet {0} is higher than remaining quantity error# w0026",
                x0OfX1PaletsScrappedStoppedAtErrorForSSCCX: "{0} of {1} pallets scrapped. Stopped at error for SSCC:{2} -{3}",
                dateRecorded: "Date Recorded",
                errorNewBatch: "An error occured preparing to insert a new Batch.",
                litModQtyMax: "Quantity for a full pallet",
                litModQtyMin: "Quantity for small pallet",
                palStat_Default_Page_Load_Pallet_Status_Management: "Pallet Status Management",
                popDown: "Pop Down",
                endDate: "End Date",
                differentWOOnConsumptionAndLabeling2: "Active GPO in Labeling is different from Consumption one!",
                x0OfX1PaletsDeleted: "{0} of {1} pallets deleted.",
                closeAndConsume: "Stop Consumption",
                go: "Go",
                op: "Op ",
                wo: "GPO",
                to: "To:",
                btnBackWo: "Bouton Back",
                noPallets: "No. of Pallets",
                failedToConsumeSsccInDbX0ErrorX1: "Failed to consume sscc in db. {0} Error# {1}",
                areYouSureBlock1: "Are you sure you want to block this pallet?",
                litCustMat: "Customer material",
                dicoHtmlProdDate: "Prod Date",
                btnCartonDeleteLastDate: "Delete Last one",
                dicoHtmlRemove: "Remove",
                dicoHtmlRepack: "Material selected for Repacking :",
                quantityRemaining: "Quantity Remaining",
                parentPallets: "Consumed Pallets",
                dicoJsPalletOrder: "you can&apos;&apos;t create pallet before the mother pallet : ",
                seqnumber: "Seqnumber",
                errorDeleteBatch: "An error occured deleting the selected Batch.",
                inBoundErrorQuantityTotal: "The total quantity must match the total in the transaction selected.",
                lblRePrintInfoInnerHtml: "Select printer to reprint to?",
                operations: "Operations",
                labelPalletCount2: "{0}/{1}",
                couldNotIssueConsumtionX0: "Could not issue consumtion. Error# w0007: {0} ",
                btnNo: "No",
                day: "Day",
                lot: "Lot",
                key: "en-GB",
                wcl: "WC/L",
                seq: "Seq",
                inBoundLitMat: "Material",
                empty: "Empty",
                error: "Error",
                inBoundLnkAdd: "Add a new Line",
                admin: "Admin",
                apply: "Apply",
                batch: "Batch",
                block: "Block",
                btnGo: "Confirm creation new pallet/s",
                color: "Color",
                close: "Close",
                input: "Input",
                consumeScrap: "Consume\\Scrap",
                order: "Order",
                btnCancel: "Cancel",
                reset: "Reset",
                start: "Start",
                scrap: "Scrap",
                small: "Small",
                print: "Print",
                goBacktoCurrentActivity: "Go Back to Current Activity",
                titleWoMan: "Work order {0}",
                rxg_From: "From:",
                rxg_Open: "Open",
                areYouSureDelete: "Are you sure you want to delete these pallets?",
                litWomMaterial: "Material",
                metalAndEnds: "Metal And Ends",
                inBoundLitCouncil: "Fill text box and push search",
                couldNotDeleteConsumtionX0: "Could not delete consumtion. Error# w0004: {0} ",
                palletID: "PalletID",
                inBoundDxColLotNumber: "Lot",
                selectAll: "Select All",
                dicoCartonDetails: "Carton Details",
                deliveryResult: "Result",
                username: "Username",
                pausePrinting: "Pause Printing",
                labelName: "Label Name",
                x0OfX1PaletsApproved1: "{0} of {1} pallets approved.",
                addUser: "Add User",
                printFailedWithException: "{0}.  Printing failed for rank {1} Error# w0020. ",
                btnSeachWom: "Search Workorder",
                cartonQuantity: "Quantity",
                nextSeqNo: "Next Seq No.",
                addBatchLot: "Add Batch/Lot",
                actions: "Actions",
                quantity: "Qty",
                missingNoDays: "You need to insert the number of days to generate the batches",
                checkSSCC: "Are you sure you want to remove consumption for ",
                inBoundTxtMatError: "The field material cannot be empty and must have at least 3 characters.",
                massActivities: "Mass Activities",
                priorityMissing: "Priority Missing",
                palletStatusEdit: "Pallet Status Edit",
                lstDefault: "None",
                printJSFailed: "Print Failed.",
                inBoundDxSelectTran: "Select a Transaction",
                rxg_Failed_to_set_print_parameters_with_error___0_: "Failed to set print parameters with error: {0}",
                x0OfX1PaletsScrapped: "{0} of {1} pallets scrapped.",
                litMainByProd: "By Prod 1",
                rxg_Defect_comment_must_be_less_than_255_characters_: "Defect comment must be less than 255 characters.",
                yourAccountIsLockedPleaseContactTheHelpdes: "Your account is locked please contact the helpdesk.",
                litQuantityXPallet: "Pallet Qty",
                couldNotDeleteOpenItemX0ErrorX1: "Could not delete open item {0} Error# {1}",
                transactionType: "Transaction Type",
                couldNotUnblockPalletErrorX0X1: "Could Not unblock pallet. Error#{0}:{1}",
                lblErrbtnConsumptionClick1: "&quot;Cannot add the material. {0} : error# {1}&quot;",
                endDateNotGood: "The value for End Date is not a correctly formatted date.  Insert Cancelled.",
                rxg_OfflinePrintHeader: "Offline Print",
                scanNewMaterial: "Scan New Material",
                addingTwoIdenticalDefects: "Adding two identical defects (type and mould)",
                printResult: "{0} label have been sent to the print list (see below for more information about its status).",
                searchWorksOrder: "Search Works Order",
                inBoundLitTransac: "Transaction Selection",
                areYouSureUnblock: "Are you sure you want to Unblock these pallets?",
                rxg_Scrap_failed_with_error__: "Scrap failed with error: ",
                inBoundErrorPalletEdition: "The current label creation is not fully updated. Update your row and after you can print.",
                closeLine: "Close Line(s)",
                tracDifferentDialogText:
                    "Traceability batch is different from the one in consumption. The new one would be {0}. Do you want to continue anyway? Or do you want to change the traceability info to the newest ones?",
                areyousureyouwanttodeleteSSCCX0X: "Are you sure you want to delete SSCC:{0}?",
                quantityXPallet: "Quantity X Pallet",
                lblConfirmOff: "This pallet has 0 Qty ! you can t use it",
                printPallet: "Print Pallet",
                inBoundConfirmCreation: "are you sure to create those one? it ll change the transaction status to print.",
                areYouSureScrap1: "Are you sure you want to scrap this pallet?",
                woMPallFullQty: "Full",
                litByProduct: "ByProduct 1 Material",
                closeWorksOrder: "Close GPO",
                changeLog: "Change Log",
                scheduledDateTime: "Schedule Date-Time",
                areYouSureApprove: "Are you sure you want to approve the production of the selected pallet?",
                offlineconsumption: "OFF-LINE CONSUMPTION",
                efficiencyoftheLine: "Efficiency Of The Line",
                x0OfX1PaletsUnblocked1: "{0} of {1} pallets unblocked.",
                dicoHtmlConfirRepack: "Confirm Repack",
                x0OfX1PaletsDeletedStoppedAtErrorForSSCCX2: "{0} of {1} pallets deleted. Stopped at error for SSCC:{2} -{3}",
                scheduleWorkOrder: "GPO Scheduling",
                doYouWantToActivate: "Do you want to activate a new WorksOrder?",
                ssccConsumed: "SSCC Consumed",
                litCustMatDesc: "Description",
                noOfCartons: "No. of Cartons",
                printingComplete: "Printing Complete",
                couldNotApprovePalletErrorX01: "Could Not Approve pallet. Error# w00010: {0}",
                material: "FP",
                printScreen: "Print Screen",
                inBoundDxPrintStatus: "Print Status",
                printStatus: "Print Status",
                areyousureyouwanttoconsumescrapSSCC: "Are you sure you want to consume and scrap SSCC",
                closeReturn: "Close and return lines",
                woAvailable: "List of GPOs Available",
                checkDatesfuture: "Cannot consume in the future",
                dicoJsPalletquantity: "Can&apos;&apos;t use more ressources than the repack has",
                noRecFound: "No Records Found",
                rxg_Could_not_close_job__0___Error___1_: "Could not close job {0}: Error# {1}",
                rxg_QiPalletsSelectedCount: "Condition of {0} Blocked QI pallet(s) won&apos;t be updated in bulk mode",
                errorUpdateBatch: "An error occured updating the selected Batch.",
                couldNotUnblockPalletErrorX01: "Could Not unblock pallet. Error# w00010: {0}",
                litCopyNumber: "Number of copy",
                litWomDec2: "Desc2",
                litWomDec1: "Desc1",
                btnYesReturn: "I return {0} in quantity",
                btnPrintNextCarton: "Print Next Carton",
                dicoHtmlSelectMatOnHold: "selected",
                productionOrderRunning: "Production Order Running",
                massIssue: "Mass Issue",
                noOfPallets: "No. of Pallets",
                labellingStatus: "Labelling Status",
                qtyProduced: "quantity produced",
                overProdText: "Creating this pallet, you will be overproducing on this WO. Do you want to continue anyway?",
                rxg_Please_select_the_pass_number_: "Please select the pass number?",
                litQuantitySchedule: "quantity schedule",
                article: "Article",
                ignoreSapUpdates: "Ignore SAP updates",
                litWait: "Please Wait",
                litMain: "Main",
                printUsingAlternatePrinterFailed:
                    "Print failed with Alternate printer too. Do you want to try printing again?                                            Click YES to print using alternate printer or click NO then press PRINT to retry the original printer.",
                childPallets: "Produced Pallets",
                isActive: "Is Active",
                lblErrbtnConsumptionClick1Exception: "Cannot add the material.  error# {0}",
                printPartiallyFailed:
                    "Printing failed for rank {0} Error# w0021. Only {1} of {2} labels were printed. Do you want to try to reprint the missing labels?",
                qtyScheduled: "quantity schedule",
                rxg_Could_not_close_job___Error___0__: "Could not close job : Error# {0} ",
                consumeSSCC: "Consume SSCC",
                labelPalletInProgress: "Pallet in progress : Current SSCC {0}",
                printFailed: "Printing failed for rank {0}",
                approve: "Approve",
                rxg_Add_Defect: "Add Defect",
                requiredFields: "Missing required values highlighted in red*",
                cartonType: "Quantity per carton",
                printJSCancelRequest: "Cancellation Request Received.",
                litPrintHistory: "Print History",
                printEngine: "Print Engine",
                partDescription: "Part Description",
                litCustomerGTIN: "CustomerGTIN",
                lblRePrintInfo: "Select Printer?",
                copySscc: "Copy SSCC",
                inboundYes: "Yes",
                labelCurrentActivityError:
                    "Some Error in CurrentActivity for this Line!!                                                                    Do you wish to continue moving onto another line?",
                pleaseContactHelpdesk:
                    'Please contact <a href="mailto:helpdesk@ardaghgroup.com">helpdesk@ardaghgroup.com</a> for new accounts',
                rxg_Back_to_labeling: "Back to labeling",
                rxg_Yes: "Yes",
                beginPrinting: "Begin Printing",
                rxg_defectsTable_Initials: "Initials",
                woMMAterialNameError: "this Material doesn t exist : ",
                litLabelCreation: "Label Creation",
                department: "Department",
                movementDescriptionDefault: "Pallet Updated",
                rxg_defectsTable_Found: "",
                billOfBatches: "Bill Of Batches",
                onLINECONSUMPTION: "On-LINE CONSUMPTION",
                offlineconsumptionmetalandends: "OFF-LINE CONSUMPTION METAL AND ENDS",
                labelDefaultTitle: "Labeling Current Activity",
                failedToReturnSsccInDbX0: "Failed to return sscc in db. Error# w0013: {0} ",
                selectNone: "Select None",
                selectPage: "Select Page",
                blockPackaging: "Block Packaging",
                sendToSAP: "Sent To SAP",
                leavingthispagewillstopprinting: "Leaving this page will stop printing",
                reprint: "Reprint",
                billOfMaterials: "Bill Of Materials",
                woSClosed: "Closed",
                refresh: "Refresh",
                litCustCode: "Customer Code",
                litCustomer: "Customer info",
                rxg_CouldNotDeletePallet: "Could Not delete pallet. Error#{0}:{1}",
                byProductDetails: "ByProduct Details",
                inBoundLitWarehouse: "Warehouse",
                consumptionWorkorder: "Cons.WO",
                rxg_CouldNotDeletePallet1: "Could Not delete pallet. Error#:{0}",
                localServerOffline: "Local Server is Offline.",
                customerDetails: "Customer Details",
                finalPass: "Final Pass",
                areyousureyouwanttoreturnSSCC: "Are you sure you want to return SSCC",
                testPrint: "Test Print",
                deliveryEmptyWorkorder: "no work order for this pallet. you can t print it",
                rxg_Select_work_order_for_consumption: "Select GPO for consumption",
                printLabels: "Print Labels",
                palSatDefaultTitle: "Pallet Status Management",
                inBoundBtnExit: "Exit",
                failureReason: "Failure Reason",
                batchExists: "The value for Batch already exists on this work order. Insert Cancelled.",
                printJSCancelFailed: "Cancellation Failed",
                assignNewJob: "Assign New Job",
                btnYes: "Yes",
                rxg_Delete_Pallet: "Delete Pallet",
                ringDiameter: "Ring Diameter",
                btnWoMan: "Manage Work Order",
                inBoundStrCoilNr: "SU reference",
                noChangesMade: "No changes made",
                woSequenceScheduled: "GPO Sequence Scheduled",
                dicoHtmlOriginalQty: "Original Qty",
                inBoundErrorLabelRank: "The number of label must be a numeric",
                startDateIsLaterThanEndDate: "Start date is later than end date",
                inBoundDxwarehouse: "Warehouse",
                rxg_You_must_enter_a_comment_for_the_defect_s__: "You must enter a comment for the defect(s).",
                errorCommandNotRecognised: "error: command not recognised. Error# w0011",
                extBarcode: "External Barcode",
                rxg_Cannot_issue_the_material___0___error___1_: "Cannot issue the material. {0}: error# {1}",
                lblFailErr: "Error :",
                btnYesWarn: "Yes",
                description: "Description",
                notUpdateByERP: "Fields not updated by ERP",
                palletStatusId: "StatusId",
                initQty: "InitQty",
                woMPallTxtModQty: "Changed by Operator",
                youCanOnlyHaveNumberOfPalletsIssuedConsume:
                    "You can only have {0} pallets issued. Would you like to consume the oldest issued?",
                chkError: "Get only Error Logs",
                selectDefects: "Select Defects:",
                couldNotGetConsumptionPalletDetailsForJobE: "Could not get consumption pallet details for job Error# w0006: {0} ",
                couldNotGetConsumptionPalletDetailsForJobX: "Could not get consumption pallet details for job {0}: Error# {1}",
                smallQtyNumeric: "Small qty must be an integer",
                assignedSuccessfully: "Assigned Successfully",
                consumptionCannotBeDisplayedNoWO:
                    "Consumption cannot be displayed. No work order selected. Assign a job to this line instead.  error# w0002",
                rxg_defectsTable_Defect: "Defect",
                material12: "FP12",
                lblOIErrorDate: "wrong date!",
                inBoundDxColLocation: "Location",
                defectsModified: "Defects or status changed. Please refresh",
                failedToReturnSsccInDbX0ErrorX1: "Failed to return sscc in db. {0} Error# {1}",
                fullQtyNumeric: "Full qty must be an integer",
                condition: "Condition",
                rxg_Back_to_current_activity: "Back to current activity",
                dayAlreadyExists: "The value for Day already exists on this work order. Insert Cancelled.",
                deliveryTextPurchaseOrder: "Customer Purchase Order",
                inBoundIntLabelRank: "Nr.Of Labels",
                printJSServerOffline: "Server Offline.  ",
                deliveryTitleCustCode: "Customer code :",
                lblConfiramtionReturn: "Do you confirm your Return 0 quantity?",
                dayNotWhole: "The value for Day is not whole a number. Insert Cancelled.",
                previousBatchNr: "Prev.Batch Nr",
                btnYesReturn2: "I close the GPO \\n because i return 0 in quantity",
                newPalletNumber: "New Pallet Number",
                rxg_Is_the_previous_SSCC___0___completely_consumed___dialog__apl00002: "Is the previous SSCC ({0}) completely consumed?",
                haveFollowingPalletsBeenFullyUsed: "Have following pallets been fully used?",
                cartonError: "Total Quantity does not match the quantity of selected pallet!!",
                oldValue: "Old Value",
                deliveryTextNoteNr: "Delivery Note Nr.",
                component: "Component",
                backUpServer: "Running on back up central server.",
                palletIdentify: "Pallet Identify",
                rxg_SSCC___0___has__1__quantity_and_cannot_be_consumed__error_4123:
                    "SSCC ({0}) has {1} quantity and cannot be consumed. error#w0023",
                byProduct1: "By Product 1",
                byProduct2: "By Product 2",
                byProducts: "By Products",
                areYouSureBlock: "Are you sure you want to block these pallets?",
                couldNotDeleteOpenItemX0: "Could not delete open item Error# w0005: {0} ",
                areYouSureScrap: "Are you sure you want to scrap these pallets?",
                preventERPUpdate: "Stop any update from ERP (SAP or BPCS)",
                hotKeyInfo: "Press {0} to print.",
                hotKeyWait: "Please wait.",
                noOfPalletsProduced: "No. of Pallets Produced on WO",
                inLineJob: "Inline Job",
                rxg_Label_parameters: "Label parameters",
                localServerOnline: "Local server is online.",
                dicoHtmlScanSSCC: "Scan New SSCC :",
                dicoHtmlRepackNew: " Date Repack of the new pallet",
                statusHistory: "Status History",
                mvtDesc: "Movement description",
                mvtDate: "Movement date",
                rxg__0__assigned_to__1_: "{0} assigned to {1}",
                inBoundBtnReset: "Reset Date",
                fullQtyGreaterThanSmall: "Full quantity must be greater or equal to small quantity",
                inBoundDxColunit: "Unit",
                couldNotBlockPalletErrorX0: "Could Not block pallet. Error# w0003: {0}",
                inBoundDxComment: "Delivery Note",
                name: "value",
                edit: "Edit",
                exit: "Exit",
                full: "Full",
                date: "Date",
                desc: "Desc",
                main: "Main",
                back: "Back",
                item: "Item",
                next: "Next",
                okay: "Okay",
                oops: "An unexpected error occurred, we apologise for the inconveniance.  This error has been logged, if this persists please contact the help desk.  Error# w0016",
                open: "Open",
                line: "Line",
                unit: "Unit",
                time: "Time",
                rank: "Rank",
                stop: "Stop",
                save: "Save",
                sscc: "SSCC",
                pass: "Pass",
                bpNoOfCopies: "No. of Copies",
                dicoHtmlRepackProgress: "RePacking Material in progress :",
                litWoOpeByProd2: "By Prod 2",
                custCrossRef: "Customer Cross Ref",
                rxg_No: "No",
                cartonProdResume: "Carton Production : Resume",
                consumptionStatus: "Consumption Status",
                couldNotApprovePalletErrorX0X1: "Could Not Approve pallet. Error#{0}:{1}",
                inBoundsearch: "Search",
                success: "Success",
                dicoHtmlAddPallet: "Add a New Pallet to be Created",
                workorderAssignedPrinting: "Workorder was assigned for Label printing. Switch to activity?",
                workorderAssignedConsumption: "Workorder was assigned for consumption. Switch to activity?",
                jobIn: "Job In",
                statusChangeNotAllowed: "Status change not allowed",
                deselect: "Deselect",
                resetView: "Reset View",
                foil: "Foil",
                searchForDelivery: "Search for Delivery",
                dropLocation: "Drop Location",
                deliveryNoteMerck: "Delivery Note",
                deliveryNoteWrong: "No data found for entered delivery note",
                deliveryPalletListEmpty: "No Pallets found (keep in mind that data from SAP could need up to 6 minutes)",
                dropLocationEmpty1: "Select Droplocation",
                dropLocationEmpty2: "Select Droplocation",
                dropLocationTooltip: "Please select the drop location given by customer on delivery note",
                deliveryNoteEmpty: "Please type Delivery Note",
                deliveryNoteTooltip: "Please enter a valid delivery note as you can find on your delivery document from SAP",
                containerVolume: "Volume",
                youCanOnlyHaveNumberOfPalletsIssued: "You can only have {0} pallets issued",
                partPallet: "Part Pallet",
                manualEntry: "Manual Entry",
                consumed: "Consumed",
                issued: "Issued"
            }
        }
    },
    "da-DK": {
        translation: {
            main: {
                palletConditionId00: "Information",
                palletConditionId01: "Prod-ikke sat på lager",
                palletConditionId02: "Sat på lager",
                palletConditionId03: "Omsorteret",
                palletConditionId04: "Læsset",
                palletConditionId05: "Leveret",
                palletConditionId06: "Destrureret",
                palletConditionId07: "Sat i lokation via SUL",
                palletConditionId08: "Udgået",
                palletConditionId09: "Deleted",
                palletConditionId10: "Lager flytning",
                palletConditionId11: "Midlertidig palle",
                palletConditionId12: "Kvalitet inspektion",
                palletConditionId13: "Spærret til omsortering",
                palletConditionId94: "Allocated for Delivery",
                palletConditionId99: "Palleseddel udskrevet",
                palletStatusId00: "Label Printing",
                palletStatusId01: "Palleseddel udskrevet",
                palletStatusId02: "Palleseddel udskrevet",
                palletStatusId03: "Palleseddel udskrevet",
                palletStatusId04: "Godkendt",
                palletStatusId05: "Blokeret",
                palletStatusId06: "Omsorteret",
                palletStatusId07: "Destrueret",
                palletStatusId08: "Test Palle",
                palletStatusId09: "Retur",
                palletStatusId10: "Blokeret for kontrol",
                palletStatusId11: "Godkendt med forbehold",
                palletStatusId12: "Blokeret pakkematriale",
                palletStatusId13: "Tilført",
                palletStatusId14: "Omsorteret",
                palletStatusId15: "Returneret",
                palletStatusId16: "Antal modtaget",
                palletStatusId17: "Godkent",
                palletStatusId18: "Slettet",
                palletStatusId19: "Ompakning",
                palletStatusId20: "Læsset",
                palletStatusId21: "Leveret",
                palletStatusId22: "Destrureret på lager",
                palletStatusId30: "PreBilled",
                palletStatusId90: "WIP",
                offlineCons: "Offline forbrug",
                operator: "Operatør",
                openedWO: "Åbne produktionsordre",
                litEANGTAN: "EAN/Gtin",
                noWorkOrderOnLabelingAndOneRunningOnConsum:
                    "Intet ordrenr. på etikettering men et på igangværende produktionsforbrug. Error# w0015:",
                deliveryTextPurchaseOrderLine: "Kundens  indkøbsordre linie",
                woSSuspended: "Pauset",
                passFirst: "Vælg godkendelsesnummer",
                woMPallQty: "Antal X palle",
                rxg_Label_paramters_save_successfully_: "Palleseddelsopsætning er gemt.",
                rxg_Please_enter_the_quantity_remaining_on_the_previous_pallet__input__APL00031:
                    "Indtast rest-antal på sidste palle. input# APL00001",
                lblFailSSCC: "SSCC  {0} eksisterer ikke på denne side",
                string1: "",
                lblErrOI: "Antal tilbage skal være størrere end 0 ! Error# w0026",
                x0OfX1PaletsBlocked: "{0} af {1} paller spærret.",
                chkInPRogresse: "Vis printkø i tid",
                inBoundDxDescription1: "Decription",
                batchMissing: "batch mangler",
                popMaxcatonLimit: "Antallet af plader er ikke tilladt",
                printJSSequenceNumber: "Next Seq No.",
                litUserUpdate: "Ændret af bruger",
                inValidWorkOrderId: "Fejl i produktionsordre/linie.!! / kontroller ordreoversigt",
                scrapped: "Slettet",
                rxg_Could_not_assign__0__to__1__Error____2_: "Kunne ikke tildele ordre {0} til linie {1} Error#: {2}",
                emptyRowDelivery: "Ingen data fundet med disse parametere ",
                rxg_Please_select_a_defect: "Vælg venligst en fejl",
                cartonCreateLastDate: "Sidste produktionsdag",
                offlinePrint: "Offline printe",
                noWorkOrderOnConsumptionAndOneRunningForLa:
                    "Intet ordrenr. på produktionsforbruget men et kører for etikettering. Error# w0014:  ",
                litCartonLabel: "Palleseddel 2",
                batchNr: "Batchnummer",
                printSuccessful: "Udskrift gennemført",
                litNameCust: "Kunde Navn",
                womTitle: "Produktionsordre Admin",
                mouldNo: "Formnummer",
                noDefectIdSelected: "Blank DefectId selected",
                differentWOOnConsumptionAndLabeling: "Forskellige ordrenumre på forbrug og palleseddel. Error# w0010",
                operation: "Funktion",
                btnUpdateWoM: "Opdater",
                lotNotWhole: "The value for Lot is not whole a number.  Insert Cancelled.",
                unableToAddOpenItemToLineX0X1ErrorX2: "Ikke muligt at tildele emne til linien  {0} error#: {2}",
                batchStart: "Batch Start",
                deleteLastOne: "Slet sidste",
                lblErrbtnConsumeClick: "Forkert dato. Du kan ikke forbruge pallen i fremtiden. Ændre dato",
                labelImSwitchQty: "Ændre antal mellem hel palle og delt palle",
                conditionID: "Tilstands kode",
                toolTipchkRaw: "Tryk OPDATER for at indsætte filter",
                offlinePrintingFailedException: "Printeren er ikke klar ,print på hold ,vælg anden printer og tryk  START PRINT",
                palletStatusDialogText: "Denne palle er spæret , ønsker du stadig at fortsætte",
                inBoundDxMaterialCode: "Material Code",
                consumptionNbPallet: "Nb Pall",
                palletsQty: "Pal (Qty)",
                palletRank: "Pallenr.",
                inBoundDxTransactionDate: "Date",
                cannotConsumeInTheFuture: "Forbrug i fremtid ikke gyldig. error# w0001",
                palletDetail: "Palle info",
                linePrintAll: "udskriv alle pallesedler",
                deliveryNote: "Delivery Note",
                btnCartonDeleteConfirmation: "Er du sikker på at du vil slette dette &quot;låg/pap/mellemlæg&quot;",
                inBoundLitLabelName: "Label Type : ",
                printResultSuccess: "{0} copy(s) of Sequence {1} sent to printer {2} at {3}.",
                scheduledOrders: "Planlagte produktionsordre",
                dicoJsPalletDate: "Du kan ikke lave palle i fremtiden",
                openItems: "Åbent emne",
                actQty: "Antal",
                rxg_SSCC___0___was_not_found___error__00001: "SSCC ({0}) kunne ikke findes.  error#:#w0024",
                chkDetails: "Print informationer",
                lotExists: "The value for Lot already exists on this work order. Insert Cancelled.",
                assign: "Tilldela",
                dicoRepackSummary: "Ompakning total",
                cartonDeleteLastDate: "Slet sidste",
                labellingPrintingComplete: "Udskrift klar",
                inBoundErrorQtyLabel: "The QtyxLAbel must be a numeric.",
                noDefectsPassed: "At least one defect required for blocking",
                woMPallTxtFullQty: "Standard",
                palletsProduced: "palle produktion.",
                dicoHtmlSelectMat: "Vaelg dette materiale",
                goBack: "Tilbage",
                btnDeleteLastOne: "Slet sidste &quot;Låg/pap/mellemlæg&quot;",
                litMessWarn: "Antallet er størrere end maks. antal på palle. Vil du ændre til antallet som er på pallen ?",
                dateIn: "Start dato",
                delete: "Slet",
                detail: "Detaljer",
                deleteConsumption: "Slet forbrug",
                newValue: "ny værdi",
                lotNumber: "Partinummer",
                inBoundTotalLabelCreation: "Total",
                inBoundTxtTanDateError: "A valid Date is required",
                rxg_No_Department_specified__Error__w0007: "Vælg først afdeling. Error# w0025",
                checkDateslater: "Startdato er senere end slutdato",
                dicoHtmlQuantityUsed: "Antal brugt : ",
                consumptionCurrentActivity: "Forbrug til igangværende ordre",
                inputLine: "",
                inBoundErrorReceiptDate: "The Expiry Date must be a valide date and time.",
                columnName: "Kolonne navn",
                txtQuantityErr: "Ugyldigt antal",
                consumptionParameters: "Forbrugsparametre",
                btnPrintPalletAndClose: "Udskriv palleseddel og afslut",
                failedToConsumeSsccInDbX0: "Kunne ikke forbruge sscc i DB. Error# w0012: {0} ",
                inBoundIntQtyLabel: "Qty x Label",
                rxg_Could_not_assign_Work_Order___Error___0_: "Kunne ikke tildele produktionsordre. Error: {0}",
                blockQi: "QI",
                blocked: "spærret",
                unableToAddOpenItemToLineX0ErrorX1: "Ikke muligt at tildele emne til linien  {0} error#: {1}",
                noOfSheets: "Antal plader",
                cancel: "Fortryd",
                pickingLblNumCopy: "Antal kopier",
                workOrder: "Prod Ord",
                wantToUseAlternatePrinter: "Valgt printer er ikke klar!! Tryk ja for at bruge anden printer {0} til udskrift",
                x0OfX1PaletsApprovedStoppedAtErrorForPalletX21: "{0} af{1} paller godkendt. Stoppet med fejl :{2} -{3}",
                inBoundBtnConfirm: "Confirm",
                inboundNo: "No",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheck:
                    "SSCC {0} er åben på følgende linie(r). Vælg venligst den linie du ønsker at lukke.",
                inLine: "In Line",
                insert: "indsæt",
                inBoundTxtwareError: "The field warhouse cannot be empty and cannot have more than 2 characters",
                lblErrbtnConsumeClickMissing: "Kunne ikke finde SSCC. Error# w0006",
                rxg_PrintDefect: "udskriftsfejl",
                workOrderOp: "Produktionsordre / ",
                batchNotWhole: "The value for Batch is not whole a number.  Insert Cancelled.",
                inBoundBtnCancel: "Cancel",
                inBoundBtnCancel2: "Finish",
                noData: "Der er ikke data at vise for denne linie",
                changeCloseJob: "Ændre/Forlad denne ordre",
                inValidUser: "Fejl i bruger.! Log ind igen",
                inValidTime: "Fejl i klokkeslæt.!! Indtast korrekt klokkeslæt(TT:MM)",
                woSPlanned: "Planlagt ",
                inValidDate: "Fejl i dato.!! Indtast korrekt dato (DD/MM/ÅÅÅÅ)",
                inBoundErrorDate: "the date is not Correct",
                palletCreated: "Palle {0} ({1}) oprettet.",
                x0OfX1PaletsUnblockedStoppedAtErrorForPalletX21: "{0} af {1} paller godkendt.  Stoppet med fejl:{2} -{3}",
                inBoundDxColSeqNumber: "Seq",
                litPalLabel4: "Palleseddel 4",
                litPalLabel3: "Palleseddel 3",
                litWoS: "nuværende produktionsordre status",
                printAbort: "Udskrift for palle {0} mislykkedes. Server svarer ikke. error# w0017.",
                labels: "Palleseddel",
                logout: "Log ud",
                length: "længde",
                btnYesReturnDetail: "Luk  uden der er  tilbageført antal",
                finalPalletRank: "Sidste pallenr. ",
                update: "Opdater",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheckReturn:
                    "SSCC {0} er åben på følgende linie(r). Vælg venligst den linie du ønsker at gå tilbage til",
                printfailedselectanotherprinter: "Udskrift mislykkedes, vælg en anden printer eller prøv igen. Error# w0019 ",
                batchLot: "Batch\\Lot",
                batchEnd: "Batch slut",
                prodDate: "Produktionsdato",
                litAllInOne: "Alt på engang",
                couldNotScrapPalletErrorX0X1: "Palle kunne ikke skrottes. Error#{0}:{1}",
                lblDefaultSetting: "Antal lag",
                rxg_Labeling_Pass_Number: "Palleseddel godkendelsesnummer",
                lblErrbtnConsumptionClick1Else: "Kunne ikke forbruge SSCC ugyldigt antal. Error# W0008",
                btnBack: "Slut",
                dicoHtmlSapcode: "Materiale  Sap Kode",
                cartonSumQty: "antal lag &quot;låg/pap/mellemlæg&quot;",
                rxg_Unable_to_consume_pallet__0____1__Error____2__: "Kunne ikke forbruge palle {0}: {1} error#: {2} ",
                dicoTotalQuantity: "Totalt antal",
                priority: "Prioritet ",
                printMod: "udskrifts opsætning",
                thisMethodRequiresAConfirmationAndNoneIsDe: "Denne metode kræver en bekræftelse, men der er ingen registreret.",
                litTitre: "Igangværende palleseddel",
                qtyReq: "Planlagt antal",
                litWoOpe: "Åben produktionsordre",
                litWoMan: "Produktionsordre information",
                standard: "Standard",
                noWorkorder: "Intet produktionsordrenr.",
                thereIsNoWorkOrderConfiguredForThisLine: "Der er ikke oprettet nogen produktionsordre for denne linie",
                dicoHtmlRepackResult: "Ompaknings resultat",
                tableName: "Tabel navn",
                woMPallMinQty: "Del",
                inBoundLitTranDate: "Tansaction Date",
                materialMissing: "material mangler",
                quality: "Quality",
                allPallets: "All pallets",
                pleaseSelectaPrinter: "Vælg venligst printer for ny palleseddel",
                rxg_ThereIsNoWorksOrderAssignedForThisLine: "Denne linie har ingen tildelt prod. ordre ",
                palletStatus: "Produktion",
                cuttedSheetsBlocked: "Stanset ark spærret",
                litByProduct2: "Producer 2 matriale",
                tracDialogText: "Historik på batch mangler , ønsker du at fortsætte?",
                sqlTranslation: "SQL oversættelse",
                rxg_Back_to_offline_consumption: "Tilbage til offline forbrug",
                woSInUse: "Aktiv",
                rxg_Open_SSCC__0__on_the_following_line_s__: "Åbn SSCC {0} på følgende linie(r).",
                thislinehasajobassignedClosethejob: "Der er allerede tildelt en produktionsordre. Vil du lukke denne?",
                rxg_Work_Order_Enquiry: "Produktionsordre Admin",
                partDesc2: "Artikelbeskrivelse 2",
                litQtyReq: "Bestilt antal",
                dicoHtmlMaterial: "Materiale",
                timeIn: "Start tid",
                startDateNotGood: "The value for Start Date is not a correctly formatted date.  Insert Cancelled.",
                labelPalletCount: "Antal paller produceret:&lt;br/&gt; &lt;b&gt;{0}&lt;/b&gt;",
                numberOfCopies: "Antal kopier",
                inBoundLitDescription: "Description",
                ckBoxCartonSave: "Med pap",
                palletsScheduled: "paller planlagt.",
                cartonQty: " &quot;låg/pap/mellemlæg&quot; antal",
                return: "Tilbageførsel",
                inBoundStrVendorBatch: "Vendor Batch",
                inBoundErrorNbrPallet: "The field Nbr*OF LAbel must be a numeric greater than 0",
                scrapProduction: "Scrap Production",
                mouldAndNonMouldSameDefectId: "Unable to add mould and non-mould related with the same defect ID",
                overProdHeader: "Overproduction",
                btnUnderstoodBack: "Tilbage",
                defaultActivityLabeling: "Palleseddels udskrift",
                sumQty: "Total Stk.",
                status: "Status",
                palSatEditSelectPrinter: "Vælg printer til genudskrift",
                inBoundLitInfosTrans: "Blank = All,or OO,U,UC, UT, UR, RT ",
                search: "Søg",
                select: "Vælg",
                timeEnd: "Slut tid",
                prompt: "Prompt",
                addDefect: "Fejl tilføjes",
                couldNotLoadWorkOrderPleaseCheckTheOrderCo: "Ordre kunne ikke indlæses. Tjek ordrenr. og prøv igen. error# w0008",
                pieces: "stk.",
                couldNotIssueConsumtionX0ErrorX1: "Kunne ikke placere forbrug. {0} Error# {1}",
                startingPalletRank: "Start pallenr.",
                movementDescription11: "Label Printed - Pallet Produced",
                movementDescription10: "Return Pallet off line",
                movementDescription13: "Change pallet status from SAP",
                movementDescription12: "Label Printed - Pallet Produced (offline)",
                movementDescription15: "Block pallet QI",
                movementDescription14: "Change pallet Birth Date/Condition in APL from PLC ",
                movementDescription17: "Scrap pallet",
                movementDescription16: "Release pallet",
                movementDescription19: "User connection",
                movementDescription18: "Delete/Cancel pallet",
                movementDescription01: "Start WorkOrder Front End Line",
                movementDescription02: "Stop Workorder Front End line",
                movementDescription03: "Start Workorder Back End Line",
                movementDescription04: "Stop Workorder Back End line",
                movementDescription05: "Issue Pallet on line ",
                movementDescription06: "Consumed Pallet on line ",
                movementDescription07: "Return Pallet on line",
                movementDescription08: "Delete Consumption",
                movementDescription09: "Consumed Pallet off line ",
                movementDescription33: "Block pallet for Scrap",
                movementDescription32: "Pallet quantity change",
                movementDescription35: "Scrap in Warehouse",
                movementDescription34: "Block Pallet for Packaging",
                movementDescription22: "Open Item Return ",
                movementDescription23: "Block pallet for resorting",
                movementDescription20: "Open Item Issuing",
                movementDescription21: "Open Item Consumption",
                movementDescription26: "Remove defect on a pallet",
                movementDescription27: "Defect found",
                movementDescription24: "Open Item delete",
                movementDescription25: "Add Defects to Pallet",
                movementDescription28: "Defect not found",
                movementDescription55: "SU defect removed from SAP",
                movementDescription54: "SU defect added from SAP",
                movementDescription51: "SU Updated from SAP",
                movementDescription50: "SU Created from SAP",
                movementDescription53: "SU condition Updated from SAP",
                movementDescription52: "SU status Updated from SAP",
                movementDescription44: "Approve Pallet",
                movementDescription40: "Pallet Scanned for Repack",
                movementDescription41: "Remove Pallet from Repack",
                movementDescription42: "Pallet Splitting",
                movementDescription43: "Create pallet from other",
                movementDescription60: "Pallet Locked",
                movementDescription61: "Pallet Unlocked",
                movementDescription99: "SU Imported for Go Live",
                inBoundErrorQuantity: "The field Label*Qty must be a numeric greater than 0",
                couldNotDeleteConsumtionX0ErrorX1: "Forbrug kunne ikke slettes. {0} Error# {1}",
                rxg_Consumption: "Omsortering",
                toolTipEnter: "Tryk ENTER for at insætte filter",
                inBoundErrorAmount: "Error in the total amount. Please check the values and correct them",
                litSearch: "Søg efter ny produktionsordre",
                currentPalletRank: "Igangværende pallenr.",
                rxg__0__units_returned_on_SSCC__1___When_all_pallets_are_consumed_returned__click_OK_again_to_close_the_job__dialog_w0005:
                    "{0} enheder returneret på SSCC {1}. Når alle paller er brugt/returneret, klik OK igen, for at lukke jobbet. dialog#w0001",
                passNumber: "Godkendelses kode",
                printer: "Printer",
                bpQuantity: "antal",
                unblock: "Godkend",
                deliverySelected: "Valg",
                couldNotScrapPalletErrorX0: "Palle kunne ikke skrottes. Error# w0009: {0}",
                quantityScrapped: "Antal slettet",
                dicoHtmlLine: "Linie",
                multipleSelectionError: "Status matcher ikke valgte antal rækker. Vælg antal rækker med samme status",
                deliveryTitle: "Udskriver JWO etiket",
                dateCreate: "Oprettelses dato",
                btnCloseOff: "Luk",
                areyousureyouwanttoclosethejob: "Vil du virkelig slutte dette job?",
                traceabilityInfo: "Traceability Info",
                baseProduct: "Container Code",
                litPalLabel: "Palleseddel",
                rxg_You_must_enter_your_initials_to_add_a_defect: "Du skal indtaste dine initialer for at tilføje en fejl",
                itemClass: "Klassificering af materiale",
                inBoundErrorPalletCreation: "Error during the pallet creation. Please chech your values.",
                inBoundConfirmDelete: "are you sure you want to delete this line?",
                currentActivity: "Igangværende aktivitet",
                backToCurrentActivity: "Tilbage til igangværende aktivitet",
                confirm: "Bekræft",
                consume: "Forbrug / omsortering",
                comment: "Bemærkning",
                rxg_Select_work_order_for_labeling: "Vælg produktionsordre til palleseddel",
                specialText: "Special Text",
                selectLines: "Vælg linie",
                printJSWorksOrder: "Works Order",
                palletStatusDialogHeader: "Spærrede paller",
                backToOfflineHome: "Tilbage til Offline Home",
                consumptionPageTitle: "Konsumtions deklaration",
                rxg_Could_not_assign_Work_Order_Error___0____1_: "Kunne ikke tildele produktionsordre. Error#:{0}: {1}",
                noOfCoils: "Antal af coils",
                x0OfX1PaletsBlockedStoppedAtErrorForSSCCX2: "{0} af {1} paller spærret. Stoppet ved fejl i SSCC:{2} -{3}",
                coilCutting: "Coil stansning",
                popLabelErrorCartonQty: "Forkert antal , skal være størrere end{0}og mindre end total antal på pallen",
                adminView: "Admin oversigt",
                inBoundDxSelTranType: "Transaction Type",
                partCode: "Artikel Nr",
                partDesc: "Artikelbeskrivelse 1",
                headerTextUser: "Bruger",
                rxg_PrintBoth: "Udskriv begge",
                userNotRecognised: "Brugernavn ikke genkendt",
                dicoHtmlWo: "Produktionsordre",
                mainDetails: "Hoved detalje",
                saveChanges: "Gem ændringer",
                inBoundStrWorkOrder: "WorkOrder ref",
                rxg_BeginPrint: "Start udskrivning",
                litQuantityProd: "Antal Produceret",
                centralServer: "On Central Server",
                blockPallet: "Spær palle",
                litActQty: "Antal",
                byProduct: "Produkt",
                woSApproved: "Godkendt",
                rxg_Title: "Offline udskrivning",
                synoptic: "Synoptic",
                printSucceeded: "Udskrift i gang",
                rxg_Print: "Udskriv",
                btnNoWarn: "Nej",
                pleaseSelectaLine: "Vælg venligst en linie",
                lblConfirmRepackCondition: "Det aktuelle valg i ompak vil blive ændret",
                litsearchWomField: "Søg efter ny produktionsordre",
                consumptionUnit: "Enhed",
                dateEnd: "Slut dato",
                reprintFailed:
                    "Gentagelse mislykkedes til palle {0} Error# w0022. Kun {1} af {2} pallesedler blev printet. Vil du prøve at udskrive manglende palleseddel igen?",
                quantityProduced: "Antal producerede (antal paller forbrugt)",
                customerCode: "Kunde nr.",
                customerDesc: "Kunde SAP No.",
                rxg_Quantity: "Antal",
                offLineMetalSSCCAway: "Denne SSCC eksisterer ikke ",
                pallets: "Paller",
                printFailedAbr: "Udskrift mislykkedes. Error# w0018",
                rxg_Defect_Added: "Status ændret ingen fejl tilføjet",
                declarationOPENITEMS: "Henvisning: Åbent emne",
                noCopiesNumeric1to10: "antal kopier skal være mellem 1 og 10",
                inBoundLitRecap: "Summary of the label creation. Label(s) Created and Printed : ",
                inBoundLitPrint: "Print",
                inBoundLitTrans: "Transaction",
                inBoundLitTitre: "Inbound Label",
                workCenter: "Linie",
                blockFailedWithError: "Spærring mislykkedes med fejlmelding:",
                baseLineNotRecognised: "Line not Recognised.",
                inBoundTransactionQuantity: "Qty.",
                rxg_Scrap_Pallet: "Slet palle",
                changesNotSaved: "Ændringer vil ikke blive gemt.",
                quantityConsumed: "Forbrugt antal",
                defects: "Fejlkode",
                showRawMaterial: "Vis råvarer ",
                areYouSureDelete1: "Vil du virkelig slette denne palle?",
                inBoundBtnOk: "Ok",
                scrapWarehouse: "Scrap Warehouse",
                cuttedSheetsScrapped: "Stanset ark slettet",
                blockResort: "Spærret for omsortering",
                rxg_defectsTable_Comment: "Kommentar",
                mouldNotParsed: "Problem parsing mould numbers",
                inBoundDateExpiryDate: "Expiry Date",
                areyousureyouwishtoassignworkorder01toline3: "Vil du virkelig tildele produktionsordre {0}({1}-{2})  linie {3}",
                byProductDuplicate: "Du kan ikke anvende produkt , som er det samme som hovedmatrialet eller have 2 ens matrialer.  ",
                couldNotBlockPalletErrorX0X1: "Palle kunne ikke spærres. Error#{0}:{1}",
                chkEdit: "Ændre",
                initials: "Initialer",
                rxg_Defects_Added: "Fejl tilføjet",
                rxg_Could_not_assign__0__to__1___Error___2___3_: "Kunne ikke tildele ordre {0} til linie {1}, Error#:{2}-{3}",
                dicoJsPalletquantity2: "Med dette antal er størrere end det antal som er til rådighed",
                dicobtnCreatePallet: "opret ny palle",
                scanExternalTag: "Orig/Ext Tag Identifier",
                rxg_DeleteFailedWithError: "Sletning mislykkedes. Error:{0}",
                consumptionQty: "Antal",
                lblConfirmRepack: "Vil du bekræfte genpakning af det valgte materiale?",
                created: "Oprettet",
                inBoundErrorUpdate: "An Error occurred during the update. Please check the values and if it persist ask apl team.",
                btnNoReturn: "Nej, intet forbrug",
                woMButton1: "Adminstrer produktionsordre",
                printerName: "Printer navn",
                deliveryPalletLoaded: "Pallenummer læsset.",
                invalideQuantity: "Restantallet på returpallen{0} er størrere end antal på pallen error# w0026",
                x0OfX1PaletsScrappedStoppedAtErrorForSSCCX: "{0} af {1} paller slettet. Stoppet ved fejl i SSCC:{2} -{3}",
                dateRecorded: "Gemt dato",
                errorNewBatch: "An error occured preparing to insert a new Batch.",
                litModQtyMax: "Antal på hel palle",
                litModQtyMin: "Antal på delt palle",
                palStat_Default_Page_Load_Pallet_Status_Management: "Palle fejl registrering",
                popDown: "Minimer billede",
                endDate: "Slut dato",
                differentWOOnConsumptionAndLabeling2: "Aktivt ordrenummer og palleseddel er forskellig ",
                x0OfX1PaletsDeleted: "{0} af {1} paller slettet.",
                closeAndConsume: "Afslut omsortering",
                go: "Start",
                op: "Aktiver",
                wo: "PO",
                to: "Gå til",
                btnBackWo: "Tilbage",
                noPallets: "Aantal Paller",
                failedToConsumeSsccInDbX0ErrorX1: "Kunne ikke forbruge sscc i DB. {0} Error# {1}",
                areYouSureBlock1: "Vil du virkelig spærre denne palle?",
                litCustMat: "Kunde Artikel Nummer",
                dicoHtmlProdDate: "Produktions dato",
                btnCartonDeleteLastDate: "slet foregående",
                dicoHtmlRemove: "Fjern",
                dicoHtmlRepack: "Materiale valgt for ompakning :",
                quantityRemaining: "Antal tilbage",
                parentPallets: "Consumed Pallets",
                dicoJsPalletOrder: "Du kan ikke oprette ny palle inden &quot;startpallen&quot;",
                seqnumber: "Sekvensnummer",
                errorDeleteBatch: "An error occured deleting the selected Batch.",
                inBoundErrorQuantityTotal: "The total quantity must match the total in the transaction selected.",
                lblRePrintInfoInnerHtml: "Vælg printer for at udskrive igen",
                operations: "Operationer",
                labelPalletCount2: "{0}/{1}",
                couldNotIssueConsumtionX0: "Kunne ikke placere forbrug. Error# w0007: {0} ",
                btnNo: "Nej",
                day: "Dag",
                lot: "Lot",
                key: "Nøgle",
                wcl: "Linje",
                seq: "Sekvens",
                inBoundLitMat: "Material",
                empty: "Tom",
                error: "Fejl",
                inBoundLnkAdd: "Add a new Line",
                admin: "Menu for admin",
                apply: "Tilføj",
                main: "Hoved",
                batch: "Batch",
                block: "Spærre",
                btnGo: "Bekræft  ny(e) palle®",
                color: "Farve",
                close: "Afslut",
                input: "Indtastning",
                consumeScrap: "Forbrug / destrurer",
                order: "Ordre",
                btnCancel: "Annullera",
                reset: "Genstart",
                start: "Start",
                scrap: "Destruere",
                small: "Del",
                print: "Udskriv",
                goBacktoCurrentActivity: "Tilbage til igangværende aktivitet",
                titleWoMan: "Produktionsordre{0}",
                rxg_From: "Fra",
                rxg_Open: "Åbn",
                areYouSureDelete: "Vil du virkelig slette disse paller?",
                litWomMaterial: "Material",
                metalAndEnds: "Blik og låg",
                inBoundLitCouncil: "Fill text box and push search",
                couldNotDeleteConsumtionX0: "Forbrug kunne ikke slettes. Error# w0004: {0}",
                palletID: "Palle ID",
                inBoundDxColLotNumber: "Lot",
                selectAll: "Vælg alt",
                dicoCartonDetails: "&quot;låg/pap/mellemlæg&quot; beskrivelse",
                deliveryResult: "Resultat",
                username: "Bruger",
                pausePrinting: "Print på hold",
                labelName: "Palleseddels benævnelse ",
                x0OfX1PaletsApproved1: "{0} af {1} paller godkendt",
                addUser: "Tilføj ny bruger",
                printFailedWithException: "{0}.  Udskrift til palle {1} mislykkedes. Error# w0020. Vil du prøve igen?&apos;",
                btnSeachWom: "Søg produktionsordre",
                cartonQuantity: "Antal",
                nextSeqNo: "Næste palle no.",
                actions: "Handlinger",
                quantity: "Antal lag",
                missingNoDays: "You need to insert the number of days to generate the batches",
                checkSSCC: "Er du sikker på at du vil slette konsumering af ",
                inBoundTxtMatError: "The field material cannot be empty and must have at least 3 characters.",
                priorityMissing: "priority mangler",
                palletStatusEdit: "Ændring af palle-status",
                lstDefault: "Ingen",
                printJSFailed: "Print Failed.",
                inBoundDxSelectTran: "Select a Transaction",
                rxg_Failed_to_set_print_parameters_with_error___0_: "Fejl i indtastede udskriftsparametre med fejl: {0}",
                x0OfX1PaletsScrapped: "{0} af {1} paller slettet.",
                litMainByProd: "Prod. 1",
                rxg_Defect_comment_must_be_less_than_255_characters_: "Bemærkninger til fejl må kun fylde 255 tegn",
                yourAccountIsLockedPleaseContactTheHelpdes: "Din konto er låst.",
                couldNotDeleteOpenItemX0ErrorX1: "Kunne ikke slette åbent emne {0} Error# {1}",
                transactionType: "Transaktion mangler",
                couldNotUnblockPalletErrorX0X1: "Kan ikke godekende palle. Error# {0}:{1}",
                lblErrbtnConsumptionClick1: "Kunne ikke registrerer matriel.{0} : Error# {1}",
                endDateNotGood: "The value for End Date is not a correctly formatted date.  Insert Cancelled.",
                rxg_OfflinePrintHeader: "Udskriv offline",
                scanNewMaterial: "Scan nyt materiale",
                addingTwoIdenticalDefects: "Adding two identical defects (type and mould)",
                printResult: "{0} Pallseddel er sendt til printer",
                inBoundLitTransac: "Transaction Selection",
                areYouSureUnblock: "Vil du virkelig godkende disse paller?",
                rxg_Scrap_failed_with_error__: "Sletning mislykkedes med fejl:",
                inBoundErrorPalletEdition: "The current label creation is not fully updated. Update your row and after you can print.",
                closeLine: "Luk linie",
                tracDifferentDialogText:
                    "historik på batch er forskelligt fra produktionsordre. Det nye vil blive{0}. Ønsker du at fortsætte eller vi du flytte historikken til nyeste batch. ",
                areyousureyouwanttodeleteSSCCX0X: "Vil du virkelig slette SSCC :{0}?",
                quantityXPallet: "Antal på palle",
                lblConfirmOff: "Denne palle har 0 stk i antal !! Du kan ikke anvende den",
                printPallet: "Udskriv palleseddel",
                inBoundConfirmCreation: "are you sure to create those one? it ll change the transaction status to print.",
                areYouSureScrap1: "Vil du virkelig skrotte denne palle?",
                woMPallFullQty: "Hel",
                litByProduct: "Producer 1 matriale",
                closeWorksOrder: "Afslut produktionsordre",
                changeLog: "ændre log.",
                scheduledDateTime: "Planlagt start-tid",
                areYouSureApprove: "Vil du virkelig godkende produktionen af de valgte paller?",
                offlineconsumption: "OFFLINE FORBRUG",
                efficiencyoftheLine: "Effiktivitet  på linie",
                x0OfX1PaletsUnblocked1: "{0} af{1} paller godkendt.",
                dicoHtmlConfirRepack: "Bekræft ompakning",
                x0OfX1PaletsDeletedStoppedAtErrorForSSCCX2: "{0} af {1} paller slettet. Stoppet ved fejl i SSCC:{2} -{3}",
                scheduleWorkOrder: "Produktionsplanlægning",
                doYouWantToActivate: "Vil du aktivere  ny produktionsordre.?",
                ssccConsumed: "SSCC brugt",
                litCustMatDesc: "Kunde SAP No.",
                noOfCartons: "antal lag",
                printingComplete: "Udskrift gennemført",
                couldNotApprovePalletErrorX01: "Kan ikke godkende palle. Error#w00010: {0}",
                material: "Materiale",
                printScreen: "Utskriftsidan",
                inBoundDxPrintStatus: "Print Status",
                printStatus: "Udskriftskø",
                areyousureyouwanttoconsumescrapSSCC: "Vil du virkelig  forbruge og skrotte denne SSCC",
                closeReturn: "Luk og tilbage til linie",
                woAvailable: "Liste på tilgængelige produktionsordre",
                checkDatesfuture: "Fremtidig konsumering ikke tilladt.",
                dicoJsPalletquantity: "Kan ikke bruge flere end ompakningen indeholder",
                noRecFound: "No Records Found",
                rxg_Could_not_close_job__0___Error___1_: "Kunne ikke lukke/afslutte job {0}: Error# {1}",
                rxg_QiPalletsSelectedCount: "Condition of {0} Blocked QI pallet(s) won&apos;t be updated in bulk mode",
                errorUpdateBatch: "An error occured updating the selected Batch.",
                couldNotUnblockPalletErrorX01: "Kan ikke godekende palle. Error# w00010: {0}",
                litCopyNumber: "Antal kopier",
                litWomDec2: "Desc2",
                litWomDec1: "Desc1",
                btnYesReturn: "Intet tilbageført",
                btnPrintNextCarton: "Udskriv næste &quot;låg/pap/mellemlæg&quot;",
                dicoHtmlSelectMatOnHold: "Valg",
                productionOrderRunning: "Produktionsorder kørende",
                massIssue: "Mængde fejl",
                noOfPallets: "Antal af paller",
                labellingStatus: "Jobstatus Palleseddel",
                qtyProduced: "Antal producerede",
                overProdText: "Oprettelse af denne palle , er overproduktion på denne ordre , ønske du stadig at fortsætte",
                rxg_Please_select_the_pass_number_: "Vælg seneste godkendelsesnummer",
                litQuantitySchedule: "Antal Planlagt",
                article: "Artikel",
                ignoreSapUpdates: "Ignore SAP updates",
                litWait: "Vent venligst",
                litMain: "Oprindelig",
                printUsingAlternatePrinterFailed:
                    "Udskrift mislykkedes på alternativ printer, Vil du prøve igen.?      Vælg ja for alternativ printer eller nej for at bruge standard printer.",
                childPallets: "Produced Pallets",
                isActive: "Aktiv",
                lblErrbtnConsumptionClick1Exception: "Kan ikke registrerer antal. Error# {0}",
                printPartiallyFailed:
                    "Udskrift til palle {0} mislykkedes. Error# w0021. Kun {1} af {2}pallesedler blev udskrevet. Vil du prøve at udskrive manglende palleseddel igen?",
                qtyScheduled: "Antal planlagt",
                rxg_Could_not_close_job___Error___0__: "Kunne ikke afslutte job: Error# {0} ",
                consumeSSCC: "Forbrug SSCC",
                labelPalletInProgress: "Palle i gang: nuværende SSCC{0}",
                printFailed: "Udskrift mislykkedes for palle {0}. Vil du prøve igen?",
                approve: "Godkend",
                rxg_Add_Defect: "Tilføj fejl",
                requiredFields: "Manglende indtastninger vises med rød skrift*",
                cartonType: "antal pr. lag &quot;låg/pap/mellemlæg&quot;",
                printJSCancelRequest: "Cancellation Request Received.",
                litPrintHistory: "Palleseddels historik",
                printEngine: "Printer",
                partDescription: "Material – Beskrivelse",
                litCustomerGTIN: "CustomerGTIN",
                lblRePrintInfo: "Vaelg Printer",
                copySscc: "Copy SSCC",
                inboundYes: "Yes",
                labelCurrentActivityError:
                    "Fejl på nuværende job for denne linie                                  Ønske du at fortsætte med at skifte linie",
                pleaseContactHelpdesk:
                    'Please contact <a href="mailto:helpdesk@ardaghgroup.com">helpdesk@ardaghgroup.com</a> for new accounts',
                rxg_Back_to_labeling: "Tilbage til palleseddelsudskrift",
                rxg_Yes: "Ja",
                beginPrinting: "Start offline print",
                rxg_defectsTable_Initials: "Initialer",
                woMMAterialNameError: "Dette matriale eksisterer ikke",
                litLabelCreation: "Opret palleseddel",
                department: "Afdeling",
                movementDescriptionDefault: "Pallet Updated",
                onLINECONSUMPTION: "On-line forbrug",
                offlineconsumptionmetalandends: "OFFLINE FORBRUG AF BLIK OG LÅG",
                labelDefaultTitle: "Palleseddel til aktuelt job",
                failedToReturnSsccInDbX0: "Kunne ikke returnere sscc i DB. Error# w0013: {0} ",
                selectNone: "Select None",
                blockPackaging: "Spærret ompak",
                sendToSAP: "Send til SAP",
                leavingthispagewillstopprinting: "Forlades denne side afbrydes printjobbet",
                reprint: "Gentag Udskrift",
                billOfMaterials: "Materiale BOM",
                woSClosed: "Lukket",
                refresh: "opdater",
                litCustCode: "Kunde Nummer",
                litCustomer: "Kunde information",
                rxg_CouldNotDeletePallet: "Kunne ikke slette palle. Error#{0}:{1}",
                byProductDetails: "produkt detalje",
                inBoundLitWarehouse: "Warehouse",
                consumptionWorkorder: "Cons.WO",
                rxg_CouldNotDeletePallet1: "Kunne ikke slette palle. Error#:{0}",
                localServerOffline: "Local Server is Offline.",
                customerDetails: "Kunde detaljer",
                finalPass: "Sidste godkendelse",
                areyousureyouwanttoreturnSSCC: "Vil du virkelig returnere denne SSCC?",
                deliveryEmptyWorkorder: "Ingen arbejdsordre&quot;produktionsordre&quot; til denne palle ,udskrivning ikke mulig",
                rxg_Select_work_order_for_consumption: "Vælg produktionsordre til forbrug",
                printLabels: "Udskriv palleseddel",
                palSatDefaultTitle: "Palle fejl registrering",
                inBoundBtnExit: "Exit",
                failureReason: "Fejl i årsag",
                batchExists: "The value for Batch already exists on this work order. Insert Cancelled.",
                printJSCancelFailed: "Cancellation Failed",
                assignNewJob: "Tildel nyt job",
                btnYes: "Ja",
                rxg_Delete_Pallet: "Slet palle",
                ringDiameter: "Ring diameter",
                btnWoMan: "Administrera Prod. Order",
                inBoundStrCoilNr: "SU reference",
                noChangesMade: "No changes made",
                woSequenceScheduled: "Produktionsordre sekvensoversigt",
                dicoHtmlOriginalQty: "Original antal",
                inBoundErrorLabelRank: "The number of label must be a numeric",
                startDateIsLaterThanEndDate: "Start-dato er senere end slut-dato",
                inBoundDxwarehouse: "Warehouse",
                rxg_You_must_enter_a_comment_for_the_defect_s__: "Du skal indtaste bemærkning for fejlen",
                errorCommandNotRecognised: "Fejl: Kommando ikke genkendt. Error# w0011",
                extBarcode: "Ukendt eller ekstern  stregkode",
                rxg_Cannot_issue_the_material___0___error___1_: "Kan ikke tildele materialet {0}: error# {1}",
                lblFailErr: "Fejl :",
                btnYesWarn: "Ja",
                description: "Beskrivelse",
                notUpdateByERP: "Fejl er ikke opdateret af ERP",
                palletStatusId: "Status fejl",
                initQty: "Antal",
                woMPallTxtModQty: "Ændret af bruger",
                youCanOnlyHaveNumberOfPalletsIssuedConsume:
                    "You can only have {0} pallets issued. Would you like to consume the oldest issued?",
                chkError: "Vis kun fejl meddelser",
                selectDefects: "Vælg fejltype:",
                couldNotGetConsumptionPalletDetailsForJobE: "Kunne ikke finde forbrugsdetaljer for ordre. Error# w0006: {0} ",
                couldNotGetConsumptionPalletDetailsForJobX: "Kunne ikke finde forbrugsdetaljer for ordre {0}: Error# {1}",
                smallQtyNumeric: "Antal skal være heltal",
                assignedSuccessfully: "Ordre tildelt korrekt",
                consumptionCannotBeDisplayedNoWO: "Forbrug kan ikke vises. Ingen ordre valgt. Tilføj nyt job til linien. error# w0002",
                rxg_defectsTable_Defect: "Fejltype",
                material12: "FP12",
                lblOIErrorDate: "Forkert dato",
                inBoundDxColLocation: "Location",
                defectsModified: "Defects or status changed. Please refresh",
                failedToReturnSsccInDbX0ErrorX1: "Kunne ikke returnere sscc i DB. {0} Error# {1}",
                fullQtyNumeric: "Mængden skal være i heltal",
                condition: "Tilstand",
                rxg_Back_to_current_activity: "Tilbage til igangværende aktivitet",
                dayAlreadyExists: "The value for Day already exists on this work order. Insert Cancelled.",
                deliveryTextPurchaseOrder: "Kundens  indkøbsordre",
                inBoundIntLabelRank: "Nr.Of Labels",
                printJSServerOffline: "Server Offline.  ",
                deliveryTitleCustCode: "Kunde kode:",
                lblConfiramtionReturn: "Vil du godkende med 0 i antal",
                dayNotWhole: "The value for Day is not whole a number. Insert Cancelled.",
                previousBatchNr: "Tidligere .Batch Nr",
                btnYesReturn2: "Luk produktionsordre uden der er tilbageført antal",
                newPalletNumber: "Nyt pallenummer",
                rxg_Is_the_previous_SSCC___0___completely_consumed___dialog__apl00002: "Er forrige SSCC ({0}) fuldstændig brugt?",
                haveFollowingPalletsBeenFullyUsed: "Have following pallets been fully used?",
                cartonError: "Totalantal passer ikke med den valgte palle",
                oldValue: "Gammel værdi",
                deliveryTextNoteNr: "Delivery nummer.",
                component: "Materiale",
                backUpServer: "Running on back up central server.",
                palletIdentify: "Palle identifikation",
                rxg_SSCC___0___has__1__quantity_and_cannot_be_consumed__error_4123:
                    "SSCC ({0}) har {1} stk. og kan ikke forbruges error#w0023",
                byProduct1: "Produkt 1",
                byProduct2: "Produkt 2",
                byProducts: "Produkt",
                areYouSureBlock: "Vil du virkelig spærre disse paller?",
                couldNotDeleteOpenItemX0: "Kunne ikke slette åbent emne: Error# w0005: {0}",
                areYouSureScrap: "Vil du virkelig skrotte disse paller?",
                preventERPUpdate: "Stop opdatering fra ERP (SAPeller BPCS)",
                hotKeyInfo: "Press {0} to print.",
                hotKeyWait: "Please wait.",
                noOfPalletsProduced: "antal paller produceret på produktionsordre",
                inLineJob: "Inline Job",
                rxg_Label_parameters: "Palleseddelsopsætning",
                localServerOnline: "Local server is online.",
                dicoHtmlScanSSCC: "Scan ny SSCC :",
                dicoHtmlRepackNew: "Dato for ompakning af ny palle",
                statusHistory: "Statusoversigt",
                rxg__0__assigned_to__1_: "{0} tildelt {1}",
                inBoundBtnReset: "Reset Date",
                fullQtyGreaterThanSmall: "Mængde skal være større eller lig med mindste mængde",
                inBoundDxColunit: "Unit",
                couldNotBlockPalletErrorX0: "Palle kunne ikke spærres. Error# w0003: {0}",
                inBoundDxComment: "Delivery Note",
                name: "Værdi",
                edit: "Ændring ",
                exit: "Forlad",
                full: "Fuld",
                date: "Dato",
                desc: "Desc",
                back: "Tilbage",
                item: "Matriale ",
                next: "Næste",
                okay: "OK",
                oops: "Der opstod en uventet fejl. Vi undskylder for ulejligheden. Vi har registreret fejlen. Hvis fejlen fortsætter, kontakt da HELPDESK. Error# w0016",
                open: "Åben",
                line: "Linie",
                unit: "Enhed",
                time: "Tid",
                rank: "Palle Nr",
                stop: "Stop",
                save: "Gem",
                sscc: "SSCC",
                pass: "Godkendt",
                bpNoOfCopies: "antal af kopier",
                dicoHtmlRepackProgress: "ompaknings i gang :",
                litWoOpeByProd2: "Produktionsordre",
                custCrossRef: "Customer Cross Ref",
                rxg_No: "Nej",
                cartonProdResume: "Genoptag",
                consumptionStatus: "Jobstatus Omsortering",
                couldNotApprovePalletErrorX0X1: "Kan ikke godkende palle. Error#{0}:{1}",
                inBoundsearch: "Search",
                success: "Gennemført",
                dicoHtmlAddPallet: "Tilføj ny palle ",
                printDate: "Print Date",
                printDown: "System.Drawing.Bitmap",
                barcode: "Barcode",
                addMultipleBatches: "Add Multiple Batches",
                previous: "Forutgående",
                batchManagement: "Batch Management",
                noDays: "No Days",
                layers: "Layers",
                palletWeight: "Pallet Weight",
                articleWeight: "Article Weight",
                interlayer: "Interlayer",
                pallet: "Pallet",
                carton: "Carton",
                printUp: "System.Drawing.Bitmap",
                startDate: "Start Date",
                customerGTIN: "CustomerGTIN",
                dateScheduleFuture: "You are going to assign a job scheduled for a future date.",
                addBatchLot: "Add Batch/Lot",
                massActivities: "Mass Activities",
                litQuantityXPallet: "Pallet Qty",
                searchWorksOrder: "Search Works Order",
                rxg_defectsTable_Found: "",
                billOfBatches: "Bill Of Batches",
                selectPage: "Select Page",
                testPrint: "Test Print",
                mvtDesc: "Movement description",
                mvtDate: "Movement date",
                workorderAssignedPrinting: "Workorder was assigned for Label printing. Switch to activity?",
                workorderAssignedConsumption: "Workorder was assigned for consumption. Switch to activity?",
                jobIn: "Job In",
                statusChangeNotAllowed: "Status change not allowed",
                deselect: "Deselect",
                resetView: "Reset View",
                searchForDelivery: "Søg forsendelse",
                deliveryNoteMerck: "Følgeseddel",
                dropLocation: "Leveringssted",
                deliveryNoteWrong: "Ingen data fundet for den valgte følgseddel",
                deliveryPalletListEmpty: "Ingen paller fundet (vær opmærksom på at data fra SAP kan tage op til 6 minutter)",
                dropLocationEmpty1: "Vælg leveringssted",
                dropLocationEmpty2: "Vælg leveringssted",
                dropLocationTooltip: "Angiv kundens ønskede leveringssted på følgesedlen",
                deliveryNoteEmpty: "Angiv følgseddelsnummer",
                deliveryNoteTooltip: "Angiv et validt følgseddelsnummer du kan finde det på leveringsdokumentet fra SAP",
                containerVolume: "Volumen",
                youCanOnlyHaveNumberOfPalletsIssued: "You can only have {0} pallets issued",
                lineIn: "Line In",
                partPallet: "Part Pallet",
                manualEntry: "Manual Entry",
                consumed: "Consumed",
                issued: "Issued"
            }
        }
    },
    "de-DE": {
        translation: {
            main: {
                palletConditionId00: "Info",
                palletConditionId01: "Produziert – nicht im lager",
                palletConditionId02: "Im lager",
                palletConditionId03: "Sortiert",
                palletConditionId04: "Ausgewählt",
                palletConditionId05: "Geliefert",
                palletConditionId06: "Verschrottet",
                palletConditionId07: "Einlagern via Einlagerungsi",
                palletConditionId08: "Verschwunden",
                palletConditionId09: "Gelöscht",
                palletConditionId10: "Transfer ins Lager",
                palletConditionId11: "Zwischenlage",
                palletConditionId12: "Quality Inspection",
                palletConditionId13: "Blocked Resort",
                palletConditionId94: "Allocated for Delivery",
                palletConditionId99: "Etikett gedruckt",
                palletStatusId00: "Label Printing",
                palletStatusId01: "Label Printed",
                palletStatusId02: "Label Printed_NIU",
                palletStatusId03: "Cus. Incubation",
                palletStatusId04: "Good",
                palletStatusId05: "Blocked",
                palletStatusId06: "Resorted",
                palletStatusId07: "Scrap",
                palletStatusId08: "Test Pallet",
                palletStatusId09: "Customer Return",
                palletStatusId10: "Blocked QI",
                palletStatusId11: "Saleable restricted",
                palletStatusId12: "Blocked Packaging",
                palletStatusId13: "Issued",
                palletStatusId14: "Consumed",
                palletStatusId15: "Returned",
                palletStatusId16: "Stock Received",
                palletStatusId17: "Good",
                palletStatusId18: "Deleted",
                palletStatusId19: "Repacking",
                palletStatusId20: "Loaded",
                palletStatusId21: "Shipped",
                palletStatusId22: "Scrap Warehouse",
                palletStatusId30: "PreBilled",
                palletStatusId90: "WIP",
                offlineCons: "Offline Verbrauch",
                openedWO: "Opened GPOs",
                litEANGTAN: "EAN/Gtin",
                noWorkOrderOnLabelingAndOneRunningOnConsum: "Kein Auftrag für Etikettierung, aber für Verbrauch. Error# w0015:",
                deliveryTextPurchaseOrderLine: "Bestellposition",
                woSSuspended: "Suspended",
                passFirst: "Select Pass Number",
                woMPallQty: "Quantity X Pallet",
                rxg_Label_paramters_save_successfully_: "Etikettierungsparameter erfolgreich gesichert",
                rxg_Please_enter_the_quantity_remaining_on_the_previous_pallet__input__APL00031:
                    "Bitte Restmenge der Vorpalette eingeben. input# APL00001",
                lblFailSSCC: "Die Lagereinheit {0} existiert nicht",
                string1: "",
                lblErrOI: "Return Quantity must be greater than 0! error# w0026",
                x0OfX1PaletsBlocked: "{0} von {1} Palette gesperrt",
                chkInPRogresse: "NUR ausstehende Druckanforderungen holen",
                inBoundDxDescription1: "Decription",
                popMaxcatonLimit: "the total number of carton can not exceed",
                printJSSequenceNumber: "Next Seq No.",
                litUserUpdate: "Changed by operator",
                inValidWorkOrderId: "ungültiger Fertigungsauftrag/Fertigungslinie !! Bitte Datenbank / Stammdaten prüfen",
                scrapped: "Schrott",
                rxg_Could_not_assign__0__to__1__Error____2_: "Konnte nicht zuordnen {0} to {1} Error#: {2}",
                emptyRowDelivery: "Keine Daten mit den Parametern gefunden!",
                rxg_Please_select_a_defect: "Bitte einen Sachmangel auswählen",
                cartonCreateLastDate: "Last Production Date",
                offlinePrint: "Offline Drucken",
                noWorkOrderOnConsumptionAndOneRunningForLa: "Kein Auftrag für den Verbrauch aber einen für Etikettieren. Error# w0014:  ",
                litCartonLabel: "Carton Label",
                batchNr: "Batch Nr",
                printSuccessful: "Druck erfolgreich",
                litNameCust: "Name",
                womTitle: "Workorder Management",
                mouldNo: "Moulds",
                noDefectIdSelected: "Blank DefectId selected",
                differentWOOnConsumptionAndLabeling: "Unterschiedlicher SO für Verbrauch und Etikettierung. Error# w0010 ",
                operation: "Funktion",
                btnUpdateWoM: "Update",
                lotNotWhole: "The value for Lot is not whole a number.  Insert Cancelled.",
                unableToAddOpenItemToLineX0X1ErrorX2: "Nicht möglich offenes Item der Zeile hinzuzufügen {0} {1} error#: {2}",
                batchStart: "Batch Start",
                lblErrbtnConsumeClick: "Wrong date. You can t consume pallet in the future. Change the date please!",
                labelImSwitchQty: "Switch Quantity between full and Small",
                conditionID: "ConditionID",
                toolTipchkRaw: "Press update button to apply your filter(s)",
                offlinePrintingFailedException:
                    "The printer is not ready, printing has been paused, please select a new printer and press BEGIN PRINTING to continue.Restart printing using the selected printer from the drop down.",
                palletStatusDialogText: "The pallet you are going to issue is blocked. Do you want to continue anyway?",
                inBoundDxMaterialCode: "Material Code",
                consumptionNbPallet: "Nb Pallet",
                palletsQty: "Paletten (QTY)",
                palletRank: "Paletten Reihenfolge",
                inBoundDxTransactionDate: "Date",
                cannotConsumeInTheFuture: "Kann in Zukunft nicht verbraucht werden. error# w0001 ",
                palletDetail: "Paletten Detail",
                linePrintAll: "Print all Labels",
                deliveryNote: "Delivery Note",
                btnCartonDeleteConfirmation: "Are you sure you want to delete this carton ?",
                inBoundLitLabelName: "Label Type : ",
                printResultSuccess: "{0} copy(s) of Sequence {1} sent to printer {2} at {3}.",
                scheduledOrders: "Scheduled GPOs",
                dicoJsPalletDate: "Palettenlabel  erstellen in der Zukunft nicht möglich",
                openItems: "Offene Items",
                actQty: "IST-St",
                rxg_SSCC___0___was_not_found___error__00001: "SSCC ({0}) nicht gefunden. error#:#w0024",
                chkDetails: "Druckinformationen",
                lotExists: "The value for Lot already exists on this work order. Insert Cancelled.",
                assign: "Zuordnen",
                dicoRepackSummary: "Ergebnisse zum Umpackvorgang",
                cartonDeleteLastDate: "Delete Last one",
                labellingPrintingComplete: "Printing Complete",
                inBoundErrorQtyLabel: "The QtyxLAbel must be a numeric.",
                noDefectsPassed: "At least one defect required for blocking",
                woMPallTxtFullQty: "Standard",
                palletsProduced: "pallets prod.",
                dicoHtmlSelectMat: "Material auswählen ",
                goBack: "Zurück",
                btnDeleteLastOne: "Delete last carton",
                litMessWarn:
                    "The quantity on the pallet exceed the max quantity schedule on work order. Do you want to change the current quantity on the pallet?",
                dateIn: "Eingangsdatum ",
                delete: "Löschen",
                detail: "Details",
                deleteConsumption: "Verbrauch löschen",
                lotNumber: "Lot",
                inBoundTotalLabelCreation: "Total",
                inBoundTxtTanDateError: "A valid Date is required",
                rxg_No_Department_specified__Error__w0007: "Keine Abteilung benannt. Error# w0025 ",
                checkDateslater: "Start date is later than end date",
                dicoHtmlQuantityUsed: "Verwendete Menge : ",
                consumptionCurrentActivity: "Verbrauch des aktuellen Auftrages",
                inputLine: "Input Line",
                inBoundErrorReceiptDate: "The Expiry Date must be a valide date and time.",
                txtQuantityErr: "Invalide quantity",
                consumptionParameters: "Verbrauchsparameter",
                btnPrintPalletAndClose: "Print Pallet Label and Close it",
                failedToConsumeSsccInDbX0: "Verbrauch von SSCC in DB fehlgeschlagen. Error# w0012:  {0} ",
                inBoundIntQtyLabel: "Qty x Label",
                rxg_Could_not_assign_Work_Order___Error___0_: "Konnte Auftrag nicht zuordnen. Error#: {0}",
                blockQi: "Qualitätsüberprüfung",
                blocked: "Isoliert",
                unableToAddOpenItemToLineX0ErrorX1: "Nicht möglich offenes Item der Zeile hinzuzufügen {0} error#: {1}",
                noOfSheets: "Tafeln",
                cancel: "Schließen",
                pickingLblNumCopy: "Number of Copy :",
                workOrder: "Auftragsnum",
                wantToUseAlternatePrinter: "Der ausgewählte Drucker ist nicht bereit!! Möchten sie einen Ersatzdrucker auswählen ?",
                x0OfX1PaletsApprovedStoppedAtErrorForPalletX21: "{0} of {1} pallets Approved. Stopped at error for PalletId:{2} -{3}",
                inBoundBtnConfirm: "Confirm",
                inboundNo: "No",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheck:
                    "SSCC {0} noch auf den folgenden Zeilen offen. Bitte die Zeilen prüfen, die sie schließen wollen.",
                inLine: "In Line",
                inBoundTxtwareError: "The field warhouse cannot be empty and cannot have more than 2 characters",
                lblErrbtnConsumeClickMissing: "Could not find SSCC. error# W0006",
                rxg_PrintDefect: "Print Defect",
                workOrderOp: "Auftragsnummer/ OPE",
                batchNotWhole: "The value for Batch is not whole a number.  Insert Cancelled.",
                inBoundBtnCancel: "Cancel",
                inBoundBtnCancel2: "Finish",
                noData: "Es gibt keine Daten für diese Linie",
                changeCloseJob: "Auftrag beenden/wechseln",
                inValidUser: "ungültiger Benutzer! Bitte neue  Anmeldung versuchen",
                inValidTime: "ungültige Uhrzeit ! Bitte korrekte Uhrzeit eingeben (hh:mm)",
                woSPlanned: "Planned",
                inValidDate: "ungültiges Datum ! Bitte korrektes Datum eingeben",
                inBoundErrorDate: "the date is not Correct",
                palletCreated: "Palette {0} ({1}) erfolgreich erstellt ",
                x0OfX1PaletsUnblockedStoppedAtErrorForPalletX21:
                    "(0) of (1) Paletten entsperrt. Abbruch wegen Fehler bei PalettenID:(2)-(3)",
                inBoundDxColSeqNumber: "Seq",
                litPalLabel4: "Pallet Label 4",
                litPalLabel3: "Pallet Label 3",
                litWoS: "Current work order status : ",
                printAbort: "Druck für Rang {0} fehlgeschlagen. Server antwortet nicht. Error# w0017.",
                labels: "Etiketten",
                logout: "Ausloggen",
                length: "Lange",
                btnYesReturnDetail: "I close this \\n because i return 0 in quantity",
                finalPalletRank: "Letzte Palette beim Offline Druck",
                update: "Update",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheckReturn:
                    "SSCC {0} is open on the following line(s). Please check lines you wish to return.",
                printfailedselectanotherprinter:
                    "Druck fehlgeschlagen, einen anderen Drucker wählen oder nochmals versuchen. Error# w0019 ",
                batchLot: "Batch\\Lot",
                batchEnd: "Batch End",
                prodDate: "Prod.Datum",
                litAllInOne: "all in one shot",
                couldNotScrapPalletErrorX0X1: "Verschrotten nicht möglich: Error#{0}:{1}",
                lblDefaultSetting: "Quantity for Carton {0}",
                rxg_Labeling_Pass_Number: "",
                lblErrbtnConsumptionClick1Else: "Could not consume SSCC invalid quantity. error# W0008.",
                btnBack: "Abschließen",
                dicoHtmlSapcode: "SAP Materialnummer",
                cartonSumQty: "Number of Carton",
                rxg_Unable_to_consume_pallet__0____1__Error____2__: "Palettenverbrauch nicht erfassbar {0}: {1} error#: {2} ",
                dicoTotalQuantity: "Total Quantity",
                printMod: "Print Mod",
                thisMethodRequiresAConfirmationAndNoneIsDe: "Diese Methode erfordert eine Bestätigung, aber es ist keine definiert.",
                litTitre: "Inbound Label",
                litWoOpe: "Work Order Operation",
                litWoMan: "Work order information",
                noWorkorder: "Kein Auftrag",
                thereIsNoWorkOrderConfiguredForThisLine: "Kein Auftrag für diese Zeile definiert",
                dicoHtmlRepackResult: "Zusammenfassung Umpackvorgang",
                woMPallMinQty: "Small",
                inBoundLitTranDate: "Tansaction Date",
                quality: "Quality",
                allPallets: "All pallets",
                pleaseSelectaPrinter: "Bitte Drucker wählen, um ein neues Etikett zu drucken?",
                rxg_ThereIsNoWorksOrderAssignedForThisLine: "Dieser Zeile ist kein Auftrag zugewiesen",
                palletStatus: "Paletten Status",
                cuttedSheetsBlocked: "gesperrte geschnittene Tafeln",
                litByProduct2: "ByProduct 2 Material",
                tracDialogText: "Traceability batch is missing. Do you want to continue anyway?",
                sqlTranslation: "SQL translation",
                rxg_Back_to_offline_consumption: "Zurück zur offline Verbrauch",
                woSInUse: "In use (On line)",
                rxg_Open_SSCC__0__on_the_following_line_s__: "SSCC {0} auf folgenden/r Linie offen",
                thislinehasajobassignedClosethejob: "Diese Zeile hat einen Auftrag zugewiesen. Auftrag schließen?",
                rxg_Work_Order_Enquiry: "Arbeitsauftrag Prüfung",
                litQtyReq: "Quantity Requested",
                dicoHtmlMaterial: "Material",
                timeIn: "Anfangszeit",
                startDateNotGood: "The value for Start Date is not a correctly formatted date.  Insert Cancelled.",
                labelPalletCount: "Number of Pallet Procuced :&lt;br/&gt; &lt;b&gt;{0}&lt;/b&gt;",
                numberOfCopies: "Anzahl der Etikettenkopien",
                inBoundLitDescription: "Description",
                ckBoxCartonSave: "Mit Karton",
                palletsScheduled: "pallets sched.",
                return: "Rückgabe",
                inBoundStrVendorBatch: "Vendor Batch",
                inBoundErrorNbrPallet: "The field Nbr*OF LAbel must be a numeric greater than 0",
                scrapProduction: "Scrap Production",
                mouldAndNonMouldSameDefectId: "Unable to add mould and non-mould related with the same defect ID",
                overProdHeader: "Overproduction",
                btnUnderstoodBack: "Tilbage",
                defaultActivityLabeling: "Etiketten",
                status: "Status",
                palSatEditSelectPrinter: "Select printer to reprint to?",
                inBoundLitInfosTrans: "Blank = All,or OO,U,UC, UT, UR, RT ",
                search: "Suche",
                select: "Auswählen",
                timeEnd: "Zeit Ende",
                prompt: "Eingabeaufforderung",
                addDefect: "Mangel hinzufügen",
                couldNotLoadWorkOrderPleaseCheckTheOrderCo:
                    "Auftrag konnte nicht gezogen werden. Bitte Auftragsnr prüfen und nochmal versuchen. error# w0008",
                pieces: "Pcs",
                couldNotIssueConsumtionX0ErrorX1: "Verbrauch konnte nicht gebucht werden.{0} Error# {1}",
                startingPalletRank: "Start Palettenreihenfolge",
                movementDescription11: "Label Printed - Pallet Produced",
                movementDescription10: "Return Pallet off line",
                movementDescription13: "Change pallet status from SAP",
                movementDescription12: "Label Printed - Pallet Produced (offline)",
                movementDescription15: "Block pallet QI",
                movementDescription14: "Change pallet Birth Date/Condition in APL from PLC ",
                movementDescription17: "Scrap pallet",
                movementDescription16: "Release pallet",
                movementDescription19: "User connection",
                movementDescription18: "Delete/Cancel pallet",
                movementDescription01: "Start WorkOrder Front End Line",
                movementDescription02: "Stop Workorder Front End line",
                movementDescription03: "Start Workorder Back End Line",
                movementDescription04: "Stop Workorder Back End line",
                movementDescription05: "Issue Pallet on line ",
                movementDescription06: "Consumed Pallet on line ",
                movementDescription07: "Return Pallet on line",
                movementDescription08: "Delete Consumption",
                movementDescription09: "Consumed Pallet off line ",
                movementDescription33: "Block pallet for Scrap",
                movementDescription32: "Pallet quantity change",
                movementDescription35: "Scrap in Warehouse",
                movementDescription34: "Block Pallet for Packaging",
                movementDescription22: "Open Item Return ",
                movementDescription23: "Block pallet for resorting",
                movementDescription20: "Open Item Issuing",
                movementDescription21: "Open Item Consumption",
                movementDescription26: "Remove defect on a pallet",
                movementDescription27: "Defect found",
                movementDescription24: "Open Item delete",
                movementDescription25: "Add Defects to Pallet",
                movementDescription28: "Defect not found",
                movementDescription55: "SU defect removed from SAP",
                movementDescription54: "SU defect added from SAP",
                movementDescription51: "SU Updated from SAP",
                movementDescription50: "SU Created from SAP",
                movementDescription53: "SU condition Updated from SAP",
                movementDescription52: "SU status Updated from SAP",
                movementDescription44: "Approve Pallet",
                movementDescription40: "Pallet Scanned for Repack",
                movementDescription41: "Remove Pallet from Repack",
                movementDescription42: "Pallet Splitting",
                movementDescription43: "Create pallet from other",
                movementDescription60: "Pallet Locked",
                movementDescription61: "Pallet Unlocked",
                movementDescription99: "SU Imported for Go Live",
                inBoundErrorQuantity: "The field Label*Qty must be a numeric greater than 0",
                couldNotDeleteConsumtionX0ErrorX1: "Verbrauch konnte nicht gelöscht werden: Error# {1} ",
                rxg_Consumption: "Verbrauch",
                toolTipEnter: "Press Enter to apply your filter(s)",
                inBoundErrorAmount: "Error in the total amount. Please check the values and correct them",
                litSearch: "Search a new Workorder",
                currentPalletRank: "Aktuelle Paletten Nummer",
                rxg__0__units_returned_on_SSCC__1___When_all_pallets_are_consumed_returned__click_OK_again_to_close_the_job__dialog_w0005:
                    "{0}Einheiten an  SSCC zurück gemeldet {1}. Wenn alle Paletten verbraucht/ zurück sind, Okay klicken um das Fenster zu schließen. dialog#w0001",
                passNumber: "Anzahl Durchgänge",
                printer: "Drucker",
                bpQuantity: "Menge",
                unblock: "entsperren",
                deliverySelected: "ausgewählt",
                couldNotScrapPalletErrorX0: "Verschrotten nicht möglich:Error# w0009: {0}",
                quantityScrapped: "Quantity Scrapped",
                dicoHtmlLine: "Linie",
                multipleSelectionError: "Status trifft nicht für die ausgewählten Zeilen zu. Bitte Zeilen mit dem gleichen Status wählen.",
                deliveryTitle: "Drucken - JWO Lieferetiketten",
                btnCloseOff: "Aboard",
                areyousureyouwanttoclosethejob: "Sind Sie sicher die Anwendung beenden zu wollen?",
                traceabilityInfo: "Traceability Info",
                baseProduct: "Base Product",
                litPalLabel: "Pallet Label",
                rxg_You_must_enter_your_initials_to_add_a_defect: "Bitte die eigenen Initialen zu dem Sachmangel hinzufügen",
                itemClass: "Itemklasse",
                inBoundErrorPalletCreation: "Error during the pallet creation. Please chech your values.",
                inBoundConfirmDelete: "are you sure you want to delete this line?",
                currentActivity: "laufender Vorgang",
                backToCurrentActivity: "Zurück zur aktuellen Sitzung",
                confirm: "Bestätigen",
                consume: "Verbrauch",
                comment: "Kommentar",
                rxg_Select_work_order_for_labeling: "Bitte Arbeitsauftrag zum etikettieren auswählen",
                specialText: "Special Text",
                selectLines: "Zeile auswählen",
                printJSWorksOrder: "Works Order",
                palletStatusDialogHeader: "Blocked Pallet",
                backToOfflineHome: "Zurück zu Offline Home",
                consumptionPageTitle: "Consumption Declaration",
                rxg_Could_not_assign_Work_Order_Error___0____1_: "Konnte Auftrag nicht zuordnen Error#:{0}: {1}",
                noOfCoils: "N.Coils",
                x0OfX1PaletsBlockedStoppedAtErrorForSSCCX2: "{0} von {1} Palette gesperrt. Gestoppt wegen eines Fehler im SSCC:{2} -{3}",
                coilCutting: "Coil schneiden",
                popLabelErrorCartonQty: "wrong Quantity for this carton. must be greater than 0 and less than final quantity pallet",
                adminView: "Sicht für ADMIN holen",
                inBoundDxSelTranType: "Transaction Type",
                partCode: "Teilcode",
                headerTextUser: "User",
                rxg_PrintBoth: "Print Both",
                userNotRecognised: "Benutzername nicht erkannt",
                dicoHtmlWo: "Auftrag",
                mainDetails: "Übersichten",
                inBoundStrWorkOrder: "WorkOrder ref",
                rxg_BeginPrint: "Druck beginnen",
                litQuantityProd: "quantity produced",
                centralServer: "On Central Server",
                blockPallet: "Palette sperren",
                litActQty: "Actual Quantity",
                byProduct: "Nebenprodukt",
                woSApproved: "Approved",
                rxg_Title: "Offline drucken",
                synoptic: "Linien Schema",
                printSucceeded: "Druck erfolgt",
                rxg_Print: "Drucken",
                btnNoWarn: "No",
                pleaseSelectaLine: "Bitte eine Zeile auswählen",
                lblConfirmRepackCondition: " Die aktuelle Auswahl im Umpacken wird geändert",
                litsearchWomField: "Search a new Workorder",
                consumptionUnit: "Unit",
                dateEnd: "Datum Ende",
                reprintFailed:
                    "Neudruck fehlgeschlagen für Rang {0} Error# w0022. Nur {1} von {2} Etiketten wurden gedruckt. Neudruck der fehlenden Etiketten?.",
                quantityProduced: "Quantity produced(Pallet Consumed)",
                customerCode: "Kunden Code",
                customerDesc: "Kundenartikelbeschreibung",
                rxg_Quantity: "Menge",
                offLineMetalSSCCAway: "This SSCC Doesn t exist.",
                pallets: "Palette",
                printFailedAbr: "Druck fehlgeschlagen. Error# w0018",
                rxg_Defect_Added: "Schaden hinzugefügt",
                declarationOPENITEMS: "Hinweis: Offene Items",
                inBoundLitRecap: "Summary of the label creation. Label(s) Created and Printed : ",
                inBoundLitPrint: "Print",
                inBoundLitTrans: "Transaction",
                inBoundLitTitre: "Inbound Label",
                workCenter: "Arbeitsplatz",
                blockFailedWithError: "Sperren fehlgeschlagen mit Fehlermeldung",
                baseLineNotRecognised: "Line not Recognised.",
                inBoundTransactionQuantity: "Qty.",
                rxg_Scrap_Pallet: "Palette verschrotten",
                quantityConsumed: "Verbrauchte Menge",
                defects: "Schäden",
                showRawMaterial: "Rohmaterial zeigen",
                areYouSureDelete1: "Sind Sie sicher, dass sie diese Palette löschen wollen?",
                inBoundBtnOk: "Ok",
                scrapWarehouse: "Scrap Warehouse",
                cuttedSheetsScrapped: "verschrottete geschnittene Tafeln",
                blockResort: "Sperren zur Sortierung",
                rxg_defectsTable_Comment: "Comment",
                mouldNotParsed: "Problem parsing mould numbers",
                inBoundDateExpiryDate: "Expiry Date",
                areyousureyouwishtoassignworkorder01toline3:
                    "Sind Sie sicher dass sie die Aufgabe {0}({1}-{2}) der Linie {3} zuweisen wollen",
                couldNotBlockPalletErrorX0X1: "Paletten Sperrung nicht möglich:Error#{0}:{1}",
                chkEdit: "Edit",
                initials: "Initialien",
                rxg_Defects_Added: "Schaden hinzugefügt",
                rxg_Could_not_assign__0__to__1___Error___2___3_: "Konnte nicht zuordnen {0} to {1}, Error#:{2}-{3}",
                dicoJsPalletquantity2: "Mit dieser Menge wird die verfügbare Menge überschritten.",
                dicobtnCreatePallet: "Neue Palette erstellen",
                scanExternalTag: "Orig/Ext Tag Identifier",
                rxg_DeleteFailedWithError: "Löschung abgebrochen wegen Error#:(0)",
                consumptionQty: "Quantity",
                lblConfirmRepack: "Möchten Sie das Umpacken des ausgewählten Materials bestätigen?",
                created: "erstellt",
                inBoundErrorUpdate: "An Error occurred during the update. Please check the values and if it persist ask apl team.",
                btnNoReturn: "No i don&apos;t consume anything",
                woMButton1: "Manage this work order",
                printerName: "Drucker",
                deliveryPalletLoaded: "Anzahl der geladenen Paletten",
                invalideQuantity: "The return quantity set for the return pallet {0} is higher than remaining quantity error# w0026",
                x0OfX1PaletsScrappedStoppedAtErrorForSSCCX: "{0} von {1} Palette verschrottet. Gestoppt wegen eines SSCC Fehler:{2} -{3}",
                errorNewBatch: "An error occured preparing to insert a new Batch.",
                litModQtyMax: "Quantity for a full pallet",
                litModQtyMin: "Quantity for small pallet",
                palStat_Default_Page_Load_Pallet_Status_Management: "Pallet Status Management",
                popDown: "Fenster minimieren",
                endDate: "Enddatum",
                differentWOOnConsumptionAndLabeling2: "Active GPO in Labeling is different from Consumption one!",
                x0OfX1PaletsDeleted: "{0} von {1} Palette gelöscht",
                closeAndConsume: "Stop Consumption",
                go: "Los",
                op: "Op",
                wo: "WO",
                to: "Gehe zu",
                btnBackWo: "Bouton Back",
                noPallets: "Paletten Nr",
                failedToConsumeSsccInDbX0ErrorX1: "Verbrauch von SSCC in DB fehlgeschlagen. {0} Error# {1}",
                areYouSureBlock1: "Wollen Sie diese Palette sperren?",
                litCustMat: "Customer material",
                dicoHtmlProdDate: "Produktionsdatum",
                btnCartonDeleteLastDate: "Delete Last one",
                dicoHtmlRemove: "Entfernen",
                dicoHtmlRepack: "Materialauswahl zum Umpacken",
                quantityRemaining: "Verbleibende Menge",
                parentPallets: "Consumed Pallets",
                dicoJsPalletOrder: "Palettenlabel  erstellen  vor der Basispalette nicht möglich",
                seqnumber: "Seqnumber",
                errorDeleteBatch: "An error occured deleting the selected Batch.",
                inBoundErrorQuantityTotal: "The total quantity must match the total in the transaction selected.",
                lblRePrintInfoInnerHtml: "Select printer to reprint to?",
                labelPalletCount2: "{0}/{1}",
                couldNotIssueConsumtionX0: "Verbraucht konnte nicht gebucht werden. Error# w0007: {0} ",
                btnNo: "Nein",
                day: "Day",
                lot: "Lot",
                wcl: "WC/L",
                seq: "Seq",
                inBoundLitMat: "Material",
                empty: "Leer",
                error: "Fehler",
                inBoundLnkAdd: "Add a new Line",
                admin: "Menu Admin Bereich",
                apply: "Ausführen",
                batch: "Batch",
                block: "Blocken",
                btnGo: "Neue Palette/n erstellen.Bestätigen",
                color: "Color",
                close: "Beenden",
                input: "Eingabe",
                consumeScrap: "Consume\\Scrap",
                order: "Bestellung",
                btnCancel: "Stornieren",
                start: "Starten",
                scrap: "Verschrotten",
                print: "Drucken",
                goBacktoCurrentActivity: "Zurück zur aktuellen Sitzung",
                titleWoMan: "Work order {0}",
                rxg_From: "Von",
                rxg_Open: "Öffnen",
                areYouSureDelete: "Sind Sie sicher, dass sie diese Paletten löschen wollen?",
                litWomMaterial: "Material",
                metalAndEnds: "Blech und Stanzteile",
                inBoundLitCouncil: "Fill text box and push search",
                couldNotDeleteConsumtionX0: "Verbrauch konnte nicht gelöscht werden: Error# w0004: {0} ",
                palletID: "Palettenidentifikationsnummer",
                inBoundDxColLotNumber: "Lot",
                selectAll: "Alles auswählen",
                dicoCartonDetails: "Carton Details",
                deliveryResult: "Ergebnis",
                pausePrinting: "Druck anhalten",
                labelName: "Etikettenname",
                x0OfX1PaletsApproved1: "{0} of {1} pallets approved.",
                addUser: "Hinzufügen Neuer User",
                printFailedWithException: "{0}.  Druck fehlgeschlagen für Rang {1} Error# w0020.  Neudruck starten?&apos;",
                btnSeachWom: "Search Workorder",
                cartonQuantity: "Quantity",
                nextSeqNo: "Next Seq No.",
                actions: "Aktionen",
                quantity: "Menge",
                missingNoDays: "You need to insert the number of days to generate the batches",
                checkSSCC: "Are you sure you want to remove consumption for ",
                inBoundTxtMatError: "The field material cannot be empty and must have at least 3 characters.",
                palletStatusEdit: "Paletten Status ändern",
                lstDefault: "None",
                printJSFailed: "Print Failed.",
                inBoundDxSelectTran: "Select a Transaction",
                rxg_Failed_to_set_print_parameters_with_error___0_: "Printparmeter setzten fehlgeschlagen Fehler: {0}",
                x0OfX1PaletsScrapped: "{0} von {1} Palette verschrottet",
                litMainByProd: "By Prod 1",
                rxg_Defect_comment_must_be_less_than_255_characters_: "Mangel muss weniger als 255 Zeichen haben",
                yourAccountIsLockedPleaseContactTheHelpdes: "Ihr Konto ist gesperrt.",
                couldNotDeleteOpenItemX0ErrorX1: "Offenes Item konnte nicht gelöscht werden: {0} Error# {1}",
                transactionType: "Transaction Type",
                couldNotUnblockPalletErrorX0X1: "Palette kann nicht entsperrt werden. Error#(0):(1)",
                lblErrbtnConsumptionClick1: "&quot;Cannot add the material. {0} : error# {1}&quot;",
                endDateNotGood: "The value for End Date is not a correctly formatted date.  Insert Cancelled.",
                rxg_OfflinePrintHeader: "Offline drucken",
                scanNewMaterial: "Neues Material scannen",
                addingTwoIdenticalDefects: "Adding two identical defects (type and mould)",
                printResult: "{0} Label wurden zur Druckliste gesendet (siehe unten für weitere Informationen über den Status).",
                inBoundLitTransac: "Transaction Selection",
                areYouSureUnblock: "Wollen Sie wirklich entsperren ",
                rxg_Scrap_failed_with_error__: "Verschrotten fehlgeschlagen mit Fehlermeldung",
                inBoundErrorPalletEdition: "The current label creation is not fully updated. Update your row and after you can print.",
                closeLine: "Close Line(s)",
                tracDifferentDialogText:
                    "Traceability batch is different from the one in consumption. The new one would be {0}. Do you want to continue anyway? Or do you want to change the traceability info to the newest ones?",
                areyousureyouwanttodeleteSSCCX0X: "Sind Sie sicher, dass sie SSCC löschen wollen?",
                lblConfirmOff: "This pallet has 0 Qty ! you can t use it",
                inBoundConfirmCreation: "are you sure to create those one? it ll change the transaction status to print.",
                areYouSureScrap1: "Wollen Sie diese Palette verschrotten?",
                woMPallFullQty: "Full",
                litByProduct: "ByProduct 1 Material",
                closeWorksOrder: "Auftrag schließen",
                scheduledDateTime: "Ablaufplan Datum-Zeit",
                areYouSureApprove: "Are you sure you want to approve the production of the selected pallet?",
                offlineconsumption: "Offline Verbrauch",
                efficiencyoftheLine: "EFF Zur Zeit",
                x0OfX1PaletsUnblocked1: "(0) of (1) Paletten entsperrt",
                dicoHtmlConfirRepack: "Umpackvorgang bestätigen",
                x0OfX1PaletsDeletedStoppedAtErrorForSSCCX2: "{0} von {1} Palette gelöscht. Gestoppt wegen eines Fehlers im SSCC:{2} -{3}",
                scheduleWorkOrder: "GPO Scheduling",
                doYouWantToActivate: "Möchten Sie einen neuen Auftrag starten?",
                ssccConsumed: "SSCC verbraucht",
                litCustMatDesc: "Description",
                noOfCartons: "Anzahl Kartons",
                printingComplete: "Druck beendet",
                couldNotApprovePalletErrorX01: "Could Not Approve pallet. Error# w00010: {0}",
                material: "Material",
                printScreen: "Print Screen",
                inBoundDxPrintStatus: "Print Status",
                printStatus: "Drucker Status",
                areyousureyouwanttoconsumescrapSSCC: "Are you sure you want to consume and scrap SSCC",
                closeReturn: "Close and return line(s)",
                woAvailable: "List of GPOs Available",
                checkDatesfuture: "Cannot consume in the future",
                dicoJsPalletquantity: "Das Überschreiten der Menge im Umpacklager ist nicht möglich.",
                noRecFound: "No Records Found",
                rxg_Could_not_close_job__0___Error___1_: "Schließen des Jobs nicht möglich {0}: Error# {1}",
                rxg_QiPalletsSelectedCount: "Condition of {0} Blocked QI pallet(s) won&apos;t be updated in bulk mode",
                errorUpdateBatch: "An error occured updating the selected Batch.",
                couldNotUnblockPalletErrorX01: "Palette kann nicht verschrottet werden. Error# (0):(1)",
                litCopyNumber: "Number of copy",
                litWomDec2: "Desc2",
                litWomDec1: "Desc1",
                btnYesReturn: "Yes i return {0} in quantity",
                btnPrintNextCarton: "Print Next Carton",
                dicoHtmlSelectMatOnHold: "selected",
                productionOrderRunning: "Aktiver Autrag",
                noOfPallets: "No. of Pallets",
                qtyProduced: "quantity produced",
                overProdText: "Creating this pallet, you will be overproducing on this WO. Do you want to continue anyway?",
                rxg_Please_select_the_pass_number_: "Bitte Pass Nummer auswählen",
                litQuantitySchedule: "quantity schedule",
                article: "Material",
                ignoreSapUpdates: "Ignore SAP updates",
                litWait: "Please Wait",
                litMain: "Main",
                printUsingAlternatePrinterFailed:
                    "Print failed with Alternate printer too. Do you want to try printing again?                                            Click YES to print using alternate printer or click NO then press PRINT to retry the original printer.",
                childPallets: "Produced Pallets",
                lblErrbtnConsumptionClick1Exception: "Cannot add the material.  error# {0}",
                printPartiallyFailed:
                    "Druck fehlgeschlagen für Rang {0} Error# w0021. Nur {1} von {2} Etiketten gedruckt. Fehlende Etiketten drucken?",
                qtyScheduled: "quantity schedule",
                rxg_Could_not_close_job___Error___0__: "Schließen des Jobs nicht möglich Error# {0} ",
                consumeSSCC: "Verbrauch SSCC",
                labelPalletInProgress: "Pallet in progress : Current SSCC {0}",
                printFailed: "Druck fehlgeschlagen für Rang {0}. Neudruck starten?",
                approve: "Approve",
                rxg_Add_Defect: "Schaden hinzufügen",
                requiredFields: "Fehlende Eingaben werden in Rot angezeigt*",
                cartonType: "Quantity per carton",
                printJSCancelRequest: "Cancellation Request Received.",
                litPrintHistory: "Print History",
                printEngine: "Drucker",
                partDescription: "Teilbeschreibung",
                litCustomerGTIN: "CustomerGTIN",
                lblRePrintInfo: "Drucker auswählen?",
                copySscc: "Copy SSCC",
                inboundYes: "Yes",
                labelCurrentActivityError:
                    "Fehler in der aktuellen Aktivität auf dieser Linie. Weiter fortfahre oder auf eine andere Linie wechseln ?",
                pleaseContactHelpdesk:
                    'Please contact <a href="mailto:helpdesk@ardaghgroup.com">helpdesk@ardaghgroup.com</a> for new accounts',
                rxg_Back_to_labeling: "Zurück zum etikettieren",
                rxg_Yes: "Ja",
                beginPrinting: "Offline Drucken",
                rxg_defectsTable_Initials: "Initials",
                woMMAterialNameError: "this Material doesn t exist : ",
                litLabelCreation: "Label Creation",
                department: "Abteilung",
                movementDescriptionDefault: "Pallet Updated",
                onLINECONSUMPTION: "On-line Verbrauch",
                offlineconsumptionmetalandends: "Offline Verbrauch Blech und Stanzteile",
                labelDefaultTitle: "Labeling Current Activity",
                failedToReturnSsccInDbX0: "Rückgabe SSCC nach DB fehlgeschlagen. Error# w0013: {0} ",
                selectNone: "Select None",
                blockPackaging: "Block Packaging",
                sendToSAP: "an SAP senden",
                leavingthispagewillstopprinting: "Verlassen dieser Seite wird den Druck beenden",
                reprint: "Neudruck",
                woSClosed: "Closed",
                litCustCode: "Customer Code",
                litCustomer: "Customer info",
                rxg_CouldNotDeletePallet: "Paletten kann nicht gelöscht werden. Error#(0):(1)",
                byProductDetails: "Nebenprodukt Details",
                inBoundLitWarehouse: "Warehouse",
                consumptionWorkorder: "Cons.WO",
                rxg_CouldNotDeletePallet1: "Palette kann nicht gelöscht werden. Error#:(0)",
                localServerOffline: "Local Server is Offline.",
                finalPass: "Letzter Durchgang",
                areyousureyouwanttoreturnSSCC: "Sind Sie sicher, dass sie zu SSCC zurück wollen?",
                deliveryEmptyWorkorder: "kein Arbeitsauftrag für diese Palette.Sie können es nicht drucken.",
                rxg_Select_work_order_for_consumption: "Auftrag zum verbrauch auswählen",
                printLabels: "Etiketten drucken",
                palSatDefaultTitle: "Pallet Status Management",
                inBoundBtnExit: "Exit",
                failureReason: "Fehlergrund",
                batchExists: "The value for Batch already exists on this work order. Insert Cancelled.",
                printJSCancelFailed: "Cancellation Failed",
                assignNewJob: "Neuen Job starten",
                btnYes: "Ja",
                rxg_Delete_Pallet: "Paletten löschen",
                ringDiameter: "Ring Durchmesser",
                btnWoMan: "Manage Work Order",
                inBoundStrCoilNr: "SU reference",
                noChangesMade: "No changes made",
                woSequenceScheduled: "GPO Sequence Scheduled",
                dicoHtmlOriginalQty: "Ursprüngliche Menge",
                inBoundErrorLabelRank: "The number of label must be a numeric",
                startDateIsLaterThanEndDate: "Anfangsdatum ist später als Anfangsdatum",
                inBoundDxwarehouse: "Warehouse",
                rxg_You_must_enter_a_comment_for_the_defect_s__: "Bitte einen Sachmangel eintragen",
                errorCommandNotRecognised: "Fehler: Befehl nicht erkannt .Error# w0011",
                extBarcode: "External Barcode",
                rxg_Cannot_issue_the_material___0___error___1_: "Materialverbrauch nicht möglich.  {0}: error# {1}",
                lblFailErr: "Fehler",
                btnYesWarn: "Yes",
                description: "Beschreibung",
                palletStatusId: "Statusidentifikation",
                initQty: "AnfanQTY",
                woMPallTxtModQty: "Changed by Operator",
                youCanOnlyHaveNumberOfPalletsIssuedConsume:
                    "You can only have {0} pallets issued. Would you like to consume the oldest issued?",
                chkError: "NUR Fehlermeldungen holen",
                selectDefects: "Schadenstyp auswählen",
                couldNotGetConsumptionPalletDetailsForJobE: "Verbrauchsdetails für Auftrag nicht möglich Error# w0006: {0} ",
                couldNotGetConsumptionPalletDetailsForJobX: "Verbrauchsdetails für Auftrag nicht möglich {0}: Error# {1}",
                assignedSuccessfully: "Erfolgreich zugeordnet",
                consumptionCannotBeDisplayedNoWO:
                    "Verbrauch kann nicht angezeigt werden. Kein Auftrag ausgewählt. Bitte einen Auftrag in der Zeile eingeben. error# w0002",
                rxg_defectsTable_Defect: "Defect",
                material12: "FP12",
                lblOIErrorDate: "wrong date!",
                inBoundDxColLocation: "Location",
                defectsModified: "Defects or status changed. Please refresh",
                failedToReturnSsccInDbX0ErrorX1: "Rückgabe SSCC nach DB fehlgeschlagen. {0} Error# {1}",
                condition: "",
                rxg_Back_to_current_activity: "Zurück zur aktuellen Aktivität",
                dayAlreadyExists: "The value for Day already exists on this work order. Insert Cancelled.",
                deliveryTextPurchaseOrder: "Kunden Bestellnummer",
                inBoundIntLabelRank: "Nr.Of Labels",
                printJSServerOffline: "Server Offline.  ",
                deliveryTitleCustCode: "Kundenartikelnummer:",
                lblConfiramtionReturn: "Do you confirm your Return 0 quantity?",
                dayNotWhole: "The value for Day is not whole a number. Insert Cancelled.",
                previousBatchNr: "Prev.Batch Nr",
                btnYesReturn2: "I close the work order\\n because i return 0 in quantity",
                newPalletNumber: "New Pallet Number",
                rxg_Is_the_previous_SSCC___0___completely_consumed___dialog__apl00002: "Wurde vorherige SSCC ({0}) komplett verbraucht?",
                haveFollowingPalletsBeenFullyUsed: "Have following pallets been fully used?",
                cartonError: "Gesamtmenge entspricht nicht der Menge der ausgewählten Palette",
                deliveryTextNoteNr: "Lieferschein-Nr.",
                component: "Bestandteil",
                backUpServer: "Running on back up central server.",
                palletIdentify: "Paletten-ID-Nummer",
                rxg_SSCC___0___has__1__quantity_and_cannot_be_consumed__error_4123:
                    "SSCC ({0}) hat Menge  {1} und kann nicht verbraucht werden. error#w0023",
                areYouSureBlock: "Wollen Sie diese Paletten sperren?",
                couldNotDeleteOpenItemX0: "Offenes Item konnte nicht gelöscht werden: Error# w0005: {0} ",
                areYouSureScrap: "Wollen Sie diese Paletten verschrotten?",
                hotKeyInfo: "Press {0} to print.",
                hotKeyWait: "Please wait.",
                noOfPalletsProduced: "Palleten",
                inLineJob: "Inline Job",
                rxg_Label_parameters: "Etikettierungsparameter",
                localServerOnline: "Local server is online.",
                dicoHtmlScanSSCC: "Neue Lagereinheit scannen :",
                dicoHtmlRepackNew: "Erstellungsdatum der neuen Palette",
                statusHistory: "Status Übersicht",
                rxg__0__assigned_to__1_: "{0}zugewiesen zu {1}",
                inBoundBtnReset: "Reset Date",
                inBoundDxColunit: "Unit",
                couldNotBlockPalletErrorX0: "Paletten Sperrung nicht möglich:Error# w0003: {0}",
                inBoundDxComment: "Delivery Note",
                name: "value",
                edit: "Editieren",
                exit: "Exit",
                date: "Datum",
                back: "Zurück",
                item: "Item",
                next: "Weiter",
                okay: "Okay",
                oops: "Ein unerwarteter Fehler ist aufgetreten, dafür entschuldigen für uns. Der Fehler wurde erfasst, wenn er fortbesteht, bitte an den Helpdesk wenden. Error# w0016",
                line: "Linie",
                unit: "Einheit",
                time: "Zeit",
                rank: "Reihenfolge",
                stop: "Stopp",
                save: "Sichern",
                sscc: "SSCC",
                pass: "Durchgang",
                bpNoOfCopies: "Anzahl Kopien",
                dicoHtmlRepackProgress: "Das umzupackende Material ist in Bearbeitung :",
                litWoOpeByProd2: "By Prod 2",
                custCrossRef: "Customer Cross Ref",
                rxg_No: "Nein",
                couldNotApprovePalletErrorX0X1: "Could Not Approve pallet. Error#{0}:{1}",
                inBoundsearch: "Search",
                success: "Erfolgt",
                dicoHtmlAddPallet: "Fügen Sie eine neue Palette die erstellt werden soll",
                operator: "Operator",
                batchMissing: "Batch Missing",
                printDate: "Print Date",
                printDown: "System.Drawing.Bitmap",
                barcode: "Barcode",
                deleteLastOne: "Delete Last One",
                addMultipleBatches: "Add Multiple Batches",
                newValue: "New Value",
                previous: "Previous",
                batchManagement: "Batch Management",
                columnName: "Column Name",
                insert: "Insert",
                noDays: "No Days",
                layers: "Layers",
                priority: "Priority",
                qtyReq: "Qty Req.",
                standard: "Standard",
                tableName: "Table Name",
                materialMissing: "Material Missing",
                palletWeight: "Pallet Weight",
                articleWeight: "Article Weight",
                interlayer: "Interlayer",
                pallet: "Pallet",
                carton: "Carton",
                partDesc2: "Part Desc. 2",
                cartonQty: "Carton Qty",
                sumQty: "Sum Qty",
                printUp: "System.Drawing.Bitmap",
                dateCreate: "Date Create",
                startDate: "Start Date",
                partDesc: "Part Desc",
                saveChanges: "Save Changes",
                customerGTIN: "CustomerGTIN",
                noCopiesNumeric1to10: "No. Copies must be an integer between 1 and 10",
                changesNotSaved: "Changes will not be saved.",
                dateScheduleFuture: "You are going to assign a job scheduled for a future date.",
                byProductDuplicate:
                    "You cannot set a byproduct to the same material as the main material or have two of the same byproduct",
                dateRecorded: "Date Recorded",
                operations: "Operations",
                key: "en-GB",
                reset: "Reset",
                small: "Small",
                username: "Username",
                addBatchLot: "Add Batch/Lot",
                massActivities: "Mass Activities",
                priorityMissing: "Priority Missing",
                litQuantityXPallet: "Pallet Qty",
                searchWorksOrder: "Search Works Order",
                quantityXPallet: "Quantity X Pallet",
                printPallet: "Print Pallet",
                changeLog: "Change Log",
                massIssue: "Mass Issue",
                labellingStatus: "Labelling Status",
                isActive: "Is Active",
                rxg_defectsTable_Found: "",
                billOfBatches: "Bill Of Batches",
                selectPage: "Select Page",
                billOfMaterials: "Bill Of Materials",
                refresh: "Refresh",
                customerDetails: "Customer Details",
                testPrint: "Test Print",
                notUpdateByERP: "Fields not updated by ERP",
                smallQtyNumeric: "Small qty must be an integer",
                fullQtyNumeric: "Full qty must be an integer",
                oldValue: "Old Value",
                byProduct1: "By Product 1",
                byProduct2: "By Product 2",
                byProducts: "By Products",
                preventERPUpdate: "Stop any update from ERP (SAP or BPCS)",
                mvtDesc: "Movement description",
                mvtDate: "Movement date",
                fullQtyGreaterThanSmall: "Full quantity must be greater or equal to small quantity",
                full: "Full",
                desc: "Desc",
                main: "Main",
                open: "Open",
                cartonProdResume: "Carton Production : Resume",
                consumptionStatus: "Consumption Status",
                workorderAssignedPrinting: "Workorder was assigned for Label printing. Switch to activity?",
                workorderAssignedConsumption: "Workorder was assigned for consumption. Switch to activity?",
                jobIn: "Job In",
                statusChangeNotAllowed: "Status change not allowed",
                deselect: "Deselect",
                resetView: "Reset View",
                searchForDelivery: "Suche nach Verladeanweisung",
                deliveryNoteMerck: "Verladeanweisung",
                dropLocation: "Abladestelle",
                deliveryNoteWrong: "Es wurden zu der eingegebnen Verladeanweisung keine Daten gefunden",
                deliveryPalletListEmpty: "Keine Paletten gefunden (Bitte bedenken, dass Daten aus SAP bis zu 6 Minuten brauchen)",
                dropLocationEmpty1: "Abladestelle wählen",
                dropLocationEmpty2: "Abladestelle wählen",
                dropLocationTooltip: "Bitte wählen Sie die Abladestelle des Kunden (zu finden auf der Ladeanweisung)",
                deliveryNoteEmpty: "Bitte Verladeanweisung angeben",
                deliveryNoteTooltip:
                    "Bitte eine gültige Verladeanweisungsnummer eingeben wie sie auf der Ladeanweisung von SAP zu finden ist",
                containerVolume: "Volumen",
                youCanOnlyHaveNumberOfPalletsIssued: "You can only have {0} pallets issued",
                lineIn: "Line In",
                partPallet: "Part Pallet",
                manualEntry: "Manual Entry",
                consumed: "Consumed",
                issued: "Issued"
            }
        }
    },
    "it-IT": {
        translation: {
            main: {
                palletConditionId00: "Info",
                palletConditionId01: "Produced - Not in Warehouse",
                palletConditionId02: "In Warehouse",
                palletConditionId03: "Resorted",
                palletConditionId04: "Picked",
                palletConditionId05: "Delivered",
                palletConditionId06: "Scrapped",
                palletConditionId07: "Put-Away via Storage UnitList",
                palletConditionId08: "Lost",
                palletConditionId09: "Deleted",
                palletConditionId10: "Stock Transfer",
                palletConditionId11: "Intermediate pallet",
                palletConditionId12: "Quality Inspection",
                palletConditionId13: "Blocked Resort",
                palletConditionId94: "Allocated for Delivery",
                palletConditionId99: "Label Printed",
                palletStatusId00: "Label Printing",
                palletStatusId01: "Label Printed",
                palletStatusId02: "Label Printed_NIU",
                palletStatusId03: "Cus. Incubation",
                palletStatusId04: "Good",
                palletStatusId05: "Blocked",
                palletStatusId06: "Resorted",
                palletStatusId07: "Scrap",
                palletStatusId08: "Test Pallet",
                palletStatusId09: "Customer Return",
                palletStatusId10: "Blocked QI",
                palletStatusId11: "Saleable restricted",
                palletStatusId12: "Blocked Packaging",
                palletStatusId13: "Issued",
                palletStatusId14: "Consumed",
                palletStatusId15: "Returned",
                palletStatusId16: "Stock Received",
                palletStatusId17: "Good",
                palletStatusId18: "Deleted",
                palletStatusId19: "Repacking",
                palletStatusId20: "Loaded",
                palletStatusId21: "Shipped",
                palletStatusId22: "Scrap Warehouse",
                palletStatusId30: "PreBilled",
                palletStatusId90: "WIP",
                offlineCons: "Consumo Off-line",
                operator: "Operatore",
                openedWO: "Opened GPOs",
                litEANGTAN: "EAN/Gtin",
                cycleCountConfig: "Imposta Conta Ciclica",
                noWorkOrderOnLabelingAndOneRunningOnConsum:
                    "Nessun Ordine nell&apos;Etichettatura e uno aperto nel Consumato. Error# w0015:",
                endBeforeStart: "La data di fine ({1}) non può precedere la data di inizio({0}).",
                deliveryTextPurchaseOrderLine: "Customer Purchase Order Line",
                prinColour7: "Vernice",
                firstTimeProd: "Prima volta prodotto",
                woSSuspended: "Suspended",
                processFinished: "Processo terminato",
                passFirst: "Select Pass Number",
                woMPallQty: "Quantity X Pallet",
                rxg_Label_paramters_save_successfully_: "Parametri etichetta salvati con successo",
                rxg_Please_enter_the_quantity_remaining_on_the_previous_pallet__input__APL00031:
                    "Prego inserire la quantità rimasta per il pallet precedente. input# APL00001",
                lblFailSSCC: "Questo SSCC {0} non esiste ",
                string1: "",
                lblErrOI: "Return Quantity must be greater than 0! error# w0026",
                x0OfX1PaletsBlocked: "{0} di {1} pallet bloccati.",
                loadLine: "Deli.\\Riga",
                loadList: "Lista di Carico",
                chkInPRogresse: "Ottieni solo Richieste di Stampa in attesa ",
                inBoundDxDescription1: "Decrizione",
                popMaxcatonLimit: "Non puoi eccedere il numero totale di cartoni",
                clickLoadShift: "Devi cliccare &quot;Carica Turno&quot; prima di procedere!",
                printJSSequenceNumber: "Next Seq No.",
                litUserUpdate: "Changed by operator",
                inValidWorkOrderId: "ID Ordine/ID Linea non valido!! Prego cntrolla il tuo Database.",
                areYouSureMassiveScrap: "Sei sicuro di voler procedere allo scrap? {0} pallet su {1} selezionati saranno scrappati. ",
                startDateTime: "D\\o Inizio",
                shippingPoint: "Ship.Point",
                actualQty: "Qtà Attuale",
                couldNotReturnPalletErrorX0X1: "Impossibile ritornare il pallet. Error#{0}:{1}",
                prinSheet: "Foglio Litog.",
                transReas: "Motivo Trasp.",
                transSent: "Spedizione Postata in SAP",
                flexChar: "Caratteristiche Flex",
                scrapped: "Scartato",
                rxg_Could_not_assign__0__to__1__Error____2_: "Impossibile assegnare {0} a {1} Error#: {2}",
                emptyRowDelivery: "No data found with those parameters!",
                areYouSureMassiveBlock: "Sei sicuro di voler bloccare? {0} pallet su {1} selezionati saranno bloccati.",
                lastChatMessageLastsHours: "Messaggi di chat nell ultime {0} ore:",
                rxg_Please_select_a_defect: "Prego selezionare un difetto",
                cartonCreateLastDate: "Ultima data di produzione",
                offlinePrint: "Stampa Off-line",
                noWorkOrderOnConsumptionAndOneRunningForLa:
                    "Nessun Ordine nel Consumato e uno aperto per l&apos;Etichettatura. Error# w0014:  ",
                palletCount: "pall.prod.",
                litCartonLabel: "Carton Label",
                printLoad: "Stampa  Delivery",
                batchNr: "Batch Nr",
                printSuccessful: "Stampato correttamente",
                extWhsNoB2B: "Mag.Esterno (senza B2B)",
                schedQtyPal: "Qtà Pian&lt;br&gt;Pallet",
                litNameCust: "Name",
                importSSCC: "Carica SSCC",
                deliveryDateReq: "Data\\Ora di rich. Spedizione",
                womTitle: "Workorder Management",
                noDefectIdSelected: "Blank DefectId selected",
                differentWOOnConsumptionAndLabeling: "Ordine Differenti nel Consumato ed Etichettato. Error# w0010",
                enable: "Abilita",
                operation: "Operazione",
                errMsg: "Messaggio",
                btnUpdateWoM: "Update",
                destination: "Destinazione",
                durationMinutes: "Dur.(min.)",
                drawingNb: "Disegno",
                unableToAddOpenItemToLineX0X1ErrorX2: "Impossibile aggiungere Open Item alla Linea {0} {1} error#: {2}",
                batchStart: "Batch Start",
                deleteLastOne: "Cancella ultimo",
                couldNotApprovePalletErrorX0: "Non si può approvare il pallet. Error# w0003:{0}",
                lblErrbtnConsumeClick: "Wrong date. You can t consume pallet in the future. Change the date please!",
                labelImSwitchQty: "Switch Quantity between full and Small",
                conditionID: "ID Condiz.",
                noPreviousOperation: "No Operazioni Preced.",
                toolTipchkRaw: "Press update button to apply your filter(s)",
                shipmentHistory: "Storia Spedizione",
                statusBack: "Stato Fondo",
                offlinePrintingFailedException:
                    "La stampante non è pronta, la stampa  è stata messa in pausa, prego selezionare una nuova stampante e premi Inizio Stampa per continuare. Riavvia la stampa utilizzando la stampante selezionata dal menù a tendina.",
                whitePP: "FerroLite",
                palletStatusDialogText: "The pallet you are going to issue is blocked. Do you want to continue anyway?",
                inBoundDxMaterialCode: "Material Code",
                consumptionNbPallet: "Nb Pallet",
                palletsQty: "Pallet (Q.tà)",
                palletRank: "Seq.Pallet ",
                inBoundDxTransactionDate: "Data",
                cannotConsumeInTheFuture: "Impossibile consumare in data futura. error# w0001 ",
                palletDetail: "Dettagli Pallet",
                linePrintAll: "Stampa tutte le etichette",
                deliveryNote: "Bolla di consegna",
                btnCartonDeleteConfirmation: "Sei sicuro di voler CANCELLARE questo cartone?",
                woScheduler: "APL Planning Viewer",
                drawingNumber: "Lito",
                embossing: "Punzonatura",
                inBoundLitLabelName: "Tipo di Etichetta: ",
                printResultSuccess: "{0} copy(s) of Sequence {1} sent to printer {2} at {3}.",
                scheduledOrders: "Scheduled GPOs",
                workOrderEnd: "Data Fine Ordine",
                prodOrdHeaderText: "Note testata Ord.Prod.",
                prodQtyPal: "Qtà Prod&lt;br&gt;Pallet",
                dicoJsPalletDate: "Non puoi creare un pallet nel futuro",
                openItems: "Open Items",
                addBin: "Aggiungi Bin",
                actQty: "Qtà Att",
                rxg_SSCC___0___was_not_found___error__00001: "SSCC ({0}) non è stato trovato.  error#:#w0024",
                chkDetails: "Informazioni Stampa",
                aluTab: "Tab Allum.",
                defectTimeStamp: "Data\\Ora Difetto",
                assign: "Assegna",
                dicoRepackSummary: "Situazione Reimballo",
                unitOfMeasure: "Unità di Misura",
                supplier: "Fornitore",
                cartonDeleteLastDate: "Cancella ultimo",
                binToBinT: "Bin to Bin transfer",
                labellingPrintingComplete: "Stampa Eseguita",
                areYouSureConsume: "Sei sicuro di voler consumare l&apos;SSCC",
                aplBin: "Bin APL",
                inBoundErrorQuantityMaxTotal: "Total number of produced pallet must be less than",
                releaseReturnedPallet: "Rilascio",
                inBoundErrorQtyLabel: "La Quantità per Etichetta deve essere numerica.",
                noDefectsPassed: "At least one defect required for blocking",
                lbl_spoilage_reasons_title: "Spoilage",
                woMPallTxtFullQty: "Standard",
                palletsProduced: "pallets prod.",
                dicoHtmlSelectMat: "Select this material",
                goBack: "Torna indietro",
                archivedShip: "Spedizioni Completate",
                btnDeleteLastOne: "Cancella ultimo cartone",
                litMessWarn:
                    "La quantità nel pallet eccede la quantità massima prevista nell Ordine di Produzione. Vuoi cambiare la quantità attuale nel pallet?",
                plannerComment: "Commenti del Planner",
                binMgmt: "Gestione Bin",
                binType: "Tipo Bin",
                dateIn: "Data Iniz.",
                defect: "Difetto",
                delete: "Cancella",
                detail: "Dettagli",
                trailer: "Targa",
                deleteConsumption: "Cancella Consumo",
                newValue: "Nuovo Valore",
                lotNumber: "Lot",
                returnQuantity: "Quantità restituita",
                inBoundTotalLabelCreation: "Totale",
                areYouSureMassiveRelease: "Are you sure you want to release? {0} of {1} pallets will be affected ",
                inBoundTxtTanDateError: "E  necessaria una data valida",
                areYouSureMassiveReprint: "Sei sicuro di voler ristampare? {0} etichette su {1} selezionate saranno stampate.",
                rxg_No_Department_specified__Error__w0007: "Nessun Reparto specificato. Error# w0025",
                outsideSideStripe: "Side Stripe esterno",
                previous: "Precedente",
                translateCode: "TranslateValue",
                previousOIConsumed: "SSCC precedente ({0}) è consumato?.",
                checkDateslater: "Start date is later than end date",
                dicoHtmlQuantityUsed: "Qta usata : ",
                consumptionCurrentActivity: "Attività Corrente del Consumo",
                removeNonAmendmentMarker: "Rimuovi il blocco modifica Delivery in SAP",
                inputLine: "Input Line",
                batchManagement: "Gestione Batch",
                inBoundErrorReceiptDate: "La data di Scadenza deve avere una data e ora valida.",
                columnName: "Nome Colonna",
                txtQuantityErr: "Invalide quantity",
                cmrSheets: "Pallet di fogli",
                consumptionParameters: "Parametri Consumo",
                binWhs: "Mag\\Bin",
                btnPrintPalletAndClose: "Stampa etichetta e chiudere",
                coilNrOfSheets: "No di Fogli",
                failedToConsumeSsccInDbX0: "Errore consumo dell’ SSCC nel DB. Error# w0012:  {0} ",
                inBoundIntQtyLabel: "Q.tà x Etichetta",
                rxg_Could_not_assign_Work_Order___Error___0_: "Impossibile assegnare l&apos;Ordine di Lavoro.  Error: {0}",
                qtySched: "Qtà Pian.",
                scanned: "Letti",
                blockQi: "Bloccato  C.Q.",
                blocked: "Bloccato",
                unableToAddOpenItemToLineX0ErrorX1: "Impossibile aggiungere Open Item alla Linea {0} error#: {1}",
                totQtyScan: "Tot. Qtà",
                colors: "Colori",
                noOfSheets: "Nr. di Fogli",
                cancel: "Annulla",
                valMustBeInteger: "{0} deve essere intero",
                pickingLblNumCopy: "Number of Copy :",
                workOrder: "Ordine",
                wantToUseAlternatePrinter: "La stampante selezionata non è pronta!! Clicca Sì per utilizzare la stampante alternativa{0} ?",
                password: "Password",
                x0OfX1PaletsApprovedStoppedAtErrorForPalletX21: "{0} of {1} pallets Approved. Stopped at error for PalletId:{2} -{3}",
                inBoundBtnConfirm: "Conferma",
                section: "Section",
                operationNotCompleted: "Operazione Precedente non Completata",
                inboundNo: "No",
                rxgSearchMissingWorkOrder: "Inserisci un ordine o un range di date per procedere",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheck:
                    "SSCC {0} è aperto nella seguente linea/e. Prego verifica le linee che vorresti chiudere",
                packagingListChangeover: "Lista Cambio Imballi",
                insCol: "Colore interno coperchio",
                insert: "Inserisci",
                inBoundTxtwareError: "Il campo Magazzino non può essere vuoto ed avere più di 2 caratteri",
                import: "Importa",
                palletScheduled: "pall.sched.",
                maxNoCopiesMessage: "Stai stampando un numero di copie più alto del massimo consentito. Sei sicuro di procedere?",
                lblErrbtnConsumeClickMissing: "Could not find SSCC. error# W0006",
                rxg_PrintDefect: "Stampa difetti",
                tKeyActivity: "Tipo Attività",
                workOrderOp: "Ordine / OPE",
                inBoundBtnCancel: "Annulla",
                bpcsLocation: "Locaz.SAP",
                inBoundBtnCancel2: "Fine",
                selPrinterToPrintTo: "Selezionare stampante per il reprint",
                notes2: "Note 2",
                notes1: "Note 1",
                noData: "Nessuna data visualizzabile per queta linea!!",
                changeCloseJob: "Cambia / Chiudi Lavoro",
                noPall: "Pal.No",
                bundleTurner: "VoltaPacco",
                inValidUser: "Non è un utente valido! Prego provare ancora il Login...",
                inValidTime: "Ora errata!! Prego inserire una data valida (hh:mm).",
                woSPlanned: "Planned",
                inValidDate: "Data errata!! Prego inserire una data valida (dd/MM/yyyy).",
                loginButtonText: "Accedi",
                newBin: "Nuovo Bin",
                inBoundErrorDate: "La data non è corretta",
                noRecordExtID: "Nessun pallet trovato col seguente codice identificativo esterno: {0}",
                noRecordFound: "SSCC {0} non trovato nel sito corrente",
                palletCreated: "Pallet {0} ({1}) creato correttamente.",
                x0OfX1PaletsUnblockedStoppedAtErrorForPalletX21:
                    "{0} di {1} pallet Sbloccati.  Fermato all&apos;errore per il Pallet ID:{2} -{3}",
                resultNumber: "Numero di risultati: {0} nelle ultime {1} ore",
                inBoundDxColSeqNumber: "Seq",
                ordQty: "Qtà Ord.",
                litPalLabel4: "Pallet Label 4",
                litPalLabel3: "Pallet Label 3",
                litWoS: "Current work order status : ",
                outCol: "Colore esterno coperchio",
                printAbort: "Stampa annullata per progr. {0}.  Il server non risponde. Error# w0017.",
                labels: "Etichette",
                logout: "Disconnetti",
                logMsg: "Mess.Log",
                loaded: "Caricato",
                loadNo: "Del N",
                noColours: "No.Colori",
                length: "Lunghezza",
                sapClassDesc: "Descr.Classe SAP",
                btnYesReturnDetail: "Ho chiuso questo \\n  perchè ho reso 0 nella quantità",
                valueCantBeNull: "{0} non può essere null",
                finalPalletRank: "Seq.Pallet Finale -",
                sessionName: "Nome Sessione",
                update: "Aggiorna",
                deliveryTransferConfig: "Configurazione Delivery Transfer",
                zeroPallet: "Nessun Pallet",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheckReturn:
                    "SSCC {0} è aperto nelle seguenti linee. Prego controlla la linea dalla quale desideri fare il reso.",
                printfailedselectanotherprinter: "Stampa fallita, selezionare un&apos;altra stampante o riprovare. Error# w0019 ",
                separator: "Sep.",
                underV: "Sottovuoto",
                palletNumber: "Numero del pallet: &lt;b&gt;{0}&lt;/b&gt;  ",
                batchLot: "Batch\\Lot",
                batchEnd: "Fine Batch",
                goDowntime: "Vai a Downtime",
                prodDate: "Data Prod.",
                produced: "Prodotti",
                litAllInOne: "Tutto in una volta",
                x0OfX1PaletsApproved: "{0} di {1} pallet rilasciati.",
                totalTimeGreaterThanShift: "Il tempo di attività totale è maggiore della durata del turno",
                couldNotScrapPalletErrorX0X1: "Impossibile scartare pallet. Error#{0}:{1}",
                lblDefaultSetting: "Quantità per Cartone {0}",
                rememberMeText: "Ricordami su questo computer",
                resetDefaults: "Resetta Turno Default",
                scanHere: "Leggi SSCC",
                durationValidation: "* La durata deve essere un valore numerico.",
                rxg_Labeling_Pass_Number: "Etichettatura numero di passata",
                tabCoil: "Coil Tab",
                getData: "Acquisisci i dati da APS",
                lblErrbtnConsumptionClick1Else: "Could not consume SSCC invalid quantity. error# W0008.",
                btnBack: "Finito",
                dicoHtmlSapcode: "Codice Materiale SAP",
                cartonSumQty: "Numero di Cartoni",
                height: "Altezza",
                rxg_Unable_to_consume_pallet__0____1__Error____2__: "Impossibile consumare il pallet {0}: {1} error#: {2} ",
                handle: "Manico",
                qtyNotSetForMaterial: "Nessuna quantità impostata per questo materiale",
                dicoTotalQuantity: "Total Quantity",
                priority: "Priorità",
                printMod: "Print Mod",
                printCMR: "Stampa CMR",
                totalShiftHours: "Durata totale del turno (minuti)",
                componentText: "Note componente",
                previousOpeCompleted: "Oper. Precedente Completata",
                thisMethodRequiresAConfirmationAndNoneIsDe: "Questo metodo richiede una conferma e nulla è stato definito.",
                litTitre: "Etichette in entrata",
                qtyPal: "Qtà Pallet",
                qtyReq: "Qty.Rich.",
                litWoOpe: "Work Order Operation",
                litWoMan: "Work order information",
                standard: "Standard",
                slitter: "Cesoia",
                outOfShift: "L&apos;intervallo di date impostate per l&apos;importazione non è compatibile con giorno e turno selezionati",
                x0OfX1PaletsReturned1: "{0} of {1} pallets returned.",
                noWorkorder: "Nessun Ordine di Produzione ",
                thereIsNoWorkOrderConfiguredForThisLine: "Non c&apos;è nessun Ordine di Produzione configurato per questa linea",
                dicoHtmlRepackResult: "Risulato Reimballo",
                noLines: "No Righe",
                tableName: "Nome Tabella",
                woMPallMinQty: "Small",
                palletCodeChangeover: "Cambio codice Imballi",
                cmrOthers: "Pallet di altri materiali",
                inBoundLitTranDate: "Data Tansazione",
                quality: "Quality",
                allPallets: "All pallets",
                pleaseSelectaPrinter: "Si vuole selezionare una stampante per stampare la nuova etichetta?",
                rxg_ThereIsNoWorksOrderAssignedForThisLine: "Non ci sono Ordini di lavoro assegnati per questa linea",
                palletStatus: "Stato Pallet",
                cuttedSheetsBlocked: "Fogli Tagliati Bloccati ",
                litByProduct4: "Mat.ByProduct4",
                litByProduct2: "ByProduct 2 Material",
                litByProduct3: "Mat.ByProduct3",
                tracDialogText: "Traceability batch is missing. Do you want to continue anyway?",
                goSetup: "Vai a Setup",
                sqlTranslation: "Traduzione SQL",
                rxg_Back_to_offline_consumption: "Torna al consumo Off-line",
                woSInUse: "In use (On line)",
                rxg_Open_SSCC__0__on_the_following_line_s__: "Apri SSCC {0} nella seguente linea/e.",
                shipAddress: "Indirizzo di spediz.",
                groupDesc: "Descr.Gruppo",
                thislinehasajobassignedClosethejob: "Questa linea ha un lavoro assegnato. Chiudere il lavoro?",
                palletWeight: "Peso",
                articleWeight: "Peso de botella",
                interlayer: "Interlayer",
                pallet: "Pallet",
                carton: "Carton",
                rxg_Work_Order_Enquiry: "Ricerca Ordine di Lavoro",
                groupStatus: "Stato Gruppo",
                partDesc2: "ArtDesc.2",
                qtyProd: "Qtà Prod.",
                litQtyReq: "Quantity Requested",
                labelsTraceability: "Etichette e Consumo",
                dicoHtmlMaterial: "Material",
                timeIn: "Oran Inizio",
                postedToSAP: "Postato in SAP",
                autoPutaway: "PutAway Automatico",
                totQty: "Tot.Qtà",
                totPal: "Tot.Pal.",
                labelPalletCount: "Number of Pallet Procuced :&lt;br/&gt; &lt;b&gt;{0}&lt;/b&gt;",
                shipLog: "Log Spedizione",
                numberOfCopies: "Nr. di Copie",
                schedPal: "Pal.Pian.",
                inBoundLitDescription: "Descrizione",
                ckBoxCartonSave: "Con Cartoni",
                palletsScheduled: "pallets sched.",
                cartonQty: "Qta Cartoni",
                reqQty: "Qtà Rich.",
                resume: "Ritorno",
                result: "Esito",
                retQty: "Quantità Reso",
                return: "Reso",
                reason: "Reason",
                inBoundStrVendorBatch: "Vendor Batch",
                remQty: "Qtà Riman.",
                inBoundErrorNbrPallet: "Il campo Numero di etichette deve essere numerico e maggiore di 0",
                scrapProduction: "Scrap Production",
                rankTo: "Rank a",
                sealMachineNo: "No SealMach",
                roller: "Rullo",
                mouldAndNonMouldSameDefectId: "Unable to add mould and non-mould related with the same defect ID",
                overProdHeader: "Sovrapproduzione",
                btnUnderstoodBack: "Indietro",
                defaultActivityLabeling: "Etichettatura",
                sumQty: "Qta Totale",
                status: "Stato",
                stdQty: "Qtà Std",
                couldNotReturnPalletErrorX01: "Non si può ritornare il pallet. Error# w0003: {0}",
                palSatEditSelectPrinter: "Seleziona stampante per ristampare?",
                importDataFromAPS: "Importa i dati da APS",
                materialBPCSCode: "Materiale",
                inBoundLitInfosTrans: "Vuoto = Tutti, oppure OO, U, UC, UT, UR, RT ",
                newShip: "Nuova Spedizione",
                system: "Sistema",
                returnToVendor: "Restituzione al fornitore",
                scroll: "Scroll",
                search: "Cerca",
                select: "Seleziona",
                sapEdi: "SAP EDI",
                tinpTab: "Tinp.Tab",
                tinning: "Copertura",
                timeEnd: "Ora Fine",
                shipTo: "ShipTo",
                shifts: "Turni",
                prompt: "Messaggio",
                addDefect: "Agg. Difetto",
                pause2: "2a Pausa",
                passNo: "Num.Pass",
                spoilageReasons: "Motivazioni Spoilage",
                couldNotLoadWorkOrderPleaseCheckTheOrderCo:
                    "Impossibile caricare l&apos;Ordine di Produzione. Prego controlla il codice dell’Ordine e prova ancora. error# w0008",
                pieces: "Pcs",
                couldNotIssueConsumtionX0ErrorX1: "Impossibile rilasciare il consumo. {0} Error# {1}",
                x0OfX1PaletsReturnedStoppedAtErrorForPalletX21: "{0} of {1} pallets Returned.  Stopped at error for PalletId:{2} -{3}",
                startingPalletRank: "Seq.pallet iniziale-",
                movementDescription11: "Label Printed - Pallet Produced",
                movementDescription10: "Return Pallet off line",
                movementDescription13: "Change pallet status from SAP",
                movementDescription12: "Label Printed - Pallet Produced (offline)",
                movementDescription15: "Block pallet QI",
                movementDescription14: "Change pallet Birth Date/Condition in APL from PLC ",
                movementDescription17: "Scrap pallet",
                movementDescription16: "Release pallet",
                movementDescription19: "User connection",
                movementDescription18: "Delete/Cancel pallet",
                movementDescription01: "Start WorkOrder Front End Line",
                movementDescription02: "Stop Workorder Front End line",
                movementDescription03: "Start Workorder Back End Line",
                movementDescription04: "Stop Workorder Back End line",
                movementDescription05: "Issue Pallet on line ",
                movementDescription06: "Consumed Pallet on line ",
                movementDescription07: "Return Pallet on line",
                movementDescription08: "Delete Consumption",
                movementDescription09: "Consumed Pallet off line ",
                movementDescription33: "Block pallet for Scrap",
                movementDescription32: "Pallet quantity change",
                movementDescription35: "Scrap in Warehouse",
                movementDescription34: "Block Pallet for Packaging",
                movementDescription22: "Open Item Return ",
                movementDescription23: "Block pallet for resorting",
                movementDescription20: "Open Item Issuing",
                movementDescription21: "Open Item Consumption",
                movementDescription26: "Remove defect on a pallet",
                movementDescription27: "Defect found",
                movementDescription24: "Open Item delete",
                movementDescription25: "Add Defects to Pallet",
                movementDescription28: "Defect not found",
                movementDescription55: "SU defect removed from SAP",
                movementDescription54: "SU defect added from SAP",
                movementDescription51: "SU Updated from SAP",
                movementDescription50: "SU Created from SAP",
                movementDescription53: "SU condition Updated from SAP",
                movementDescription52: "SU status Updated from SAP",
                movementDescription44: "Approve Pallet",
                movementDescription40: "Pallet Scanned for Repack",
                movementDescription41: "Remove Pallet from Repack",
                movementDescription42: "Pallet Splitting",
                movementDescription43: "Create pallet from other",
                movementDescription60: "Pallet Locked",
                movementDescription61: "Pallet Unlocked",
                movementDescription99: "SU Imported for Go Live",
                inBoundErrorQuantity: "Il campo Quantità per Etichetta deve essere numerico maggiore di 0",
                couldNotDeleteConsumtionX0ErrorX1: "Impossibile cancellare il consumo. {0} Error# {1}",
                rxg_Consumption: "Consumo",
                toolTipEnter: "Press Enter to apply your filter(s)",
                inBoundErrorAmount: "Errore nella quantità totale. Verificare i valori e correggerli",
                litSearch: "Search a new Workorder",
                currentPalletRank: "Seq. Pallet Corrente -",
                transferCompleted: "Trasferim.Completo",
                mustInsertComment: "Devi inserire un commento per sbloccare il pallet",
                rxg__0__units_returned_on_SSCC__1___When_all_pallets_are_consumed_returned__click_OK_again_to_close_the_job__dialog_w0005:
                    "{0} unità rese con SSCC {1}. Quando tutti i pallet saranno consumati/resi clicca ancora OK per chiudere il lavoro. dialog#w0001",
                operationEnd: "Data Fine Operazione",
                checkSLEDNullText:
                    "&lt;b&gt;Ci sono {0} pallet dello stesso materiale per cui non è indicata la data scadenza!&lt;/b&gt; &lt;/br&gt;",
                prodQty: "Qtà Prod",
                prodPal: "Pal.Prod.",
                profile: "Profilo",
                passNumber: "Numero Passate",
                printer: "Stampante",
                bpQuantity: "Quantità",
                unblock: "Sblocca",
                deliverySelected: "Selected",
                noPalletScanned2: "Nessun pallet letto. Sei sicuro di voler continuare?",
                couldNotScrapPalletErrorX0: "Impossibile scartare pallet. Error# w0009: {0}",
                standQuantity: "Qtà Standard",
                quantityScrapped: "Quantity Scrapped",
                grossWeight: "Peso Lordo",
                dicoHtmlLine: "Linea",
                couldNotUpdateExpiryDatePalletErrorX0X1: "Errore nell&apos;aggiornamento della data di scadenza per il pallet {0}: {1}",
                multipleSelectionError:
                    "Lo Stato non corrisponde per le righe selezionate. Prego selezionare ancora le righe con lo stesso Stato!!",
                setupGroupDesc: "Descr.Gruppo",
                deliveryTitle: "Printing  - JWO Delivery Label",
                setupGroup: "Gruppo",
                shipmentRevoked: "Conferma spedizione revocata in SAP",
                oldestPalletProductionDate: "Data Prod. Più vecchia",
                deleteSession: "Cancella Sessione",
                dateCreate: "Data Creazione",
                btnCloseOff: "Aboard",
                internalLacquer: "Vernice interna",
                areyousureyouwanttoclosethejob: "Sei sicuro di voler chiudere il lavoro?",
                warehouse: "Magazzino",
                possibleJOJO: "Cambio Ordine in corso",
                noPalletsToUpdate: "Nessun Pallet da Aggiornare",
                totalImportedMinutes: "Durata dei T-Key importati(min.)",
                tinningAlloy: "Tin.Al.",
                traceabilityInfo: "Traceability Info",
                printDelDocs: "Stampa Bolla di Trasferimento",
                deliverydDate: "Data\\Ora Del.",
                lacqSheet: "Foglio Vern.",
                baseProduct: "Base Product",
                x0OfX1ExpiryDatesUpdated: "Data di Scadenza {0} di {1}",
                wall2Wall: "Wall to Wall",
                saveDefaults: "Salva default",
                startAfterEnd: "La data di inizio ({0}) è successiva a quella di fine ({1}). error# W0007",
                litPalLabel: "Pallet Label",
                rxg_You_must_enter_your_initials_to_add_a_defect: "Devi inserire le tue iniziale per aggiungere un difetto",
                itemClass: "Item Class",
                inBoundErrorPalletCreation: "Errore durante la creazione del pallet. Prego verificare i tuoi valori.",
                printDeliveryNote: "Stampa Bolla",
                tracDialogHeader: "Controlla Dati Tracciabilità",
                savesendtosap: "SALVA ed INVIA A SAP",
                litRepCurAct: "Attività di Repacking in Corso",
                moveSSCCToBin: "Sposta SSCC nel Bin selezionato",
                inBoundConfirmDelete: "Sei sicuro di voler cancellare questa linea?",
                currentActivity: "Attività corrente",
                backToCurrentActivity: "Torna alla Attività Corrente",
                deliveryDateTime: "Data\\Ora Del.",
                changeover: "Cambio",
                titleText: "Accedi ad APL",
                confirm: "Conferma",
                consQty: "Qtà Cons",
                consume: "Consuma",
                comment: "Commenti",
                rxg_Select_work_order_for_labeling: "Seleziona Ordine di Lavoro per l&apos;Etichettatura",
                addNewActivities: "Aggiungi Nuove attività",
                specialText: "Special Text",
                standardKeyTextDescription: "Descrizione ",
                selectLines: "Seleziona Linee",
                printJSWorksOrder: "Works Order",
                scannedPallets: "Pallet Letti",
                palletStatusDialogHeader: "Blocked Pallet",
                slitChar: "Cesoia",
                backToOfflineHome: "Torna alla pagina Offline ",
                consumptionPageTitle: "Consumption Declaration",
                rxg_Could_not_assign_Work_Order_Error___0____1_: "Impossibile assegnare l&apos;Ordine di Lavoro. Error#:{0}: {1}",
                cyclType: "Tipo di Conta Ciclica",
                cyclConf: "Configurazione Conta Ciclica",
                noOfCoils: "Nr. di Coils",
                x0OfX1PaletsBlockedStoppedAtErrorForSSCCX2: "{0} di {1} pallet bloccati. Fermato all&apos;errore per l&apos; SSCC:{2} -{3}",
                tooling: "Attrezzi",
                binDescription: "Descriz.Bin",
                operationCompleted: "Operazione Precedente Completata",
                coilCutting: "Linea taglio Coil",
                popLabelErrorCartonQty:
                    "Quantità errata per questo cartone. Deve essere maggiore di 0 e minore della quantità finale del pallet.",
                adminView: "Vai alla Visuale Admin",
                confirmUnload: "Confermi il rientro del pallet?",
                startDate: "Data Inizio",
                startTime: "Ora Inizio",
                canChar: "Caratteristiche Scatole",
                activity: "Attività",
                tKeyDescription: "Descrizione TKey",
                shipmentCode: "Cod.Spediz.",
                shipmentName: "Nome Spediz.",
                inBoundDxSelTranType: "Tipo transazione",
                partCode: "Cod. Articolo",
                partDesc: "ArtDesc",
                carrier: "Trasportatore",
                headerTextUser: "User",
                rxg_PrintBoth: "Stampa entrambi",
                searchArea: "Area di Ricerca",
                searchLoad: "Cerca\\Aggiungi Delivery",
                userNotRecognised: "Utente non riconosciuto",
                dicoHtmlWo: "OrdProd",
                mainDetails: "Dettagli Principale",
                blockScrap: "Blocco per Scrap",
                saveChanges: "Salva cambiamenti",
                inBoundStrWorkOrder: "Rif. OdP",
                nrColli: "No.Colli",
                rxg_BeginPrint: "Inizio Stampa",
                insertSSCC: "Inserisci gli SSCC ",
                litQuantityProd: "Quantità prodotta",
                calcNetWeight: "Calc.P.Netto",
                noShiftsToDisplay: "Non ci sono turni per cui mostrare le attività",
                centralServer: "On Central Server",
                operatorCode: "Codice Operatore",
                operatorName: "Nome Operatore",
                blockPallet: "Blocca Pallet",
                mrpController: "MRP Controller",
                litActQty: "Quantità Attuale",
                deleteTkeyReasonConfirm: "Sei sicuro di voler cancellare questo Tkey?",
                document: "Documento",
                tooManyBins: "Troppi bin di diversi magazzini selezionati",
                byProduct: "Per Prodotto",
                woSApproved: "Approved",
                rxg_Title: "Stampa Offline",
                synoptic: "Sinottico",
                areYouSureAutoPutaway: "Sei sicuro di volev fare il PutAway Automatico del pallet al bin di default della linea?",
                printSucceeded: "Stampato correttamente",
                rxg_Print: "Stampa",
                btnNoWarn: "No",
                binToBin: "Bin to Bin transfer",
                pleaseSelectaLine: "Prego seleziona una linea",
                lblConfirmRepackCondition: "La selezione attuale verrà cambiata",
                litsearchWomField: "Search a new Workorder",
                consumptionUnit: "Unit",
                dateEnd: "Data Fine",
                reprintFailed:
                    "Ristampa fallita per progr. {0} Error# w0022. Solo {1} di {2} etichette sono state stampate. Desideri ristampare le etichette mancanti?",
                quantityProduced: "Quantità Prodotta (Palle consumati)",
                operationInProgress: "Operazione Precedente in Corso",
                facility: "Facility",
                markerTincoat: "Righe Marcatura",
                customerCode: "Customer Code",
                customerDesc: "Descrizione Cliente",
                customerName: "Magazzino",
                rxg_Quantity: "Quantità",
                insertActQty: "Inserisci la nuova quantità (vuoto per lasciarla com&apos;è)",
                cantLoadShifts: "Impossibile caricare i turni: {0}",
                offLineMetalSSCCAway: "This SSCC Doesn t exist.",
                pallets: "Pallet",
                printFailedAbr: "Stampa annullata. Error# w0018",
                loadOrder: "Delivery",
                rxg_Defect_Added: "Stato modificato, ma nessun difetto aggiunto!!",
                declarationOPENITEMS: "Dichiarazione - OPEN ITEMS",
                loadShift: "Carica turni",
                loadManag: "Gestione  Delivery",
                noCopiesNumeric1to10: "Nr.Copie solo numeri interi da 1 a 10",
                areYouSureMassiveAddDefect: "Sei sicuro di voler aggiungere difetti? {0} pallet su {1} selezionati saranno coinvolti. ",
                inBoundLitRecap: "Riepilogo della creazione etichetta. Etichette Create e Stampate: ",
                inBoundLitPrint: "Stampa",
                inBoundLitTrans: "Transazione",
                inBoundLitTitre: "Inbound Label",
                workCenter: "Centro di Costo",
                blockFailedWithError: "Blocco fallito con errore:",
                authNumber: "Nr Autorizzazione",
                allMaterials: "Articoli Predefiniti",
                baseLineNotRecognised: "Line not Recognised.",
                inBoundTransactionQuantity: "Q.tà",
                rxg_Scrap_Pallet: "Scarta pallet",
                changesNotSaved: "Cambiamenti non verranno salvati",
                quantityConsumed: "Quantità Consumata",
                dateStart: "Data Inizio",
                needCustomerAndMaterial: "Devi selezionare un magazzino ed almeno un materiale per procedere",
                defects: "Difetti",
                endGauge: "Spessore",
                stopSession: "Arresta Sessione",
                showRawMaterial: "Mostra Materie Prime",
                delShip: "Cancella Spedizione",
                finalPassShort: "Passata Finale",
                stdUserQty: "Qtà Standard Utente",
                details: "Dettagli",
                areYouSureDelete1: "Sei sicuro di voler cancellare questi pallet?",
                inBoundBtnOk: "Ok",
                shiftNoWorkOrders: "Non ci sono WO per questa linea",
                scrapWarehouse: "Scrap Warehouse",
                goodDescr: "Desc.Beni",
                packPallet: "Pallet",
                cuttedSheetsScrapped: "Fogli Tagliati Scartati",
                blockResort: "Bloccato Cernita",
                rxg_defectsTable_Comment: "Comment",
                visGrpBy: "Visualizza Raggruppato per",
                spoilageManagment: "Gestione Spoilage",
                stockTake: "Inventario",
                mouldNotParsed: "Problem parsing mould numbers",
                inBoundDateExpiryDate: "Data scadenza",
                areyousureyouwishtoassignworkorder01toline3:
                    "Sei sicuro di volere assegnare l’Ordine di Produzione {0}({1}-{2}) alla linea {3}",
                byProductDuplicate: "Prod.Alternatividevono essere diversi dal prodotto principale e diversi tra di loro",
                couldNotBlockPalletErrorX0X1: "Impossibile bloccare pallet. Error#{0}:{1}",
                chkEdit: "Edit",
                revokePallets: "Revoca pallet",
                initials: "Iniziali",
                stdUserSmallQty: "Qtà Standard (pal. Basso) Utente",
                returnFromCustomer: "Ritorno da cliente",
                finalPassNotSAP:
                    "Stai modificando il flag &quot;Passata Finale&quot;. Il valore corrente non corrisponde al flag MA04 sull&apos;operazione di SAP",
                sealMachine: "NULL",
                rxg_Defects_Added: "Difetto aggiunto",
                rxg_Could_not_assign__0__to__1___Error___2___3_: "Impossibile assegnare {0} a {1}. Error#:{2}-{3}",
                dicoJsPalletquantity2: "La quantità eccede la qta originale",
                printBarcodesRepacking: "NULL",
                dicobtnCreatePallet: "Crea Nuovo Pallet",
                scanExternalTag: "Orig/Ext Tag Identifier",
                userStdQtySmall: "Qtà Utente (Pal.Basso)",
                rxg_DeleteFailedWithError: "Impossibile cancellare con Errore:{0}",
                saveShiftNotEqual: "Il totale dei minuti registrati non coincide con i minuti totali del turno.\\r\\n\\r\\n Sei sicuro?",
                motherPalletNotFullyRepacked: "I pallet di origine non saranno utilizzati interamente. Sei sicuro di voler continuare?",
                consumptionQty: "Quantity",
                lblConfirmRepack: "Do you confirm the Repack of the selected Material?",
                created: "Creato",
                shipmentComple: "Completa Spedizione",
                display: "Mostra",
                operationStart: "Data Inizio Operazione",
                disable: "Disabilita",
                custCod: "Cod.Cli",
                createST: "Crea Inven.",
                inBoundErrorUpdate:
                    "Si è verificato un errore durante l aggiornamento. Verificrare i valori e se persiste domandare al TEAM APL.",
                btnNoReturn: "No, non ho consumato nulla",
                x0OfX1PaletsApprovedStoppedAtErrorForSSCCX: "{0} di {1} pallet rilasciati. Stopped at error for SSCC:{2} -{3}",
                woMButton1: "Manage this work order",
                areYouSureMovePallet: "Sei sicuro di voler spostare {0} pallet selezionati nel bin {1} ?",
                printerName: "Nome Stampante",
                deliveryPalletLoaded: "Nr.Pallets Loaded",
                invalideQuantity: "La quantià di reso impostata per il pallet reso {0} è maggiore della quantità rimasta error# w0026",
                loadCompleted: " Delivery Completata",
                preImportSSCC: "Pre - Import.",
                areYouSureRemovePalletRepack: "Sei sicuro di voler rimuovere il pallet selezionato dal repack?",
                colorGroup: "Gruppo",
                x0OfX1PaletsScrappedStoppedAtErrorForSSCCX: "{0} di {1} pallet scartati. Fermato all&apos;errore per l&apos; SSCC:{2} -{3}",
                salesOrder: "Ord.Cli.",
                plasticCoil: "Film",
                dateRecorded: "Dati salvati",
                mustInsertCommentScrap: "Devi inserire un commento per lo scrap del pallet",
                bomBatch: "Batch",
                litModQtyMax: "Quantity for a full pallet",
                litModQtyMin: "Quantity for small pallet",
                palStat_Default_Page_Load_Pallet_Status_Management: "Gestione Pallet Status",
                reOpenLoad: "Riapri Delivery",
                mustInsertQty: "Devi inserire la quantità per il ritorno del pallet",
                setupPack: "Setup Imb.",
                popDown: "Menù a discesa",
                download: "Scarica",
                downTime: "Down-Time",
                nextOpeDateSchedule: "Data\\Ora Oper Succ",
                noUpdateAfterSAP: "Impossibile modificare dati già inviati a SAP",
                endChar: "Caratteristiche coperchio",
                endDate: "Data fine",
                endTime: "Ora Fine",
                differentWOOnConsumptionAndLabeling2: "Active GPO in Labeling is different from Consumption one!",
                x0OfX1PaletsDeleted: "{0} di {1} pallet cancellati.",
                enabled: "Abilitato",
                closeAndConsume: "Ferma Consumo",
                go: "Vai",
                op: "Op.",
                wo: "Ordine",
                to: "A:",
                operationDescription: "Descr. Operazione",
                itemCategory: "Tipo Articolo",
                massiveScan: "Scan Massivo",
                btnBackWo: "Bouton Back",
                noPallets: "Nr. di Pallet",
                failedToConsumeSsccInDbX0ErrorX1: "Errore consumo dell’ SSCC nel DB. {0} Error# {1}",
                missingAPSDef: "Default di importazione da APS mancanti",
                packList: "Lista Imballi",
                packConsumed: "NULL",
                areYouSureBlock1: "Sei sicuro di voler bloccare questi pallet? ",
                litCustMat: "Customer material",
                supplierCode: "Codice Fornitore",
                supplierName: "Nome Fornitore",
                dicoHtmlProdDate: "DataProd",
                sendingTrans: "Dati SAP generati. In attesa di risposta da SAP.",
                btnCartonDeleteLastDate: "Cancella ultimo cartone",
                dateWorkOrderSpoilage: "Data",
                dicoHtmlRemove: "Rimuovi",
                dicoHtmlRepack: "Materiale selezionato per Reimballo:",
                quantityRemaining: "Quantità Rimasta",
                parentPallets: "Consumed Pallets",
                userStatus: "Stati Ordine",
                userStdQty: "Qtà Std Utente",
                custNameShort: "Cliente",
                vendorBatch: "Vendor Batch",
                dicoJsPalletOrder: "Non puoi creare pallet con data inferiore al padre : ",
                seqnumber: "Seqnumber",
                negativeOEEWarning: "ID Errore :31001 Break-down deve essere inferiore a Run-time + Set-up.",
                openItems2: "Open Items",
                inBoundErrorQuantityTotal: "La quantità totale deve corrispondere al totale della transazione selezionata.",
                requested: "Richiesti",
                cycleCount: "Conta Ciclica",
                lblRePrintInfoInnerHtml: "Select printer to reprint to?",
                operations: "Operazioni",
                reasonCodeDescription: "Descrizione Reason Code",
                mustInsertWo: "Devi inserire un valore per l&apos;ordine di produzione",
                labelPalletCount2: "{0}/{1}",
                processed: "Processati",
                toBeLoaded: "Da Caricare",
                sapClass: "Classe SAP",
                lbl_spoilage_item_classes_title: "Classi Spoilage",
                bpcsDescription: "Descr.SAP",
                materialCode: "Codice Materiale",
                errorSavingActivity: "Errore nel salvataggio delle attività",
                couldNotIssueConsumtionX0: "Impossibile rilasciare il consumo. Error# w0007: {0} ",
                systemStatus: "Stati Ordine ",
                btnNo: "No",
                rsgSearchNoLine: "Seleziona una linea o un ordine per procedere!",
                uom: "UdM",
                end: "Coperchio",
                all: "Tutto",
                day: "Day",
                bin: "Bin",
                can: "Scatola",
                noP: "NoP",
                new: "Nuovo",
                loc: "Loc",
                lot: "Lot",
                key: "it-IT",
                qty: "Qtà",
                wgt: "Peso",
                whs: "Mag.",
                tab: "Tab",
                wcl: "CdC/L",
                wms: "WMS",
                seq: "Seq",
                poc: "Stato Operazione Precedente",
                pal: "Pal",
                sNo: "Num.Ses.",
                sol: "OC\\L",
                inBoundLitMat: "Materiale",
                empty: "Vuoto",
                error: "Errore",
                inBoundLnkAdd: "Aggiungi una nuova Linea",
                admin: "Admin",
                apply: "Applica",
                found: "Trovato",
                front: "Fronte",
                gauge: "Spessore",
                group: "Gruppo",
                diam1: "Diam.1",
                diam2: "Diam.2",
                main: "Principale",
                beats: "Nervature",
                batch: "Batch",
                block: "Blocca",
                btnGo: "Conferma reimballo di nuovi pallets",
                color: "Color",
                close: "Chiudi",
                clear: "Indietro",
                areYouSureRelease: "Sei sicuro di voler rilasciare questi pallet?",
                infos: "Info Principali",
                input: "Input",
                nopwc: "Pr.Ope. WC",
                nopdt: "Pr.Ope. DO",
                notes: "Note",
                consumeScrap: "Consume\\Scrap",
                order: "Ordine",
                label: "Etichetta",
                btnCancel: "Cancella",
                untdw: "UN\\TDW",
                transNotSent: "Attenzione: Le transazioni non sono state inviate a SAP",
                hours: "Ore",
                value: "Valore",
                valid: "Valido",
                width: "Larghezza",
                tKeys: "Gestione T-Keys",
                reset: "Azzerare",
                rivet: "Rivetto",
                start: "Data Da",
                scrap: "Scarto",
                setUp: "Set-Up",
                small: "Basso",
                shift: "Turno",
                shell: "Shell",
                sheet: "Foglio",
                print: "Stampa",
                pause: "Pausa",
                sName: "Nome Sessione",
                goBacktoCurrentActivity: "Ritorna alla Attività Corrente",
                titleWoMan: "Work order {0}",
                noAPSData: "Nessun dato inserito per questa attività",
                insertNew: "Inserisci nuovo record",
                rxg_From: "Da:",
                rxg_Open: "Apri",
                docPath: "Percorso Doc.",
                areYouSureDelete: "Sei sicoro di volere cancellare questi pallet?",
                litWomMaterial: "Material",
                shipNotes: "Note Spedizione",
                metalAndEnds: "Metallo e Coperchi",
                shipManag: "Gestione Spedizione",
                inBoundLitCouncil: "Completa la casella di testo e seleziona Cerca",
                couldNotDeleteConsumtionX0: "Impossibile cancellare il consumo. Error# w0004: {0} ",
                shipNote: "Note Spedizione",
                shipment: "Spedizione",
                palletID: "ID Pallet",
                freeText1: "Testo Libero 1",
                freeText2: "Testo Libero 2",
                inBoundDxColLotNumber: "Lotto",
                selectAll: "Seleziona Tutti",
                shipments: "Spedizioni",
                tNotConfigured:
                    "I reason code di default per l&apos;importazione da APS non sono configurati correttamente per questo dipartimento",
                dicoCartonDetails: "Carton Details",
                deliveryResult: "Result",
                username: "Username",
                userTime: "Ora Locale",
                pausePrinting: "Pausa stampa",
                labelName: "Nome Etichetta",
                x0OfX1PaletsApproved1: "{0} of {1} pallets approved.",
                lastEdit: "Ultima Modifica",
                addLoad: "Aggiungi Delivery",
                addUser: "Agg. Utente",
                printFailedWithException: "{0}. Stampa annullata per progr. {1} Error# w0020. ",
                btnSeachWom: "Search Workorder",
                shipCheckIn: "Fai il check - in",
                consPerc: "% Consumo",
                palletExpired:
                    "Il pallet che stai per consumare è scaduto. La data di scadenza è {0}. Sei sicuro di voler continuare comunque?",
                consumed: "Consumati",
                cartonQuantity: "Quantità",
                netWeight: "Peso Netto",
                orderedQty: "Qtà Ord.",
                nextOpeWC: "Linea Successiva",
                nextSeqNo: "Next Seq No.",
                purchaseOrder: "Ordine di Acquisto",
                areYouSureReturnToVendor: "Sei sicuro di voler ritornare al fornitore i pallet selezionati?",
                addBatchLot: "Aggiungi Batch\\Lotto",
                actions: "Azioni",
                materialDescription2: "Descr. Materiale",
                quantity: "Q.tà",
                loadManagement: "Gestione  Delivery",
                scrapSelectedSSCC: "Scrap pallet selezionati",
                areYouSureMassiveApprove: "Sei sicuro di voler rilasciare i pallet? {0} di {1} pallet saranno aggiornati",
                checkSSCC: "Are you sure you want to remove consumption for ",
                checkSLED: "Controllo Data Scadenza",
                inBoundTxtMatError: "Il campo materiale non può essere vuoto e deve avere almeno 3 caratteri.",
                apsImportHistory: "Storia delle importazioni APS",
                compound: "Mastice",
                massActivities: "Operaz.Multiple",
                palletStatusEdit: "Gestione Pallet Status",
                lstDefault: "None",
                wantToMove: "Sei sicuro di voler spostare i pallet selezionati nella delivery selezionata?",
                printJSFailed: "Print Failed.",
                noResult: "Nessun Risultato",
                inBoundDxSelectTran: "Seleziona una Transazione",
                rxg_Failed_to_set_print_parameters_with_error___0_:
                    "Errore nell&apos;impostazione della stampante, messggio di segnalazione: {0}",
                x0OfX1PaletsScrapped: "{0} di {1} pallet scartati.",
                createLoad: "Crea  Delivery",
                litMainByProd: "By Prod 1",
                customer: "Cliente",
                custCode: "Cod.Cli",
                custName: "Nome Cliente",
                rxg_Defect_comment_must_be_less_than_255_characters_: "Il commento del difetto deve essere minore di 255 caratteri.",
                loadDateTime: "Data\\Ora Deliv.",
                loadDateFrom: "Data Creaz. Deliv.",
                apsImport: "Importa da APS",
                yourAccountIsLockedPleaseContactTheHelpdes: "Account bloccato, prego contattare l&apos;Help Desk.",
                colorName: "Codice Colore",
                shiftTime: "Orari Turno",
                colorDesc: "Decrizione Colore",
                disabledOperators: "Mostra solo gli operatori disabilitati",
                totWgtScan: "Tot. Peso",
                couldNotDeleteOpenItemX0ErrorX1: "Impossibile cancellare Open Item {0} Error# {1}",
                transactionType: "Transaction Type",
                couldNotUnblockPalletErrorX0X1: "Impossibile sbloccare il pallet. Error#{0}:{1}",
                backToConsumptionScreen: "Torna alla schermata di consumo",
                lblErrbtnConsumptionClick1: "&quot;Cannot add the material. {0} : error# {1}&quot;",
                antiImp: "Anti.Impl.",
                rxg_OfflinePrintHeader: "Stampa Offline",
                scanNewMaterial: "Leggi Nuovo Materiale",
                deleteTKeyGroupConfirm: "Sei sicuro di voler cancellare i gruppi Tkey?",
                addingTwoIdenticalDefects: "Adding two identical defects (type and mould)",
                printResult: "{0} label have been sent to the print list (see below for more information about its status).",
                workOrderSpoilage: "Scarti ordini produzione",
                goosReceip: "Ricevimento",
                messagesCount: "No Messaggi",
                inBoundLitTransac: "SelezioneTransazione",
                areYouSureUnblock: "Sei sicuro di volere sbloccare questi pallet?",
                rxg_Scrap_failed_with_error__: "Scarto fallito con errore:",
                notesDelNote: "Note Bolla",
                inBoundErrorPalletEdition:
                    "La creazione dell etichetta attuale non è completamente aggiornata. Aggiorna le righe e dopo potrai stampare.",
                closeLine: "Chiudi Linea/e",
                loadStatus: "Stato Delivery",
                dontprint: "Non stampare",
                tracDifferentDialogText:
                    "Traceability batch is different from the one in consumption. The new one would be {0}. Do you want to continue anyway? Or do you want to change the traceability info to the newest ones?",
                areyousureyouwanttodeleteSSCCX0X: "Sei sicuro di volere cancellare l&apos; sscc:{0}?",
                areYouSureRevoke: "Seleziona il bin in cui vuoi spostare i pallet selezionati",
                quantityXPallet: "QuantitÓ x Pallet",
                lblConfirmOff: "This pallet has 0 Qty ! you can t use it",
                printPallet: "Stampa Pallet",
                validationSummary: "Errori da risolvere per poter procedere.",
                inBoundConfirmCreation: "Sei sicuro di voler crearlo? Questo cambierà lo stato della transazione da stampare.",
                areYouSureScrap1: "Sei sicuro di voler scartare questi pallet?",
                startNewSession: "Apri Nuova Sessione",
                runTime: "Run-Time",
                woMPallFullQty: "Full",
                firstPalletWOShift: "Primo SSCC del turno per il WO",
                litByProduct: "ByProduct 1 Material",
                ordered: "Ordinato",
                cmrEnds: "Pallet di coperchi",
                cmrCans: "Pallet di scatole",
                couldNotReturnToVendorPalletErrorX0X1: "Ritorno al fornitore impossibile. Error#{0}:{1}",
                repacking: "Repacking",
                closeWorksOrder: "Chiudi Ordine di Produzione",
                changeLog: "Log modifiche",
                scheduledDateTime: "Data - Ora Programmata",
                extWhsB2B: "Bin Mag. Esterno (con B2B man)",
                areYouSureApprove: "Sei sicuro di voler rilasciare i pallet selezionati?",
                offlineconsumption: "CONSUMO OFF-LINE ",
                efficiencyoftheLine: "Efficienza della Linea ",
                consQtyPal: "Qtà Cons&lt;br&gt;Pallet",
                x0OfX1PaletsUnblocked1: "{0} di {1} pallet sbloccati.",
                dicoHtmlConfirRepack: "Conferm il reimballo",
                userNameLabelText: "Nome Utente",
                printLoadList: "Stampa Pack list",
                x0OfX1PaletsDeletedStoppedAtErrorForSSCCX2:
                    "{0} di {1} pallet cancellati. Fermato all&apos;errore per l&apos; SSCC:{2} -{3}",
                scheduleWorkOrder: "GPO Scheduling",
                doYouWantToActivate: "Vuoi attivare un nuovo Ordine di Produzione?",
                scheduled: "Pianificati",
                newTransfer: "Nuovo Trasferimento",
                scanMulti: "Leggi SSCC multipli",
                ssccConsumed: "SSCC Consumato",
                notShowSUS: "Non Mostrare SUS",
                doYouSetWorkOrderDefaultDataCollection: "Sei sicuro di voler impostare {0} come WO predefinito per questo turno?",
                insideSideStripe: "Side Stripe Interno",
                litCustMatDesc: "Description",
                noOfCartons: "Nr. di Cartoni",
                printingComplete: "Stampa Completata",
                bpcsWhsLocDes: "Mag\\Loc\\Desc.SAP",
                couldNotApprovePalletErrorX01: "Could Not Approve pallet. Error# w00010: {0}",
                material: "Materiale",
                scanSingle: "Leggi singolo SSCC",
                scanningLog: "Log di Lettura",
                mustSelectPass: "Devi selezionare il numero di passata per procedere",
                printScreen: "Print Screen",
                errorMatchingExtID: "Errore nel trovare un codice SSCC corrispondente al codice identificativo esterno",
                inBoundDxPrintStatus: "Status stampa",
                shipmentManagement: "Gestione Spedizione",
                printStatus: "Stato stampante",
                areyousureyouwanttoconsumescrapSSCC: "Are you sure you want to consume and scrap SSCC",
                dateTimeInconsistency: "L&apos;intervallo di tempo selezionato non è consistente",
                closeReturn: "Close and return lines",
                maxNoCopies: "Numero max Copie",
                woAvailable: "List of GPOs Available",
                checkDatesfuture: "Cannot consume in the future",
                dicoJsPalletquantity: "Non puoi usare maggiori risorse dello origine",
                sapLocked: "Blocco modifica Delivery attivo in SAP",
                characteristics: "Caratteristiche",
                userComment: "Commento Utente",
                rxg_Could_not_close_job__0___Error___1_: "Impossibile chiudere il lavoro:  {0}: Error# {1}",
                sealContainer: "Seal Cont.",
                palletCondition: "Condiz.Pallet",
                rxg_QiPalletsSelectedCount: "Condition of {0} Blocked QI pallet(s) won&apos;t be updated in bulk mode",
                couldNotUnblockPalletErrorX01: "Impossibile sbloccare il pallet. Error# w00010: {0}",
                plantBin: "Bin Plant",
                litCopyNumber: "Number of copy",
                useAllStock: "UTS ",
                litWomDec2: "Desc2",
                litWomDec1: "Desc1",
                btnYesReturn: "Ho reso  {0} nella quantità",
                saveStay: "Salva e Rimani",
                btnPrintNextCarton: "Stampa Cartone successivo",
                dicoHtmlSelectMatOnHold: "selected",
                productionOrderRunning: "Production Order Running",
                massIssue: "Consumo di Massa",
                noOfPallets: "Nr. di Pallet",
                labellingStatus: "Stato Etichettatura",
                salesOrderLine: "NoRiga",
                qtyProduced: "quantity produced",
                overProdText:
                    "Stampando questa etichetta, la quantità prodotta sara maggiore di quella pianificata sull&apos;ordine. Sei sicuro di continuare?",
                rxg_Please_select_the_pass_number_: "Prego inserire numero di passata?",
                litQuantitySchedule: "Quantità programmata",
                article: "Articolo",
                ignoreSapUpdates: "Ignore SAP updates",
                litWait: "Attendere Prego...",
                litMain: "Main",
                printUsingAlternatePrinterFailed:
                    "Impossibile stampare anche con la Stampante Alternativa. Vuoi provare a stampare ancora?                                            Clicca Sì per utilizzare la stampante alternativa o clicca NO quindi premi STAMPA  per riprovare con la stampante predefinita.",
                childPallets: "Produced Pallets",
                isActive: "Attivo",
                lblErrbtnConsumptionClick1Exception: "Cannot add the material.  error# {0}",
                activityDefaultInstructions: "Valori di default per le nuove attività",
                printPartiallyFailed:
                    "Stampa annullata per progr. {0} Error# w0021. Solo {1} di {2} etichette sono state stampate. Desideri ristampare le etichette mancanti?",
                qtyScheduled: "quantity schedule",
                rxg_Could_not_close_job___Error___0__: "Impossibile chiudere il lavoro: Error# {0} ",
                nbStorageUnit: "Nr Pallet",
                consumeSSCC: "Consuma SSCC",
                goRuntime: "Vai a Runtime",
                totNPScan: "Tot. Num.Pallet",
                rememberSave: "Ricorda di salvare i default",
                totalShiftDuration: "Durata del turno (min.)",
                labelPalletInProgress: "Pallet in corso:Corrente SSCC {0}",
                printFailed: "Stampa annullata per il progr. {0}.  Vuoi ristampare questa etichetta?",
                endDateTime: "D\\O Fine",
                shiftPatternNumber: "Numero Turno",
                approvePallet: "Positive Release",
                selectMaterials: "Seleziona articoli per il trasferimento",
                approve: "Approve",
                rxg_Consumption2: "CONSUMO ON-LINE",
                x0OfX1PalletsReturnedToVendor: "{0} of {1} pallets Returned to Vendor",
                pleaseSelectOrderBin: "Selezionare un ordine od un bin",
                mouldNo: "No Stampo",
                rxg_Add_Defect: "Aggiungi difetto",
                requiredFields: "I valori mancanti necessari sono evidenziati in rosso*",
                cartonType: "Quantità per cartone",
                reqQtyPal: "Qtà Rich.&lt;br&gt;Pallet",
                extLabelNotFound: "Nessun pallet trovato con l&apos;identificativo esterno {0}",
                printJSCancelRequest: "Cancellation Request Received.",
                remaining: "Rimanente",
                workOrderStart: "Data Inizio Ordine",
                litPrintHistory: "Storico Stampe",
                othInfo: "Altre Info",
                printEngine: "Print Engine",
                partDescription: "Descrizione Articolo",
                litCustomerGTIN: "CustomerGTIN",
                lblRePrintInfo: "Seleccione la impresora",
                areYouSureUnblockComment: "Inserisci un commento prima di procedere se vuoi sbloccare i pallet selezionati",
                copySscc: "Copy SSCC",
                printDefect: "Stampa etichetta difetti",
                inboundYes: "Sì",
                labelCurrentActivityError:
                    "Alcuni errori nella Attività Corrente per questa Linea!!                                                                    Desideri continuare spostandoti su un&apos;altra Linea?",
                couldNotReturnToVendorPalletErrorX0: "Ritorno al fornitore impossibile. Error# w0009: {0}",
                basicDataText: "Note Articolo",
                pleaseContactHelpdesk:
                    'Please contact <a href="mailto:helpdesk@ardaghgroup.com">helpdesk@ardaghgroup.com</a> for new accounts',
                areYouSureMassiveUnblock: "Sei sicuro di voler procedere allo sblocco? {0} pallet su {1} selezionati saranno sbloccati.",
                rxg_Back_to_labeling: "Torna all&apos;Etichettatura",
                rxg_Yes: "Sì",
                materialDescription: "Materiale",
                beginPrinting: "Inizio stampa",
                scanSessions: "Sessioni di Lettura",
                rxg_defectsTable_Initials: "Initials",
                woMMAterialNameError: "this Material doesn t exist : ",
                manningValidation: "Il manning deve essere un valore numerico",
                litLabelCreation: "Creazione Etichetta",
                department: "Reparto",
                movementDescriptionDefault: "Pallet Updated",
                finished: "Completato",
                withCarton: "Con Cartoni",
                chordBar: "Chord Bar",
                outisdeShiftTime: "L&apos;attività deve essere tra {0} e {1}.",
                removeAmendmentMarker: "Rimuovi il blocco modifica Delivery in SAP",
                noBinSelected: "Nessun Bin Selezionato",
                onLINECONSUMPTION: "CONSUMO ON-LINE",
                offlineconsumptionmetalandends: "CONSUMO OFF-LINE METALLO E COPERCHI",
                labelDefaultTitle: "Attività Corrente Etichettatura",
                plantTime: "Ora Server",
                generatePartPallet: "Genera Part pallet",
                failedToReturnSsccInDbX0: "Errore reso SSCC nel DB. Error# w0013: {0} ",
                createShipment: "Crea Spedizione da Delivery",
                selectNone: "Select None",
                blockPackaging: "Blocco per Imballaggio",
                sendToSAP: "Invia a SAP",
                sendTrans: "Invia SAP Transaction",
                renameSession: "Rinomina Sessione",
                lacquer: "Vernice",
                leavingthispagewillstopprinting: "Uscendo da questa pagina la stampa verrà interrotta ",
                reprint: "Ristampa",
                manning: "Manning",
                shipmentOv: "Panoramica Spedizioni",
                billOfMaterials: "Distinta Base",
                woSClosed: "Closed",
                refresh: "Aggiorna",
                useAllStockTooltip: "Usa tutto lo stock",
                matCode: "Cod.Materiale",
                rxgSearchLT30Days: "La ricerca non può superare i 30 giorni.",
                release: "Rilascia",
                litCustCode: "Customer Code",
                litCustomer: "Customer info",
                dataCollection: "Data Collection",
                rxg_CouldNotDeletePallet: "Impossibile cancellare il pallet. Error#{0}:{1}",
                tabColor: "Colore Tab",
                logDate: "Data Log",
                loading: "In Caricamento",
                loadInq: "Ricerca  Delivery",
                loadQty: "Qtà Caricata",
                byProductDetails: "Per Dettagli Prodotto",
                inBoundLitWarehouse: "Magazzino",
                extLabelId: "Rif.Est.Pall.",
                consumptionWorkorder: "Cons.WO",
                rxg_CouldNotDeletePallet1: "Impossibile cancellare il pallet. Error#:{0}",
                localServerOffline: "Local Server is Offline.",
                destinationBin: "Bin di Destinaz.",
                customerDetails: "Dettagli Cliente",
                finalPass: "Passata Finale",
                cannotMove: "Non c&apos;è alcuna delivery in cui spostare i pallet selezionati",
                areyousureyouwanttoreturnSSCC: "Sei sicuro che l&apos; SSCC sia reso?",
                deliveryEmptyWorkorder: "no work order for this pallet. you can t print it",
                rxg_Select_work_order_for_consumption: "Seleziona Ordine di Lavoro per il Consumo",
                statusFront: "Stato Fronte",
                backToConsumptionDetail: "Torna alla schermata di dettaglio del consumo",
                printLabels: "Stampa Etichette",
                palSatDefaultTitle: "Gestione Pallet Status",
                calcGrossWeight: "Calc.P.Lordo",
                closureType: "Chiusura",
                message: "Messaggio",
                vendorPalIdent: "Vendor Pal ID",
                packagingList: "PackList",
                inBoundBtnExit: "Esci",
                failureReason: "Motivo Errore",
                stagingAreaManagement: "Gestione Staging Area",
                closeButton: "Chiudi",
                cantDelete: "Errore Numero: {0} Impossibile cancellare.",
                printJSCancelFailed: "Cancellation Failed",
                assignNewJob: "Assegna nuovo lavoro",
                btnYes: "Si",
                rxg_Delete_Pallet: "Cancella pallet",
                noPalletScanned: "Nessun pallet letto. Sei sicuro di voler continuare?",
                ringDiameter: "Diametro Anello",
                btnWoMan: "Manage Work Order",
                inBoundStrCoilNr: "SU reference",
                noChangesMade: "No changes made",
                woSequenceScheduled: "GPO Sequence Scheduled",
                dicoHtmlOriginalQty: "Qta orginale",
                inBoundErrorLabelRank: "Il numero di etichetta deve essere numerico",
                startDateIsLaterThanEndDate: "Data inizio successiva alla data di fine.",
                inBoundDxwarehouse: "Magazzino",
                rxg_You_must_enter_a_comment_for_the_defect_s__: "Devi inserire un commento per i(l) difetti(o).",
                selected: "Selezionato",
                errorCommandNotRecognised: "Errore: comando non riconosciuto. Error# w0011",
                storageUnit: "Pallet",
                userNotes: "Note",
                extBarcode: "External Barcode",
                userInfo2: "Descr.",
                rxg_Cannot_issue_the_material___0___error___1_: "Non è possibile rilasciare il materiale. {0}: error# {1}",
                moveSSCC: "Sposta SSCC",
                noColoursValidation: "Il numero di colori deve essere un valore numerico",
                lblFailErr: "Errore :",
                btnYesWarn: "Sì",
                totalMinutesBooked: "Tempo totale inserito (minuti)",
                palletNotFound: "SSCC {0} non trovato",
                description: "Descrizione",
                notUpdateByERP: "Campi non aggiornati da ERP",
                palletStatusId: "Stato ID",
                rxg_ApproveFailedWithError: "Positive Release fallito con errore {0}",
                sheetChar: "Caratteristiche foglio",
                startSession: "Apri Sessione",
                firstTimeProdShort: "1°volta",
                initQty: "Qtà Ini",
                woMPallTxtModQty: "Changed by Operator",
                intPass: "Pass.Int.",
                binInquiry: "Ricerca nei Bin",
                youCanOnlyHaveNumberOfPalletsIssuedConsume:
                    "You can only have {0} pallets issued. Would you like to consume the oldest issued?",
                chkError: "Ottieni solo Log Errori ",
                selectDefects: "Seleziona difetti:",
                couldNotGetConsumptionPalletDetailsForJobE:
                    "Impossibile ottenre il dettaglio dei pallet consumati per il lavoro Error# w0006: {0} ",
                couldNotGetConsumptionPalletDetailsForJobX:
                    "Impossibile ottenre il dettaglio dei pallet consumati per il lavoro {0}: Error# {1}",
                rankFrom: "Rank da",
                couldNotUpdateExpiryDatePalletErrorX0: "Errore nell&apos;aggiornamento della data di scadenza : {0}",
                shipCondition: "Cond.Spedizione",
                shiftLength: "Da {0} a {1}. Totale: {2} ore",
                checkSLEDText:
                    "Sei sicuro di voler consumare il pallet selezionato? La sua data di scadenza è &lt;b&gt;{0}&lt;/b&gt;. &lt;/br&gt; Il pallet con la data scadenza più vecchia sarebbe: &lt;/br&gt;&lt;/br&gt; - sscc:&lt;b&gt;{1}&lt;/b&gt; &lt;/br&gt; - data scad.: &lt;b&gt;{2}&lt;/b&gt; &lt;/br&gt;&lt;/br&gt; Inserisci il tuo nome ed un commento se vuoi continuare col pallet corrente. &lt;/br&gt;&lt;/br&gt;",
                smallQtyNumeric: "Qta Basso solo numeri interi",
                assignedSuccessfully: "Assegnato Correttamente",
                consumptionCannotBeDisplayedNoWO:
                    "Il Consumo non può essere visualizzato. Nessuno OdP è stato selezionato. Assegna un Lavoro a questa linea.  error# w0002",
                rxg_defectsTable_Defect: "Defect",
                reactivateSession: "Riapri Sessione",
                reasonCode: "Reason Code ",
                reasonDesc: "Descrizione Scarto",
                material12: "FP12",
                documents: "Documenti",
                lblOIErrorDate: "wrong date!",
                inBoundDxColLocation: "Locazione",
                defectsModified: "Defects or status changed. Please refresh",
                failedToReturnSsccInDbX0ErrorX1: "Errore reso SSCC nel DB. {0} Error# {1}",
                fullQtyNumeric: "Qta Alto solo numeri interi",
                shiftPatternName: "Nome Turno",
                condition: "Condiz.",
                aplWarehouse: "Mag.APL",
                shortText: "Testo ",
                rxg_Back_to_current_activity: "Torna alla attività corrente",
                spoilageItemClasses: "Classi Spoilage",
                messages: "Messaggi",
                deliveryTextPurchaseOrder: "Customer Purchase Order",
                duration: "Durata",
                loadShiftsTip: "Load shifts for line and Date selection. Carica turni per",
                inBoundIntLabelRank: "N. di etichette",
                printJSServerOffline: "Server Offline.  ",
                deliveryTitleCustCode: "Customer code :",
                lblConfiramtionReturn: "Vuoi confermare la Quantità 0 di Reso?",
                controlKey: "Controllo",
                previousBatchNr: "Prev.Batch Nr",
                btnYesReturn2: "Ho chiuso l&apos; Ordine di Produzione \\n perchè ho reso 0 nella quantià",
                newPalletNumber: "Nuovo Numero pallet",
                rxg_Is_the_previous_SSCC___0___completely_consumed___dialog__apl00002:
                    "Il precedente  SSCC ({0}) è stato completamente consumato?",
                haveFollowingPalletsBeenFullyUsed: "Have following pallets been fully used?",
                cartonError: "La Quantità Totale non corrisponde la quantità dei pallet selezionati!!",
                oldValue: "Vecchio Valore",
                qtyshe: "Qtà in stock inferiore a quella richiesta",
                areYouSureMassiveDelete: "Sei sicuro di voler cancellare? {0} pallet su {1} selezionati saranno cancellati. ",
                deliveryTextNoteNr: "Delivery Note Nr.",
                component: "Componenti",
                backUpServer: "Running on back up central server.",
                binsNumber: "Numbero di Bin",
                palletIdentify: "Identificativo Pallet ",
                rxg_SSCC___0___has__1__quantity_and_cannot_be_consumed__error_4123:
                    "SSCC ({0}) ha {1} quantità e non può essere consumato. error#w0023",
                byProduct4: "Prod.Alternativo 4",
                byProduct1: "Prod.Alternativo 1",
                byProduct3: "Prod.Alternativo 3",
                byProduct2: "Prod.Alternativo 2",
                byProducts: "Prodotti Alternativi",
                areYouSureBlock: "Sei sicuro di volere bloccare questi pallet?",
                calcNrColli: "Calc.N.Colli",
                couldNotDeleteOpenItemX0: "Impossibile cancellare Open Item Error# w0005: {0} ",
                litScanNewMaterial: "Scan New Material",
                areYouSureScrap: "Sei sicuro di volere scartare questi pallet?",
                countdown: "Countdown",
                checkSLEDError: "Devi inserire nome utente e un commento per poter consumare questo pallet",
                deliveryPicking: "Delivery Picking",
                preventERPUpdate: "Ferma ogni aggiornamento da ERP (SAP o BPCS)",
                hotKeyInfo: "Press {0} to print.",
                hotKeyWait: "Please wait.",
                onlineConsForbidden: "Consumo online\\offlline vietato su questa linea. Si prega di utilizzare il consumo Open Item.",
                noOfPalletsProduced: "Nr. di Pallets Prodotti nell&apos; Ordine",
                inLineJob: "Inline Job",
                rxg_Label_parameters: "Parametri etichetta",
                rightClickError: "Attenzione: click destro non permesso su una riga non selezionata",
                closeConsumption: "Chiudi/Consuma",
                localServerOnline: "Local server is online.",
                dicoHtmlScanSSCC: "Scannerizza Nuovo SSCC :",
                defectDesc: "Desc.Difetto",
                dicoHtmlRepackNew: "Data reimballo nuovo pallet",
                x0OfX1PaletsReturnedToVendorStoppedAtErrorForSSCCX:
                    "{0} of {1} pallets ReturnedToVendor. Stopped at error for SSCC:{2} -{3}",
                statusHistory: "Storico dello stato",
                mvtDesc: "Desc.Mov.",
                mvtDate: "Data Mov.",
                mvtType: "Tipo Movimento",
                bpcsWarehouse: "Mag.SAP",
                forTheNewPalletNo: "Per il nuovo numero del pallet",
                tKeyCode: "Codice TKey",
                rxg__0__assigned_to__1_: "{0} assegnato a {1}",
                inBoundBtnReset: "Reset Data",
                fullQtyGreaterThanSmall: "Qta Alto deve essere maggiore di Qta Basso",
                inBoundDxColunit: "Unità",
                couldNotBlockPalletErrorX0: "Impossibile bloccare pallet. Error# w0003: {0}",
                inBoundDxComment: "Bolla di consegna",
                operationText: "Testo Operazione",
                removeLoad: "Rimuovi  Delivery",
                removeSSCC: "Rimuovi SSCC",
                totPallet: "Tot.Pallet",
                name: "value",
                ears: "Borchie",
                edit: "Visualizza",
                exit: "Esci",
                foil: "Foglio All.",
                full: "Alto",
                date: "Data",
                desc: "Desc ",
                done: "Fatto",
                dock: "Dock",
                move: "Sposta",
                memo: "Memo",
                back: "Indietro",
                coil: "Coil",
                cond: "Cond.",
                code: "Codice",
                clbk: "Libro dei colori",
                cher: "Mix  Pronto",
                item: "Item",
                inkr: "Inchiostro miscelato pronto",
                next: "Pross.",
                okay: "Conferma",
                oops: "Errore inaspettato. Ci scusiamo per l&apos;inconveniente. L&apos;errore è stato registrato, nel caso si ripetesse, prego contattare l&apos;Help Desk.  Error# w0016",
                open: "Apri",
                line: "Linea",
                load: " Delivery",
                user: "Utente",
                unit: "Unità",
                view: "Visualizza",
                tKey: "Tkey",
                tool: "Attrezzatura disponibile",
                text: "Testo ",
                time: "Ora",
                rpfr: "File di ripetizione pronto",
                rank: "Rank",
                ppop: "Lastra di stampa creata (Op)",
                stop: "Stop",
                prtm: "Lastra di stampa creata (Intestazione)",
                seam: "Aggraffato",
                send: "Invia",
                save: "Salva",
                sscc: "SSCC",
                pass: "Passata",
                btnWorkOrderSpoilage: "Scarti OP",
                bpNoOfCopies: "Nr. di Copie",
                dicoHtmlRepackProgress: "Materiale per il reimballo in processo:",
                shippingModule: "Modulo Spedizioni",
                saveShiftAreYouSure: "Sei sicuro?",
                packsRemaining: "Pack rimanenti",
                litWoOpeByProd4: "By Prod 4",
                litWoOpeByProd2: "By Prod 2",
                litWoOpeByProd3: "By Prod 3",
                custCrossRef: "Customer Cross Ref",
                rxg_No: "No",
                openItemNotInBOM:
                    "L&apos;articolo {0} non è nella distinta base dell&apos;ordine {1} che è attualmente in consumo su questa linea",
                cartonProdResume: "Produzione Cartone: Riprendi",
                shiftPatterns: "Gestione Turni",
                consumptionStatus: "Stato Consumo",
                couldNotApprovePalletErrorX0X1: "Non si può approvare il pallet. Error# {0}:{1}",
                inBoundsearch: "Cerca",
                success: "Effettuato",
                dicoHtmlAddPallet: "Aggiungi nuovo pallet da creare",
                batchMissing: "Batch Missing",
                printDate: "Print Date",
                printDown: "System.Drawing.Bitmap",
                barcode: "Barcode",
                lotNotWhole: "The value for Lot is not whole a number.  Insert Cancelled.",
                lotExists: "The value for Lot already exists on this work order. Insert Cancelled.",
                addMultipleBatches: "Add Multiple Batches",
                inLine: "In Line",
                batchNotWhole: "The value for Batch is not whole a number.  Insert Cancelled.",
                noDays: "No Days",
                layers: "Layers",
                materialMissing: "Material Missing",
                startDateNotGood: "The value for Start Date is not a correctly formatted date.  Insert Cancelled.",
                printUp: "System.Drawing.Bitmap",
                customerGTIN: "CustomerGTIN",
                dateScheduleFuture: "You are going to assign a job scheduled for a future date.",
                errorNewBatch: "An error occured preparing to insert a new Batch.",
                errorDeleteBatch: "An error occured deleting the selected Batch.",
                missingNoDays: "You need to insert the number of days to generate the batches",
                priorityMissing: "Priority Missing",
                litQuantityXPallet: "Pallet Qty",
                endDateNotGood: "The value for End Date is not a correctly formatted date.  Insert Cancelled.",
                searchWorksOrder: "Search Works Order",
                noRecFound: "No Records Found",
                errorUpdateBatch: "An error occured updating the selected Batch.",
                rxg_defectsTable_Found: "",
                billOfBatches: "Bill Of Batches",
                selectPage: "Select Page",
                testPrint: "Test Print",
                batchExists: "The value for Batch already exists on this work order. Insert Cancelled.",
                dayAlreadyExists: "The value for Day already exists on this work order. Insert Cancelled.",
                dayNotWhole: "The value for Day is not whole a number. Insert Cancelled.",
                workorderAssignedPrinting: "Workorder was assigned for Label printing. Switch to activity?",
                workorderAssignedConsumption: "Workorder was assigned for consumption. Switch to activity?",
                jobIn: "Job In",
                statusChangeNotAllowed: "Status change not allowed",
                deselect: "Deselect",
                resetView: "Reset View",
                searchForDelivery: "Cerca per Spedizioni",
                deliveryNoteMerck: "Bolla di Consegna",
                dropLocation: "Zona scarico",
                deliveryNoteWrong: "Nessuna informazione trovata per la Bolla inserita",
                deliveryPalletListEmpty: "Nessun pallet trovato (ricordarsi che i dati importati da SAP necessitano fino a 6 minuti)",
                dropLocationEmpty1: "Seleziona zona di scarico",
                dropLocationEmpty2: "Seleziona zona di scarico",
                dropLocationTooltip: "Seleziona la zona di scarico indicato dal cliente nella Bolla di Consegna",
                deliveryNoteEmpty: "Prego digitare Bolla di Consegna",
                deliveryNoteTooltip:
                    "Prego inserire una Bolla di Consegna valide come potete trovare nel vostro documento di consegna da SAP",
                containerVolume: "Volume",
                youCanOnlyHaveNumberOfPalletsIssued: "You can only have {0} pallets issued",
                lineIn: "Line In",
                partPallet: "Part Pallet",
                manualEntry: "Manual Entry",
                issued: "Issued"
            }
        }
    },
    "nl-NL": {
        translation: {
            main: {
                palletConditionId00: "Info",
                palletConditionId01: "Produced - Not in Warehouse",
                palletConditionId02: "In Warehouse",
                palletConditionId03: "Resorted",
                palletConditionId04: "Picked",
                palletConditionId05: "Delivered",
                palletConditionId06: "Scrapped",
                palletConditionId07: "Put-Away via Storage UnitList",
                palletConditionId08: "Lost",
                palletConditionId09: "Deleted",
                palletConditionId10: "Stock Transfer",
                palletConditionId11: "Intermediate pallet",
                palletConditionId12: "Quality Inspection",
                palletConditionId13: "Blocked Resort",
                palletConditionId94: "Allocated for Delivery",
                palletConditionId99: "Label Printed",
                palletStatusId00: "Label aangemaakt",
                palletStatusId01: "Label geprint",
                palletStatusId02: "Label Printed_NIU",
                palletStatusId03: "Klant Incubatie",
                palletStatusId04: "Goed",
                palletStatusId05: "Geblokkeerd",
                palletStatusId06: "Nagesorteerd",
                palletStatusId07: "Stort",
                palletStatusId08: "Test pallet",
                palletStatusId09: "Retour pallet",
                palletStatusId10: "Kwaliteitsinspectie",
                palletStatusId11: "Saleable restricted",
                palletStatusId12: "Blocked Packaging",
                palletStatusId13: "Issued",
                palletStatusId14: "Consumed",
                palletStatusId15: "Returned",
                palletStatusId16: "Stock Received",
                palletStatusId17: "Good",
                palletStatusId18: "Deleted",
                palletStatusId19: "Repacking",
                palletStatusId20: "Loaded",
                palletStatusId21: "Shipped",
                palletStatusId22: "Scrap Warehouse",
                palletStatusId30: "PreBilled",
                palletStatusId90: "WIP",
                offlineCons: "?Offline verbruik (buiten de lijn?? - gelijk aan off-line/geen netwerk)",
                openedWO: "Opened GPOs",
                litEANGTAN: "EAN/Gtin",
                noWorkOrderOnLabelingAndOneRunningOnConsum: "Geen werkorder voor Labeling, maar wel voor Verbruik. Foutmelding# w0015",
                deliveryTextPurchaseOrderLine: "Customer Purchase Order Line",
                woSSuspended: "Suspended",
                passFirst: "Select Pass Number",
                woMPallQty: "Quantity X Pallet",
                rxg_Label_paramters_save_successfully_: "Label parameters succesvol opgeslagen",
                rxg_Please_enter_the_quantity_remaining_on_the_previous_pallet__input__APL00031:
                    "Vul het resterend aantal van de vorige pallet in.  input# APL00001",
                lblFailSSCC: "Deze SSCC {0} bestaat niet",
                string1: "",
                lblErrOI: "Return Quantity must be greater than 0! error# w0026",
                x0OfX1PaletsBlocked: "{0} van {1} pallets geblokkeerd",
                chkInPRogresse: "Krijg alleen Printaanvraag in wachtrij",
                inBoundDxDescription1: "Decription",
                popMaxcatonLimit: "the total number of carton can not exceed",
                printJSSequenceNumber: "Next Seq No.",
                litUserUpdate: "Changed by operator",
                inValidWorkOrderId: "Ongeldige werkorder ID/LijnID. Controleer database.",
                scrapped: "Vernietigd",
                rxg_Could_not_assign__0__to__1__Error____2_: "Kan {0} niet toewijzen aan {1}, Foutmelding#: {2}",
                emptyRowDelivery: "No data found with those parameters!",
                rxg_Please_select_a_defect: "Selecteer een afwijking",
                cartonCreateLastDate: "Last Production Date",
                offlinePrint: "Offline print",
                noWorkOrderOnConsumptionAndOneRunningForLa: "Geen werkorder voor Verbruik, maar wel voor Labeling. Foutmelding# w0014",
                litCartonLabel: "Carton Label",
                batchNr: "Batch Nr",
                printSuccessful: "Printopdracht voltooid",
                litNameCust: "Name",
                womTitle: "Workorder Management",
                mouldNo: "Vormnummer",
                noDefectIdSelected: "Blank DefectId selected",
                differentWOOnConsumptionAndLabeling: "Verschil in Werkorder op verbruik en Labeling. Foutmelding# w0010",
                operation: "Processtap",
                btnUpdateWoM: "Update",
                lotNotWhole: "The value for Lot is not whole a number.  Insert Cancelled.",
                unableToAddOpenItemToLineX0X1ErrorX2:
                    "Niet mogelijk om Openstaand Product toe te voegen aan Lijn {0} {1} Foutmelding#: {2}",
                batchStart: "Batch Start",
                lblErrbtnConsumeClick: "Wrong date. You can t consume pallet in the future. Change the date please!",
                labelImSwitchQty: "Switch Quantity between full and Small",
                conditionID: "Palletstatus ID",
                toolTipchkRaw: "Press update button to apply your filter(s)",
                offlinePrintingFailedException:
                    "De printer is niet gereed, printopdracht is gepauzeerd. Selecteer een nieuwe printer uit het dropdownmenu en druk op &quot; START PRINTEN&quot; om verder te gaan.",
                palletStatusDialogText: "The pallet you are going to issue is blocked. Do you want to continue anyway?",
                inBoundDxMaterialCode: "Material Code",
                consumptionNbPallet: "Nb Pallet",
                palletsQty: "Pallets",
                palletRank: "Pallet Rank",
                inBoundDxTransactionDate: "Date",
                cannotConsumeInTheFuture: "Kan niet in de toekomst worden verbruikt. Foutmelding# w0001",
                palletDetail: "Pallet gegevens",
                linePrintAll: "Print all Labels",
                deliveryNote: "Delivery Note",
                btnCartonDeleteConfirmation: "Are you sure you want to delete this carton ?",
                inBoundLitLabelName: "Label Type : ",
                printResultSuccess: "{0} copy(s) of Sequence {1} sent to printer {2} at {3}.",
                scheduledOrders: "Scheduled GPOs",
                dicoJsPalletDate: "Het is niet mogelijk een pallet in de toekomst aan te maken",
                openItems: "Openstaande Producten",
                actQty: "Aantal",
                rxg_SSCC___0___was_not_found___error__00001: "SSCC ({0}) is niet gevonden. Foutmelding#:#w0024",
                chkDetails: "Print gegevens",
                lotExists: "The value for Lot already exists on this work order. Insert Cancelled.",
                assign: "Toewijzen",
                dicoRepackSummary: "Overzicht Omverpakking",
                cartonDeleteLastDate: "Delete Last one",
                labellingPrintingComplete: "Printing Complete",
                inBoundErrorQtyLabel: "The QtyxLAbel must be a numeric.",
                noDefectsPassed: "At least one defect required for blocking",
                woMPallTxtFullQty: "Standard",
                palletsProduced: "pallets prod.",
                dicoHtmlSelectMat: "Select this material",
                goBack: "Ga Terug",
                btnDeleteLastOne: "Delete last carton",
                litMessWarn:
                    "The quantity on the pallet exceed the max quantity schedule on work order. Do you want to change the current quantity on the pallet?",
                dateIn: "Startdatum",
                delete: "Verwijderen",
                detail: "Detail",
                deleteConsumption: "Verwijder verbruik",
                lotNumber: "Lot",
                inBoundTotalLabelCreation: "Total",
                inBoundTxtTanDateError: "A valid Date is required",
                rxg_No_Department_specified__Error__w0007: "Geen afdeling gespecificeerd. Foutmelding# w0025",
                checkDateslater: "Start date is later than end date",
                dicoHtmlQuantityUsed: "Aantal verbruikt : ",
                consumptionCurrentActivity: "Verbruik Huidige Activiteit",
                inputLine: "Input Line",
                inBoundErrorReceiptDate: "The Expiry Date must be a valide date and time.",
                txtQuantityErr: "Invalide quantity",
                consumptionParameters: "Verbruik parameters",
                btnPrintPalletAndClose: "Print Pallet Label and Close it",
                failedToConsumeSsccInDbX0: "SSCC kan niet worden verbruikt in database. Foutmelding#w0012: {0}",
                inBoundIntQtyLabel: "Qty x Label",
                rxg_Could_not_assign_Work_Order___Error___0_: "Kan geen werkorder toewijzen.  Foutmelding: {0}",
                blockQi: "GEEL Afkeuren",
                blocked: "Geblokkeerd",
                unableToAddOpenItemToLineX0ErrorX1: "Niet mogelijk om Openstaand Product toe te voegen aan Lijn {0} Foutmelding#: {1}",
                noOfSheets: "Aantal bladen",
                cancel: "Annuleren",
                pickingLblNumCopy: "Number of Copy :",
                workOrder: "Werkorder",
                wantToUseAlternatePrinter: "De geselecteerde printer is niet gereed. Klik JA om alternatieve printer {0} te gebruiken",
                x0OfX1PaletsApprovedStoppedAtErrorForPalletX21: "{0} of {1} pallets Approved. Stopped at error for PalletId:{2} -{3}",
                inBoundBtnConfirm: "Confirm",
                inboundNo: "No",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheck:
                    "?SSCC {0} is geopend op de volgende lijn(en). Controleer de lijn(en) die u wilt sluiten.",
                inLine: "In Line",
                inBoundTxtwareError: "The field warhouse cannot be empty and cannot have more than 2 characters",
                lblErrbtnConsumeClickMissing: "Could not find SSCC. error# W0006",
                rxg_PrintDefect: "Print Defect",
                workOrderOp: "Werkorder/Processtap",
                batchNotWhole: "The value for Batch is not whole a number.  Insert Cancelled.",
                inBoundBtnCancel: "Cancel",
                inBoundBtnCancel2: "Finish",
                noData: "Voor deze lijn kan geen data weergegeven worden.",
                changeCloseJob: "Wijzig / Sluit werkorder",
                inValidUser: "Ongeldige gebruiker. Log opnieuw in.",
                inValidTime: "Ongeldige tijd. Vul geldige tijd in. (hh:mm)",
                woSPlanned: "Planned",
                inValidDate: "Ongeldige datum. Vul geldige datum in (dd/mm/yyyy)",
                inBoundErrorDate: "the date is not Correct",
                palletCreated: "Pallet {0} ({1}) succesvol aangemaakt.",
                x0OfX1PaletsUnblockedStoppedAtErrorForPalletX21:
                    "{0} van {1} pallets gedeblokkeerd. Gestopt op fout voor Pallet ID:{2} -{3}",
                inBoundDxColSeqNumber: "Seq",
                litPalLabel4: "Pallet Label 4",
                litPalLabel3: "Pallet Label 3",
                litWoS: "Current work order status : ",
                printAbort: "Printopdracht mislukt voor rank {0}. De server reageert niet. Foutmelding# w0017",
                labels: "Labels",
                logout: "Uitloggen",
                length: "Lengte",
                btnYesReturnDetail: "Ik sluit dit \\n omdat ik 0 terugboek",
                finalPalletRank: "Ranknummer laatste pallet",
                update: "Updaten",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheckReturn:
                    "?SSCC {0} is geopend op de volgende lijn(en). Controleer de lijn(en) die u wilt terugboeken.",
                printfailedselectanotherprinter:
                    "Printopdracht mislukt, selecteer een andere printer of probeer opnieuw. Foutmelding# w0019 ",
                batchLot: "Batch\\Lot",
                batchEnd: "Batch End",
                prodDate: "Productiedatum",
                litAllInOne: "all in one shot",
                couldNotScrapPalletErrorX0X1: "Kan pallet niet vernietigen.  Foutmelding#{0}:{1}",
                lblDefaultSetting: "Quantity for Carton {0}",
                rxg_Labeling_Pass_Number: "Labeling Nummer van Doorgang",
                lblErrbtnConsumptionClick1Else: "Could not consume SSCC invalid quantity. error# W0008.",
                btnBack: "Einde",
                dicoHtmlSapcode: "Materiaal Sap Code",
                cartonSumQty: "Number of Carton",
                rxg_Unable_to_consume_pallet__0____1__Error____2__: "Onmogelijk om pallet {0} te verbruiken: {1} Foutmelding#: {2}",
                dicoTotalQuantity: "Total Quantity",
                printMod: "?Print modus",
                thisMethodRequiresAConfirmationAndNoneIsDe: "?Deze methode vraagt om een bevestiging, deze is niet gedefinieerd.",
                litTitre: "Inbound Label",
                litWoOpe: "Work Order Operation",
                litWoMan: "Work order information",
                noWorkorder: "Geen werkorder",
                thereIsNoWorkOrderConfiguredForThisLine: "Er is geen werkorder geconfigureerd voor deze lijn",
                dicoHtmlRepackResult: "Resultaat omverpakken",
                woMPallMinQty: "Small",
                inBoundLitTranDate: "Tansaction Date",
                quality: "Quality",
                allPallets: "All pallets",
                pleaseSelectaPrinter: "Selecteer een printer om de nieuwe label op te printen",
                rxg_ThereIsNoWorksOrderAssignedForThisLine: "Er is geen werkorder toegewezen aan deze lijn",
                palletStatus: "Palletstatus",
                cuttedSheetsBlocked: "Geblokkeerd Geknipt Blik",
                litByProduct2: "ByProduct 2 Material",
                tracDialogText: "Traceability batch is missing. Do you want to continue anyway?",
                sqlTranslation: "SQL Vertaling",
                rxg_Back_to_offline_consumption: "Terug naar Offline Verbruik",
                woSInUse: "In use (On line)",
                rxg_Open_SSCC__0__on_the_following_line_s__: "Open SSCC {0} op de volgende lijn(en).",
                thislinehasajobassignedClosethejob: "Deze lijn heeft een werkorder toegewezen gekregen. Wilt u deze werkorder sluiten?",
                rxg_Work_Order_Enquiry: "Werkorder informatie",
                litQtyReq: "Quantity Requested",
                dicoHtmlMaterial: "Materiale",
                timeIn: "Starttijd",
                startDateNotGood: "The value for Start Date is not a correctly formatted date.  Insert Cancelled.",
                labelPalletCount: "Number of Pallet Procuced :&lt;br/&gt; &lt;b&gt;{0}&lt;/b&gt;",
                numberOfCopies: "Aantal kopieën",
                inBoundLitDescription: "Description",
                ckBoxCartonSave: "Met dozen",
                palletsScheduled: "pallets sched.",
                return: "?Terugboeken",
                inBoundStrVendorBatch: "Vendor Batch",
                inBoundErrorNbrPallet: "The field Nbr*OF LAbel must be a numeric greater than 0",
                scrapProduction: "Scrap Production",
                mouldAndNonMouldSameDefectId: "Unable to add mould and non-mould related with the same defect ID",
                overProdHeader: "Overproduction",
                btnUnderstoodBack: "Terug",
                defaultActivityLabeling: "Labeling",
                status: "Status",
                palSatEditSelectPrinter: "Selecteer printer om de herprint uit te voeren?",
                inBoundLitInfosTrans: "Blank = All,or OO,U,UC, UT, UR, RT ",
                search: "Zoeken",
                select: "Selecteer",
                timeEnd: "Eindtijd",
                prompt: "?Prompt",
                addDefect: "Fout Toevoegen",
                couldNotLoadWorkOrderPleaseCheckTheOrderCo:
                    "Kan werkorder niet laden. Controleer Order Code en probeer opnieuw. Foutmelding# w0008",
                pieces: "Pcs",
                couldNotIssueConsumtionX0ErrorX1: "Kan verbruik niet toewijzen. {0} Foutmelding# {1}",
                startingPalletRank: "Ranknummer startende pallet - ",
                movementDescription11: "Label Printed - Pallet Produced",
                movementDescription10: "Return Pallet off line",
                movementDescription13: "Change pallet status from SAP",
                movementDescription12: "Label Printed - Pallet Produced (offline)",
                movementDescription15: "Block pallet QI",
                movementDescription14: "Change pallet Birth Date/Condition in APL from PLC ",
                movementDescription17: "Scrap pallet",
                movementDescription16: "Release pallet",
                movementDescription19: "User connection",
                movementDescription18: "Delete/Cancel pallet",
                movementDescription01: "Start WorkOrder Front End Line",
                movementDescription02: "Stop Workorder Front End line",
                movementDescription03: "Start Workorder Back End Line",
                movementDescription04: "Stop Workorder Back End line",
                movementDescription05: "Issue Pallet on line ",
                movementDescription06: "Consumed Pallet on line ",
                movementDescription07: "Return Pallet on line",
                movementDescription08: "Delete Consumption",
                movementDescription09: "Consumed Pallet off line ",
                movementDescription33: "Block pallet for Scrap",
                movementDescription32: "Pallet quantity change",
                movementDescription35: "Scrap in Warehouse",
                movementDescription34: "Block Pallet for Packaging",
                movementDescription22: "Open Item Return ",
                movementDescription23: "Block pallet for resorting",
                movementDescription20: "Open Item Issuing",
                movementDescription21: "Open Item Consumption",
                movementDescription26: "Remove defect on a pallet",
                movementDescription27: "Defect found",
                movementDescription24: "Open Item delete",
                movementDescription25: "Add Defects to Pallet",
                movementDescription28: "Defect not found",
                movementDescription55: "SU defect removed from SAP",
                movementDescription54: "SU defect added from SAP",
                movementDescription51: "SU Updated from SAP",
                movementDescription50: "SU Created from SAP",
                movementDescription53: "SU condition Updated from SAP",
                movementDescription52: "SU status Updated from SAP",
                movementDescription44: "Approve Pallet",
                movementDescription40: "Pallet Scanned for Repack",
                movementDescription41: "Remove Pallet from Repack",
                movementDescription42: "Pallet Splitting",
                movementDescription43: "Create pallet from other",
                movementDescription60: "Pallet Locked",
                movementDescription61: "Pallet Unlocked",
                movementDescription99: "SU Imported for Go Live",
                inBoundErrorQuantity: "The field Label*Qty must be a numeric greater than 0",
                couldNotDeleteConsumtionX0ErrorX1: "Kan verbruik niet verwijderen. {0} Foutmelding# {1}",
                rxg_Consumption: "Verbruik",
                toolTipEnter: "Press Enter to apply your filter(s)",
                inBoundErrorAmount: "Error in the total amount. Please check the values and correct them",
                litSearch: "Search a new Workorder",
                currentPalletRank: "Ranknummer Huidige Pallet - ",
                rxg__0__units_returned_on_SSCC__1___When_all_pallets_are_consumed_returned__click_OK_again_to_close_the_job__dialog_w0005:
                    "{0} eenheden teruggeboekt op SSCC {0}. Wanneer alle pallets verbruikt/teruggeboekt zijn, klik opnieuw op OK om de werkorder af te sluiten. dialog#w0001",
                passNumber: "Nummer van de doorgang",
                printer: "Printer",
                bpQuantity: "Hoeveelheid",
                unblock: "Deblokkeer",
                deliverySelected: "Selected",
                couldNotScrapPalletErrorX0: "Kan pallet niet vernietigen. Foutmelding# w0009: {0}",
                quantityScrapped: "Quantity Scrapped",
                dicoHtmlLine: "Lijn",
                multipleSelectionError: "Status komt niet overeen met geselecteerde rijen. Selecteer rijen met dezelfde status opnieuw.",
                deliveryTitle: "Printing  - JWO Delivery Label",
                btnCloseOff: "Aboard",
                areyousureyouwanttoclosethejob: "Weet u zeker dat u de werkorder wilt afsluiten?",
                traceabilityInfo: "Traceability Info",
                baseProduct: "Base Product",
                litPalLabel: "Pallet Label",
                rxg_You_must_enter_your_initials_to_add_a_defect: "Vul je initialen in om een afwijking toe te voegen",
                itemClass: "Productklasse",
                inBoundErrorPalletCreation: "Error during the pallet creation. Please chech your values.",
                inBoundConfirmDelete: "are you sure you want to delete this line?",
                currentActivity: "Huidige Activiteit",
                backToCurrentActivity: "Terug naar huidige activiteit",
                confirm: "Bevestig",
                consume: "Verbruik",
                comment: "Opmerking",
                rxg_Select_work_order_for_labeling: "Selecteer werkorder voor labeling.",
                specialText: "Special Text",
                selectLines: "Selecteer lijnen",
                printJSWorksOrder: "Works Order",
                palletStatusDialogHeader: "Blocked Pallet",
                backToOfflineHome: "Terug naar Offline Beginscherm",
                consumptionPageTitle: "Consumption Declaration",
                rxg_Could_not_assign_Work_Order_Error___0____1_: "Kan geen werkorder toewijzen.  Foutmelding#:{0}: {1}",
                noOfCoils: "Aantal rollen",
                x0OfX1PaletsBlockedStoppedAtErrorForSSCCX2: "{0} van {1} pallets geblokkeerd. Gestopt op fout voor SSCC:{2} -{3}",
                coilCutting: "Bandknippen",
                popLabelErrorCartonQty: "wrong Quantity for this carton. must be greater than 0 and less than final quantity pallet",
                adminView: "Open Beheerdersmodus",
                inBoundDxSelTranType: "Transaction Type",
                partCode: "Artikel",
                headerTextUser: "Gebruiker",
                rxg_PrintBoth: "Print Both",
                userNotRecognised: "Gebruiker niet herkend",
                dicoHtmlWo: "Werkorder",
                mainDetails: "Hoofddetails",
                inBoundStrWorkOrder: "WorkOrder ref",
                rxg_BeginPrint: "Start printen",
                litQuantityProd: "quantity produced",
                centralServer: "On Central Server",
                blockPallet: "Blokkeer pallet",
                litActQty: "Actual Quantity",
                byProduct: "Bijproduct",
                woSApproved: "Approved",
                rxg_Title: "Offline Printen",
                synoptic: "Overzicht",
                printSucceeded: "Printopdracht ontvangen",
                rxg_Print: "Print",
                btnNoWarn: "No",
                pleaseSelectaLine: "Selecteer een lijn",
                lblConfirmRepackCondition: "De huidige selectie voor omverpakken wordt gewijzigd",
                litsearchWomField: "Search a new Workorder",
                consumptionUnit: "Unit",
                dateEnd: "Einddatum",
                reprintFailed:
                    "Herprint mislukt voor rank {0} Foutmelding# w0022. {1} van de {2} labels zijn geprint. Wil je de missende labels opnieuw printen?",
                quantityProduced: "Aantal geproduceerd (pallets verbruikt)",
                customerCode: "Customer Code",
                customerDesc: "Klant omschrijving",
                rxg_Quantity: "Hoeveelheid",
                offLineMetalSSCCAway: "This SSCC Doesn t exist.",
                pallets: "Pallets",
                printFailedAbr: "Printopdracht mislukt. Foutmelding# w0018",
                rxg_Defect_Added: "Status gewijzigd maar geen afwijkingen toegevoegd.",
                declarationOPENITEMS: "Declaratie - Openstaande Producten",
                inBoundLitRecap: "Summary of the label creation. Label(s) Created and Printed : ",
                inBoundLitPrint: "Print",
                inBoundLitTrans: "Transaction",
                inBoundLitTitre: "Inbound Label",
                workCenter: "WorkCenter",
                blockFailedWithError: "Blokkade mislukt. Foutmelding:",
                baseLineNotRecognised: "Line not Recognised.",
                inBoundTransactionQuantity: "Qty.",
                rxg_Scrap_Pallet: "Vernietig pallet",
                quantityConsumed: "Aantal verbruikt",
                defects: "Fouten",
                showRawMaterial: "Toon Ruw Materiaal",
                areYouSureDelete1: "Weet u zeker dat u deze pallet wilt verwijderen?",
                inBoundBtnOk: "Ok",
                scrapWarehouse: "Scrap Warehouse",
                cuttedSheetsScrapped: "Vernietigd Geknipt Blik",
                blockResort: "Blokkeren",
                rxg_defectsTable_Comment: "Comment",
                mouldNotParsed: "Problem parsing mould numbers",
                inBoundDateExpiryDate: "Expiry Date",
                areyousureyouwishtoassignworkorder01toline3: "Weet u zeker dat u werkorder {0}({1}-{2}) wilt toewijzen aan lijn {3}?",
                couldNotBlockPalletErrorX0X1: "Kan pallet niet blokkeren. Foutmelding#{0}:{1}",
                chkEdit: "Edit",
                initials: "Initialen",
                rxg_Defects_Added: "Toegevoegde afwijkingen",
                rxg_Could_not_assign__0__to__1___Error___2___3_: "Kan {0} niet toewijzen aan {1}, Foutmelding#:{2}-{3}",
                dicoJsPalletquantity2: "Aantal is groter dan het beschikbare aantal, u heeft",
                dicobtnCreatePallet: "Maak een nieuw pallet aan",
                scanExternalTag: "Orig/Ext Tag Identifier",
                rxg_DeleteFailedWithError: "Verwijdering mislukt met Foutmelding:{0}",
                consumptionQty: "Quantity",
                lblConfirmRepack: "Do you confirm the Repack of the selected Material?",
                created: "Aangemaakt",
                inBoundErrorUpdate: "An Error occurred during the update. Please check the values and if it persist ask apl team.",
                btnNoReturn: "Nee, ik verbruik niets",
                woMButton1: "Manage this work order",
                printerName: "Printernaam",
                deliveryPalletLoaded: "Nr.Pallets Loaded",
                invalideQuantity: "De ingevulde terug te boeken hoeveelheid {0} is hoger dan de resterende hoeveelheid. Foutmelding# w0026",
                x0OfX1PaletsScrappedStoppedAtErrorForSSCCX: "{0} van {1} pallets vernietigd. Gestopt op fout voor SSCC:{2} -{3}",
                errorNewBatch: "An error occured preparing to insert a new Batch.",
                litModQtyMax: "Quantity for a full pallet",
                litModQtyMin: "Quantity for small pallet",
                palStat_Default_Page_Load_Pallet_Status_Management: "Pallet Status Management",
                popDown: "?Minimaliseren",
                endDate: "Einddatum",
                differentWOOnConsumptionAndLabeling2: "Active GPO in Labeling is different from Consumption one!",
                x0OfX1PaletsDeleted: "{0} van {1} pallets verwijderd",
                closeAndConsume: "Stop verbruik",
                go: "Start",
                op: "Processtap",
                wo: "WO",
                to: "Naar:",
                btnBackWo: "Bouton Back",
                noPallets: "Aantal pallets",
                failedToConsumeSsccInDbX0ErrorX1: "SSCC kan niet worden verbruikt in database. {0} Foutmelding# {1}",
                areYouSureBlock1: "Weet u zeker dat u deze pallet wilt blokkeren?",
                litCustMat: "Customer material",
                dicoHtmlProdDate: "Productie datum",
                btnCartonDeleteLastDate: "Delete Last one",
                dicoHtmlRemove: "Verwijder",
                dicoHtmlRepack: "Materiaal geselecteerd voor herverpakken :",
                quantityRemaining: "Resterend aantal",
                parentPallets: "Consumed Pallets",
                dicoJsPalletOrder: "Het is niet mogelijk een pallet aan te maken met een datum voor het moeder pallet : ",
                seqnumber: "Seqnumber",
                errorDeleteBatch: "An error occured deleting the selected Batch.",
                inBoundErrorQuantityTotal: "The total quantity must match the total in the transaction selected.",
                lblRePrintInfoInnerHtml: "Select printer to reprint to?",
                labelPalletCount2: "{0}/{1}",
                couldNotIssueConsumtionX0: "Kan verbruik niet toewijzen. Foutmelding# w0007: {0} ",
                btnNo: "Nee",
                day: "Day",
                lot: "Lot",
                wcl: "Lijn",
                seq: "Seq",
                inBoundLitMat: "Material",
                empty: "Leeg",
                error: "Foutmelding",
                inBoundLnkAdd: "Add a new Line",
                admin: "Beheerder",
                apply: "Toepassen",
                batch: "Batch",
                block: "Blokkeren",
                btnGo: "Bevestig aanmaken nieuwe pallet(s)",
                color: "Color",
                close: "Sluiten",
                input: "Invoer",
                consumeScrap: "Consume\\Scrap",
                order: "Order",
                btnCancel: "Cancel",
                start: "Start",
                scrap: "Vernietig",
                print: "Print",
                goBacktoCurrentActivity: "Ga Terug naar huidige activiteit",
                titleWoMan: "Work order {0}",
                rxg_From: "Van:",
                rxg_Open: "Open",
                areYouSureDelete: "Weet u zeker dat u deze pallets wilt verwijderen?",
                litWomMaterial: "Material",
                metalAndEnds: "Metal en Ends",
                inBoundLitCouncil: "Fill text box and push search",
                couldNotDeleteConsumtionX0: "Kan verbruik niet verwijderen. Foutmelding# w0004: {0} ",
                palletID: "Pallet ID",
                inBoundDxColLotNumber: "Lot",
                selectAll: "Selecteer alles",
                dicoCartonDetails: "Carton Details",
                deliveryResult: "Result",
                pausePrinting: "Pauzeer printopdracht",
                labelName: "Labelnaam",
                x0OfX1PaletsApproved1: "{0} of {1} pallets approved.",
                addUser: "Gebruiker toevoegen",
                printFailedWithException: "{0}.  Printopdracht mislukt voor rank {1} Foutmelding# w0020. ",
                btnSeachWom: "Search Workorder",
                cartonQuantity: "Hoeveelheid",
                nextSeqNo: "Next Seq No.",
                actions: "Acties",
                quantity: "Aantal",
                missingNoDays: "You need to insert the number of days to generate the batches",
                checkSSCC: "Are you sure you want to remove consumption for ",
                inBoundTxtMatError: "The field material cannot be empty and must have at least 3 characters.",
                palletStatusEdit: "Bewerk Pallet Status",
                lstDefault: "None",
                printJSFailed: "Print Failed.",
                inBoundDxSelectTran: "Select a Transaction",
                rxg_Failed_to_set_print_parameters_with_error___0_: "Instellen printparameters mislukt met Foutmelding: {0}",
                x0OfX1PaletsScrapped: "{0} van {1} pallets vernietigd",
                litMainByProd: "By Prod 1",
                rxg_Defect_comment_must_be_less_than_255_characters_: "Opmerking dient minder dan 255 karakters te bevatten.",
                yourAccountIsLockedPleaseContactTheHelpdes: "Dit account is geblokkeerd, neem contact op met de helpdesk.",
                couldNotDeleteOpenItemX0ErrorX1: "Kan geopend item niet verwijderen.  {0} Foutmelding# {1}",
                transactionType: "Transaction Type",
                couldNotUnblockPalletErrorX0X1: "Kan pallet niet deblokkeren. Foutmelding#{0}:{1}",
                lblErrbtnConsumptionClick1: "&quot;Cannot add the material. {0} : error# {1}&quot;",
                endDateNotGood: "The value for End Date is not a correctly formatted date.  Insert Cancelled.",
                rxg_OfflinePrintHeader: "Offline print",
                scanNewMaterial: "Scan nieuw materiaal",
                addingTwoIdenticalDefects: "Adding two identical defects (type and mould)",
                printResult: "{0} label have been sent to the print list (see below for more information about its status).",
                inBoundLitTransac: "Transaction Selection",
                areYouSureUnblock: "Weet u zeker dat u deze pallet wilt deblokkeren?",
                rxg_Scrap_failed_with_error__: "Vernietigen mislukt met Foutmelding:",
                inBoundErrorPalletEdition: "The current label creation is not fully updated. Update your row and after you can print.",
                closeLine: "Sluit lijn(en)",
                tracDifferentDialogText:
                    "Traceability batch is different from the one in consumption. The new one would be {0}. Do you want to continue anyway? Or do you want to change the traceability info to the newest ones?",
                areyousureyouwanttodeleteSSCCX0X: "Weet u zeker dat u SSCC:{0} wilt verwijderen?",
                lblConfirmOff: "This pallet has 0 Qty ! you can t use it",
                inBoundConfirmCreation: "are you sure to create those one? it ll change the transaction status to print.",
                areYouSureScrap1: "Weet u zeker dat u deze pallet wilt vernietigen?",
                woMPallFullQty: "Full",
                litByProduct: "ByProduct 1 Material",
                closeWorksOrder: "Sluit Werkorder",
                scheduledDateTime: "Plan Datum-Tijd",
                areYouSureApprove: "Are you sure you want to approve the production of the selected pallet?",
                offlineconsumption: "OFF-LINE VERBRUIK",
                efficiencyoftheLine: "Lijnefficiency",
                x0OfX1PaletsUnblocked1: "{0} van {1} pallets gedeblokkeerd",
                dicoHtmlConfirRepack: "Bevestig omverpakken",
                x0OfX1PaletsDeletedStoppedAtErrorForSSCCX2: "{0} van {1} pallets verwijderd. Gestopt op fout voor SSCC:{2} -{3}",
                scheduleWorkOrder: "GPO Scheduling",
                doYouWantToActivate: "Wilt u een nieuwe Werkorder activeren?",
                ssccConsumed: "SSCC Verbruikt",
                litCustMatDesc: "Description",
                noOfCartons: "Aantal dozen",
                printingComplete: "Printopdracht voltooid",
                couldNotApprovePalletErrorX01: "Could Not Approve pallet. Error# w00010: {0}",
                material: "Materiaal",
                printScreen: "Print Screen",
                inBoundDxPrintStatus: "Print Status",
                printStatus: "Printstatus",
                areyousureyouwanttoconsumescrapSSCC: "Are you sure you want to consume and scrap SSCC",
                closeReturn: "Sluit en geef regels weer",
                woAvailable: "List of GPOs Available",
                checkDatesfuture: "Cannot consume in the future",
                dicoJsPalletquantity: "Het is niet mogelijk meer producten te gebruiken dan de herverpakking heeft.",
                noRecFound: "No Records Found",
                rxg_Could_not_close_job__0___Error___1_: "Kan werkorder niet sluiten. {0}: Foutmelding# {1}",
                rxg_QiPalletsSelectedCount: "Condition of {0} Blocked QI pallet(s) won&apos;t be updated in bulk mode",
                errorUpdateBatch: "An error occured updating the selected Batch.",
                couldNotUnblockPalletErrorX01: "Kan pallet niet deblokkeren. Foutmelding# w00010: {0}",
                litCopyNumber: "Number of copy",
                litWomDec2: "Desc2",
                litWomDec1: "Desc1",
                btnYesReturn: "Ik boek {0} terug",
                btnPrintNextCarton: "Print Next Carton",
                dicoHtmlSelectMatOnHold: "selected",
                productionOrderRunning: "Lopende werkorder",
                noOfPallets: "Aantal pallets",
                qtyProduced: "quantity produced",
                overProdText: "Creating this pallet, you will be overproducing on this WO. Do you want to continue anyway?",
                rxg_Please_select_the_pass_number_: "Selecteer nummer van de doorgang",
                litQuantitySchedule: "quantity schedule",
                article: "Artikel",
                ignoreSapUpdates: "Ignore SAP updates",
                litWait: "Please Wait",
                litMain: "Main",
                printUsingAlternatePrinterFailed:
                    "Printopdracht is ook mislukt met alternatieve printer. Wilt u opnieuw proberen te printen?                                            Klik op JA om de alternatieve printer te gebruiken of klik op NEE en klik op PRINT om de originele printer opnieuw te proberen.",
                childPallets: "Produced Pallets",
                lblErrbtnConsumptionClick1Exception: "Cannot add the material.  error# {0}",
                printPartiallyFailed:
                    "Printopdracht mislukt voor rank {0} Foutmelding# w0021. Alleen {1} van {2} labels zijn geprint. Wil je de missende label opnieuw printen?",
                qtyScheduled: "quantity schedule",
                rxg_Could_not_close_job___Error___0__: "Kan werkorder niet sluiten. Foutmelding# {0}",
                consumeSSCC: "Verbruik SSCC",
                labelPalletInProgress: "Pallet in progress : Current SSCC {0}",
                printFailed: "Printopdracht mislukt voor ranknummer {0}. Wil je dit label opnieuw printen?",
                approve: "Approve",
                rxg_Add_Defect: "Afwijking toevoegen",
                requiredFields: "Ontbrekende waarden zijn rood gemarkeerd.",
                cartonType: "Quantity per carton",
                printJSCancelRequest: "Cancellation Request Received.",
                litPrintHistory: "Print History",
                printEngine: "Print aansturing",
                partDescription: "Onderdeel omschrijving",
                litCustomerGTIN: "CustomerGTIN",
                lblRePrintInfo: "Kies Printer",
                copySscc: "Copy SSCC",
                inboundYes: "Yes",
                labelCurrentActivityError:
                    "Een Foutmelding in Huidige Activiteit voor deze lijn.                                                                    Wilt u verder gaan naar een andere lijn?",
                pleaseContactHelpdesk:
                    'Please contact <a href="mailto:helpdesk@ardaghgroup.com">helpdesk@ardaghgroup.com</a> for new accounts',
                rxg_Back_to_labeling: "Terug naar Labeling",
                rxg_Yes: "Ja",
                beginPrinting: "Start printen",
                rxg_defectsTable_Initials: "Initials",
                woMMAterialNameError: "this Material doesn t exist : ",
                litLabelCreation: "Label Creation",
                department: "Afdeling",
                movementDescriptionDefault: "Pallet Updated",
                onLINECONSUMPTION: "ON-LINE VERBRUIK",
                offlineconsumptionmetalandends: "OFF-LINE VERBRUIK METAL EN ENDS",
                labelDefaultTitle: "Labeling Huidige Activiteit",
                failedToReturnSsccInDbX0: "SSCC kan niet worden teruggeboekt in database. Foutmelding#w0013: {0}",
                selectNone: "Select None",
                blockPackaging: "Afkeuren verpakking",
                sendToSAP: "Exporteer naar SAP",
                leavingthispagewillstopprinting: "Printopdracht wordt gestopt bij het verlaten van deze pagina. ",
                reprint: "Herprint",
                woSClosed: "Closed",
                litCustCode: "Customer Code",
                litCustomer: "Customer info",
                rxg_CouldNotDeletePallet: "Kan pallet niet verwijderen. Foutmelding#{0}:{1}",
                byProductDetails: "Bijproduct gegevens",
                inBoundLitWarehouse: "Warehouse",
                consumptionWorkorder: "Cons.WO",
                rxg_CouldNotDeletePallet1: "Kan pallet niet verwijderen. Foutmelding#:{0}",
                localServerOffline: "Local Server is Offline.",
                finalPass: "Laatste doorgang",
                areyousureyouwanttoreturnSSCC: "Weet u zeker dat u de SSCC wilt terugboeken?",
                deliveryEmptyWorkorder: "no work order for this pallet. you can t print it",
                rxg_Select_work_order_for_consumption: "Selecteer werkorder voor verbruik.",
                printLabels: "Print labels",
                palSatDefaultTitle: "Pallet Status Management",
                inBoundBtnExit: "Exit",
                failureReason: "Reden van storing",
                batchExists: "The value for Batch already exists on this work order. Insert Cancelled.",
                printJSCancelFailed: "Cancellation Failed",
                assignNewJob: "Nieuwe opdracht toewijzen",
                btnYes: "Ja",
                rxg_Delete_Pallet: "Verwijder pallet",
                ringDiameter: "Ringdiameter",
                btnWoMan: "Manage Work Order",
                inBoundStrCoilNr: "SU reference",
                noChangesMade: "No changes made",
                woSequenceScheduled: "GPO Sequence Scheduled",
                dicoHtmlOriginalQty: "Originele aantal",
                inBoundErrorLabelRank: "The number of label must be a numeric",
                startDateIsLaterThanEndDate: "Startdatum is later dan de einddatum",
                inBoundDxwarehouse: "Warehouse",
                rxg_You_must_enter_a_comment_for_the_defect_s__: "Vul een opmerking in voor de afwijking",
                errorCommandNotRecognised: "Foutmelding: Opdracht niet herkend. Foutmelding# w0011",
                extBarcode: "External Barcode",
                rxg_Cannot_issue_the_material___0___error___1_: "Kan materiaal niet toewijzen. {0}: Foutmelding# {1}",
                lblFailErr: "Error :",
                btnYesWarn: "Yes",
                description: "Omschrijving",
                palletStatusId: "Status ID",
                initQty: "Aantal",
                woMPallTxtModQty: "Changed by Operator",
                youCanOnlyHaveNumberOfPalletsIssuedConsume:
                    "You can only have {0} pallets issued. Would you like to consume the oldest issued?",
                chkError: "Krijg alleen de Foutmeldingen",
                selectDefects: "Selecteer afwijkingen: ",
                couldNotGetConsumptionPalletDetailsForJobE:
                    "Kan geen pallet verbruik details ontvangen voor werkorder. Foutmelding#w00006: {0}",
                couldNotGetConsumptionPalletDetailsForJobX:
                    "Kan geen pallet verbruik details ontvangen voor werkorder {0}: Foutmelding#{1}",
                assignedSuccessfully: "Succesvol toegewezen",
                consumptionCannotBeDisplayedNoWO:
                    "Verbruik kan niet worden weergegeven. Geen werkorder geselecteerd. Wijs aan deze regel een opdracht toe. Foutmelding# w0002",
                rxg_defectsTable_Defect: "Defect",
                material12: "FP12",
                lblOIErrorDate: "wrong date!",
                inBoundDxColLocation: "Location",
                defectsModified: "Defects or status changed. Please refresh",
                failedToReturnSsccInDbX0ErrorX1: "SSCC kan niet worden teruggeboekt in database. {0} Foutmelding# {1}",
                condition: "Palletstatus",
                rxg_Back_to_current_activity: "Terug naar huidige activiteit",
                dayAlreadyExists: "The value for Day already exists on this work order. Insert Cancelled.",
                deliveryTextPurchaseOrder: "Customer Purchase Order",
                inBoundIntLabelRank: "Nr.Of Labels",
                printJSServerOffline: "Server Offline.  ",
                deliveryTitleCustCode: "Customer code :",
                lblConfiramtionReturn: "Weet u zeker dat u 0 terugboekt?",
                dayNotWhole: "The value for Day is not whole a number. Insert Cancelled.",
                previousBatchNr: "Prev.Batch Nr",
                btnYesReturn2: "Ik sluit de werkorder omdat ik 0 terugboek",
                newPalletNumber: "Nieuw palletnummer",
                rxg_Is_the_previous_SSCC___0___completely_consumed___dialog__apl00002: "Is de vorige SSCC ({0}) volledig verbruikt?",
                haveFollowingPalletsBeenFullyUsed: "Have following pallets been fully used?",
                cartonError: "Totaal aantal komt niet overeen met het aantal van de geselecteerde pallet.",
                deliveryTextNoteNr: "Delivery Note Nr.",
                component: "Onderdeel",
                backUpServer: "Running on back up central server.",
                palletIdentify: "Pallet benoemen",
                rxg_SSCC___0___has__1__quantity_and_cannot_be_consumed__error_4123:
                    "SSCC ({0}) bevat {1} eenheden en kan niet worden verbruikt. Foutmelding#w0023",
                areYouSureBlock: "Weet u zeker dat u deze pallets wilt blokkeren?",
                couldNotDeleteOpenItemX0: "Kan geopend item niet verwijderen. Foutmelding# w0005: {0} ",
                areYouSureScrap: "Weet u zeker dat u deze pallets wilt vernietigen?",
                hotKeyInfo: "Press {0} to print.",
                hotKeyWait: "Please wait.",
                noOfPalletsProduced: "Aantal pallets geproduceerd op werkorder",
                inLineJob: "Inline Job",
                rxg_Label_parameters: "Label parameters",
                localServerOnline: "Local server is online.",
                dicoHtmlScanSSCC: "Scan nieuwe SSCC :",
                dicoHtmlRepackNew: "datum omverpakking nieuw pallet",
                statusHistory: "Statusgeschiedenis",
                rxg__0__assigned_to__1_: "{0} toegewezen aan {1}",
                inBoundBtnReset: "Reset Date",
                inBoundDxColunit: "Unit",
                couldNotBlockPalletErrorX0: "Kan pallet niet blokkeren. Foutmelding# w0003: {0}",
                inBoundDxComment: "Delivery Note",
                name: "value",
                edit: "Bewerk",
                exit: "Afsluiten",
                date: "Datum",
                back: "Terug",
                item: "Product",
                next: "Volgende",
                okay: "OK",
                oops: "Er is een onverwachte fout opgetreden, excuses voor het ongemak. De fout is opgeslagen, indien deze fout vaker voorkomt neem dan contact op met de helpdesk. Foutmelding# w0016",
                line: "Lijn",
                unit: "Eenheid",
                time: "Tijd",
                rank: "PalNo",
                stop: "Stop",
                save: "Opslaan",
                sscc: "SSCC",
                pass: "Doorgang",
                bpNoOfCopies: "Aantal kopieën",
                dicoHtmlRepackProgress: "Omverpakken in behandeling:",
                litWoOpeByProd2: "By Prod 2",
                custCrossRef: "Customer Cross Ref",
                rxg_No: "Nee",
                couldNotApprovePalletErrorX0X1: "Could Not Approve pallet. Error#{0}:{1}",
                inBoundsearch: "Search",
                success: "Succes",
                dicoHtmlAddPallet: "Voeg een nieuw pallet toe",
                operator: "Operator",
                batchMissing: "Batch Missing",
                printDate: "Print Date",
                printDown: "System.Drawing.Bitmap",
                barcode: "Barcode",
                deleteLastOne: "Delete Last One",
                addMultipleBatches: "Add Multiple Batches",
                newValue: "New Value",
                previous: "Previous",
                batchManagement: "Batch Management",
                columnName: "Column Name",
                insert: "Insert",
                noDays: "No Days",
                layers: "Layers",
                priority: "Priority",
                qtyReq: "Qty Req.",
                standard: "Standard",
                tableName: "Table Name",
                materialMissing: "Material Missing",
                palletWeight: "Pallet Weight",
                articleWeight: "Article Weight",
                interlayer: "Interlayer",
                pallet: "Pallet",
                carton: "Carton",
                partDesc2: "Part Desc. 2",
                cartonQty: "Carton Qty",
                sumQty: "Sum Qty",
                printUp: "System.Drawing.Bitmap",
                dateCreate: "Date Create",
                startDate: "Start Date",
                partDesc: "Part Desc",
                saveChanges: "Save Changes",
                customerGTIN: "CustomerGTIN",
                noCopiesNumeric1to10: "No. Copies must be an integer between 1 and 10",
                changesNotSaved: "Changes will not be saved.",
                dateScheduleFuture: "You are going to assign a job scheduled for a future date.",
                byProductDuplicate:
                    "You cannot set a byproduct to the same material as the main material or have two of the same byproduct",
                dateRecorded: "Date Recorded",
                operations: "Operations",
                key: "en-GB",
                reset: "Reset",
                small: "Small",
                username: "Username",
                addBatchLot: "Add Batch/Lot",
                massActivities: "Mass Activities",
                priorityMissing: "Priority Missing",
                litQuantityXPallet: "Pallet Qty",
                searchWorksOrder: "Search Works Order",
                quantityXPallet: "Quantity X Pallet",
                printPallet: "Print Pallet",
                changeLog: "Change Log",
                massIssue: "Mass Issue",
                labellingStatus: "Labelling Status",
                isActive: "Is Active",
                rxg_defectsTable_Found: "",
                billOfBatches: "Bill Of Batches",
                selectPage: "Select Page",
                billOfMaterials: "Bill Of Materials",
                refresh: "Refresh",
                customerDetails: "Customer Details",
                testPrint: "Test Print",
                notUpdateByERP: "Fields not updated by ERP",
                smallQtyNumeric: "Small qty must be an integer",
                fullQtyNumeric: "Full qty must be an integer",
                oldValue: "Old Value",
                byProduct1: "By Product 1",
                byProduct2: "By Product 2",
                byProducts: "By Products",
                preventERPUpdate: "Stop any update from ERP (SAP or BPCS)",
                mvtDesc: "Movement description",
                mvtDate: "Movement date",
                fullQtyGreaterThanSmall: "Full quantity must be greater or equal to small quantity",
                full: "Full",
                desc: "Desc",
                main: "Main",
                open: "Open",
                cartonProdResume: "Carton Production : Resume",
                consumptionStatus: "Consumption Status",
                workorderAssignedPrinting: "Workorder was assigned for Label printing. Switch to activity?",
                workorderAssignedConsumption: "Workorder was assigned for consumption. Switch to activity?",
                jobIn: "Job In",
                statusChangeNotAllowed: "Status change not allowed",
                deselect: "Deselect",
                resetView: "Reset View",
                containerVolume: "Volume",
                youCanOnlyHaveNumberOfPalletsIssued: "You can only have {0} pallets issued",
                lineIn: "Line In",
                partPallet: "Part Pallet",
                manualEntry: "Manual Entry",
                consumed: "Consumed",
                issued: "Issued"
            }
        }
    },
    "pl-PL": {
        translation: {
            main: {
                palletConditionId00: "Informacja",
                palletConditionId01: "Wyprodukowane - nie w magazynie",
                palletConditionId02: "W magazynie ",
                palletConditionId03: "Przesortowana",
                palletConditionId04: "Odebrana",
                palletConditionId05: "Dostarczona",
                palletConditionId06: "Na stluczke",
                palletConditionId07: "Odstawienie wg listy ",
                palletConditionId08: "Utracona",
                palletConditionId09: "Usunieta",
                palletConditionId10: "Paleta w transporcie",
                palletConditionId11: "Intermediate pallet",
                palletConditionId12: "Quality Inspection",
                palletConditionId13: "Blocked Resort",
                palletConditionId94: "Allocated for Delivery",
                palletConditionId99: "Etykieta wydrukowana",
                palletStatusId00: "Etykieta wydrukowana",
                palletStatusId01: "Etykieta zostala wydrukowana",
                palletStatusId02: "Label Printed_NIU",
                palletStatusId03: "Inkubacja klienta",
                palletStatusId04: "Dobra",
                palletStatusId05: "Zablokowana",
                palletStatusId06: "Resorted",
                palletStatusId07: "Na stluczke",
                palletStatusId08: "Paleta testowa",
                palletStatusId09: "Zworot klienta",
                palletStatusId10: "Zablokowana do KJ",
                palletStatusId11: "Ograniczona mozliwosc sprzedazy",
                palletStatusId12: "Zablokowana - pakowanie",
                palletStatusId13: "Issued",
                palletStatusId14: "Consumed",
                palletStatusId15: "Returned",
                palletStatusId16: "Stock Received",
                palletStatusId17: "Good",
                palletStatusId18: "Deleted",
                palletStatusId19: "Repacking",
                palletStatusId20: "Loaded",
                palletStatusId21: "Shipped",
                palletStatusId22: "Scrap Warehouse",
                palletStatusId30: "PreBilled",
                palletStatusId90: "WIP",
                offlineCons: "Sortowanie poza linią",
                operator: "Ilość - inna",
                openedWO: "Opened GPOs",
                litEANGTAN: "EAN/Gtin",
                noWorkOrderOnLabelingAndOneRunningOnConsum:
                    "Brak zlecenia dotyczącego etykietowania i jedno zlecenia dotyczące wykorzystania. error# w0015:",
                endBeforeStart: "Data zakonczenia ({1}) jest równa dacie rozpoczecia lub wczesniejsza ({0}).",
                deliveryTextPurchaseOrderLine: "Customer Purchase Order Line",
                woSSuspended: "Wstrzymane",
                processFinished: "Proces zakonczony",
                passFirst: "Select Pass Number",
                woMPallQty: "Quantity X Pallet",
                rxg_Label_paramters_save_successfully_: "Udało się zapisać parametry etykiet.",
                rxg_Please_enter_the_quantity_remaining_on_the_previous_pallet__input__APL00031:
                    "Wpisz ilość pozostałą na poprzedniej palecie. input# APL00001",
                lblFailSSCC: "Nie mozna znaleźć SSCC {0} dla danego SiteId",
                string1: "",
                lblErrOI: "Return Quantity must be greater than 0! error# w0026",
                x0OfX1PaletsBlocked: "Zablokowano {0} z {1} palet.",
                loadLine: "Zamówienie / Linia zaladunku",
                loadList: "Lista zaladunkowa",
                chkInPRogresse: "Wyświetlaj tylko oczekujące polecenie drukowania",
                inBoundDxDescription1: "Decription",
                popMaxcatonLimit: "the total number of carton can not exceed",
                clickLoadShift: "Zanim przejdziesz dalej, musisz kliknac „Zaladuj zmiane”!",
                printJSSequenceNumber: "Next Seq No.",
                litUserUpdate: "Changed by operator",
                inValidWorkOrderId: "Nieprawidłowe zlecenie/linia!!! Sprawdź swoją bazę danych. ",
                areYouSureMassiveScrap: "Are you sure you want to scrap? {0} of {1} pallets will be affected ",
                startDateTime: "Data i godzina rozpoczecia",
                couldNotReturnPalletErrorX0X1: "Nie mozna zwrócic palety. Blad # {0}: {1}",
                transReas: "Przyczyna transportu",
                transSent: "Transakcje wyslano  do BPCS",
                scrapped: "Zezłomowano",
                rxg_Could_not_assign__0__to__1__Error____2_: "Nie można przydzielić {0} do {1} error# {2}",
                emptyRowDelivery: "No data found with those parameters!",
                areYouSureMassiveBlock: "Are you sure you want to block? {0} of {1} pallets will be affected ",
                rxg_Please_select_a_defect: "Wybierz wadę",
                cartonCreateLastDate: "Last Production Date",
                offlinePrint: "Drukowanie w trybie off-line",
                noWorkOrderOnConsumptionAndOneRunningForLa: "No GPO on consumption and one running for Labeling. Error# w0014:  ",
                palletCount: "Liczba palet",
                litCartonLabel: "Carton Label",
                printDate: "Data wydruku",
                printLoad: "Drukuj  zaladunek",
                batchNr: "Partia",
                printSuccessful: "Drukowanie powiodło się",
                extWhsNoB2B: "Zewnetrzny  magazyn nie B2B",
                barcode: "Kod kreskowy",
                litNameCust: "Nazwa klienta",
                importSSCC: "Zaladuj SSCC",
                deliveryDateReq: "Oczekiwana data\\czas dostawy",
                womTitle: "Zarządzanie zleceniami",
                mouldNo: "Forma",
                noDefectIdSelected: "Wybrano pusty DefectId",
                differentWOOnConsumptionAndLabeling: "Różnice w zleceniu dotyczące wykorzystania i etykietowania. error# w0010",
                enable: "Wlacz",
                operation: "Operacja",
                btnUpdateWoM: "Update",
                destination: "Miejsce dostawy",
                lotNotWhole: "The value for Lot is not whole a number.  Insert Cancelled.",
                durationMinutes: "Czast trwania (min.)",
                unableToAddOpenItemToLineX0X1ErrorX2: "Nie można dodać otwartej pozycji do linii {0} {1} error# {2}",
                batchStart: "Początek partii",
                deleteLastOne: "Usun ostatni",
                lblErrbtnConsumeClick: "Wrong date. You can t consume pallet in the future. Change the date please!",
                labelImSwitchQty: "Switch Quantity between full and Small",
                conditionID: "ID stanu",
                rightClickError: "Nie mozna kliknac prawym przyciskiem myszy na nie wybrany wiersz!",
                toolTipchkRaw: "Press update button to apply your filter(s)",
                offlinePrintingFailedException:
                    "Drukarka nie jest gotowa, drukowanie zostało wstrzymane, wybierz nową drukarkę i naciśnij ROZPOCZNIJ DRUKOWANIE, aby kontynuować. Ponownie wydrukuj przy użyciu drukarki wybranej z rozwijanego menu.",
                palletStatusDialogText: "Paleta jest zablokowana. Czy chcesz kontuynuować?",
                inBoundDxMaterialCode: "Material Code",
                consumptionNbPallet: "Nb Pallet",
                palletsQty: "Palety (Ilość)",
                palletRank: "Nr palety",
                inBoundDxTransactionDate: "Date",
                cannotConsumeInTheFuture: "Nie można wykorzystać w przyszłości. error# w0001",
                palletDetail: "Informacje dotyczące palety",
                linePrintAll: "Print all Labels",
                deliveryNote: "Delivery Note",
                btnCartonDeleteConfirmation: "Are you sure you want to delete this carton ?",
                inBoundLitLabelName: "Label Type : ",
                printResultSuccess: "{0} copy(s) of Sequence {1} sent to printer {2} at {3}.",
                scheduledOrders: "Scheduled GPOs",
                dicoJsPalletDate: "you can&apos;&apos;t create pallet in the future",
                openItems: "Otwarte pozycje",
                actQty: "Szt. w palecie",
                rxg_SSCC___0___was_not_found___error__00001: "SSCC ({0}) was not found.  error#:#w0024",
                chkDetails: "Drukuj informacje",
                lotExists: "The value for Lot already exists on this work order. Insert Cancelled.",
                defectTimeStamp: "Czas wystapienia wady",
                assign: "Przydziel",
                dicoRepackSummary: "Repack Summary",
                supplier: "Dostawca",
                cartonDeleteLastDate: "Delete Last one",
                binToBinT: "Transfer z pojemnika do pojemnika",
                labellingPrintingComplete: "Printing Complete",
                areYouSureConsume: "Czy na pewno chcesz skasowac kod SSCC?",
                aplBin: "Pojemnik APL",
                inBoundErrorQuantityMaxTotal: "Calkowita liczba wyprodukowanych palet musi byc mniejsza niz",
                releaseReturnedPallet: "Wydaj zwrócona palete",
                inBoundErrorQtyLabel: "The QtyxLAbel must be a numeric.",
                noDefectsPassed: "At least one defect required for blocking",
                lbl_spoilage_reasons_title: "Spoilage",
                woMPallTxtFullQty: "Standard",
                palletsProduced: "Wyprodukowano palet",
                dicoHtmlSelectMat: "Select this material",
                goBack: "Wróć",
                addMultipleBatches: "Dodaj partie",
                archivedShip: "Wysylki archiwalne",
                btnDeleteLastOne: "Delete last carton",
                litMessWarn:
                    "The quantity on the pallet exceed the max quantity schedule on work order. Do you want to change the current quantity on the pallet?",
                binMgmt: "Zarzadzanie pojemnikami",
                binType: "Typ pojemnika",
                dateIn: "Data rozpoczęcia",
                defect: "Wada",
                delete: "Usuń",
                detail: "Informacje",
                trailer: "Naczepa \\ nr rej",
                deleteConsumption: "Anulować sortowanie?",
                newValue: "Nowa wartosc",
                lotNumber: "Lot",
                returnQuantity: "Zwróc ilosc",
                inBoundTotalLabelCreation: "Total",
                inBoundTxtTanDateError: "A valid Date is required",
                areYouSureMassiveReprint: "Are you sure you want to reprint? {0} of {1} pallets will be affected ",
                rxg_No_Department_specified__Error__w0007: "Nie określono działu. Error# w0025",
                previous: "Poprzedni",
                checkDateslater: "Start date is later than end date",
                dicoHtmlQuantityUsed: "Quantity used : ",
                consumptionCurrentActivity: "Wykorzystanie - bieżąca aktywność",
                inputLine: "Input Line",
                batchManagement: "Zarzadzanie partia",
                inBoundErrorReceiptDate: "The Expiry Date must be a valide date and time.",
                columnName: "Nazwa Kolumny",
                txtQuantityErr: "Invalide quantity",
                consumptionParameters: "Parametry wykorzystania",
                binWhs: "Magazyn \\ pojemnik",
                btnPrintPalletAndClose: "Print Pallet Label and Close it",
                failedToConsumeSsccInDbX0: "Failed to consume sscc in db. Error# w0012:  {0} ",
                inBoundIntQtyLabel: "Qty x Label",
                rxg_Could_not_assign_Work_Order___Error___0_: "Could not assign Work Order.  Error: {0}",
                scanned: "Zeskanowano",
                blockQi: "Blokada 300",
                blocked: "Zablokowano",
                unableToAddOpenItemToLineX0ErrorX1: "Nie można dodać otwartej pozycji do linii {0} error# {1}",
                noOfSheets: "Liczba arkuszy",
                cancel: "Anuluj",
                valMustBeInteger: "{0} podaj liczbe calkowita",
                pickingLblNumCopy: "Number of Copy :",
                workOrder: "Zlecenie",
                wantToUseAlternatePrinter: "Wybrana drukarka nie jest gotowa. Czy chcesz użyć {0} w zamian?",
                password: "Haslo",
                x0OfX1PaletsApprovedStoppedAtErrorForPalletX21: "{0} of {1} pallets Approved. Stopped at error for PalletId:{2} -{3}",
                inBoundBtnConfirm: "Confirm",
                inboundNo: "No",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheck:
                    "SSCC {0} jest otwarte na następujących liniach. Zaznacz linie, które chcesz zamknąć.",
                insert: "Wpisz",
                inBoundTxtwareError: "The field warhouse cannot be empty and cannot have more than 2 characters",
                palletScheduled: "Paleta zaplanowana",
                maxNoCopiesMessage:
                    "Próbujesz wydrukowac liczbe egzemplatzy wieksza niz maksymalna dozwolona. Jestes pewien, ze chcesz kontynuowac?",
                lblErrbtnConsumeClickMissing: "Could not find SSCC. error# W0006",
                rxg_PrintDefect: "Print Defect",
                tKeyActivity: "Typ Czynnosci",
                workOrderOp: "Nr zlecenia",
                batchNotWhole: "The value for Batch is not whole a number.  Insert Cancelled.",
                inBoundBtnCancel: "Cancel",
                bpcsLocation: "Lokalizacja BPCS",
                inBoundBtnCancel2: "Finish",
                selPrinterToPrintTo: "Wybierz drukarke do ponownego wydruku",
                notes2: "Notatki 2",
                notes1: "Notatki 1",
                noData: "Nie ma danych do wyświetlenia dla tej linii!",
                noDays: "Liczba dni",
                changeCloseJob: "Zmień/Zamknij Zlecenie",
                noPall: "Nr palety",
                inValidUser: "Nieprawidłowa nazwa użytkownika! Spróbuj zalogować się ponownie.",
                inValidTime: "Nieprawidłowa godzina!!! Wprowadź prawidłową godzinę (hh: mm). ",
                woSPlanned: "Planned",
                inValidDate: "Nieprawidłowa data!!! Podaj poprawną datę (dd/mm/rrrr). ",
                loginButtonText: "Logowanie",
                newBin: "Nowy  pojemnik",
                inBoundErrorDate: "the date is not Correct",
                noRecordExtID: "Nie znaleziono rekordu z nastepujacym oryginalnym / zewnetrznym oznaczeniem {0}",
                noRecordFound: "Zapis nie znaleziony w tym miejscu dla SSCC {0}",
                palletCreated: "Udało się utworzyć paletę {0} ({1}).",
                x0OfX1PaletsUnblockedStoppedAtErrorForPalletX21: "{0} of {1} pallets Unblocked.  Stopped at error for PalletId:{2} -{3}",
                resultNumber: "Numer wyniku: {0} w ciagu ostatniej {1} godziny",
                inBoundDxColSeqNumber: "Seq",
                ordQty: "Zamówiona ilosc",
                litPalLabel4: "Wzór etykiety4",
                litPalLabel3: "Wzór etykiety3",
                litWoS: "Obecny status zlecenia : ",
                printAbort: "Printing failed for rank {0}.  The server did not respond. Error# w0017.",
                labels: "Etykietowanie",
                logout: "Wyloguj się",
                logMsg: "Wiadomosc rejestru",
                loaded: "Zaladowano",
                loadNo: "Nr zaladunku",
                noColours: "Oznakowanie koloru",
                length: "Długość",
                btnYesReturnDetail: "Zamykam to \\n, ponieważ zwracam w ilości 0",
                valueCantBeNull: "{0} wartosc  nie moze wynosic zero",
                finalPalletRank: "Do palety (nr)",
                update: "Aktualizuj",
                zeroPallet: "Nie wydano zadnej palety",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheckReturn:
                    "SSCC {0} jest otwarte w następujących wierszach. Zaznacz linie, dla których chcesz dokonać zwrotu.",
                printfailedselectanotherprinter: "Drukowanie nie powiodło się, wybierz inną drukarkę lub spróbuj ponownie. error# w0019",
                palletNumber: "Nowy numer palety : &lt;b&gt;{0}&lt;/b&gt;  ",
                batchLot: "Batch\\Lot",
                batchEnd: "Koniec partii",
                prodDate: "Data produkcji",
                litAllInOne: "all in one shot",
                totalTimeGreaterThanShift: "Calkowity czas czynnosci jest wiekszy niz dlugosc zmiany.",
                couldNotScrapPalletErrorX0X1: "Nie można zezłomować palety. error# {0}: {1}",
                lblDefaultSetting: "Quantity for Carton {0}",
                rememberMeText: "Zapamietaj nastepnym razem",
                resetDefaults: "ResetDefaults",
                scanHere: "Skanuj SSCC tutaj",
                durationValidation: "* Czas trwania musi byc wartoscia liczbowa",
                rxg_Labeling_Pass_Number: "Numer przejścia etykietowania",
                getData: "Pobierz dane z TLM",
                lblErrbtnConsumptionClick1Else: "Could not consume SSCC invalid quantity. error# W0008.",
                btnBack: "Finish",
                dicoHtmlSapcode: "Material SAP Code",
                cartonSumQty: "Number of Carton",
                rxg_Unable_to_consume_pallet__0____1__Error____2__: "Nie można wykorzystać palety {0}: {1} error# {2}",
                qtyNotSetForMaterial: "Ilosc nie ustawiona dla  materialu",
                dicoTotalQuantity: "Total Quantity",
                priority: "Priorytet",
                printMod: "Tryb drukowania",
                totalShiftHours: "Calkowita liczba minut zmiany",
                thisMethodRequiresAConfirmationAndNoneIsDe: "Ta metoda wymaga potwierdzenia i nie zostało ono zdefiniowane.",
                litTitre: "Inbound Label",
                qtyReq: "Ilość produkcji",
                litWoOpe: "Operacje",
                litWoMan: "Work order information",
                standard: "Standard",
                outOfShift: "Czynnosci, które próbujesz zaimportowac, nie pasuja do wybranej zmiany i daty",
                bpQuantity1: "Ilość",
                bpQuantity2: "Ilość",
                x0OfX1PaletsReturned1: "Zwrócono {0} {1} palet.",
                noWorkorder: "Brak zleceń",
                thereIsNoWorkOrderConfiguredForThisLine: "Nie skonfigurowano zlecenia dla tej linii",
                dicoHtmlRepackResult: "Repack Result",
                noLines: "Brak linii",
                tableName: "Nazwa tabeli",
                woMPallMinQty: "Small",
                inBoundLitTranDate: "Tansaction Date",
                quality: "Quality",
                allPallets: "Wszystkie palety",
                pleaseSelectaPrinter: "Proszę wybrać drukarkę do wydrukowania nowej etykiety.",
                rxg_ThereIsNoWorksOrderAssignedForThisLine: "Brak zleceń na tej linii",
                palletStatus: "Status palety",
                cuttedSheetsBlocked: "Blokowane pocięte arkusze",
                litByProduct4: "po produkcie 4 material",
                litByProduct2: "ByProduct 2 Material",
                litByProduct3: "po produkcie 3 material",
                tracDialogText: "Traceability batch is missing. Do you want to continue anyway?",
                sqlTranslation: "Tłumaczenia SQL",
                rxg_Back_to_offline_consumption: "Wróć do wykorzystania w trybie off-line",
                woSInUse: "Aktywne",
                rxg_Open_SSCC__0__on_the_following_line_s__: "Otwórz SSCC {0} na następujących liniach.",
                shipAddress: "Adres wysylki",
                thislinehasajobassignedClosethejob: "Ta linia ma przydzielone zadanie. Zamknąć to zadanie?",
                palletWeight: "Waga palety",
                articleWeight: "Waga wyrobu",
                interlayer: "Interlayer",
                pallet: "Pallet",
                carton: "Carton",
                tracMessageConsumption:
                    "Dostawca w kodzie SSCC, który zamierzasz wydac, to {0}. Ostatnio wydany zostal {1}. Czy mimo to chcesz kontynuowac?",
                rxg_Work_Order_Enquiry: "Lista zleceń",
                partDesc2: "Nazwa artykułu 2",
                litQtyReq: "Ilość produkcji",
                labelsTraceability: "Etykiety i historia zuzycia",
                dicoHtmlMaterial: "Material",
                timeIn: "Godzina w",
                startDateNotGood: "The value for Start Date is not a correctly formatted date.  Insert Cancelled.",
                labelPalletCount: "Number of Pallet Procuced :&lt;br/&gt; &lt;b&gt;{0}&lt;/b&gt;",
                shipLog: "Rejestr wysylek",
                numberOfCopies: "Ilość etykiet",
                inBoundLitDescription: "Description",
                ckBoxCartonSave: "Z kartonem",
                palletsScheduled: "pallets sched.",
                cartonQty: "Ilosc kartonów",
                retQty: "Zwróc ilosc",
                return: "Sortowanie częściowe",
                reason: "Przyczyna",
                inBoundStrVendorBatch: "Vendor Batch",
                remQty: "Pozostala ilosc",
                inBoundErrorNbrPallet: "The field Nbr*OF LAbel must be a numeric greater than 0",
                scrapProduction: "Scrap Production",
                rankTo: "uszereguj  do",
                sealMachineNo: "Nr maszyny do zamykania pojemników",
                mouldAndNonMouldSameDefectId: "Unable to add mould and non-mould related with the same defect ID",
                overProdHeader: "Overproduction",
                btnUnderstoodBack: "Back",
                defaultActivityLabeling: "Etykietowanie",
                sumQty: "Ilosc calkowita",
                status: "Status",
                couldNotReturnPalletErrorX01: "Nie mozna zwrócic palety. Blad # w0003: {0}",
                palSatEditSelectPrinter: "Wybrać drukarkę do ponownego wydruku",
                importDataFromAPS: "Importuj dane z TLM",
                inBoundLitInfosTrans: "Blank = All,or OO,U,UC, UT, UR, RT ",
                newShip: "Nowa wysylka",
                returnToVendor: "Zwrot do dostawcy",
                search: "Szukaj",
                select: "Wybierz",
                timeEnd: "Godzina końcowa",
                shipTo: "Wyslij do",
                prompt: "Przyspiesz",
                addDefect: "Dodaj wadę",
                pause2: "Druga pauza",
                spoilageReasons: "Spoilage Reasons",
                couldNotLoadWorkOrderPleaseCheckTheOrderCo:
                    "Nie można załadować zlecenia. Sprawdź kod zlecenia i spróbuj ponownie. error# w0008",
                pieces: "Pcs",
                couldNotIssueConsumtionX0ErrorX1: "Nie można wyświetlić wykorzystania. {0} error# {1}",
                x0OfX1PaletsReturnedStoppedAtErrorForPalletX21:
                    "Zwrócono {0} z {1} palet. Przerwa przy bledzie dla palety o oznaczeniu: {2} - {3}",
                startingPalletRank: "Od palety (nr)",
                movementDescription11: "Wydruk - produkcja",
                movementDescription10: "Return Pallet off line",
                movementDescription13: "Status uaktualniony przez SAP",
                movementDescription12: "Wydruk - produkcja (poza linią)",
                movementDescription15: "Zablokowana QI",
                movementDescription14: "Zmiana daty produkcji lub statusu przez PLC",
                movementDescription17: "Paleta zezłomowana",
                movementDescription16: "Paleta oblokowana",
                movementDescription19: "User connection",
                movementDescription18: "Paleta usunięta",
                movementDescription01: "Zlecenie rozpoczęte (Sortowanie)",
                movementDescription02: "Zlecenie zakończone (Sortowanie)",
                movementDescription03: "Zlecenie rozpoczęte (Drukowanie)",
                movementDescription04: "Zlecenie zakończone (Drukowanie)",
                movementDescription05: "Sortowanie rozpoczęte",
                movementDescription06: "Paleta przesortowana",
                movementDescription07: "Return Pallet on line",
                movementDescription08: "Sortowanie usunięte",
                movementDescription09: "Paleta przesortowana (poza linią)",
                movementDescription33: "Zablokowana złomowanie",
                movementDescription32: "Zmiana ilości",
                movementDescription35: "Scrap in Warehouse",
                movementDescription34: "Zablokowana pakowanie",
                movementDescription22: "Open Item Return ",
                movementDescription23: "Zablokowana sortowania",
                movementDescription20: "Open Item Issuing",
                movementDescription21: "Open Item Consumption",
                movementDescription26: "Wada usunięta",
                movementDescription27: "Wada znaleziona",
                movementDescription24: "Open Item delete",
                movementDescription25: "Wada dodana",
                movementDescription28: "Wada nie znaleziona",
                movementDescription55: "Wada usunięta przez SAP",
                movementDescription54: "Wada dodana przez SAP",
                movementDescription51: "Uaktualniona przez SAP",
                movementDescription50: "Paleta utworzona przez SAP",
                movementDescription53: "Stan uaktualniony przez SAP",
                movementDescription52: "Status uaktualniony przez SAP",
                movementDescription44: "Paleta potwierdzona",
                movementDescription40: "Pallet Scanned for Repack",
                movementDescription41: "Remove Pallet from Repack",
                movementDescription42: "Podział palety",
                movementDescription43: "Create pallet from other",
                movementDescription60: "Paleta zablokowana",
                movementDescription61: "Paleta oblokowana",
                movementDescription99: "SU Imported for Go Live",
                inBoundErrorQuantity: "The field Label*Qty must be a numeric greater than 0",
                couldNotDeleteConsumtionX0ErrorX1: "Nie można anulować wykorzystania {0}. error# {1}",
                rxg_Consumption: "Sortowanie",
                toolTipEnter: "Press Enter to apply your filter(s)",
                inBoundErrorAmount: "Error in the total amount. Please check the values and correct them",
                litSearch: "Search a new Workorder",
                currentPalletRank: "Aktualny poziom palet -",
                transferCompleted: "Transfer zakonczony",
                mustInsertComment: "Musisz wstawic komentarz, aby odblokowac palety",
                rxg__0__units_returned_on_SSCC__1___When_all_pallets_are_consumed_returned__click_OK_again_to_close_the_job__dialog_w0005:
                    "{0} jednostki zwrócone na SSCC {1}. Gdy wszystkie palety zostaną wykorzystane/zwrócone, naciśnij ponownie OK, aby zamknąć zadanie. Dialog nr w0001",
                checkSLEDNullText: "&lt;b&gt; Jest/sa {0} paleta/y bez daty waznosci! &lt;/b&gt; &lt;/br&gt;",
                passNumber: "Numer przejścia",
                printer: "Drukarka",
                bpQuantity: "Ilość",
                unblock: "Odblokuj",
                deliverySelected: "Selected",
                couldNotScrapPalletErrorX0: "Nie można zezłomować palety. error# w0009: {0}",
                quantityScrapped: "Quantity Scrapped",
                grossWeight: "Waga brutto",
                dicoHtmlLine: "Line",
                multipleSelectionError: "Stan nie zgadza się z wybranymi wierszami. Wybierz ponownie wiersze z takim samym statusem!!",
                deliveryTitle: "Printing  - JWO Delivery Label",
                dateCreate: "Data utworzenia",
                btnCloseOff: "Aboard",
                areyousureyouwanttoclosethejob: "Czy na pewno chcesz zamknąć zadanie?",
                noPalletsToUpdate: "Brak palet do aktualizacji",
                totalImportedMinutes: "Czas trwania zaimportowanego klucza T-Key (min.)",
                traceabilityInfo: "Traceability Info",
                baseProduct: "Produkt bazowy",
                saveDefaults: "Zapisz domyslne",
                startAfterEnd: "Rozpoczecie ({0}) nastepuje po zakonczeniu ({1}). blad nr W0007",
                litPalLabel: "Wzór etykiety",
                rxg_You_must_enter_your_initials_to_add_a_defect: "Musisz wprowadzić inicjały, aby dodać wadę",
                itemClass: "Klasa pozycji",
                inBoundErrorPalletCreation: "Error during the pallet creation. Please chech your values.",
                tracDialogHeader: "Sprawdz dane identyfikowalnosci",
                savesendtosap: "ZAPISZ i EKSPORTUJ do systemu SAP",
                litRepCurAct: "Ponowne pakowanie biezacej czynnosci",
                moveSSCCToBin: "Przesun kod SSCC do wybranego pojemnika",
                inBoundConfirmDelete: "are you sure you want to delete this line?",
                currentActivity: "Bieżąca aktywność",
                backToCurrentActivity: "Powrót do bieżącej aktywności",
                titleText: "Zapisz sie do APL",
                confirm: "Potwierdź",
                consume: "Zakończ sortowanie",
                comment: "Komentarz",
                rxg_Select_work_order_for_labeling: "Wybierz zlecenie do etykietowania",
                addNewActivities: "Dodaj nowe czynnosci",
                specialText: "Dodatkowe informacje",
                selectLines: "Wybierz linie",
                printJSWorksOrder: "Works Order",
                palletStatusDialogHeader: "Blocked Pallet",
                backToOfflineHome: "Powrót do strony startowej w trybie off-line",
                consumptionPageTitle: "Consumption Declaration",
                rxg_Could_not_assign_Work_Order_Error___0____1_: "Nie można przydzielić numeru zlecenia error# {0}: {1}",
                noOfCoils: "Liczba kształtników",
                x0OfX1PaletsBlockedStoppedAtErrorForSSCCX2: "{0} of {1} pallets blocked.  Stopped at error for SSCC:{2} -{3}",
                binDescription: "Opis pojemnika",
                coilCutting: "Cięcie kształtowników",
                popLabelErrorCartonQty: "wrong Quantity for this carton. must be greater than 0 and less than final quantity pallet",
                adminView: "Przejdź do widoku administratora",
                confirmUnload: "Potwierdzic rozladunek palety?",
                startDate: "Od",
                startTime: "Godzina rozpoczecia",
                activity: "Czynnosc",
                tKeyDescription: "Opis Tkey",
                shipmentCode: "Kod wysylki",
                shipmentName: "Nazwa wysylki",
                inBoundDxSelTranType: "Transaction Type",
                partCode: "Nr artykułu",
                partDesc: "Nazwa artykułu",
                carrier: "Przewoznik",
                headerTextUser: "Użytkownik",
                rxg_PrintBoth: "Print Both",
                searchArea: "Obszar poszukiwan",
                searchLoad: "Szukaj\\Dodaj zaladunek",
                userNotRecognised: "Użytkownik nie został rozpoznany",
                dicoHtmlWo: "WorkOrder",
                mainDetails: "Podstawowe informacje ",
                saveChanges: "Zapisz zmiany",
                inBoundStrWorkOrder: "WorkOrder ref",
                nrColli: "Nr Colli",
                rxg_BeginPrint: "Rozpocznij drukowanie",
                litQuantityProd: "Ilość wyprodukowanych",
                calcNetWeight: "Obliczona masa netto",
                noShiftsToDisplay: "Nie ma zmian do wyswietlania czynnosci",
                centralServer: "On Central Server",
                operatorCode: "Kod operatora",
                operatorName: "Imie i nazwisko operatora",
                blockPallet: "Blokuj paletę",
                litActQty: "Actual Quantity",
                deleteTkeyReasonConfirm: "Czy na pewno chcesz usunac ten TKey?",
                byProduct: "Produkt uboczny",
                woSApproved: "Oczekujące",
                rxg_Title: "Drukowanie w trybie off-line",
                synoptic: "Synoptyczny",
                printSucceeded: "Drukowanie powiodło się",
                rxg_Print: "Drukuj",
                btnNoWarn: "No",
                binToBin: "Transfer z pojemnika do pojemnika",
                pleaseSelectaLine: "Wybierz linię.",
                lblConfirmRepackCondition: "&lt;br /&gt;The curent selection in RePacking will be changed",
                litsearchWomField: "Search a new Workorder",
                consumptionUnit: "Unit",
                dateEnd: "Data zakończenia",
                reprintFailed:
                    "Ponowny wydruk nie powiódł się dla poziomu {0} error# w0022. Wydrukowano tylko {1} z {2} etykiet. Czy chcesz spróbować wydrukować brakujące etykiety?",
                quantityProduced: "Ilość wytworzona (wykorzystanie palety)",
                facility: "Obiekt",
                customerCode: "Customer Code",
                customerDesc: "Opis klienta",
                rxg_Quantity: "Ilość",
                insertActQty: "Wpisz nowa ilosc (zostaw puste pole jesli sie nie zmienila)",
                cantLoadShifts: "Nie mozna wczytac zmian: {0}",
                offLineMetalSSCCAway: "This SSCC Doesn t exist.",
                pallets: "Palety",
                printFailedAbr: "Drukowanie nie powiodło się. error# w0018",
                rxg_Defect_Added: "Zmieniono status, ale nie dodano żadnych wad!",
                declarationOPENITEMS: "Deklaracje - POZYCJE OTWARTE",
                loadShift: "Zaladuj zmiany",
                loadManag: "Zarzadzanie zaladunkami",
                noCopiesNumeric1to10: "Liczba egzemplarzy musi byc liczba calkowita od 1 do 10",
                areYouSureMassiveAddDefect: "Are you sure you want to add defect? {0} of {1} pallets will be affected ",
                inBoundLitRecap: "Summary of the label creation. Label(s) Created and Printed : ",
                inBoundLitPrint: "Print",
                inBoundLitTrans: "Transaction",
                inBoundLitTitre: "Inbound Label",
                workCenter: "Linia",
                blockFailedWithError: "Blokowanie nie powiodło się z powodu błędu:",
                baseLineNotRecognised: "Line not Recognised.",
                inBoundTransactionQuantity: "Qty.",
                rxg_Scrap_Pallet: "Złomowana paleta",
                changesNotSaved: "Zmiany nie zostana zapisane.",
                quantityConsumed: "Ilość wykorzystana",
                dateStart: "Data poczatkowa",
                defects: "Wady",
                showRawMaterial: "Pokaż surowce",
                delShip: "Usun wysylke",
                details: "Details",
                areYouSureDelete1: "Czy na pewno chcesz usunąć tę paletę?",
                inBoundBtnOk: "Ok",
                shiftNoWorkOrders: "Brak zlecen pracy dla tej linii.",
                scrapWarehouse: "Scrap Warehouse",
                goodDescr: "Dobry opis",
                cuttedSheetsScrapped: "Zezłomowane pocięte arkusze",
                blockResort: "Blokada 800",
                rxg_defectsTable_Comment: "Komentarz ",
                spoilageManagment: "Spoilage Managment",
                mouldNotParsed: "Problem parsing mould numbers",
                inBoundDateExpiryDate: "Expiry Date",
                areyousureyouwishtoassignworkorder01toline3: "Czy na pewno chcesz przydzielić zlecenie {0}({1}-{2}) do linii {3}",
                byProductDuplicate:
                    "Nie mozna ustawic produktu ubocznego na ten sam material, co material glówny lub dwóch takich samych produktów ubocznych",
                couldNotBlockPalletErrorX0X1: "Nie można zablokować palety. error# {0}:{1}",
                chkEdit: "Edit",
                initials: "Inicjały",
                returnFromCustomer: "Zwrot od klienta",
                sealMachine: "Maszyna do zamykania pojemników",
                rxg_Defects_Added: "Wady dodane",
                rxg_Could_not_assign__0__to__1___Error___2___3_: "Nie można przypisać {0} do {1}, error# {2} - {3}",
                dicoJsPalletquantity2: "with those quantity you are over the quantity aviable. you have ",
                printBarcodesRepacking: "Drukuj kody kreskowe podczas przepakowywania",
                dicobtnCreatePallet: "Create New Pallet",
                scanExternalTag: "Orig/Ext Tag Identifier",
                userStdQtySmall: "Standardowa ilosc uzytkownika (male palety)",
                rxg_DeleteFailedWithError: "Anulowanie nie powiodło się z powodu błędu: {0}",
                saveShiftNotEqual: "Liczba zarezerwowanych minut nie jest równa calkowitej liczbie minut. \\r\\n\\r\\nNa pewno?",
                motherPalletNotFullyRepacked: "Palety pierwotne nie zostana w pelni przepakowane. Czy  chcesz kontynuowac?",
                consumptionQty: "Quantity",
                lblConfirmRepack: "Do you confirm the Repack of the selected Material?",
                created: "Utworzono",
                shipmentComple: "Ustaw wysylke zakonczono",
                display: "Pokaz",
                disable: "Wylacz",
                custCod: "Kod klienta",
                inBoundErrorUpdate: "An Error occurred during the update. Please check the values and if it persist ask apl team.",
                btnNoReturn: "Nie, nie wykorzystuję niczego",
                woMButton1: "Manage this work order",
                areYouSureMovePallet: "czy jestes pewien ze chcesz przesunac {0} wybrane palety do wybranego pojemnika {1}?",
                printerName: "Nazwa drukarki",
                deliveryPalletLoaded: "Nr.Pallets Loaded",
                invalideQuantity: "Ilość zwrócona dla palety zwrotnej {0} jest wyższa niż pozostała ilość. error# w0026 ",
                loadCompleted: "Zaladunek  zakonczony",
                preImportSSCC: "Preimport",
                areYouSureRemovePalletRepack: "Czy na pewno chcesz usunac wybrana palete z przepakowania?",
                x0OfX1PaletsScrappedStoppedAtErrorForSSCCX: "Zezłomowano {0} z {1} palet. Zatrzymanie z powodu błędu sscc:{2} - {3}",
                salesOrder: "Zamówienie klienta",
                dateRecorded: "Data",
                mustInsertCommentScrap: "Musisz wstawic komentarz, aby utylizowac palety",
                errorNewBatch: "An error occured preparing to insert a new Batch.",
                litModQtyMax: "Quantity for a full pallet",
                litModQtyMin: "Quantity for small pallet",
                palStat_Default_Page_Load_Pallet_Status_Management: "Zarządzanie statusem palety",
                reOpenLoad: "Otwórz ponownie zaladunek",
                mustInsertQty: "Musisz wpisac ilosc, aby oddac palety",
                popDown: "Rozwijane menu",
                downTime: "Czas przestoju",
                noUpdateAfterSAP: "Nie mozna zaktualizowac wpisu po wyslaniu do systemu SAP.",
                endDate: "Do",
                endTime: "Data zakonczenia",
                differentWOOnConsumptionAndLabeling2: "Active GPO in Labeling is different from Consumption one!",
                x0OfX1PaletsDeleted: "Usunięto {0} z {1} palet.",
                enabled: "Wlaczony",
                closeAndConsume: "Zatrzymaj wykorzystanie",
                go: "Idź",
                op: "Otw",
                wo: "WO",
                to: "Do:",
                massiveScan: "Skanowanie masowe",
                btnBackWo: "Wróć",
                noPallets: "Liczba palet",
                failedToConsumeSsccInDbX0ErrorX1: "Nie można wykorzystać sscc w bazie danych. {0} error# {1}",
                missingAPSDef: "Brak domyslnych ustawien importu TLM",
                areYouSureBlock1: "Czy na pewno chcesz usunąć tę paletę?",
                litCustMat: "Numer materiału klienta",
                supplierCode: "Kod dostawcy",
                supplierName: "Nazwa dostawcy",
                dicoHtmlProdDate: "Prod Date",
                btnCartonDeleteLastDate: "Delete Last one",
                dateWorkOrderSpoilage: "Date",
                dicoHtmlRemove: "Remove",
                dicoHtmlRepack: "Material selected for Repacking :",
                quantityRemaining: "Ilość pozostała",
                parentPallets: "Consumed Pallets",
                userStdQty: "Standardowa ilosc uzytkownika",
                vendorBatch: "Partia Dostawcy",
                dicoJsPalletOrder: "you can&apos;&apos;t create pallet before the mother pallet : ",
                seqnumber: "Seqnumber",
                negativeOEEWarning: "Blad 31001: Czas awarii musi byc krótszy niz czas pracy + konfiguracja.",
                errorDeleteBatch: "An error occured deleting the selected Batch.",
                openItems2: "WYKORZYSTANIE W TRYBIE OFF-LINE",
                inBoundErrorQuantityTotal: "The total quantity must match the total in the transaction selected.",
                lblRePrintInfoInnerHtml: "Select printer to reprint to?",
                operations: "Operacje",
                reasonCodeDescription: "Opis kodu przyczyny",
                mustInsertWo: "Musisz wpisac typ zlecenia pracy, to pole nie moze byc puste",
                labelPalletCount2: "{0}/{1}",
                toBeLoaded: "Do  zaladunku",
                lbl_spoilage_item_classes_title: "Spoilage Item Classes",
                bpcsDescription: "Opis BPCS",
                materialCode: "Material Code",
                errorSavingActivity: "Wystapil blad podczas zapisywania czynnosci, blad:",
                couldNotIssueConsumtionX0: "Nie można wyświetlić wykorzystania. error# w0007: {0}",
                btnNo: "No",
                day: "Dzień",
                bin: "Pojemnik",
                noP: "Liczba palet",
                new: "Nowe",
                loc: "Lokalizacja",
                lot: "Lot",
                key: "en-GB",
                wgt: "Waga",
                whs: "Magazyn",
                wcl: "WC/L",
                seq: "Seq",
                pal: "Paleta ",
                sol: "SO\\L",
                inBoundLitMat: "Material",
                empty: "Pusty ",
                error: "Błąd ",
                inBoundLnkAdd: "Add a new Line",
                admin: "Administrator",
                apply: "Zastosuj",
                found: "Znaleziono",
                batch: "Partia",
                block: "Blokuj",
                btnGo: "Confirm creation new pallet/s",
                color: "Kolor",
                close: "Zamknij",
                areYouSureRelease: "Czy na pewno chcesz wydac te palety?",
                input: "Dane wejściowe",
                notes: "Uwagi",
                consumeScrap: "Consume\\Scrap",
                order: "Zlecenie",
                btnCancel: "Cancel",
                transNotSent: "Ostrzezenie: transakcje nie zostaly przeslane do BPCS",
                valid: "Wazny",
                tKeys: "Klucze T-Key",
                reset: "Resetowanie",
                start: "Rozpocznij",
                scrap: "Złomuj",
                setUp: "Ustawienia",
                small: "Minimalna",
                shift: "Zmiana",
                print: "Drukuj",
                pause: "Pauza",
                goBacktoCurrentActivity: "Wróć do bieżącej aktywności",
                titleWoMan: "Work order {0}",
                noAPSData: "Brak danych dla tej czynnosci!",
                insertNew: "Wstaw nowe pole",
                rxg_From: "Od:",
                rxg_Open: "Otwórz",
                areYouSureDelete: "Czy na pewno chcesz usunąć te palety?",
                litWomMaterial: "Nr artykułu",
                shipNotes: "Notatki wysylki",
                metalAndEnds: "Metal i końcówki",
                shipManag: "Zarzadzanie wysylka",
                inBoundLitCouncil: "Fill text box and push search",
                couldNotDeleteConsumtionX0: "Nie można anulować wykorzystania. error# w0004: {0} ",
                shipNote: "Notatki wysylki",
                shipment: "Wysylka",
                palletID: "ID palety",
                freeText1: "Dowolny tekst 1",
                freeText2: "Dowolny tekst 2",
                inBoundDxColLotNumber: "Lot",
                selectAll: "Zaznacz wszystko",
                tNotConfigured: "Domyslne kody przyczyny dla importu TLM nie sa poprawnie skonfigurowane dla tego dzialu",
                dicoCartonDetails: "Carton Details",
                deliveryResult: "Result",
                username: "Nazwa uzytkownika",
                userTime: "Czas uzytkownika",
                pausePrinting: "Wstrzymaj drukowanie",
                labelName: "Projekt etykiety",
                x0OfX1PaletsApproved1: "{0} of {1} pallets approved.",
                addLoad: "Dodaj ladunek",
                addUser: "Dodaj użytkownika",
                printFailedWithException: "{0}.  Printing failed for rank {1} Error# w0020. ",
                btnSeachWom: "Wyszukaj zlecenie",
                shipCheckIn: "Zamelduj wysylke",
                cartonQuantity: "Ilość",
                netWeight: "Waga netto",
                nextSeqNo: "Numer kolejnej palety",
                purchaseOrder: "Zamówienie zakupu",
                areYouSureReturnToVendor: "Czy na pewno chcesz zwrócic palete do dostawcy?",
                addBatchLot: "Dodaj partie/serie",
                actions: "Działania",
                quantity: "Ilość",
                loadManagement: "Zarzadzanie zaladunkami",
                scrapSelectedSSCC: "Zlomuj wybrany SSCC",
                missingNoDays: "You need to insert the number of days to generate the batches",
                checkSSCC: "Are you sure you want to remove consumption for ",
                checkSLED: "Sprawdz SLED",
                inBoundTxtMatError: "The field material cannot be empty and must have at least 3 characters.",
                apsImportHistory: "Historia importów TLM",
                massActivities: "Wykonaj dla wielu",
                palletStatusEdit: "Status palety - edytuj",
                lstDefault: "None",
                wantToMove: "Czy  jestes pewny, ze chcesz przesunac wybrane palety do wynranego  ladunku?",
                printJSFailed: "Print Failed.",
                noResult: "Brak wyników",
                inBoundDxSelectTran: "Select a Transaction",
                rxg_Failed_to_set_print_parameters_with_error___0_: "Nieprawidłowe ustawienie parametrów drukowania z powodu błędu: {0}",
                x0OfX1PaletsScrapped: "Zezłomowano {0} z {1} palet..",
                litMainByProd: "By Prod 1",
                customer: "Klient",
                custCode: "Kod klienta",
                custName: "Nazwa klienta",
                rxg_Defect_comment_must_be_less_than_255_characters_: "Komentarz dotyczący wad nie może przekraczać 255 znaków.",
                loadDateTime: "Data/Czas zaladunku",
                loadDateFrom: "Data utworzenia zaladunku",
                apsImport: "Importuj TLM",
                yourAccountIsLockedPleaseContactTheHelpdes: "Twoje konto jest zablokowane. Skontaktuj się z działem pomocy.",
                shiftTime: "Czas zmiany",
                litQuantityXPallet: "Ilość w palecie",
                disabledOperators: "Pokaz tylko wylaczonych operatorów:",
                couldNotDeleteOpenItemX0ErrorX1: "Nie można anulować otwartej pozycji {0} error# {1}",
                transactionType: "Transaction Type",
                couldNotUnblockPalletErrorX0X1: "Nie można odblokować palety. error# {0}: {1}",
                backToConsumptionScreen: "Powórt do konsumpcji ekran",
                lblErrbtnConsumptionClick1: "&quot;Cannot add the material. {0} : error# {1}&quot;",
                endDateNotGood: "The value for End Date is not a correctly formatted date.  Insert Cancelled.",
                rxg_OfflinePrintHeader: "Drukowanie w trybie off-line",
                scanNewMaterial: "Skanuj",
                deleteTKeyGroupConfirm: "Czy na pewno chcesz usunac te grupe TKey?",
                addingTwoIdenticalDefects: "Adding two identical defects (type and mould)",
                printResult: "{0} label have been sent to the print list (see below for more information about its status).",
                workOrderSpoilage: "Work Order Spoilage",
                searchWorksOrder: "Wyszukaj zlecenie",
                inBoundLitTransac: "Transaction Selection",
                areYouSureUnblock: "Czy na pewno chcesz odblokować te palety?",
                rxg_Scrap_failed_with_error__: "Nie udało się zezłomować z powodu błędu:",
                inBoundErrorPalletEdition: "The current label creation is not fully updated. Update your row and after you can print.",
                closeLine: "Zamknij linię/linie",
                loadStatus: "status zaladunku",
                tracDifferentDialogText:
                    "Traceability batch is different from the one in consumption. The new one would be {0}. Do you want to continue anyway? Or do you want to change the traceability info to the newest ones?",
                areyousureyouwanttodeleteSSCCX0X: "Czy na pewno chcesz usunąć SSCC:{0}?",
                quantityXPallet: "Ilość w palecie",
                lblConfirmOff: "This pallet has 0 Qty ! you can t use it",
                printPallet: "Drukuj palete",
                validationSummary: "Przed zakonczeniem operacji nalezy rozwiazac nastepujace problemy.",
                inBoundConfirmCreation: "are you sure to create those one? it ll change the transaction status to print.",
                areYouSureScrap1: "Czy na pewno chcesz zezłomować tę paletę?",
                runTime: "Czas pracy",
                woMPallFullQty: "Full",
                firstPalletWOShift: "Pierwszy kod SSCC na zmianie w zleceniu pracy",
                litByProduct: "ByProduct 1 Material",
                ordered: "Zamówiono",
                couldNotReturnToVendorPalletErrorX0X1: "Nie mozna zwrócic palety do dostawcy. Blad # {0}:{1}",
                repacking: "Przepakowywanie",
                closeWorksOrder: "Zamknij zlecenie",
                changeLog: "Lista zmian",
                scheduledDateTime: "Początek zlecenia",
                extWhsB2B: "Zewnetrzny  magazyn pojemników (B2B)",
                areYouSureApprove: "Are you sure you want to approve the production of the selected pallet?",
                offlineconsumption: "WYKORZYSTANIE W TRYBIE OFF-LINE",
                efficiencyoftheLine: "Wydajność linii ",
                x0OfX1PaletsUnblocked1: "Odblokowano {0} z {1} palet.",
                dicoHtmlConfirRepack: "Confirm Repack",
                userNameLabelText: "Użytkownik",
                x0OfX1PaletsDeletedStoppedAtErrorForSSCCX2: "Usunięto {0} z {1} palet. Zatrzymanie z powodu błędu sscc:{2} - {3}",
                scheduleWorkOrder: "Planowanie",
                doYouWantToActivate: "Czy chcesz uruchomić nowe zlecenie?",
                scanMulti: "Skanuj wiele SSCC",
                ssccConsumed: "Wykorzystane SSCC",
                doYouSetWorkOrderDefaultDataCollection: "Czy chcesz ustawic {0} jako domyslne zlecenie pracy dla tej zmiany?",
                litCustMatDesc: "Artykuł",
                noOfCartons: "Liczba kartonów",
                printingComplete: "Drukowanie zakończone",
                bpcsWhsLocDes: "Mag\\Lok\\Opis BPCS",
                couldNotApprovePalletErrorX01: "Could Not Approve pallet. Error# w00010: {0}",
                material: "Artykuł",
                scanSingle: "Skanuj pojedynczy SSCC",
                mustSelectPass: "Wybierz numer przejscia aby kontynuowac",
                printScreen: "Drukowanie",
                errorMatchingExtID: "Wystapil blad podczas wyszukiwania zgodnego kodu SSCC dla zewnetrznego oznaczenia etykiety",
                inBoundDxPrintStatus: "Print Status",
                shipmentManagement: "Zarzadzanie wysylka",
                printStatus: "Stan drukowania",
                areyousureyouwanttoconsumescrapSSCC: "Are you sure you want to consume and scrap SSCC",
                dateTimeInconsistency: "Rozbieznosci dat/czasowe",
                closeReturn: "Zamknij linie i zwróć",
                maxNoCopies: "Maks. ilosc egzemplarzy",
                woAvailable: "List of GPOs Available",
                checkDatesfuture: "Cannot consume in the future",
                dicoJsPalletquantity: "Can&apos;&apos;t use more ressources than the repack has",
                noRecFound: "No Records Found",
                rxg_Could_not_close_job__0___Error___1_: "Nie można zamknąć zadania {0}: error# {1}",
                sealContainer: "Zamknij pojemnik",
                palletCondition: "Stan palety",
                rxg_QiPalletsSelectedCount: "Condition of {0} Blocked QI pallet(s) won&apos;t be updated in bulk mode",
                errorUpdateBatch: "An error occured updating the selected Batch.",
                couldNotUnblockPalletErrorX01: "Nie można odblokować palety. error# w00010: {0}",
                plantBin: "Pojemnik zakladu",
                litCopyNumber: "Number of copy",
                litWomDec2: "Inne",
                litWomDec1: "Nazwa wyrobu",
                btnYesReturn: "Zwracam w ilości {0}",
                btnPrintNextCarton: "Print Next Carton",
                dicoHtmlSelectMatOnHold: "selected",
                productionOrderRunning: "Bieżące zlecenie",
                massIssue: "Wydanie masowe",
                noOfPallets: "Liczba palet",
                labellingStatus: "Status Etykietowania",
                salesOrderLine: "Nr linii",
                qtyProduced: "Wyprodukowano sztuk",
                overProdText: "Creating this pallet, you will be overproducing on this WO. Do you want to continue anyway?",
                rxg_Please_select_the_pass_number_: "Wybierz numer przejścia",
                litQuantitySchedule: "quantity schedule",
                article: "Artykuł",
                ignoreSapUpdates: "Ignore SAP updates",
                litWait: "Please Wait",
                litMain: "Main",
                printUsingAlternatePrinterFailed:
                    "Print failed with Alternate printer too. Do you want to try printing again?                                            Click YES to print using alternate printer or click NO then press PRINT to retry the original printer.",
                childPallets: "Produced Pallets",
                isActive: "Jest aktywny",
                lblErrbtnConsumptionClick1Exception: "Cannot add the material.  error# {0}",
                activityDefaultInstructions: "Domyslne wartosci dla nowych czynnosci",
                printPartiallyFailed:
                    "Drukowanie nie powiodło się dla poziomu {0} error# w0021. Wydrukowano tylko {1} z {2} etykiet. Czy chcesz spróbować wydrukować brakujące etykiety?",
                qtyScheduled: "quantity schedule",
                rxg_Could_not_close_job___Error___0__: "Nie można zamknąć zadania: error#{0}",
                consumeSSCC: "Wykorzystuj SSCC",
                rememberSave: "Zapamietaj, aby zapisac wartosci domyslne.",
                totalShiftDuration: "Czas trwania zmiany (min.)",
                labelPalletInProgress: "Pallet in progress : Current SSCC {0}",
                printFailed: "Printing failed for rank {0}",
                endDateTime: "Data zakonczenia",
                shiftPatternNumber: "Przykladowy numer zmiany",
                approve: "Approve",
                rxg_Consumption2: "WYKORZYSTANIE W TRYBIE ON-LINE",
                x0OfX1PalletsReturnedToVendor: "{0} z {1} palet zwrócono dostawcy.",
                rxg_Add_Defect: "Dodaj wadę",
                requiredFields: "Brakuje wymaganych wartości podświetlonych na czerwono*",
                cartonType: "Quantity per carton",
                extLabelNotFound: "Nie znaleziono rekordu z nastepujacym oznaczeniem zewnetrznym palety {0}",
                printJSCancelRequest: "Cancellation Request Received.",
                remaining: "Pozostalo",
                litPrintHistory: "Historia drukowania",
                printEngine: "Mechanizm drukujący",
                partDescription: "Artykuł",
                litCustomerGTIN: "CustomerGTIN",
                lblRePrintInfo: "Select Printer?",
                areYouSureUnblockComment: "Wstaw komentarz i kliknij „Tak”, jesli chcesz odblokowac wybrane palety",
                copySscc: "Kopiuj SSCC",
                inboundYes: "Yes",
                labelCurrentActivityError:
                    "Some Error in CurrentActivity for this Line!!                                                                    Do you wish to continue moving onto another line?",
                couldNotReturnToVendorPalletErrorX0: "Nie mozna zwrócic palety do dostawcy. Blad # w0009: {0}",
                pleaseContactHelpdesk:
                    'Please contact <a href="mailto:helpdesk@ardaghgroup.com">helpdesk@ardaghgroup.com</a> for new accounts',
                areYouSureMassiveUnblock: "Are you sure you want to unblock? {0} of {1} pallets will be affected ",
                rxg_Back_to_labeling: "Powrót do etykietowania",
                rxg_Yes: "Tak",
                beginPrinting: "Rozpocznij drukowanie",
                rxg_defectsTable_Initials: "Iniciały",
                woMMAterialNameError: "this Material doesn t exist : ",
                manningValidation: "* Obsada musi byc wartoscia numeryczna.",
                litLabelCreation: "Label Creation",
                department: "Dział",
                movementDescriptionDefault: "Pallet Updated",
                finished: "Zakonczono",
                withCarton: "Z kartonem",
                outisdeShiftTime: "Wpis czynnosci musi byc miedzy {0} a {1}.",
                rxg_defectsTable_Found: "Znaleziony",
                noBinSelected: "Brak wybranego pojemnika",
                onLINECONSUMPTION: "WYKORZYSTANIE W TRYBIE ON-LINE",
                offlineconsumptionmetalandends: "WYKORZYSTANIE W TRYBIE OFF-LINE METAL I KOŃCÓWKI",
                labelDefaultTitle: "Bieżąca aktywność - etykietowanie",
                plantTime: "Czas fabryki",
                failedToReturnSsccInDbX0: "Nie można zwrócić sscc w bazie danych. error# w0013: {0} ",
                selectNone: "Odznacz wszystko",
                blockPackaging: "Blokada 500",
                sendToSAP: "Wysłano do SAP",
                sendTrans: "Wysij transakcje do BPCS",
                leavingthispagewillstopprinting: "Opuszczanie tej strony przerwie proces drukowania",
                reprint: "Ponowny wydruk",
                manning: "Obsada",
                shipmentOv: "Przeglad wysylek",
                billOfMaterials: "BOM",
                woSClosed: "Zakończone",
                refresh: "Odswiez",
                matCode: "Kod materialu",
                release: "Wydaj",
                litCustCode: "Numer referencyjny klienta",
                litCustomer: "Customer info",
                dataCollection: "Zbieranie danych",
                rxg_CouldNotDeletePallet: "Nie można usunąć palety. error# {0}: {1}",
                logDate: "Data rejestru",
                loading: "Ladowanie",
                loadInq: "Zapytanie dotyczace zaladunku",
                loadQty: "Zaladowana ilosc",
                byProductDetails: "Informacje dotyczące produktu ubocznego",
                inBoundLitWarehouse: "Warehouse",
                extLabelId: "Oznaczenie zewnetrzne etykiety\\Oznaczenie palety dostawcy",
                consumptionWorkorder: "Cons.WO",
                rxg_CouldNotDeletePallet1: "Nie można usunąć palety. error#: {0}",
                localServerOffline: "Local Server is Offline.",
                destinationBin: "Miejsce przeznaczenia pojemnika",
                customerDetails: "Dane Klienta",
                finalPass: "Końcowe przejście",
                cannotMove: "Zaladunek, do którego chcesz przesunac palety  nie istnieje",
                areyousureyouwanttoreturnSSCC: "Czy na pewno chcesz zwrócić SSCC?",
                testPrint: "Wydruk testowy",
                deliveryEmptyWorkorder: "no work order for this pallet. you can t print it",
                rxg_Select_work_order_for_consumption: "Lista zleceń do sortowania",
                backToConsumptionDetail: "Powórt do konsumpcji szczególy",
                printLabels: "Drukuj etykiety",
                palSatDefaultTitle: "Zarządzanie statusem palet",
                calcGrossWeight: "Obliczona masa brutto",
                vendorPalIdent: "ID palety dostawcy",
                inBoundBtnExit: "Exit",
                failureReason: "Przyczyna niepowodzenia",
                stagingAreaManagement: "Zarzadzanie obszarem postojowym",
                closeButton: "Close",
                cantDelete: "Blad numer: {0} Nie mozna usunac.",
                batchExists: "The value for Batch already exists on this work order. Insert Cancelled.",
                printJSCancelFailed: "Cancellation Failed",
                assignNewJob: "Uruchom zlecenie",
                btnYes: "Yes",
                rxg_Delete_Pallet: "Usuń paletę",
                ringDiameter: "Średnica pierścienia",
                btnWoMan: "Edycja zlecenia",
                inBoundStrCoilNr: "SU reference",
                noChangesMade: "No changes made",
                woSequenceScheduled: "GPO Sequence Scheduled",
                dicoHtmlOriginalQty: "Original Qty",
                inBoundErrorLabelRank: "The number of label must be a numeric",
                startDateIsLaterThanEndDate: "Data rozpoczęcia jest późniejsza od daty zakończenia",
                inBoundDxwarehouse: "Warehouse",
                rxg_You_must_enter_a_comment_for_the_defect_s__: "Musisz wpisać komentarz dotyczący wady/wad.",
                selected: "Wybrane",
                errorCommandNotRecognised: "Błąd: nie rozpoznano polecenia. error# w0011 ",
                extBarcode: "Kod klienta",
                rxg_Cannot_issue_the_material___0___error___1_: "Nie można wydać materiału. {0}: error# {1}",
                moveSSCC: "Ruch SSCC",
                noColoursValidation: "* Oznakowanie koloru musi byc wartoscia numeryczna.",
                lblFailErr: "Error :",
                btnYesWarn: "Yes",
                totalMinutesBooked: "Calkowita liczba zarezerwowanych minut",
                palletNotFound: "Nie znaleziono palety o kodzie SSCC {0} ",
                description: "Nazwa wyrobu",
                notUpdateByERP: "Pola nie uzupelnione przez ERP",
                palletStatusId: "ID statusu",
                initQty: "Ilość w palecie",
                woMPallTxtModQty: "Changed by Operator",
                binInquiry: "Zapytanie pojemnik",
                youCanOnlyHaveNumberOfPalletsIssuedConsume:
                    "Mozliwe sortowanie {0} palet na raz. Skanowanie obecnej palety spowoduje zakonczenie sortowania najstarszej z dodanych.",
                chkError: "Wyświetlaj tylko błędy",
                selectDefects: "Wybierz wady:",
                couldNotGetConsumptionPalletDetailsForJobE:
                    "Nie można uzyskać informacji dotyczących wykorzystania palety dla tego zadania. error# w0006: {0}",
                couldNotGetConsumptionPalletDetailsForJobX:
                    "Nie można uzyskać informacji dotyczących wykorzystania palety dla zadania {0}. error# {1}",
                rankFrom: "uszereguj  od",
                noStackers: "Brak danych o ukladaczach! Czy chcesz sprawdzic inne linie?",
                shipCondition: "Stan wysylki",
                shiftLength: "Od {0} do {1} z {2} godzin lacznie",
                checkSLEDText:
                    "Czy na pewno chcesz skasowac wybrana palete? Jej data waznosci to &lt;b&gt; {0} &lt;/b&gt;. &lt;/br&gt; Kod SSCC z najstarsza data waznosci to: &lt;/br&gt; &lt;/br&gt; - sscc:&lt;b&gt; {1} &lt;/b&gt; &lt;/br&gt; - wazn.: &lt;b&gt; {2} &lt;/b&gt; &lt;/br&gt; &lt;/br&gt; Wpisz swoje imie i komentarz, jesli mimo wszystko chcesz kontynuowac. &lt;/br&gt; &lt;/br&gt;",
                smallQtyNumeric: "Minimalna ilosc musi byc liczba calkowita",
                assignedSuccessfully: "Przydzielenie zakończone sukcesem",
                consumptionCannotBeDisplayedNoWO:
                    "Consumption cannot be displayed. No work order selected. Assign a job to this line instead.  error# w0002",
                rxg_defectsTable_Defect: "Wada",
                reasonCode: "Kod przyczyny",
                reasonDesc: "Reason Description",
                material12: "FP12",
                lblOIErrorDate: "wrong date!",
                inBoundDxColLocation: "Location",
                defectsModified: "Defects or status changed. Please refresh",
                failedToReturnSsccInDbX0ErrorX1: "Nie można zwrócić sscc w bazie danych. {0} error# {1} ",
                fullQtyNumeric: "Ilosc dla zapelnionej palety musi byc liczba calkowita",
                shiftPatternName: "Przykladowa nazwa zmiany",
                condition: "Stan",
                aplWarehouse: "Magazyn APL",
                rxg_Back_to_current_activity: "Wróć do listy zleceń",
                spoilageItemClasses: "Spoilage Item Classes",
                dayAlreadyExists: "The value for Day already exists on this work order. Insert Cancelled.",
                deliveryTextPurchaseOrder: "Customer Purchase Order",
                duration: "Czast trwania",
                loadShiftsTip: "Zaladuj zmiany w celu wybrania linii i daty",
                inBoundIntLabelRank: "Nr.Of Labels",
                printJSServerOffline: "Server Offline.  ",
                deliveryTitleCustCode: "Customer code :",
                lblConfiramtionReturn: "Czy potwierdzasz zwrot ilości 0?",
                dayNotWhole: "The value for Day is not whole a number. Insert Cancelled.",
                previousBatchNr: "Prev.Batch Nr",
                btnYesReturn2: "Zamykam to zlecenie \\n, ponieważ zwracam w ilości 0",
                newPalletNumber: "Nowa liczba palet",
                rxg_Is_the_previous_SSCC___0___completely_consumed___dialog__apl00002:
                    "Czy poprzednie SSCC ({0}) zostało całkowicie wykorzystane?",
                haveFollowingPalletsBeenFullyUsed: "Czy palety zostały załkowicie wykorzystane?",
                cartonError: "Całkowita ilość nie odpowiada ilości wybranych palet ",
                oldValue: "Stara wartosc",
                areYouSureMassiveDelete: "Are you sure you want to delete? {0} of {1} pallets will be affected ",
                deliveryTextNoteNr: "Delivery Note Nr.",
                component: "Materiały",
                backUpServer: "Running on back up central server.",
                palletIdentify: "Zidentyfikuj paletę",
                rxg_SSCC___0___has__1__quantity_and_cannot_be_consumed__error_4123:
                    "SSCC ({0}) ma {1} ilość i nie może zostać wykorzystane. error# w0023",
                byProduct4: "Produkt uboczny 4",
                byProduct1: "Produkt uboczny 1",
                byProduct3: "Produkt uboczny 3",
                byProduct2: "Produkt uboczny 2",
                byProducts: "Produkty uboczne",
                areYouSureBlock: "Czy na pewno chcesz zablokować te palety?",
                calcNrColli: "Przelicz nr ",
                couldNotDeleteOpenItemX0: "Nie można anulować otwartej pozycji. error# w0005: {0} ",
                litScanNewMaterial: "Skanuj nowy material",
                areYouSureScrap: "Czy na pewno chcesz zezłomować te palety?",
                checkSLEDError: "Musisz podac nazwe uzytkownika i komentarz, aby wygenerowac ten kod SSCC",
                deliveryPicking: "Podjecie wysylki",
                preventERPUpdate: "Zatrzymaj wszystkie aktualizacje systemu ERP ",
                hotKeyInfo: "Press {0} to print.",
                hotKeyWait: "Please wait.",
                noOfPalletsProduced: "Liczba palet wyprodukowanych w ramach tego zlecenia",
                inLineJob: "Inline Job",
                rxg_Label_parameters: "Parametry etykiet",
                closeConsumption: "Zamknij",
                localServerOnline: "Local server is online.",
                dicoHtmlScanSSCC: "Scan New SSCC :",
                defectDesc: "Opis wady",
                dicoHtmlRepackNew: " Date Repack of the new pallet",
                x0OfX1PaletsReturnedToVendorStoppedAtErrorForSSCCX:
                    "{0} z {1} palet zwrócono dostawcy. Przerwa przy bledzie dla kodu sscc:{2} - {3}",
                statusHistory: "Historia statusu",
                mvtDesc: "Działanie",
                mvtDate: "Data działania",
                mvtType: "Rodzaj działania",
                bpcsWarehouse: "Magazyn BPCS",
                forTheNewPalletNo: "Dla nowego numeru palety",
                tKeyCode: "Kod Tkey",
                rxg__0__assigned_to__1_: "{0} przypisany do {1}",
                inBoundBtnReset: "Reset Date",
                fullQtyGreaterThanSmall: "Ilosc dla zapelnionej palety musi byc wieksza lub równa ilosci minimalnej",
                inBoundDxColunit: "Unit",
                couldNotBlockPalletErrorX0: "Nie można zablokować palety. error# w0003: {0}",
                inBoundDxComment: "Delivery Note",
                removeLoad: "Usun zaladunek",
                removeSSCC: "Usun SSCC",
                name: "value",
                edit: "Edytuj",
                exit: "Wyjście ",
                full: "Pełna",
                date: "Data",
                desc: "Nazwa wyrobu",
                done: "Gotowe",
                dock: "Dok",
                move: "Ruch",
                main: "Ogólne",
                back: "Powrót",
                code: "Kod",
                item: "Pozycja ",
                next: "Następny",
                okay: "W porządku",
                oops: "An unexpected error occurred, we apologise for the inconveniance.  This error has been logged, if this persists please contact the help desk.  Error# w0016",
                open: "Otwórz",
                line: "Linia",
                load: "Zaladunek",
                unit: "Jednostka",
                tKey: "Klucz Tkey",
                time: "Godzina",
                rank: "Nr palety",
                stop: "Zatrzymaj",
                save: "Zapisz",
                sscc: "SSCC",
                pass: "Przejście",
                btnWorkOrderSpoilage: "WO Spoilage",
                bpNoOfCopies: "Liczba etykiet",
                dicoHtmlRepackProgress: "RePacking Material in progress :",
                shippingModule: "Modul wysylek",
                saveShiftAreYouSure: "Na pewno?",
                litWoOpeByProd4: "po prod 3",
                litWoOpeByProd2: "By Prod 2",
                litWoOpeByProd3: "po prod 3",
                custCrossRef: "Inny numer ref klienta",
                rxg_No: "Nie",
                openItemNotInBOM:
                    "Material {0} nie znajduje sie w zestawieniu materialowym zlecenia pracy {1} obowiazujacym obecnie na tej linii",
                cartonProdResume: "Produkcja kartonów: Wznów",
                shiftPatterns: "Uklad  zmian",
                consumptionStatus: "Status Sortowania",
                couldNotApprovePalletErrorX0X1: "Could Not Approve pallet. Error#{0}:{1}",
                inBoundsearch: "Search",
                success: "Powodzenie",
                dicoHtmlAddPallet: "Add a New Pallet to be Created",
                batchMissing: "Batch Missing",
                printDown: "System.Drawing.Bitmap",
                inLine: "In Line",
                layers: "Layers",
                materialMissing: "Material Missing",
                printUp: "System.Drawing.Bitmap",
                customerGTIN: "CustomerGTIN",
                dateScheduleFuture: "You are going to assign a job scheduled for a future date.",
                priorityMissing: "Priority Missing",
                billOfBatches: "Bill Of Batches",
                selectPage: "Zaznacz stronę",
                workorderAssignedPrinting: "Zlecenie przydzielone (etykietowanie)",
                workorderAssignedConsumption: "Zlecenie przydzielone (sortowanie)",
                jobIn: "Job In",
                statusChangeNotAllowed: "Zmiana statusu niedozwolona",
                deselect: "Odznacz",
                resetView: "Resetuj widok",
                containerVolume: "Objętość",
                youCanOnlyHaveNumberOfPalletsIssued: "Mozliwe sortowanie {0} palet na raz",
                lineIn: "Line In",
                partPallet: "Part Pallet",
                manualEntry: "Wpisywanie ręczne",
                consumed: "Consumed",
                issued: "Issued"
            }
        }
    },
    "sv-SE": {
        translation: {
            main: {
                palletConditionId00: "Info",
                palletConditionId01: "Godkänd -Ej i Lager",
                palletConditionId02: "I Lager",
                palletConditionId03: "Omsynat",
                palletConditionId04: "Vald för lastning",
                palletConditionId05: "Levererard",
                palletConditionId06: "Pall Skrotad",
                palletConditionId07: "I Lager (SUL)",
                palletConditionId08: "Lost",
                palletConditionId09: "Pall Borttagen",
                palletConditionId10: "Lagerflytt",
                palletConditionId11: "Null",
                palletConditionId12: "Quality Inspection",
                palletConditionId13: "Undanställd ",
                palletConditionId94: "Allocated for Delivery",
                palletConditionId99: "Palletikett Utskrivet",
                palletStatusId00: "Label Printing",
                palletStatusId01: "Palletikett Utskrivet",
                palletStatusId02: "Palletikett Utskrive_NIUt",
                palletStatusId03: "Kund Inkubation",
                palletStatusId04: "Godkänd",
                palletStatusId05: "Undanställd",
                palletStatusId06: "Omsorterad",
                palletStatusId07: "Skrot",
                palletStatusId08: "Test Pall",
                palletStatusId09: "Kund Retur",
                palletStatusId10: "Undanställd QI",
                palletStatusId11: "Begränsade Försäljning ",
                palletStatusId12: "Begränsade FörsUndanställdäljning ",
                palletStatusId13: "Issued",
                palletStatusId14: "Förbrukat",
                palletStatusId15: "Returer",
                palletStatusId16: "Pallar Mottaget",
                palletStatusId17: "Godkänd",
                palletStatusId18: "Borttaget",
                palletStatusId19: "Ompackat",
                palletStatusId20: "Lastade",
                palletStatusId21: "Levererade",
                palletStatusId22: "Skrotad  Lageret",
                palletStatusId30: "PreBilled",
                palletStatusId90: "WIP",
                offlineCons: "Efterregistrering av förbrukade pallar",
                operator: " Operatör",
                openedWO: " Opened GPOs",
                litEANGTAN: "  EAN/GTIN",
                noWorkOrderOnLabelingAndOneRunningOnConsum: " No work order on labeling and one running on consumption. Error# w0015:",
                deliveryTextPurchaseOrderLine: "DeliveryTextPurchaseOrderLine",
                woSSuspended: " Pausad",
                passFirst: " Välj Pass nummer",
                woMPallQty: " Antal X pall",
                rxg_Label_paramters_save_successfully_: "  Etikett parametrar sparade",
                rxg_Please_enter_the_quantity_remaining_on_the_previous_pallet__input__APL00031:
                    " Registerera antal som är kvar på föregående pall. Input# APL0001",
                lblFailSSCC: " SSCC {0} existerar inte.",
                lblErrOI: " Antal kvar måste vara större än 0! Fel# w0026",
                x0OfX1PaletsBlocked: " {0} of {1} pallar spärrad. ",
                chkInPRogresse: " Get only Print Request in wait time",
                inBoundDxDescription1: " Beskrivning",
                batchMissing: "Batch saknas",
                popMaxcatonLimit: " Totala antalet kartonger kan inte överskrider",
                printJSSequenceNumber: " Next Seq No.",
                litUserUpdate: " Ändrad av operatör",
                inValidWorkOrderId: " InValid WorkOrderId/LineId!!Please check your database.",
                scrapped: " Skrotad",
                rxg_Could_not_assign__0__to__1__Error____2_: " Could not assign {0} to {1} Error#: {2}",
                emptyRowDelivery: "Ingan data hittades!",
                rxg_Please_select_a_defect: " Välj felkod",
                cartonCreateLastDate: "CartonCreateLastDate",
                offlinePrint: " Offline Print",
                noWorkOrderOnConsumptionAndOneRunningForLa: " No work order on consumption and one running for Labeling. Error# w0014:  ",
                litCartonLabel: " Palletikett 2",
                printDate: " Print Date",
                printDown: " System.Drawing.Bitmap",
                batchNr: "Batch Nr",
                printSuccessful: " Utskrift lyckades",
                barcode: " Barcode",
                litNameCust: "Kund Namn:",
                womTitle: "Produktionsorderlistan",
                mouldNo: " Moulds",
                noDefectIdSelected: " Blank DefectId selected",
                differentWOOnConsumptionAndLabeling: " Olika jobb igång på Avpalletering och Produktion",
                operation: " Operation",
                btnUpdateWoM: "Uppdatera",
                lotNotWhole: " The value for Lot is not whole a number.  Insert Cancelled.",
                unableToAddOpenItemToLineX0X1ErrorX2: " Unable to Add open item to Line {0} {1} error#: {2}",
                batchStart: "Batch Start Datum",
                deleteLastOne: " Ta bort föregående",
                lblErrbtnConsumeClick: "Pall kan inte registreras på framtida datum. Ändra datum.",
                labelImSwitchQty: " Ändra antal mellan hel pall och del pall",
                conditionID: "ConditionID",
                toolTipchkRaw: " Tryck uppdatera för att lägga på filter",
                offlinePrintingFailedException: " Skrivaren är inte redo.  Utskrift pausad. Välj en ny skrivare.",
                palletStatusDialogText: "Pallen har felkod och är spärrad. Vill du förtsätta med registrering?",
                inBoundDxMaterialCode: " Materialkod",
                consumptionNbPallet: "ConsumptionNbPallet",
                palletsQty: "Pal (Qty)",
                palletRank: " Pall nr.",
                inBoundDxTransactionDate: " Datum",
                cannotConsumeInTheFuture: "CannotConsumeInTheFuture",
                palletDetail: " Palldetaljer",
                linePrintAll: " Skriv ut alla etiketter",
                deliveryNote: " Leveransnotering",
                btnCartonDeleteConfirmation: " Are you sure you want to delete this carton ?",
                inBoundLitLabelName: "Etikett Namn",
                printResultSuccess: " {0} copy(s) of Sequence {1} sent to printer {2} at {3}.",
                scheduledOrders: " Scheduled GPOs",
                dicoJsPalletDate: " Du få inte skapa pall i framtiden",
                openItems: " öppna artiklar",
                actQty: " Act Qty",
                rxg_SSCC___0___was_not_found___error__00001: " SSCC ({0}) kunde inte hittas. Fel#:#w0024",
                chkDetails: "Utskrifts info",
                lotExists: " The value for Lot already exists on this work order. Insert Cancelled.",
                assign: "Starta ett jobb",
                dicoRepackSummary: " Summering ompack",
                cartonDeleteLastDate: "CartonDeleteLastDate",
                labellingPrintingComplete: " Utskrift klar",
                inBoundErrorQtyLabel: "  Antalet etiketter måste vara en tal",
                noDefectsPassed: " At least one defect required for blocking",
                woMPallTxtFullQty: " Standard",
                palletsProduced: "PalletsProduced",
                dicoHtmlSelectMat: " Välj detta meterial",
                goBack: " Tillbaka",
                addMultipleBatches: " Add Multiple Batches",
                btnDeleteLastOne: " Delete last carton",
                litMessWarn: "Antal producerad överstiga planerad kvantitet. ",
                dateIn: " Datum start",
                delete: " Ta bort",
                detail: " Avpalleterings info",
                deleteConsumption: " Ta bort konsumtion",
                newValue: " Nytt värde",
                lotNumber: "Lot",
                inBoundTotalLabelCreation: " Total",
                inBoundTxtTanDateError: " Ett giltigt datum krävs.",
                rxg_No_Department_specified__Error__w0007: " No Department specified. Error# w0025",
                previous: " Previous",
                checkDateslater: "Fel,  start datum måste vara före slut datum!",
                dicoHtmlQuantityUsed: " Antal förbrukad:",
                consumptionCurrentActivity: " Förbruka SSCC",
                inputLine: " Input Line",
                batchManagement: " Batch Management",
                inBoundErrorReceiptDate: " The Expiry Date must be a valide date and time.",
                columnName: "Kolumn Namn",
                txtQuantityErr: " Ogiltig kvantitet",
                consumptionParameters: " Förbruknings parametrar",
                btnPrintPalletAndClose: " Skriva ut palletikett och stänga",
                failedToConsumeSsccInDbX0: "SSCC inte konsumerad",
                inBoundIntQtyLabel: " Antal x Etikett",
                rxg_Could_not_assign_Work_Order___Error___0_: " Jobb kan inte startas. Fel: {0}",
                blockQi: "Block QI",
                blocked: "Undanställd",
                unableToAddOpenItemToLineX0ErrorX1: " Unable to Add open item to Line {0} error#: {1}",
                noOfSheets: " No. of Sheets",
                cancel: "Avbryt",
                pickingLblNumCopy: " Antal kopior",
                workOrder: "Prod Ord",
                wantToUseAlternatePrinter:
                    "  Den valda skrivaren är inte redo!! Klicka JA om du vill använda skrivare {0} istället för utskrift",
                x0OfX1PaletsApprovedStoppedAtErrorForPalletX21: " {0} of {1} pallets Approved. Stopped at error for PalletId {2} -{3}",
                inBoundBtnConfirm: "  Bekräfta",
                inboundNo: "InboundNo",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheck: " SSCC {0} är öppen på följande linjer. Kontrollera linjer du vill stänga.",
                inLine: " In Line",
                insert: "Registrera",
                inBoundTxtwareError: " The field warhouse cannot be empty and cannot have more than 2 characters",
                lblErrbtnConsumeClickMissing: " SSCC hittades inte. error# W0006",
                rxg_PrintDefect: " Print Defect",
                workOrderOp: " Produktions Order / OPE",
                batchNotWhole: "Batch nr ofullständig",
                inBoundBtnCancel: " Annullera",
                inBoundBtnCancel2: "Klar",
                noData: " Det finns ingen data att visa för denna linje!!",
                noDays: " No Days",
                changeCloseJob: "Byt / Stäng Jobb",
                inValidUser: " Not a Valid User!Please try logging again..",
                inValidTime: " Ogiltig tid!! Skriv i giltig tid (hh:mm)",
                woSPlanned: " Planerad",
                inValidDate: " Ogiltigt datum!! Skriv in giltigt datum (dd/MM/yyyy)",
                inBoundErrorDate: " Datum stämmer inte",
                palletCreated: " Pall {0} ({1}) skapad",
                x0OfX1PaletsUnblockedStoppedAtErrorForPalletX21:
                    " {0} of {1} pallar frisläppt. Frisläppning upphördes vid fel på Pall ID {2} -{3}",
                inBoundDxColSeqNumber: " Sekvens",
                litPalLabel4: " Palletikett 4",
                litPalLabel3: " Palletikett 3",
                litWoS: " Produktions order status:",
                printAbort: " Utskrift misslyckades för pall nr. {0}. Servern svarar inte. Fel# w0017",
                labels: " Palletiketter",
                logout: " Logga ut",
                length: " Längd",
                btnYesReturnDetail: " Stänger detta för att den gav 0 i kvantitet",
                finalPalletRank: " Sista pall nummer -",
                update: " Uppdatera",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheckReturn:
                    " SSCC {0} är öppen på följande linjer. Kontrollera linjer du vill lämna tillbaka.",
                printfailedselectanotherprinter: " Utskrift misslyckades,  välj en annan skrivare och försök igen. Fel# w0019",
                batchLot: "Batch\\Lot",
                batchEnd: "Slut datum - batch",
                prodDate: " Produktions datum",
                litAllInOne: " All in one",
                couldNotScrapPalletErrorX0X1: " Pallen kan inte skrotas. Fel# {0}:{1}",
                lblDefaultSetting: " Antal per kartong {0}",
                rxg_Labeling_Pass_Number: " Labeling Pass Number",
                lblErrbtnConsumptionClick1Else: " Kunde inte konsumera SSCC ogiltigt antal. Fel#W0008",
                btnBack: "Tillbaka",
                dicoHtmlSapcode: "SAP artikel nummer",
                cartonSumQty: "CartonSumQty",
                rxg_Unable_to_consume_pallet__0____1__Error____2__: " Kan inte registrera avpalletering av pall {0}: {1} fel#: {2}",
                dicoTotalQuantity: " Totalt antal",
                priority: " Priority",
                printMod: " Print Mod",
                thisMethodRequiresAConfirmationAndNoneIsDe: " This method requires a confirmation and none is defined.",
                litTitre: " Inbound Label",
                qtyReq: " Planerad Qty",
                litWoOpe: " Arbetsorder operation",
                litWoMan: "  Produktionsorder information",
                standard: " Standard",
                noWorkorder: " No Workorder",
                thereIsNoWorkOrderConfiguredForThisLine: " Det finns ingen jobb tillgänglig för denna linje.",
                dicoHtmlRepackResult: " Återpacks resultat",
                tableName: " Tabellnamn",
                woMPallMinQty: " Del",
                inBoundLitTranDate: " Transaktionsdatum",
                materialMissing: " Material Missing",
                quality: " Quality",
                allPallets: "All pallets",
                pleaseSelectaPrinter: " Välj skrivare för att skriva ut den  nya etiketten?",
                rxg_ThereIsNoWorksOrderAssignedForThisLine: " Det finns ingen jobb startad på denna linje",
                palletStatus: " Pallstatus",
                cuttedSheetsBlocked: " Cutted Sheets Blocked",
                litByProduct2: " By Produkt 2  Material",
                tracDialogText: " Traceability batch is missing. Do you want to continue anyway?",
                sqlTranslation: "  SQL översättning",
                rxg_Back_to_offline_consumption: " Tillbaka till Efterregistrering av Konsumption",
                woSInUse: " Pågående Jobb",
                rxg_Open_SSCC__0__on_the_following_line_s__: " Öppna SSCC {0} på följande linjer",
                thislinehasajobassignedClosethejob: " Denna linje har ett aktiv jobb. Stäng jobbet?",
                rxg_Work_Order_Enquiry: " Sök Produktions Ordrar",
                partDesc2: " Artikelbeskrivning. 2",
                litQtyReq: " Antal Beställd",
                dicoHtmlMaterial: " Material",
                timeIn: " Start tid",
                startDateNotGood: " The value for Start Date is not a correctly formatted date.  Insert Cancelled.",
                labelPalletCount: " Antal pallar producerade: <br/> <b>(0)</b>",
                numberOfCopies: " Antal kopior",
                inBoundLitDescription: " Beskrivning",
                ckBoxCartonSave: "ckBoxCartonSave",
                palletsScheduled: "PalletsScheduled",
                cartonQty: "CartonQty",
                return: "Retur",
                inBoundStrVendorBatch: " Kund Batch",
                inBoundErrorNbrPallet: "  Fältet Nbr*OF label måste ha en tal större än 0",
                scrapProduction: " Scrap Production",
                mouldAndNonMouldSameDefectId: " Unable to add mould and non-mould related with the same defect ID",
                overProdHeader: " Overproduction",
                btnUnderstoodBack: "Tillbaka",
                defaultActivityLabeling: "Skapa Pall & Etikett",
                sumQty: " Total Stk.",
                status: " Status",
                palSatEditSelectPrinter: " Välj skrivare att skriva ut igen?",
                inBoundLitInfosTrans: " Blank ",
                search: " Sök",
                select: " Välja",
                timeEnd: " Slut tid",
                prompt: " Prompt",
                addDefect: " Registrera feltyp",
                couldNotLoadWorkOrderPleaseCheckTheOrderCo:
                    " Could not load Work Order. Please check the Order Code and try again. error# w0008",
                pieces: " Pcs",
                couldNotIssueConsumtionX0ErrorX1: " Kunde inte utfärda konsumtion. {0} Fel# {1}",
                startingPalletRank: " Startar pall nummer -",
                movementDescription11: " Label Printed - Pallet Produced",
                movementDescription10: " Return Pallet off line",
                movementDescription13: " Change pallet status from SAP",
                movementDescription12: " Label Printed - Pallet Produced (offline)",
                movementDescription15: " Block pallet QI",
                movementDescription14: " Change pallet Birth Date/Condition in APL from PLC ",
                movementDescription17: " Scrap pallet",
                movementDescription16: " Release pallet",
                movementDescription19: " User connection",
                movementDescription18: " Delete/Cancel pallet",
                movementDescription01: " Start WorkOrder Front End Line",
                movementDescription02: " Stop Workorder Front End line",
                movementDescription03: " Start Workorder Back End Line",
                movementDescription04: " Stop Workorder Back End line",
                movementDescription05: " Issue Pallet on line ",
                movementDescription06: " Consumed Pallet on line ",
                movementDescription07: " Return Pallet on line",
                movementDescription08: " Delete Consumption",
                movementDescription09: " Consumed Pallet off line ",
                movementDescription33: " Block pallet for Scrap",
                movementDescription32: " Pallet quantity change",
                movementDescription35: " Scrap in Warehouse",
                movementDescription34: " Block Pallet for Packaging",
                movementDescription22: " Open Item Return ",
                movementDescription23: " Block pallet for resorting",
                movementDescription20: " Open Item Issuing",
                movementDescription21: " Open Item Consumption",
                movementDescription26: " Remove defect on a pallet",
                movementDescription27: " Defect found",
                movementDescription24: " Open Item delete",
                movementDescription25: " Add Defects to Pallet",
                movementDescription28: " Defect not found",
                movementDescription55: " SU defect removed from SAP",
                movementDescription54: " SU defect added from SAP",
                movementDescription51: " SU Updated from SAP",
                movementDescription50: " SU Created from SAP",
                movementDescription53: " SU condition Updated from SAP",
                movementDescription52: " SU status Updated from SAP",
                movementDescription44: " Approve Pallet",
                movementDescription40: " Pallet Scanned for Repack",
                movementDescription41: " Remove Pallet from Repack",
                movementDescription42: " Pallet Splitting",
                movementDescription43: " Create pallet from other",
                movementDescription60: " Pallet Locked",
                movementDescription61: " Pallet Unlocked",
                movementDescription99: " SU Imported for Go Live",
                inBoundErrorQuantity: "Etikett antal måste vara större än 0",
                couldNotDeleteConsumtionX0ErrorX1: " Förbrukning kan inte tas bort . {0} Error# {1}",
                rxg_Consumption: " Avpalletering",
                toolTipEnter: " Tryck Enter för att lägga på filter",
                inBoundErrorAmount: " Fel i  Antal. Se över värdena",
                litSearch: " Sök en ny Produktions Order",
                currentPalletRank: " Current Pallet Rank -",
                rxg__0__units_returned_on_SSCC__1___When_all_pallets_are_consumed_returned__click_OK_again_to_close_the_job__dialog_w0005:
                    " {0} units returned on SSCC {1}. When all pallets are consumed/returned.  Click OK again to close the job. dialog#w0001",
                passNumber: " PassNummer",
                printer: " Skrivare",
                printUp: " System.Drawing.Bitmap",
                bpQuantity: "Antal",
                unblock: " Frisläppa",
                deliverySelected: " Vald",
                couldNotScrapPalletErrorX0: " Pallen kan inte skrotas. Fel# w0009: {0}",
                quantityScrapped: " Quantity Scrapped",
                dicoHtmlLine: " Linje",
                multipleSelectionError: " Vald rader ha inte samma status. Välj rader med bara samma status.",
                deliveryTitle: " Skriver ut - JWO leveransetikett",
                dateCreate: " Datum skapa",
                btnCloseOff: " Aboard",
                areyousureyouwanttoclosethejob: "Vill du verkligen avsluta jobbet?",
                traceabilityInfo: " Spårbarhetsinfo",
                baseProduct: "SAP Container Nr",
                litPalLabel: " Palletikett",
                rxg_You_must_enter_your_initials_to_add_a_defect: " You must enter your initials to add a defect",
                itemClass: " Artikel klass",
                inBoundErrorPalletCreation: " Fel vid skapande av pall. Se över värdena.",
                inBoundConfirmDelete: " Är du säker du vill ta bort denna rad?",
                currentActivity: "Pågående Jobb",
                backToCurrentActivity: " Tillbaka till översiken",
                confirm: "Bekräfta",
                consume: "Förbruka",
                comment: "Kommentar",
                rxg_Select_work_order_for_labeling: " Välj jobb för Palletikett Utskrift",
                specialText: " Special Text",
                selectLines: " Välj linjer",
                printJSWorksOrder: " Works Order",
                palletStatusDialogHeader: " Blocked Pallet",
                backToOfflineHome: " Tillbaka till Offline Home",
                consumptionPageTitle: "Avpalleterad pallar",
                rxg_Could_not_assign_Work_Order_Error___0____1_: " Could not assign Work Order Error#:{0}: {1}",
                noOfCoils: " Nummer av Coils",
                x0OfX1PaletsBlockedStoppedAtErrorForSSCCX2: " {0} of {1} pallar spärrad. Spärrning upphördes vid fel på Pall ID {2} -{3}",
                coilCutting: " CoilCutting",
                popLabelErrorCartonQty: " wrong Quantity for this carton. must be greater than 0 and less than final quantity pallet",
                adminView: "Admin Vy ",
                startDate: " Start Datum",
                inBoundDxSelTranType: " Transaktionstyp",
                partCode: " Artikelnummer",
                partDesc: " Artikelbeskrivning",
                headerTextUser: "Användare",
                rxg_PrintBoth: " Print Both",
                userNotRecognised: "Okänd anvandare",
                dicoHtmlWo: " ProduktionsOrder",
                mainDetails: " Main Details",
                saveChanges: " Spara ändringar",
                inBoundStrWorkOrder: "  Produktionsorder reference",
                rxg_BeginPrint: " Starta utskrift",
                litQuantityProd: " Antal Producerade",
                centralServer: "Central Server",
                blockPallet: "Ställa undan pallen",
                litActQty: " Verklig kvantitet",
                byProduct: "ByProduct",
                woSApproved: " Godkänd",
                rxg_Title: " Offline Printing",
                synoptic: "  Synoptic",
                printSucceeded: " Utskrift lyckades",
                rxg_Print: " Skriv ut",
                btnNoWarn: " No",
                pleaseSelectaLine: " Välj linje",
                lblConfirmRepackCondition: " <br />The curent selection in RePacking will be changed",
                litsearchWomField: " Sök en ny Produktions Order",
                consumptionUnit: " Enhet",
                dateEnd: " Datum avslut",
                reprintFailed:
                    "  Utskrift misslyckades för pall nr. {0} Fel# w0022. Bara {1} av {2} etiketter skrevs ut. Vill du försöka skriva igen?",
                quantityProduced: "  Antal producerade (Pall förbrukad)",
                customerCode: "Kund Art. Nr.",
                customerGTIN: " Customer GTIN",
                customerDesc: " Kundbeskrivning",
                rxg_Quantity: " Antal",
                offLineMetalSSCCAway: " SSCC existerar inte",
                pallets: " Pallar",
                printFailedAbr: " Utskrift misslyckades.",
                rxg_Defect_Added: " Status ändarad men ingen felkod registrerad.",
                declarationOPENITEMS: " Deklaration - Öppna artiklar",
                noCopiesNumeric1to10: " Antal kopior måste vara mellan 1 och 10",
                inBoundLitRecap: "  Sammanställning av etiketter. Etiketter skapade och utskrivna:",
                inBoundLitPrint: " Skriv ut",
                inBoundLitTrans: " Transaktion",
                inBoundLitTitre: " Inbound Label",
                workCenter: " Produktions Linje",
                blockFailedWithError: "Undanställning misslyckades!",
                baseLineNotRecognised: " Line not Recognised.",
                inBoundTransactionQuantity: " Antal",
                rxg_Scrap_Pallet: " Skrota pall",
                changesNotSaved: "Ändringar sparas inte!",
                quantityConsumed: " Antal konsumerad",
                defects: "  Defekter",
                dateScheduleFuture: " You are scheduling a job for a future date.",
                showRawMaterial: " Visa råmaterial",
                areYouSureDelete1: "Vill du verkligen ta bort pallen?",
                inBoundBtnOk: " Ok",
                scrapWarehouse: " Scrap Warehouse",
                cuttedSheetsScrapped: " Cutted Sheets Scrapped",
                blockResort: "Block Resort",
                rxg_defectsTable_Comment: " Comment",
                mouldNotParsed: " Problem parsing mould numbers",
                inBoundDateExpiryDate: " Utgångsdatum",
                areyousureyouwishtoassignworkorder01toline3: "Är du säker du vill stara order {0}({1}-{2}) på {3}?",
                byProductDuplicate: "ByProductDuplicate",
                couldNotBlockPalletErrorX0X1: " Pallen kan inte spärras. Fel#{0}:{1}",
                chkEdit: "Ändra",
                initials: " Initialer",
                rxg_Defects_Added: " Felkod registrerad",
                rxg_Could_not_assign__0__to__1___Error___2___3_: " Kunde inte starta jobb {0} på {1} fel#:{2}-{3}",
                dicoJsPalletquantity2: " Registrerad kvantitet är mer and tillgängligt kvantitet.",
                dicobtnCreatePallet: " Skapa ny pall",
                scanExternalTag: " Orig/Ext Tag Identifier",
                rxg_DeleteFailedWithError: " Borttagning misslyckades med fel: {0}",
                consumptionQty: " Antal",
                lblConfirmRepack: " Do you confirm the Repack of the selected Material?",
                created: " Skapad",
                inBoundErrorUpdate: " Ett fel inträffade under uppdatering.  kontakta APL-Team för info",
                btnNoReturn: " No i don&apos;t consume anything",
                woMButton1: " Administrera Produktions Order",
                printerName: " Skrivarnamn",
                deliveryPalletLoaded: " Antal pallar laddade",
                invalideQuantity: " the return quantity set for the return pallet {0} is higher than remaining quantity error# w0026",
                x0OfX1PaletsScrappedStoppedAtErrorForSSCCX: " {0} of {1} pallar skrotad. Skrotning upphördes vid fel på Pall ID {2} -{3}",
                dateRecorded: " Datum sparat",
                errorNewBatch: "En fel intraffas vid registrering av Batch",
                litModQtyMax: " Antal i hel pall",
                litModQtyMin: " Antal i del pall",
                palStat_Default_Page_Load_Pallet_Status_Management: " Pallstatus Hantering",
                popDown: " Pop Down",
                endDate: "Slut datum",
                differentWOOnConsumptionAndLabeling2: " Olika jobb igång på Avpalletering och Produktion",
                x0OfX1PaletsDeleted: " {0} of {1} pallar togs bort.",
                closeAndConsume: "Förbruka och Stänga Jobb",
                go: " Kör",
                op: " Op",
                wo: " Produktions Order",
                to: " Till:",
                btnBackWo: "Tillbaka till WO list",
                noPallets: " Nummer av pallar",
                failedToConsumeSsccInDbX0ErrorX1: "SSCC inte konsumerad",
                areYouSureBlock1: "Vill du verkligen spärra pallen?",
                litCustMat: " Kund Artikel Nummer",
                dicoHtmlProdDate: " Produktionsdatum",
                btnCartonDeleteLastDate: " Delete Last one",
                dicoHtmlRemove: " Ta bort",
                dicoHtmlRepack: " Material selected for Repacking :",
                quantityRemaining: " Antal kvar",
                parentPallets: "Förbrukade pallar",
                dicoJsPalletOrder: "DicoJsPalletOrder",
                seqnumber: " Sekvensnummer",
                errorDeleteBatch: "En fel intraffas vid borttagning av Batch",
                inBoundErrorQuantityTotal: " Totala antalet måste vara lika med totala mängden vald i transaktionen.",
                lblRePrintInfoInnerHtml: " Välj skrivare för att skriva ut till igen?",
                operations: " Operationer",
                labelPalletCount2: " {0}/{1}",
                couldNotIssueConsumtionX0: "Kunde inte registera förbrukning.  Error# w0007  {0}",
                btnNo: " No",
                day: " Dag",
                lot: " Lot",
                key: "Språk",
                wcl: " Produktions Linje",
                seq: " Seq",
                inBoundLitMat: " Material",
                empty: "Tom",
                error: "Error!",
                inBoundLnkAdd: " Lägg till ny linje",
                admin: "Admin Meny",
                apply: "Tillföra",
                main1: " Main ",
                batch: "Batch",
                block: "Ställa undan",
                btnGo: " Confirm creation new pallet/s",
                color: "Glas Färg",
                close: "Stäng",
                input: " Input",
                consumeScrap: "Skrota",
                order: " Order",
                btnCancel: "Avbryt",
                reset: " Återställ",
                start: " Start",
                scrap: " Skrot",
                small: " Del",
                print: " Skriv ut",
                goBacktoCurrentActivity: "Åter till föregående sida",
                titleWoMan: " Produktions Order{0}",
                rxg_From: " Från:",
                rxg_Open: " Open",
                areYouSureDelete: "Vill du verkligen ta bort valda pallar?",
                litWomMaterial: " Material",
                metalAndEnds: " Efterregistrering (tryck på SÖK och välj rätt jobb)",
                inBoundLitCouncil: " Fill text box and push search",
                couldNotDeleteConsumtionX0: " Förbrukning kan inte tas bort . Fel# w0004: {0}",
                palletID: " Pall ID",
                inBoundDxColLotNumber: " Lot",
                selectAll: " Välja alla",
                dicoCartonDetails: "DicoCartonDetails",
                deliveryResult: " Resultat",
                username: " Användarnamn",
                pausePrinting: " Pausa utskrift",
                labelName: " Palletikett mall:",
                x0OfX1PaletsApproved1: " {0} of {1} pallets approved.",
                addUser: " Add User",
                printFailedWithException: " {0}. Utskrift misslyckades för pall nr. {1} Fel# w0020",
                btnSeachWom: "Sök Produktionsorder",
                cartonQuantity: "CartonQuantity",
                nextSeqNo: " Next Seq No.",
                addBatchLot: " Add Batch/Lot",
                actions: " Actions",
                quantity: " Antal",
                missingNoDays: " You need to insert the number of days to generate the batches",
                checkSSCC: "Vill du verkligen ta bort pallen från förbruknings listan?",
                inBoundTxtMatError: " The field material cannot be empty and must have at least 3 characters.",
                massActivities: " Mass Activities",
                priorityMissing: " Priority Missing",
                palletStatusEdit: " Ändra pallstatus",
                lstDefault: " None",
                printJSFailed: " Print Failed.",
                inBoundDxSelectTran: " Välj transaktion",
                rxg_Failed_to_set_print_parameters_with_error___0_: " Failed to set print parameters with error: {0}",
                x0OfX1PaletsScrapped: " {0} of {1} pallar skrotad.",
                litMainByProd: " By Prod 1",
                rxg_Defect_comment_must_be_less_than_255_characters_: "Kommentaren är för lång. Max 255 tecken.",
                yourAccountIsLockedPleaseContactTheHelpdes: " Your account is locked please contact the helpdesk.",
                litQuantityXPallet: " Pallet Qty",
                couldNotDeleteOpenItemX0ErrorX1: " Could not delete open item {0} Error# {1}",
                transactionType: " Transaktionstyp",
                couldNotUnblockPalletErrorX0X1: " Pallen kan inte frisläppas. Fel#{0}:{1}",
                lblErrbtnConsumptionClick1: " Unable to Add open item to Line {0} error#: {1}",
                endDateNotGood: "Fel format på datum.",
                rxg_OfflinePrintHeader: " Offline Print",
                scanNewMaterial: " Scanna ny material",
                addingTwoIdenticalDefects: " Adding two identical defects (type and mould)",
                printResult: " {0} label have been sent to the print list (see below for more information about its status).",
                searchWorksOrder: " Sök Produktionsorder",
                inBoundLitTransac: " Transaktions val",
                areYouSureUnblock: "Vill du verkligen frisläppa valda pallar?",
                rxg_Scrap_failed_with_error__: " Skrotning misslykades. Fel:",
                inBoundErrorPalletEdition: " The current label creation is not fully updated. Update your row and after you can print.",
                closeLine: " Stäng linje",
                tracDifferentDialogText:
                    " Traceability batch is different from the one in consumption. The new one would be {0}. Do you want to continue anyway? Or do you want to change the traceability info to the newest ones?",
                areyousureyouwanttodeleteSSCCX0X: "Vill du verkligen ta bort pall SSCC {0}?",
                quantityXPallet: " Antal på pall",
                lblConfirmOff: " Pallen är redan förbrukat! Den kan inte registreras.",
                printPallet: " Skriv ut pall etiketter",
                inBoundConfirmCreation: " Är du säker du vill skapa detta? Det kommer ändra transaktions status till utskrift",
                areYouSureScrap1: "Vill du verkligen skrota pallen?",
                woMPallFullQty: "Hel palls kvantitet",
                litByProduct: " By Produkt 1  Material",
                closeWorksOrder: "Stäng Produktions Order",
                changeLog: "Ändringslogg",
                scheduledDateTime: " Planerad Start Datum-Tid",
                areYouSureApprove: "Vill du verkligen godkänna valda pallar?",
                offlineconsumption: "Efterregistrering av förbrukade pallar",
                efficiencyoftheLine: "  Linje Effektivitet",
                x0OfX1PaletsUnblocked1: " {0} of {1} pallar frisläppt. ",
                dicoHtmlConfirRepack: " Bekräfta repack",
                x0OfX1PaletsDeletedStoppedAtErrorForSSCCX2:
                    " {0} of {1} pallar togs bort. Borttagning upphördes vid fel på Pall ID {2} -{3}",
                scheduleWorkOrder: " GPO Scheduling",
                doYouWantToActivate: "Vill du starta ett nytt jobb?",
                ssccConsumed: "  SSCC förbrukad",
                litCustMatDesc: " Beskrivning",
                noOfCartons: " Nummer av kartonger",
                printingComplete: " Utskrift klar",
                couldNotApprovePalletErrorX01: " Could Not Approve pallet. Error# w00010  {0}",
                material: " Material",
                printScreen: " Print Screen",
                inBoundDxPrintStatus: " Utskrifts status",
                printStatus: " Utskrifts status",
                areyousureyouwanttoconsumescrapSSCC: " Are you sure you want to consume and scrap SSCC",
                closeReturn: " Stäng och återvänd till linjer",
                woAvailable: " Lista av tillgängliga produktions order.",
                checkDatesfuture: "Fel,  datum få inte vara i framtiden!",
                dicoJsPalletquantity: "Kan inte förbruka mer glas än ",
                noRecFound: " No Records Found",
                rxg_Could_not_close_job__0___Error___1_: " Jobb kan inte stängas {0}: Fel#{1}",
                rxg_QiPalletsSelectedCount: " Condition of {0} Blocked QI pallet(s) won&apos;t be updated in bulk mode",
                errorUpdateBatch: "En uppdaterings fel intraffad vid val av Batch",
                couldNotUnblockPalletErrorX01: " Pallen kan inte frisläppas. Fel# w00010: {0}",
                litCopyNumber: " Antal kopior",
                litWomDec2: " Desc2",
                litWomDec1: " Artikelnamn",
                btnYesReturn: "Jag returnera pall som innehåller {0} stk",
                btnPrintNextCarton: " Print Next Carton",
                dicoHtmlSelectMatOnHold: " Vald",
                productionOrderRunning: " Produktionsorder aktiv",
                massIssue: "MassIssue",
                noOfPallets: " Nummer av pallar",
                labellingStatus: " Palletikett Status",
                qtyProduced: " quantity produced",
                overProdText: " Creating this pallet,  you will be overproducing on this WO. Do you want to continue anyway?",
                rxg_Please_select_the_pass_number_: " Välj passnummer",
                litQuantitySchedule: " Antal Planerad ",
                article: "Artikel nr",
                ignoreSapUpdates: "Ignore SAP updates",
                litWait: "  Vänligen vänta",
                litMain: " Main",
                printUsingAlternatePrinterFailed: " Utskrift misslyckades med alternativ skrivare. Vill du försöka skriva ut igen?",
                childPallets: "Producerade Pallar",
                isActive: " Är aktiv",
                lblErrbtnConsumptionClick1Exception: " Unable to Add open item to Line {0} {1} error#: {2}",
                printPartiallyFailed:
                    " Utskrift misslyckades för pall nr {0} Fel# w0021. Bara {1} av {2} etiketter skrevs ut. Vill du försöka skriva ut etiketterna som saknas?",
                qtyScheduled: " quantity schedule",
                rxg_Could_not_close_job___Error___0__: " Jobb kan inte stängas : Fel# {0}",
                consumeSSCC: " Konsumera SSCC",
                labelPalletInProgress: " Pall körs: Nuvarande SSCC {0}",
                printFailed: "  Utskrift misslyckades för pall nr.{0}. Vill du försöka skriva ut igen?",
                approve: "Godkänna",
                rxg_Add_Defect: " Lägg till felkod",
                requiredFields: " Data som fattas är markerad i rött",
                cartonType: "CartonType",
                printJSCancelRequest: " Cancellation Request Received.",
                litPrintHistory: "Utskriftslogg",
                printEngine: " Print Engine",
                partDescription: " Artikelbeskrivning",
                litCustomerGTIN: " Customer GTIN",
                lblRePrintInfo: " Välj Skrivare?",
                copySscc: "Kopiera SSCC Nr",
                inboundYes: " Ja",
                labelCurrentActivityError:
                    " Some Error in CurrentActivity for this Line!!   Do you wish to continue moving onto another line?",
                pleaseContactHelpdesk:
                    ' Please contact <a href="mailto helpdesk@ardaghgroup.com">helpdesk@ardaghgroup.com</a> for new accounts',
                rxg_Back_to_labeling: " Tillbaka till Palletikett modulen",
                rxg_Yes: " Ja",
                beginPrinting: "Skriva ut",
                rxg_defectsTable_Initials: " Initials",
                woMMAterialNameError: " Material existerar inte:",
                litLabelCreation: " Skapa etikett",
                department: " Avdelning",
                movementDescriptionDefault: " Pallet Updated",
                rxg_defectsTable_Found: " ",
                billOfBatches: "BOB (batchlista - ingående glas)",
                onLINECONSUMPTION: " Avpalletering",
                offlineconsumptionmetalandends: "Efterregistrering av förbrukade pallar",
                labelDefaultTitle: "Palletikett utskrift: aktuell jobb",
                failedToReturnSsccInDbX0: " Failed to return sscc in db. Error# w0013: {0} ",
                selectNone: " Välj inga",
                selectPage: " Välj hela sida",
                blockPackaging: "Användas Ej",
                sendToSAP: " Skickat till SAP",
                leavingthispagewillstopprinting: " Utskrift avbryts om ni lämnar sidan",
                reprint: " Skriv ut igen",
                billOfMaterials: "BoM",
                woSClosed: " Stängd",
                refresh: " Uppdatera",
                litCustCode: " Kund Nummer",
                litCustomer: " Kundinfo",
                rxg_CouldNotDeletePallet: " Kunde inte ta bort pall. Fel#{0}:{1}",
                byProductDetails: "ByProductDetails",
                inBoundLitWarehouse: " Lagerhus",
                consumptionWorkorder: "Förbrukat på WO:",
                rxg_CouldNotDeletePallet1: " Kunde inte ta bort pall. Fel#:{0}",
                localServerOffline: " Local Server is Offline.",
                customerDetails: " Kunddetaljer",
                finalPass: "  Slutligt pass",
                areyousureyouwanttoreturnSSCC: "Vill du verkligen skicka tillbaka pall SSCC {0}?",
                testPrint: " Test Print",
                deliveryEmptyWorkorder: " no work order for this pallet. you can t print it",
                rxg_Select_work_order_for_consumption: " Välj jobb för Avpalletering",
                printLabels: "  Skriv ut etiketter",
                palSatDefaultTitle: "Pall Status Listan",
                inBoundBtnExit: " Avsluta",
                failureReason: " Failure Reason",
                batchExists: "Batch är redan i listan",
                printJSCancelFailed: " Cancellation Failed",
                assignNewJob: "Starta ett nytt job",
                btnYes: "Ja",
                rxg_Delete_Pallet: " Ta bort pall",
                ringDiameter: " Ring diameter",
                btnWoMan: "Administrera Produktionsorder",
                inBoundStrCoilNr: " SU referens",
                noChangesMade: " No changes made",
                woSequenceScheduled: " GPO Sequence Scheduled",
                dicoHtmlOriginalQty: " Original antal",
                inBoundErrorLabelRank: " Antalet etiketter måste vara en tal",
                startDateIsLaterThanEndDate: " Startdatum är senare än slutdatum",
                inBoundDxwarehouse: " Lagerhus",
                rxg_You_must_enter_a_comment_for_the_defect_s__: " Du måste skriva i en kommentar vid undanställning. ",
                errorCommandNotRecognised: "  Ett fel inträffade: okänd kommando. Fel# w0011",
                extBarcode: " External SU Nr",
                rxg_Cannot_issue_the_material___0___error___1_: " Cannot issue the material. {0}: error# {1}",
                lblFailErr: " Fel :",
                btnYesWarn: "Ja",
                description: " Beskrivning",
                notUpdateByERP: " Fields not updated by ERP",
                palletStatusId: " StatusID",
                initQty: "Ursprungs Antal",
                woMPallTxtModQty: " Ändrad av operatör",
                youCanOnlyHaveNumberOfPalletsIssuedConsume:
                    " You can only have {0} pallets issued. Would you like to consume the oldest issued?",
                chkError: " Get only Error Logs",
                selectDefects: " Välj felkod:",
                couldNotGetConsumptionPalletDetailsForJobE: " Could not get consumption pallet details for job Error# w0006: {0} ",
                couldNotGetConsumptionPalletDetailsForJobX: " Could not get consumption pallet details for job {0}: Error# {1}",
                smallQtyNumeric: " Antal måste vara ett heltal",
                assignedSuccessfully: " Jobb Start klar",
                consumptionCannotBeDisplayedNoWO: "Förbrukning kan inte visas. Finns ingen aktiv jobb på linjen. error# w0002",
                rxg_defectsTable_Defect: " Defect",
                material12: "Speaking Part No.",
                lblOIErrorDate: " Fel datum!",
                inBoundDxColLocation: " Plats",
                defectsModified: " Defects or status changed. Please refresh",
                failedToReturnSsccInDbX0ErrorX1: " Failed to return sscc in db. {0} Error# {1}",
                fullQtyNumeric: " Kvantitet måste vara hel tal",
                condition: "Condition",
                rxg_Back_to_current_activity: " Tillbaka",
                dayAlreadyExists: " The value for Day already exists on this work order. Insert Cancelled.",
                deliveryTextPurchaseOrder: " Kund inköpsorder",
                inBoundIntLabelRank: " Antal etiketter",
                printJSServerOffline: " Server Offline.  ",
                deliveryTitleCustCode: " Kundkod:",
                lblConfiramtionReturn: " Godkänner du returen = 0 stk?",
                dayNotWhole: " The value for Day is not whole a number. Insert Cancelled.",
                previousBatchNr: " Prev.Batch Nr",
                btnYesReturn2: " Stänger arbetsorder för att den gav 0 i kvantitet",
                newPalletNumber: " Ny pallnummer",
                rxg_Is_the_previous_SSCC___0___completely_consumed___dialog__apl00002: " Är den föregående SSCC ({0}) helt avpalleterad?",
                haveFollowingPalletsBeenFullyUsed: "Have following pallets been fully used?",
                cartonError: "CartonError",
                oldValue: " Old Value",
                deliveryTextNoteNr: " Leveransnotering - nr",
                component: "Component",
                backUpServer: " Running on backup - central server.",
                palletIdentify: " Pall ID",
                rxg_SSCC___0___has__1__quantity_and_cannot_be_consumed__error_4123:
                    " SSCC ({0}) har {1} stk och kan inte förbrukas. Fel#w0023",
                byProduct1: "ByProduct1",
                byProduct2: "ByProduct2",
                byProducts: "ByProducts",
                areYouSureBlock: "Vill du verkligen spärra valda pallar?",
                couldNotDeleteOpenItemX0: " Could not delete open item Error# w0005: {0} ",
                areYouSureScrap: "Vill du verkligen skrota valda pallar?",
                preventERPUpdate: " Stoppa uppdatering från ERP (SAP or BPCS)",
                hotKeyInfo: " Press {0} to print.",
                hotKeyWait: " Please wait.",
                noOfPalletsProduced: "Pallar producerat i WO",
                inLineJob: " InLine Job",
                rxg_Label_parameters: " Label parameters",
                localServerOnline: " Local server is Online.",
                dicoHtmlScanSSCC: " Scanna ny SSCC : ",
                dicoHtmlRepackNew: "DicoHtmlRepackNew",
                statusHistory: " Status historik",
                mvtDesc: " Movement description",
                mvtDate: " Movement date",
                rxg__0__assigned_to__1_: " {0} aktiverad {1}",
                inBoundBtnReset: " Återställ datum",
                fullQtyGreaterThanSmall: "Kvantitet i en hel pall måste vara större eller lika med del pall.",
                inBoundDxColunit: " Enhet",
                couldNotBlockPalletErrorX0: " Pallen kan inte spärras. Fel# w0003: {0}",
                inBoundDxComment: " Leveransnotering",
                name: " Värde",
                edit: "Redigera",
                exit: " Avsluta",
                full: "Hel pall",
                date: " Datum",
                desc: " Desc",
                main: " Main ",
                back: "Tillbaka",
                item: " Artikel",
                next: " Nästa",
                okay: " OK",
                oops: " An unexpected error occurred,  we apologise for the inconveniance.  This error has been logged.  If this persists please contact the help desk.  Error# w0016",
                open: " öppen",
                line: " Linje",
                unit: " Enhet",
                time: " Tid",
                rank: " Pall nr.",
                stop: " Stopp",
                save: " Spara",
                sscc: " SSCC",
                pass: " Pass",
                bpNoOfCopies: "Antal Kopia",
                dicoHtmlRepackProgress: " Återpacks material som pågår:",
                litWoOpeByProd2: " By Prod 2",
                custCrossRef: " Customer Cross Ref",
                rxg_No: "Nej",
                cartonProdResume: "CartonProdResume",
                consumptionStatus: " Förbruknings status",
                couldNotApprovePalletErrorX0X1: " Could Not Approve pallet. Error#{0} {1}",
                inBoundsearch: " Sök",
                success: " Klar",
                dicoHtmlAddPallet: " Skapa en ny pall",
                layers: "Layers",
                palletWeight: "Pallet Weight",
                articleWeight: "Article Weight",
                interlayer: "Interlayer",
                pallet: "Pallet",
                carton: "Carton",
                workorderAssignedPrinting: "Jobb Start Lyckades på 'Palletiketter'. Vill du fortsätta till palletiketts sida?",
                workorderAssignedConsumption: "Jobb Start Lyckades på 'Avpalletering'. Vill du fortsätta till avpalleterings sida?",
                jobIn: "Job In",
                statusChangeNotAllowed: "Status change not allowed",
                deselect: "Deselect",
                resetView: "Reset View",
                containerVolume: "Volymen",
                youCanOnlyHaveNumberOfPalletsIssued: "You can only have {0} pallets issued",
                lineIn: "Line In",
                partPallet: "Part Pallet",
                manualEntry: "Manual Entry",
                consumed: "Consumed",
                issued: "Issued"
            }
        }
    },
    "pt-BR": {
        translation: {
            main: {
                palletConditionId00: "Info",
                palletConditionId01: "Produced – Not in Warehouse",
                palletConditionId02: "In Warehouse",
                palletConditionId03: "Resorted",
                palletConditionId04: "Picked",
                palletConditionId05: "Delivered",
                palletConditionId06: "Scrapped",
                palletConditionId07: "Put-Away via Storage UnitList",
                palletConditionId08: "Lost",
                palletConditionId09: "Deleted",
                palletConditionId10: "Stock Transfer",
                palletConditionId11: "Intermediate Pallet",
                palletConditionId12: "Quality Inspection",
                palletConditionId13: "Blocked Resort",
                palletConditionId94: "Allocated for Delivery",
                palletConditionId99: "Label Printed",
                palletStatusId00: "Label Printing",
                palletStatusId01: "Label Printed",
                palletStatusId02: "Label Printed_NIU",
                palletStatusId03: "Cus. Incubation",
                palletStatusId04: "Good",
                palletStatusId05: "Blocked",
                palletStatusId06: "Resorted",
                palletStatusId07: "Scrap",
                palletStatusId08: "Test Pallet",
                palletStatusId09: "Customer Return",
                palletStatusId10: "Blocked QI",
                palletStatusId11: "Saleable restricted",
                palletStatusId12: "Blocked Packaging",
                palletStatusId13: "Issued",
                palletStatusId14: "Consumed",
                palletStatusId15: "Returned",
                palletStatusId16: "Stock Received",
                palletStatusId17: "Good",
                palletStatusId18: "Deleted",
                palletStatusId19: "Repacking",
                palletStatusId20: "Loaded",
                palletStatusId21: "Shipped",
                palletStatusId22: "Scrap Warehouse",
                palletStatusId30: "PreBilled",
                palletStatusId90: "WIP",
                movementDescription11: "Label Printed - Pallet Produced",
                movementDescription10: "Return Pallet off line",
                movementDescription13: "Change pallet status from SAP",
                movementDescription12: "Label Printed - Pallet Produced (offline)",
                movementDescription15: "Block pallet QI",
                movementDescription14: "Change pallet Birth Date/Condition in APL from PLC ",
                movementDescription17: "Scrap pallet",
                movementDescription16: "Release pallet",
                movementDescription19: "User connection",
                movementDescription18: "Delete/Cancel pallet",
                movementDescription01: "Start WorkOrder Front End Line",
                movementDescription02: "Stop Workorder Front End line",
                movementDescription03: "Start Workorder Back End Line",
                movementDescription04: "Stop Workorder Back End line",
                movementDescription05: "Issue Pallet on line ",
                movementDescription06: "Consumed Pallet on line ",
                movementDescription07: "Return Pallet on line",
                movementDescription08: "Delete Consumption",
                movementDescription09: "Consumed Pallet off line ",
                movementDescription33: "Block pallet for Scrap",
                movementDescription32: "Pallet quantity change",
                movementDescription35: "Scrap in Warehouse",
                movementDescription34: "Block Pallet for Packaging",
                movementDescription22: "Open Item Return ",
                movementDescription23: "Block pallet for resorting",
                movementDescription20: "Open Item Issuing",
                movementDescription21: "Open Item Consumption",
                movementDescription26: "Remove defect on a pallet",
                movementDescription27: "Defect found",
                movementDescription24: "Open Item delete",
                movementDescription25: "Add Defects to Pallet",
                movementDescription28: "Defect not found",
                movementDescription55: "SU defect removed from SAP",
                movementDescription54: "SU defect added from SAP",
                movementDescription51: "SU Updated from SAP",
                movementDescription50: "SU Created from SAP",
                movementDescription53: "SU condition Updated from SAP",
                movementDescription52: "SU status Updated from SAP",
                movementDescription44: "Approve Pallet",
                movementDescription40: "Pallet Scanned for Repack",
                movementDescription41: "Remove Pallet from Repack",
                movementDescription42: "Pallet Splitting",
                movementDescription43: "Create pallet from other",
                movementDescription60: "Pallet Locked",
                movementDescription61: "Pallet Unlocked",
                movementDescription99: "SU Imported for Go Live",

                actions: "Ações",
                activity: "Atividades",
                activityDefaultInstructions: "Valores iniciais para novas atividades",
                actQty: "Quantidade de Ações",
                addDefect: "Adicionar defeito",
                addNewActivities: "Adicionar novas atividades",
                addUser: "Adicionar usuário",
                admin: "Admnistrador",
                adminView: "Obter a visualização do admnistrador",
                apply: "Aplicar",
                aPSImport: "Importar do APS",
                aPSImportHistory: "Importar histórico do APS",
                areYouSureBlock: "Tem certeza que deseja bloquear estes paletes?",
                areYouSureBlock1: "Tem certeza que deseja bloquear este palete?",
                areYouSureDelete: "Tem certeza que deseja deletar estes paletes?",
                areYouSureDelete1: "Tem certeza que deseja deletar este palete?",
                areYouSureScrap: "Tem certeza que deseja sucatear estes paletes?",
                areYouSureScrap1: "Tem certeza que deseja sucatear este palete?",
                areYouSureUnblock: "Tem certeza que deseja desbloquear estes paletes?",
                areyousureyouwanttoclosethejob: "Tem certeza que quer fechar este trabalho?",
                areyousureyouwanttoconsumescrapSSCC: "Tem certeza que quer consumir e sucatear SSCC?",
                areyousureyouwanttodeleteSSCCX0X: "Tem certeza que quer apagar o SSCC?",
                areyousureyouwanttoreturnSSCC: "tem certeza que quer retornar o SSCC?",
                areyousureyouwishtoassignworkorder01toline3: "Tem certeza que deseja atribuir uma ordem de produção na linha?",
                article: "Artigo",
                assign: "Atribuir",
                assignedSuccessfully: "Atribuido com sucesso",
                assignNewJob: "Atribuir novo trabalho",
                back: "Voltar",
                backToCurrentActivity: "Voltar a atividade atual",
                backToOfflineHome: "Voltar ao início offline",
                baseProduct: "Produção inicial",
                batch: "Lote   ",
                batchEnd: "Lote de Tampa",
                batchStart: "Lote Inicio",
                beginPrinting: "Iniciar impressão",
                billOfMaterials: "Listá Técnica de Materiais",
                block: "Bloquear",
                blocked: "Bloqueado",
                blockFailedWithError: "Bloqueio falhou com erro:",
                blockPackaging: "Bloquear embalagem",
                blockPallet: "Bloquear palete",
                blockQi: "Bloquear ",
                blockResort: "Bloquear retrabalho(RESORT)",
                bPNoOfCopies: "Número de cópias",
                bPQuantity: "Quantidade",
                btnBack: "Final",
                btnBackWo: "Voltar",
                btnCancel: "Cancelar",
                btnCartonDeleteConfirmation: "Você Tem certeza que Deseja Deletar Esta Etiqueta?",
                btnCartonDeleteLastDate: "Apagar o último",
                btnCloseOff: "A Bordo",
                btnDeleteLastOne: "Apagar a última etiqueta",
                btnGo: "Confirma criação de novo palete",
                btnNo: "Não",
                btnNoReturn: "Não consumir nada",
                btnNoWarn: "Não",
                btnPrintNextCarton: "Imprimir próxima etiqueta",
                btnPrintPalletAndClose: "Imprimir Etiqueta do Palete e Fechar",
                btnSeachWom: "Prodcurar ordem de produção",
                btnUnderstoodBack: "Voltar",
                btnUpdateWoM: "Atualizar",
                btnWoMan: "Gerenciar Ordem de produção",
                btnYes: "Sim",
                btnYesReturn: "Retornou quantidade 0",
                btnYesReturn2: "Fechar pois retornou com quantidade 0",
                btnYesReturnDetail: "Fechar pois retornou com quantidade 0",
                btnYesWarn: "Sim",
                byProduct: "Por produto",
                byProduct1: "Por produção 1",
                byProduct2: "Por produção 2",
                byProductDetails: "Detalhes por produto",
                byProductDuplicate:
                    "Você Não Pode Definir Um Subproduto no Mesmo Material que O Material  Principal, ou ter Dois Subprodutos Iguais",
                byProducts: "Por produtos",
                cancel: "Cancelar",
                cannotConsumeInTheFuture: "Não é possível consumir no futuro",
                cantDelete: "Erro numero:    Não pode ser apagado",
                cantLoadShifts: "Não carregou os turnos",
                cartonCreateLastDate: "Data da última produção",
                cartonDeleteLastDate: "Apagar o último",
                cartonError: "Quantidade total não corresponde a quantidade do palete selecionado",
                cartonProdResume: "Etiquetas produzidas: resumo",
                cartonQty: "Etiqueta Número",
                cartonQuantity: "Quantidade",
                cartonSumQty: "Número da etiqueta",
                cartonType: "Quantidade por etiqueta",
                changeCloseJob: "Alterar/Encerrar trabalho",
                changeLog: "Alterar Log",
                changesNotSaved: "Alterações Não Foram Salvas",
                checkDatesfuture: "Não é possível consumir um item no futuro",
                checkDateslater: "A data de início é posterior a data final",
                checkSSCC: "tem certeza que deseja remover o consumo?",
                chkDetails: "Informação de impressão",
                chkEdit: "Editar",
                chkError: "obter registro de erros",
                chkInPRogresse: "Receba somente a solicitação de impressão - tempo de espera",
                ckBoxCartonSave: "Com etiqueta",
                clickLoadShift: 'Você deve clicar em "Carregar turno" antes de prosseguir',
                close: "Fechar",
                closeAndConsume: "Parar Consumo",
                closeLine: "fechar linhas",
                closeReturn: "fechar e retornar linhas",
                closeWorksOrder: "Fechar GPO",
                coilCutting: "Corte bobina",
                color: "Cor   ",
                columnName: "Coluna Nome",
                comment: "Comentário",
                component: "Componente",
                condition: "Condição",
                conditionID: "Identificação da condição",
                confirm: "Confirmar",
                consume: "Consumo",
                consumeScrap: "Consumo/descarte",
                consumeSSCC: "Consumir SSCC",
                consumptionCannotBeDisplayedNoWO:
                    "Consumo não pode ser exibido. Nenhuma ordem de produção selecionada. Atribua um trabalho nesta linha",
                consumptionCurrentActivity: "Atividade de consumo atual",
                consumptionNbPallet: "Número do Palete",
                consumptionPageTitle: "Declaração de consumo",
                consumptionParameters: "Parâmetros de consumo",
                consumptionQty: "Quantidade",
                consumptionStatus: "Status de consumo",
                consumptionUnit: "Unidade",
                couldNotBlockPalletErrorX0: "Palete não pode ser bloqueado",
                couldNotBlockPalletErrorX0X1: "Palete não pode ser bloqueado",
                couldNotDeleteConsumtionX0: "Não pode ser deletado o consumo",
                couldNotDeleteConsumtionX0ErrorX1: "Não pode ser deletado o consumo",
                couldNotDeleteOpenItemX0: "Não pode ser deletado item aberto",
                couldNotDeleteOpenItemX0ErrorX1: "Não pode ser deletado item aberto",
                couldNotGetConsumptionPalletDetailsForJobE: "Não foi possível obter detalhes de palete de consumo para a atividade",
                couldNotGetConsumptionPalletDetailsForJobX: "Não foi possível obter detalhes de palete de consumo para a atividade",
                couldNotIssueConsumtionX0: "Não foi possível emitir o consumo",
                couldNotIssueConsumtionX0ErrorX1: "Não foi possível emitir o consumo",
                couldNotLoadWorkOrderPleaseCheckTheOrderCo: "Não foi possível carregar a ordem de produção. Verifique os dados da ordem",
                couldNotScrapPalletErrorX0: "Palete não pode ser descartado/sucateado",
                couldNotScrapPalletErrorX0X1: "Palete não pode ser descartado/sucateado",
                couldNotUnblockPalletErrorX01: "Não é possível desbloquear o palete",
                couldNotUnblockPalletErrorX0X1: "Não é possível desbloquear o palete",
                created: "Criado",
                currentActivity: "Atividade atual",
                currentPalletRank: "Classificação de palete atual",
                customerDesc: "Descrição do cliente",
                customerDetails: "Detalhes dos clientes",
                cuttedSheetsBlocked: "Bloqueio folhas cortadas",
                cuttedSheetsScrapped: "Bloqueio folhas descartadas/sucateadas",
                dataCollection: "Data Collection",
                date: "Data",
                dateCreate: "Data de criação",
                dateEnd: "Data Final",
                dateIn: "Data em",
                dateRecorded: "Data gravada",
                dateStart: "Data início",
                day: "Dia",
                declarationOPENITEMS: "Declaração - Itens Abertos",
                defaultActivityLabeling: "Rótulo",
                defects: "Defeitos",
                delete: "Apagar",
                deleteConsumption: "Apagar Consumo",
                deleteLastOne: "Apagar o último",
                deleteTKeyGroupConfirm: "Tem certeza que deseja apagar grupo de chave?",
                deleteTkeyReasonConfirm: "tem querteza que deseja apagar a chave?",
                deliveryEmptyWorkorder: "Nenhuma ordem de produção para o palete. Você não pode fazer isto",
                deliveryPalletLoaded: "Número de paletes Carregados",
                deliveryResult: "Resultado",
                deliverySelected: "Selecionado",
                deliveryTextNoteNr: "Nota de Entrega Número",
                deliveryTextPurchaseOrder: "Ordem de Compra do Cliente",
                deliveryTextPurchaseOrderLine: "Ordem de produção do cliente na linha",
                deliveryTitle: "Imprimindo - JWO Status do Rótulo",
                deliveryTitleCustCode: "Código do Consumidor",
                department: "Departamento",
                desc: "Descrição",
                description: "Descrição",
                detail: "Detalhe",
                dicobtnCreatePallet: "Criar Novo palete",
                dicoCartonDetails: "Detalhes da etiqueta",
                dicoHtmlAddPallet: "Adicione um novo palete pra ser criado",
                dicoHtmlConfirRepack: "Confirmar Reembalagem",
                dicoHtmlLine: "Linha",
                dicoHtmlMaterial: "Material",
                dicoHtmlOriginalQty: "Quantidade Original",
                dicoHtmlProdDate: "Data de produção",
                dicoHtmlQuantityUsed: "Quantidade usada:",
                dicoHtmlRemove: "Remover",
                dicoHtmlRepack: "Material selecionado para reembalagem",
                dicoHtmlRepackNew: "Data de reembalagem do novo palete",
                dicoHtmlRepackProgress: "Reembalar Material em processo",
                dicoHtmlRepackResult: "Resultado do Reembalamento",
                dicoHtmlSapcode: "Codigo do material SAP",
                dicoHtmlScanSSCC: "Ler novo SSCC",
                dicoHtmlSelectMat: "Selecione o material",
                dicoHtmlSelectMatOnHold: "Selecionado",
                dicoHtmlWo: "ordem de produção",
                dicoJsPalletDate: "Você não pode criar um palete no futuro",
                dicoJsPalletOrder: "Você não pode criar palete antes do palete mãe",
                dicoJsPalletquantity: "Não é possível utilizar mais recursos que o reembalar tem",
                dicoJsPalletquantity2: "Com esta quantidade está acima da quantidade disponível",
                dicoRepackSummary: "Sumário de reembalagem",
                dicoTotalQuantity: "Quantidade Total",
                differentWOOnConsumptionAndLabeling: "Diferente GPO em consumo e Rótulo",
                differentWOOnConsumptionAndLabeling2: "Ativar GPO na rotulagem e consumo",
                disable: "Desabilitar",
                disabledOperators: "Mostrar apenas operações desabilitadas:",
                display: "Monitor",
                done: "Concluido",
                downTime: "Tempo parado",
                doYouSetWorkOrderDefaultDataCollection: "Gostaria de configurar como ordem de produção padrão deste turno?",
                doYouWantToActivate: "Você quer ativar uma nova ordem de produção",
                duration: "Duração",
                durationMinutes: "Duração (min)",
                durationValidation: "Duração deve ser um número",
                edit: "Editar",
                efficiencyoftheLine: "Eficiência da linha",
                empty: "Vazio",
                emptyRowDelivery: "nenhuma Data Encontrada com Estes Parâmetros ",
                enable: "Habilitar",
                enabled: "Habilitado",
                endBeforeStart: "Data final é antes da data inicial",
                endDate: "Data final",
                endDateTime: "Data Final",
                endTime: "Tempo final",
                error: "Erro  ",
                errorCommandNotRecognised: "Erro: comando não reconhecido",
                errorSavingActivity: "Ocorreu um erro no momento de salvar a atividade",
                exit: "Saída",
                failedToConsumeSsccInDbX0: "Consumo falhou do SSCC no banco de dados",
                failedToConsumeSsccInDbX0ErrorX1: "Consumo falhou do SSCC no banco de dados",
                failedToReturnSsccInDbX0: "Retorno falhou do SSCC no banco de dados",
                failedToReturnSsccInDbX0ErrorX1: "Retorno falhou do SSCC no banco de dados",
                failureReason: "Motivo da falha",
                finalPalletRank: "Classificação final dos paletes",
                finalPass: "Final",
                finished: "Finalizado",
                freeText1: "Texto livre 1",
                freeText2: "Texto livre 2",
                full: "Completo",
                fullQtyGreaterThanSmall: "A Quantidade maior deve ser igual ou superiot a quantidade menor",
                fullQtyNumeric: "Quantidade completa deve ser um número inteiro",
                getData: "Obter dados do APS",
                go: "Ir",
                goBack: "Voltar",
                goBacktoCurrentActivity: "Voltar a atividade atual",
                headerTextUser: "Usuário",
                importDataFromAPS: "Importar dados do APS",
                inBoundBtnCancel: "Cancelar",
                inBoundBtnCancel2: "Final",
                inBoundBtnConfirm: "Confirmar",
                inBoundBtnExit: "Saída",
                inBoundBtnOk: "Ok",
                inBoundBtnReset: "Resetar data",
                deliveryNote: "Nota de entrega",
                inBoundConfirmCreation: "Tem certeza que deseja criar? Isso alterará o status da transação para imprimir",
                inBoundConfirmDelete: "Tem certeza que deseja apagar esta linha?",
                inBoundDateExpiryDate: "Data de validade",
                inBoundDxColLocation: "Localização",
                inBoundDxColLotNumber: "Muito",
                inBoundDxColSeqNumber: "Sequência",
                inBoundDxColunit: "Unidade",
                inBoundDxComment: "Nota de Entrega",
                inBoundDxDescription1: "Descrição",
                inBoundDxMaterialCode: "Código do material",
                inBoundDxPrintStatus: "Imprimir Status",
                inBoundDxSelectTran: "Selecione a Transação",
                inBoundDxSelTranType: "Tipo de Transação",
                inBoundDxTransactionDate: "Data",
                inBoundDxwarehouse: "Armazém",
                inBoundErrorAmount: "Erro no valor total. Verifique os valores e corrija-os",
                inBoundErrorDate: "A data não está correta",
                inBoundErrorLabelRank: "O número do rótulo deve ser numérico",
                inBoundErrorNbrPallet: "O campo número de palete deve ser maior que 0",
                inBoundErrorPalletCreation: "Erro Durante a Criação do Palete. Por Favor Check Seus valores",
                inBoundErrorPalletEdition: "A criação de rótulo não está atualizada. Atualize a linha e depois você pode imprimir.",
                inBoundErrorQtyLabel: "A quantidade x rótulo deve ser um número",
                inBoundErrorQuantity: "O Campo Quantidade do Rótulo Deve ser um Número Maior que 0",
                inBoundErrorQuantityTotal: "A quantidade total deve ser igual ao total na trasanção selecionada",
                inBoundErrorReceiptDate: "A data de validade deve ser uma data e hora válida",
                inBoundErrorUpdate: "Ocorreu um erro durante a atualização. Verifique os valores e, se persistir, solicite a equipe APL",
                inBoundIntLabelRank: "Número de rótulos",
                inBoundIntQtyLabel: "Quantidade x Rótulo",
                inBoundLitCouncil: "Preencha o campo e clique em pesquisar",
                inBoundLitDescription: "Descrição",
                inBoundLitInfosTrans: "Em branco = Todos, ou OO,U,UC, UT, UR, RT",
                inBoundLitLabelName: "Tipo de Rótulo:",
                inBoundLitMat: "Material",
                inBoundLitPrint: "Imprimir",
                inBoundLitRecap: "Resumo da criação de rótulo. Etiquetas criadas e impressas",
                inBoundLitTitre: "Etiqueta de Entrada",
                inBoundLitTranDate: "Data da transação",
                inBoundLitTrans: "Transação",
                inBoundLitTransac: "Selecionar Transação",
                inBoundLitWarehouse: "Armazém",
                inBoundLnkAdd: "Adicionar Nova Linha",
                inboundNo: "Não",
                inBoundsearch: "Prodcurar",
                inBoundStrCoilNr: "Referencia SU",
                inBoundStrVendorBatch: "Lote de venda",
                inBoundStrWorkOrder: "Referência Ordem de Produção",
                inBoundTotalLabelCreation: "Total",
                inBoundTransactionQuantity: "Quantidade",
                inBoundTxtMatError: "O campo material não pode estar vazio e deve conter pelo menos 3 caracteres",
                inBoundTxtTanDateError: "É necessário uma data válida",
                inBoundTxtwareError: "O Campo Armazem Não pode Estar Em Branco e Não pode Conter Mais Que 2 Caracteres",
                inboundYes: "Sim",
                initials: "Inicial",
                initQty: "Lote",
                input: "Inserir",
                insert: "Inserir",
                insertNew: "Inserir novo registro",
                inValidDate: "Data Inválida! Por favor inserir uma data válida(DD/MM/AAAA)",
                invalideQuantity: "A quantidade ajustada para o palete é maior que a quantidade restante",
                inValidTime: "Tempo inválido! Por favor inserir um tempo válido(hh:mm)",
                inValidUser: "Usuário inválido! Tente efetuar login novamente",
                inValidWorkOrderId: "Ordem de produção/Linha invalida! Por favor cheque os dados",
                isActive: "Está Ativo",
                item: "Item",
                itemClass: "Classe de item",
                key: "en-GB",
                labelCurrentActivityError: "Alguns erros na atividade corrente desta linha. Deseja continuar ou mudar de linha?",
                labelDefaultTitle: "Atividade atual de rótulo",
                labelImSwitchQty: "Alterar quantidade entre cheio e pequeno",
                labellingPrintingComplete: "Impressão completa",
                labellingStatus: "Status do Rótulo",
                labelName: "Nome do Rótulo",
                labelPalletCount: "Número de paletes produzidos",
                labelPalletCount2: "",
                labelPalletInProgress: "Palete em progresso: Atual SSCC",
                labels: "Rótulos",
                lblConfiramtionReturn: "Você confirma a quantidade 0?",
                lblConfirmOff: "Este palete tem 0 de Quantidade! Você não Pode Usá-lo",
                lblConfirmRepack: "Você Confirma a Reembalagem do matrial Selecionado?",
                lblConfirmRepackCondition: "A Seleção Atual em reembalagem Será Alterada",
                lblDefaultSetting: "Quantidade na Etiqueta",
                lblErrbtnConsumeClick: "Data Errada. Você Não pode Consumir um palete no Futuro. Por Favor Altere a Data",
                lblErrbtnConsumeClickMissing: "Não foi possível encontrar o SSCC",
                lblErrbtnConsumptionClick1: "Não Pode Adicionar o material",
                lblErrbtnConsumptionClick1Else: "Não foi possível consumir o SSCC, quantidade inválida",
                lblErrbtnConsumptionClick1Exception: "Não é possível adicionar o material",
                lblErrOI: "Quantidade deve ser maior que 0",
                lblFailErr: "Erro:",
                lblFailSSCC: "O SSCC não existe nessa planta",
                lblOIErrorDate: "Data Errada!",
                lblRePrintInfo: "Selecione Impressora",
                lblRePrintInfoInnerHtml: "Selecionada Impressora Para Reimprimir?",
                leavingthispagewillstopprinting: "Deixar esta página e parar de imprimir",
                length: "Comprimento",
                line: "Linha",
                linePrintAll: "Imprimir Todos os Rótulos",
                litActQty: "Quantidade atual",
                litAllInOne: "Tudo de uma só vez",
                litByProduct: "Por produto material 1",
                litByProduct2: "Por produtos 2 Materiais",
                litCartonLabel: "Etiqueta de Rótulo",
                litCopyNumber: "Número de Cópias",
                litCustCode: "Código do Consumidor",
                litCustMat: "Material de Cliente",
                litCustMatDesc: "Descrição",
                litCustomer: "Informação do cliente",
                litEANGTAN: "EAN / Gtin",
                litLabelCreation: "Criação do Rótulo",
                litMain: "Principal",
                litMainByProd: "Por Prod 1",
                litMessWarn:
                    "A Quantidade Excede o Cronograma de Quantidade Máxima da Ordem de  trabalho. Você deseja Alterar a Quantidade Atual do palete",
                litModQtyMax: "Quantidade Para Palete Completo",
                litModQtyMin: "Quantidade para palete pequeno",
                litNameCust: "Nome",
                litPalLabel: "Rótulo do palete",
                litPrintHistory: "Imprimir História",
                litQtyReq: "Quantidade requisitada",
                litQuantityProd: "Quantidade produzida",
                litQuantitySchedule: "Cronograma de Quantidade",
                litSearch: "Producar nova Ordem de Produção",
                litsearchWomField: "Procurar Nova Ordem de Produção",
                litTitre: "Etiqueta de Entrada",
                litUserUpdate: "Alterado pelo operador",
                litWait: "Aguarde",
                litWoMan: "Informação de ordem de produção",
                litWomDec1: "Desc1",
                litWomDec2: "Desc2",
                litWomMaterial: "Materia",
                litWoOpe: "Ordem de Produção em Operação",
                litWoOpeByProd2: "Por produção 2",
                litWoS: "Status da Ordem de Produção atual",
                loadShift: "Carregar turnos",
                loadShiftsTip: "Carregar turnos para linha e data selecionada",
                logout: "Sair/Desconectar",
                lotNumber: "Muito",
                lot: "Muito",
                lstDefault: "nenhum  ",
                main: "Principal",
                mainDetails: "Detalhes principais",
                manning: "Colaboradores",
                manningValidation: "Colaboradores tem que ser numérico",
                massIssue: "problema em massa",
                material: "Material",
                metalAndEnds: "Metal e Tampas",
                missingAPSDef: "Faltando a importação do APS",
                multipleSelectionError: "",
                name: "Valor",
                negativeOEEWarning: "A parada deve ser menor que o tempo de execução + configuração",
                new: "Novo",
                newPalletNumber: "Novo número de palete",
                newValue: "Novo Valor",
                next: "Próximo",
                noAPSData: "Nenhuma data para esta atividade",
                noColours: "Número de cores",
                noColoursValidation: "Número de cores deve ser numérico",
                noCopiesNumeric1to10: "Não. As Cópias Devem Ser Um Número inteiro Entre 1 e 10",
                noData: "Não existe data para mostrar nesta linha",
                noOfCartons: "Número de etiquetas",
                noOfCoils: "Número de bobinas",
                noOfPallets: "Número de paletes",
                noOfPalletsProduced: "Número de paletes produzidos na ordem de produção",
                noOfSheets: "Número de folhas",
                noPallets: "Número de paletes",
                noShiftsToDisplay: "Não existem atividades para este turno",
                notUpdateByERP: "Campos não atualizados pelo ERP",
                noUpdateAfterSAP: "Você não pode carregar uma entrada depois de enviar pro SAP",
                noWorkorder: "Número GPO",
                noWorkOrderOnConsumptionAndOneRunningForLa: "Nenhum GPO no consumo ou funcionando para rotulagem",
                noWorkOrderOnLabelingAndOneRunningOnConsum: "Nenhum GPO no consumo ou funcionando para rotulagem",
                numberOfCopies: "Número de cópias",
                offlineCons: "Consumo offLine",
                oFFLINECONSUMPTION: "Consumo offLine",
                oFFLINECONSUMPTIONMETALANDENDS: "Consumo offLine de metal e tampas",
                offLineMetalSSCCAway: "Este SSCC não Existe",
                offlinePrint: "Impressão Off line",
                offlinePrintingFailedException: "Impressão não está pronta ou foi pausada. Selecione uma impressora e pressione Imprimir.",
                okay: "Ok",
                oldValue: "Valor Antigo",
                onLINECONSUMPTION: "Consumo on line",
                oops: "Um erro inesperado ocorreu, caso persista, contate o ServiceDesk",
                op: "Op",
                open: "Abrir",
                openedWO: "GPOs abertos",
                openItems: "Itens Abertos",
                operation: "Operação",
                operations: "Operações",
                operator: "Operador",
                operatorCode: "Código de operador",
                operatorName: "Nome do operador",
                order: "Ordem",
                outisdeShiftTime: "A entrada deve estar no intervalo",
                outOfShift: "",
                overProdHeader: "Produção Excedida",
                overProdText: "Criando este palete você estará excedendo a Ordem de produção. Quer continuar assim mesmo?",
                palletCreated: "Palete criado com sucesso",
                palletDetail: "Detalhe do palete",
                palletID: "Identificação do palete",
                palletIdentify: "Identificação do palete",
                palletRank: "Classificação do palete",
                pallets: "Paletes",
                palletsProduced: "Paletes produzidos",
                palletsQty: "Paletes (quantidade)",
                palletsScheduled: "Paletes planejados",
                palletStatus: "Status do palete",
                palletStatusEdit: "Editar status do palete",
                palletStatusId: "Identificação do status",
                palSatDefaultTitle: "Gerenciamento do status do palete",
                palSatEditSelectPrinter: "Selecionar impressora para reimprimir",
                palStat_Default_Page_Load_Pallet_Status_Management: "Gerenciamento do status do palete",
                partCode: "FP",
                partDesc: "Descrição da peça",
                partDesc2: "Descrição da peça 2",
                partDescription: "Descrição da peça",
                pass: "",
                passFirst: "Selecionar o número",
                passNumber: "Número",
                pausePrinting: "Pausar impressão",
                pickingLblNumCopy: "Número de Cópias:",
                pieces: "Pcs",
                pleaseSelectaLine: "Por favor selecione uma linha",
                pleaseSelectaPrinter: "Por favor selecione a impressora para imprimir o novo rótulo",
                popDown: "Desativado",
                popLabelErrorCartonQty: "Quantidade errada para etiqueta. Deve ser maior que zero e menor que a quantidade final",
                popMaxcatonLimit: "O número total de etiquetas não foi excedido",
                preventERPUpdate: "Pare qualquer atualização do ERP ( SAP)",
                print: "Imprimir (F8)",
                printAbort: "A impressão falhou. Servidor não respondeu",
                printEngine: "motor de impressão",
                printer: "Impressora",
                printerName: "Nome da impressora",
                printFailed: "A impressão falhou. Deseja reimprimir este rótulo?",
                printFailedAbr: "Impressão falhou",
                printfailedselectanotherprinter: "Impressão falhou. Selecione outra impressora e tente novamente",
                printFailedWithException: "Impressão falhou pela classificação",
                printingComplete: "Impressão completa",
                printLabels: "Rótulos Impressos",
                printMod: "Modo Imprimir",
                printPallet: "Imprimir Palete",
                printPartiallyFailed: "A impressão falhou. Deseja reimprimir este rótulo?",
                printResult: "O rótulo foi enviado para a lista de impressão",
                printScreen: "Capturar tela",
                printStatus: "Status de impressão",
                printSucceeded: "Impressão com sucesso",
                printSuccessful: "Impressão com sucesso",
                printUsingAlternatePrinterFailed: "A impressão falhou com a impressora alternativa. ",
                processFinished: "Processo finalizado",
                prodDate: "Data de produção",
                productionOrderRunning: "Ordem de produção atual",
                prompt: "Tela",
                qtyProduced: "Quantidade produzida",
                qtyReq: "Quantidade necessária",
                qtyScheduled: "Quantidade planejada",
                quantity: "Quantidade",
                quantityConsumed: "Quantidade consumida",
                quantityProduced: "Quantidade produzida (palete consumido)",
                quantityRemaining: "Quantidade restante",
                quantityScrapped: "Quantidade sucateada",
                quantityXPallet: "Quantidade  x  Palete",
                rank: "Classificação",
                reason: "Razão",
                reasonCode: "Código de Razão",
                reasonCodeDescription: "Descrição do código da razão",
                refresh: "Atualizar",
                rememberSave: "Relembrar os defeitos salvos",
                reprint: "Reimprimir",
                reprintFailed: "Reimpressão falhou deseja reimprimir rótulos ausentes?",
                requiredFields: "Faltando os valores necessários destacados em vermelho *",
                reset: "Resetar",
                return: "Retornar",
                ringDiameter: "Diâmetro do anel",
                runTime: "Tempo de operação",
                rxg__0__assigned_to__1_: "Atribuido para",
                rxg__0__units_returned_on_SSCC__1___When_all_pallets_are_consumed_returned__click_OK_again_to_close_the_job__dialog_w0005:
                    "Unidades de SSCC retornadas, quando todas as unidades são consumidas/retornadas clique novamente em OK para fechar o trabalho.",
                rxg_Add_Defect: "Adicionar defeitos",
                rxg_Back_to_current_activity: "Voltar a atividade atual",
                rxg_Back_to_labeling: "Voltar aos rótulos",
                rxg_Back_to_offline_consumption: "Voltar para o consumo Off line",
                rxg_BeginPrint: "Iniciar Impressão",
                rxg_Cannot_issue_the_material___0___error___1_: "Não é possível emitir o material",
                rxg_Consumption: "Consumo",
                rxg_Could_not_assign__0__to__1___Error___2___3_: "Não foi possível atribuir o Erro",
                rxg_Could_not_assign__0__to__1__Error____2_: "Não foi possível atribuir o Erro",
                rxg_Could_not_assign_Work_Order___Error___0_: "Não foi possível atribuir a ordem de produção",
                rxg_Could_not_assign_Work_Order_Error___0____1_: "Não foi possível atribuir a ordem de produção",
                rxg_Could_not_close_job___Error___0__: "Não foi possível fechar o trabalho",
                rxg_Could_not_close_job__0___Error___1_: "Não foi possível fechar o trabalho",
                rxg_CouldNotDeletePallet: "Não foi possível deletar o palete",
                rxg_CouldNotDeletePallet1: "Não foi possível deletar o palete",
                rxg_Defect_Added: "Status alterado mas nenhum defeito adicionado",
                rxg_Defect_comment_must_be_less_than_255_characters_: "Comentários nos defeitos devem ter menos que 255 caracteres",
                rxg_Defects_Added: "Defeitos adicionados",
                rxg_Delete_Pallet: "Palete deletado",
                rxg_DeleteFailedWithError: "Falha deletada com erro:",
                rxg_Failed_to_set_print_parameters_with_error___0_: "Falha ao definir parâmetros de impressão com erro",
                rxg_From: "De:",
                rxg_Is_the_previous_SSCC___0___completely_consumed___dialog__apl00002: "O SSCC anterior foi consumido completamente?",
                haveFollowingPalletsBeenFullyUsed: "Have following pallets been fully used?",
                rxg_Label_parameters: "Parâmetros de rótulos",
                rxg_Label_paramters_save_successfully_: "Parâmetros de rótulos salvos com sucesso",
                rxg_Labeling_Pass_Number: "Numero do rótulo",
                rxg_No: "Não",
                rxg_No_Department_specified__Error__w0007: "Nenhum departamento especificado",
                rxg_OfflinePrintHeader: "Imprimir Off line",
                rxg_Open: "Abrir",
                rxg_Open_SSCC__0__on_the_following_line_s__: "Abra a SSCC na seguinte linha",
                rxg_Please_enter_the_quantity_remaining_on_the_previous_pallet__input__APL00031:
                    "Por favor insira a quantidade restante no palete anterior",
                rxg_Please_select_a_defect: "Por favor selecione um defeito",
                rxg_Please_select_the_pass_number_: "Por favor selecione o número do rótulo",
                rxg_Print: "Imprimir",
                rxg_PrintBoth: "Imprimir ambos",
                rxg_PrintDefect: "Imprimir defeito",
                rxg_Quantity: "Quantidade",
                rxg_Scrap_failed_with_error__: "Sucateamento falhou com o erro:",
                rxg_Scrap_Pallet: "Palete descartado/sucateado",
                rxg_Select_work_order_for_consumption: "Selecione GPO para o consumo",
                rxg_Select_work_order_for_labeling: "Selecione GPO para o rótulo",
                rxg_SSCC___0___has__1__quantity_and_cannot_be_consumed__error_4123: "SSCC tinha quantidade que não pode ser consumida",
                rxg_SSCC___0___was_not_found___error__00001: "SSCC não encontrado",
                rxg_ThereIsNoWorksOrderAssignedForThisLine: "Existe GPO atribuido para esta linha",
                rxg_Title: "Impressão offline",
                rxg_Unable_to_consume_pallet__0____1__Error____2__: "Não é possível consumir palete",
                rxg_Work_Order_Enquiry: "Consultar GPO",
                rxg_Yes: "Sim",
                rxg_You_must_enter_a_comment_for_the_defect_s__: "Você deve inserir um comentário para o defeito",
                rxg_You_must_enter_your_initials_to_add_a_defect: "Você deve inserir suas iniciais para adicionar um defeito",
                save: "Salvar",
                saveChanges: "Salvar mudanças",
                saveDefaults: "Salvar Padrões",
                sAVESENDTOSAP: "Salvar e Enviar pro SAP",
                saveShiftAreYouSure: "Você tem certeza?",
                saveShiftNotEqual: "O número de minutos reservado não é igual ao total de minutos",
                scanExternalTag: "Tag de identificação",
                scanNewMaterial: "Ler novo material",
                scheduledDateTime: "Programar Data - Tempo",
                scheduledOrders: "programar GPOs",
                scheduleWorkOrder: "Programação de GPO",
                scrap: "Descarte / Sucata",
                scrapped: "Descartado/Sucateado",
                search: "procurar",
                select: "Selecionar",
                selectAll: "Selecionar todos",
                selectDefects: "Selecionar defeitos: ",
                selectLines: "Selecionar Linhas",
                sendToSAP: "Enviado para o SAP",
                seq: "Sequência",
                seqnumber: "Número Sequencial",
                setUp: "Preparação",
                shift: "Turno",
                shiftLength: "De   para    no total   horas",
                shiftNoWorkOrders: "Não existem ordens de produção para esta linha",
                shiftPatterns: "Shift Patterns",
                shiftTime: "Tempo de turno",
                showRawMaterial: "SSSC gerado pelo SAP",
                small: "Pequeno",
                smallQtyNumeric: "Quantidade deve ser um número inteiro",
                sqlTranslation: "Tradução SQL",
                sscc: "SSCC",
                ssccConsumed: "SSCC consumido",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheck: "SSCC está aberto na seguinte linha. Verifique as linhas que deseja fechar",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheckReturn:
                    "SSCC está aberto na seguinte linha. Verifique as linhas que deseja retornar",
                standard: "Padrão",
                start: "Start",
                startDate: "Data Inicial",
                startDateIsLaterThanEndDate: "Data de Início é posterior a data final",
                startDateTime: "Data inicial",
                startingPalletRank: "Iniciar classificação de paletes",
                startTime: "Tempo de início",
                status: "Status",
                statusHistory: "Histórico de status",
                stop: "Parar",
                string1: "",
                success: "Sucesso",
                sumQty: "Quantidade",
                synoptic: "Sinóptico",
                tableName: "Nome da Tabela",
                thereIsNoWorkOrderConfiguredForThisLine: "Não existe GPO configurada para esta linha",
                thislinehasajobassignedClosethejob: "Esta linha já possui trabalho atribuido. Fechar o trabalho?",
                thisMethodRequiresAConfirmationAndNoneIsDe: "Este método requer uma confirmação e não foi definido",
                time: "Tempo",
                timeEnd: "Tempo final",
                timeIn: "Tempo de Entrada",
                titleWoMan: "Ordem de Produção",
                tKey: "Chave",
                tKeyActivity: "Tipo de atividade",
                tKeyCode: "Código chave",
                tKeyDescription: "Descrição da chave",
                tKeys: "TKeys",
                tNotConfigured: "Os códigos para importação do APS não estão adequadamente configurados",
                to: "Para:",
                toolTipchkRaw: "Pressione Botão Atualizar Para Aplicar Seus Filtros",
                toolTipEnter: "Pressione Enter Para Aplicar Seus Filtros",
                totalImportedMinutes: "Importada duração da chave (min.)",
                totalMinutesBooked: "Total de minutos reservados",
                totalShiftDuration: "Duração do turno(min)",
                totalShiftHours: "Total de minutos do turno",
                totalTimeGreaterThanShift: "O tempo total de atividade é maior que o tempo do turno",
                transactionType: "Tipo de Transação",
                txtQuantityErr: "Quantidade Invalida",
                unableToAddOpenItemToLineX0ErrorX1: "Não foi possível adicionar item aberto a linha",
                unableToAddOpenItemToLineX0X1ErrorX2: "Não foi possível adicionar item aberto a linha",
                unblock: "Desbloquear",
                unit: "Unidade",
                update: "Atualizar",
                username: "Usuário",
                userNotRecognised: "Usuário não reconhecido",
                validationSummary: "O acompanhamento deve ser realizado antes que a atividade possa ser concluida",
                wantToUseAlternatePrinter: "A impressora selecionada não está pronta! Clique em SIM para usar impressora alternativa",
                wCL: "WC/L",
                wO: "GPO",
                wOAvailable: "Lista de GPO disponivel",
                woMButton1: "Gerenciar a ordem de produção",
                woMMAterialNameError: "Este Material Não Existe",
                woMPallFullQty: "Completo",
                woMPallMinQty: "pequeno",
                woMPallQty: "Quantidade  x  Palete",
                woMPallTxtFullQty: "Padrão",
                woMPallTxtModQty: "Mudando de operador",
                wOMTitle: "Gerenciamento de Ordem de Produção",
                workCenter: "Centro de Trabalho",
                workOrder: "GPO",
                workOrderOp: "GPO/OPE",
                woSApproved: "Aprovado",
                woSClosed: "Fechado",
                wOSequenceScheduled: "GPO sequencia de planejamento",
                woSInUse: "Em uso (on line)",
                woSPlanned: "Planejado",
                woSSuspended: "Suspenso",
                x0OfX1PaletsBlocked: "   de      paletes bloqueados",
                x0OfX1PaletsBlockedStoppedAtErrorForSSCCX2: "   de   paletes bloqueados. Parado no erro para SSCC",
                x0OfX1PaletsDeleted: "   de    paletes  deletados",
                x0OfX1PaletsDeletedStoppedAtErrorForSSCCX2: "   de   paletes deletados. Parado no erro para SSCC",
                x0OfX1PaletsScrapped: "   de    paletes  sucateados",
                x0OfX1PaletsScrappedStoppedAtErrorForSSCCX: "   de   paletes sucateados. Parado no erro para SSCC",
                x0OfX1PaletsUnblocked1: "   de    paletes  desbloqueados",
                x0OfX1PaletsUnblockedStoppedAtErrorForPalletX21: "   de   paletes desbloqueados. Parado no erro para SSCC",
                yourAccountIsLockedPleaseContactTheHelpdes: "Sua conta está bloqueada. Por favor contate o helpdesk",
                rxg_defectsTable_Defect: "Defect",
                rxg_defectsTable_Initials: "Initials",
                rxg_defectsTable_Comment: "Comment",
                mouldNo: "Moulds",
                mvtDesc: "Movement description",
                mvtDate: "Movement date",
                billOfBatches: "Bill Of Batches",
                batchNr: "Batch Nr",
                workorderAssignedPrinting: "Workorder was assigned for Label printing. Switch to activity?",
                workorderAssignedConsumption: "Workorder was assigned for consumption. Switch to activity?",
                jobIn: "Job In",
                statusChangeNotAllowed: "Status change not allowed",
                deselect: "Deselect",
                resetView: "Reset View",
                containerVolume: "Volume",
                youCanOnlyHaveNumberOfPalletsIssued: "You can only have {0} pallets issued",
                lineIn: "Line In",
                partPallet: "Part Pallet",
                manualEntry: "Manual Entry",
                consumed: "Consumed",
                issued: "Issued"
            }
        }
    },
    "es-ES": {
        translation: {
            main: {
                palletConditionId00: "Info",
                palletConditionId01: "Produced – Not in Warehouse",
                palletConditionId02: "In Warehouse",
                palletConditionId03: "Resorted",
                palletConditionId04: "Picked",
                palletConditionId05: "Delivered",
                palletConditionId06: "Scrapped",
                palletConditionId07: "Put-Away via Storage UnitList",
                palletConditionId08: "Lost",
                palletConditionId09: "Deleted",
                palletConditionId10: "Stock Transfer",
                palletConditionId11: "Intermediate Pallet",
                palletConditionId12: "Quality Inspection",
                palletConditionId13: "Blocked Resort",
                palletConditionId94: "Allocated for Delivery",
                palletConditionId99: "Label Printed",
                palletStatusId00: "Label Printing",
                palletStatusId01: "Label Printed",
                palletStatusId02: "Label Printed_NIU",
                palletStatusId03: "Cus. Incubation",
                palletStatusId04: "Good",
                palletStatusId05: "Blocked",
                palletStatusId06: "Resorted",
                palletStatusId07: "Scrap",
                palletStatusId08: "Test Pallet",
                palletStatusId09: "Customer Return",
                palletStatusId10: "Blocked QI",
                palletStatusId11: "Saleable restricted",
                palletStatusId12: "Blocked Packaging",
                palletStatusId13: "Issued",
                palletStatusId14: "Consumed",
                palletStatusId15: "Returned",
                palletStatusId16: "Stock Received",
                palletStatusId17: "Good",
                palletStatusId18: "Deleted",
                palletStatusId19: "Repacking",
                palletStatusId20: "Loaded",
                palletStatusId21: "Shipped",
                palletStatusId22: "Scrap Warehouse",
                palletStatusId30: "PreBilled",
                palletStatusId90: "WIP",
                movementDescription11: "Label Printed - Pallet Produced",
                movementDescription10: "Return Pallet off line",
                movementDescription13: "Change pallet status from SAP",
                movementDescription12: "Label Printed - Pallet Produced (offline)",
                movementDescription15: "Block pallet QI",
                movementDescription14: "Change pallet Birth Date/Condition in APL from PLC ",
                movementDescription17: "Scrap pallet",
                movementDescription16: "Release pallet",
                movementDescription19: "User connection",
                movementDescription18: "Delete/Cancel pallet",
                movementDescription01: "Start WorkOrder Front End Line",
                movementDescription02: "Stop Workorder Front End line",
                movementDescription03: "Start Workorder Back End Line",
                movementDescription04: "Stop Workorder Back End line",
                movementDescription05: "Issue Pallet on line ",
                movementDescription06: "Consumed Pallet on line ",
                movementDescription07: "Return Pallet on line",
                movementDescription08: "Delete Consumption",
                movementDescription09: "Consumed Pallet off line ",
                movementDescription33: "Block pallet for Scrap",
                movementDescription32: "Pallet quantity change",
                movementDescription35: "Scrap in Warehouse",
                movementDescription34: "Block Pallet for Packaging",
                movementDescription22: "Open Item Return ",
                movementDescription23: "Block pallet for resorting",
                movementDescription20: "Open Item Issuing",
                movementDescription21: "Open Item Consumption",
                movementDescription26: "Remove defect on a pallet",
                movementDescription27: "Defect found",
                movementDescription24: "Open Item delete",
                movementDescription25: "Add Defects to Pallet",
                movementDescription28: "Defect not found",
                movementDescription55: "SU defect removed from SAP",
                movementDescription54: "SU defect added from SAP",
                movementDescription51: "SU Updated from SAP",
                movementDescription50: "SU Created from SAP",
                movementDescription53: "SU condition Updated from SAP",
                movementDescription52: "SU status Updated from SAP",
                movementDescription44: "Approve Pallet",
                movementDescription40: "Pallet Scanned for Repack",
                movementDescription41: "Remove Pallet from Repack",
                movementDescription42: "Pallet Splitting",
                movementDescription43: "Create pallet from other",
                movementDescription60: "Pallet Locked",
                movementDescription61: "Pallet Unlocked",
                movementDescription99: "SU Imported for Go Live",

                actions: "Actions",
                activity: "Activity",
                activityDefaultInstructions: "Default values for new activities",
                actQty: "Cantidad",
                addDefect: "Añadir defecto",
                addNewActivities: "Add New Activities",
                addUser: "Añadir usuario",
                admin: "Admin",
                adminView: "Obtener vista de administración",
                apply: "Aplicar",
                aPSImport: "APS Import",
                aPSImportHistory: "APS Import History",
                areYouSureBlock: "¿Seguro que quieres bloquear estos palets?",
                areYouSureBlock1: "¿Seguro que quieres bloquear este palet?",
                areYouSureDelete: "¿Seguro que quieres borrar estos palets?",
                areYouSureDelete1: "¿Seguro que quieres borrar este palet?",
                areYouSureScrap: "¿Seguro que quieres enviar estos palets a chatarra?",
                areYouSureScrap1: "¿Seguro que quieres enviar este palet a chatarra?",
                areYouSureUnblock: "¿Seguro que quieres desbloquear estos palets?",
                areyousureyouwanttoclosethejob: "¿Seguro que quieres desbloquear este palet?",
                areyousureyouwanttoconsumescrapSSCC: "Are you sure you want to consume and scrap SSCC",
                areyousureyouwanttodeleteSSCCX0X: "¿Seguro que quieres eliminar SSCC:{0}?",
                areyousureyouwanttoreturnSSCC: "¿Seguro que quieres devolver SSCC?",
                areyousureyouwishtoassignworkorder01toline3: "¿Seguro que quieres asignar OF {0}({1}-{2}) a línea {3}?",
                article: "Artículo",
                assign: "Asignar",
                assignedSuccessfully: "Asignado con éxito",
                assignNewJob: "Asignar nueva tarea",
                back: "Volver",
                backToCurrentActivity: "Volver a Actividad en Curso",
                backToOfflineHome: "Volver a Inicio Offline",
                baseProduct: "Base Product",
                batch: "Batch",
                batchEnd: "Batch End",
                batchStart: "Batch Start",
                beginPrinting: "Inicio impresión",
                block: "Bloquear",
                blocked: "Bloqueado",
                blockFailedWithError: "Falló bloqueo por error:",
                blockPackaging: "Block Packaging",
                blockPallet: "Bloquear palet",
                blockQi: "Bloq. para Calidad",
                blockResort: "Bloq. para Revisión",
                bPNoOfCopies: "No. de copias",
                bPQuantity: "Cantidad",
                btnBackWo: "Bouton Back",
                btnCartonDeleteConfirmation: "¿Estás seguro que quieres borrar esta caja de cartón?",
                btnCartonDeleteLastDate: "Borrar la última",
                btnCloseOff: "Aboard",
                btnDeleteLastOne: "Borrar la última caja de cartón",
                btnNoReturn: "No consumo nada",
                btnNoWarn: "No",
                btnPrintNextCarton: "Imprimir siguiente caja de cartón",
                btnPrintPalletAndClose: "Imprimir etiqueta del palé y cerrar",
                btnSeachWom: "Search Workorder",
                btnUpdateWoM: "Update",
                btnWoMan: "Manage Work Order",
                btnYesReturn: "Devuelvo una cantidad de {0}",
                btnYesReturn2: "Cierro la OF  \n porque devuelvo 0 cantidad",
                btnYesReturnDetail: "Cierro esta  \n porque devuelvo 0 cantidad",
                btnYesWarn: "Sí",
                byProduct: "Prod. Secund.",
                byProductDetails: "Detalle Prod. Secund.",
                cancel: "Cancelar",
                cannotConsumeInTheFuture: "No poner fecha del futuro. error# w0001",
                cantDelete: "Error Number: {0} Could not delete.",
                cantLoadShifts: "Could not load shifts: {0}",
                cartonCreateLastDate: "Última fecha de fabricación",
                cartonDeleteLastDate: "Borrar la última",
                cartonError: "Cantidad total no coincide con cantidad del palet seleccionado!!",
                cartonQuantity: "Cantidad",
                cartonSumQty: "Número de cajas de cartón",
                cartonType: "Cantidad por caja de cartón",
                changeCloseJob: "Cambiar/Cerrar OF",
                checkDatesfuture: "Cannot consume in the future",
                checkDateslater: "Start date is later than end date",
                checkSSCC: "Are you sure you want to remove consumption for ",
                chkDetails: "Información de impresión",
                chkEdit: "Edit",
                chkError: "Obtener solo los registros de error",
                chkInPRogresse: "Obtener solo solicitudes de impresión en tiempo de espera",
                ckBoxCartonSave: "Con Cartón",
                clickLoadShift: 'You have to click "Load Shift" before proceeding!',
                close: "Cerrar",
                closeAndConsume: "Stop Consumo",
                closeLine: "Cerrar Línea(s)",
                closeReturn: "Cerrar y devolver líneas",
                closeWorksOrder: "Cerrar OF",
                coilCutting: "Corte Metal",
                color: "Color",
                comment: "Comentario",
                component: "Componente",
                condition: "Condición",
                conditionID: "Id. Condición",
                confirm: "Confirmar",
                consume: "Consumir",
                consumeScrap: "ConsumeScrap",
                consumeSSCC: "Consumir SSCC",
                consumptionCannotBeDisplayedNoWO:
                    "No se puede mostrar consumo. Ninguna OF seleccionada. Asignar tarea a esta línea.  error# w0002",
                consumptionCurrentActivity: "Consumo En Curso",
                consumptionNbPallet: "Nº palé",
                consumptionPageTitle: "Consumption Declaration",
                consumptionParameters: "Parámetros de Consumo",
                consumptionQty: "Cantidad",
                consumptionUnit: "Unidad",
                couldNotBlockPalletErrorX0: "Fallo bloqueo del Palet. Error# w0003: {0}",
                couldNotBlockPalletErrorX0X1: "Fallo bloqueo del Palet. Error#{0}:{1}",
                couldNotDeleteConsumtionX0: "Fallo borrado Consumo. Error# w0004: {0}",
                couldNotDeleteConsumtionX0ErrorX1: "Fallo borrado Consumo. {0} Error# {1}",
                couldNotDeleteOpenItemX0: "Fallo borrado Open item. Error# w0005: {0}",
                couldNotDeleteOpenItemX0ErrorX1: "Fallo borrado Open item. {0} Error# {1}",
                couldNotGetConsumptionPalletDetailsForJobE: "Faltan datos del palet de consumo para OF Error# w0006: {0}",
                couldNotGetConsumptionPalletDetailsForJobX: "Faltan datos del palet de consumo para OF {0}: Error# {1}",
                couldNotIssueConsumtionX0: "Fallo emisión del Consumo. Error# w0007: {0}",
                couldNotIssueConsumtionX0ErrorX1: "Fallo emisión del Consumo. {0} Error# {1}",
                couldNotLoadWorkOrderPleaseCheckTheOrderCo: "Fallo carga de la OF. Verificar Código OF e intentar de nuevo. error# w0008",
                couldNotScrapPalletErrorX0: "Fallo envío palet a chatarra. Error# w0009: {0}",
                couldNotScrapPalletErrorX0X1: "Fallo envío palet a chatarra. Error#{0}:{1}",
                couldNotUnblockPalletErrorX01: "Fallo desbloqueo palet. Error# w00010: {0}",
                couldNotUnblockPalletErrorX0X1: "Fallo desbloqueo palet. Error#{0}:{1}",
                created: "Creado",
                currentActivity: "Actividad en Curso",
                currentPalletRank: "Nº seq. Palet actual -",
                customerDesc: "Descripción del Cliente",
                cuttedSheetsBlocked: "Bloqueo de hojas cortadas",
                cuttedSheetsScrapped: "Hojas cortadas a chatarra",
                date: "Fecha",
                dateEnd: "Fecha fin",
                dateIn: "Fecha entrada",
                dateStart: "DateStart",
                day: "Day",
                declarationOPENITEMS: "Declaración - OPEN ITEMS",
                defaultActivityLabeling: "Etiquetado",
                defects: "Defectos",
                delete: "Borrar",
                deleteConsumption: "Borrar Consumo",
                deleteTKeyGroupConfirm: "Are you sure you want to delete this TKey Group?",
                deleteTkeyReasonConfirm: "Are you sure you want to delete this TKey?",
                department: "Departamento",
                description: "Descripción",
                detail: "Detalle",
                dicoHtmlSelectMatOnHold: "Seleccionado",
                differentWOOnConsumptionAndLabeling: "Distintas OFs en Consumo y Etiquetado. Error# w0010",
                differentWOOnConsumptionAndLabeling2: "Active GPO in Labeling is different from Consumption one!",
                disable: "Disable",
                disabledOperators: "Show Disabled Operators Only:",
                display: "Display",
                done: "Done",
                downTime: "Down-Time",
                doYouSetWorkOrderDefaultDataCollection: "Would you like to set {0} as the Default work order for this shift?",
                doYouWantToActivate: "¿Quieres activar nueva OF?",
                duration: "Duration",
                durationMinutes: "Dur.(min.)",
                durationValidation: "* Duration must be numeric.",
                edit: "Editar",
                efficiencyoftheLine: "Eficacia de línea",
                empty: "Ninguno",
                enable: "Enable",
                enabled: "Enabled",
                endBeforeStart: "End date ({1}) is earlier than or equal to start date({0}).",
                endDate: "Fecha Fin",
                endDateTime: "EndDT",
                endTime: "End Time",
                error: "Error",
                errorCommandNotRecognised: "error: comando no conocido. Error# w0011",
                errorSavingActivity: "An error occured saving the Activity, Error:",
                exit: "Salir",
                failedToConsumeSsccInDbX0: "Fallo consumo de sscc en b/d. Error# w0012:  {0}",
                failedToConsumeSsccInDbX0ErrorX1: "Fallo consumo de sscc en b/d. {0} Error# {1}",
                failedToReturnSsccInDbX0: "Fallo devolución sscc en b/d. Error# w0013: {0}",
                failedToReturnSsccInDbX0ErrorX1: "Fallo devolución sscc en b/d. {0} Error# {1}",
                failureReason: "Motivo de fallo",
                finalPalletRank: "Nº seq. Palet final -",
                finalPass: "Último pase",
                finished: "Finished",
                freeText1: "FreeText1",
                freeText2: "FreeText2",
                getData: "Get Data From APS",
                go: "Ir",
                goBack: "Volver",
                goBacktoCurrentActivity: "Volver a Actividad en Curso",
                headerTextUser: "Usuario",
                importDataFromAPS: "Import Data from APS",
                inBoundBtnCancel: "Cancelar",
                inBoundBtnCancel2: "Finalizado",
                inBoundBtnOk: "Ok",
                inBoundBtnReset: "Reset Date",
                deliveryNote: "Delivery Note",
                inBoundConfirmCreation: "are you sure to create those one? it ll change the transaction status to print.",
                inBoundConfirmDelete: "are you sure you want to delete this line?",
                inBoundDateExpiryDate: "Expiry Date",
                inBoundDxColLocation: "Location",
                inBoundDxColLotNumber: "Lot",
                inBoundDxColSeqNumber: "Seq",
                inBoundDxColunit: "Unit",
                inBoundDxComment: "Delivery Note",
                inBoundDxDescription1: "Decription",
                inBoundDxMaterialCode: "Material Code",
                inBoundDxPrintStatus: "Print Status",
                inBoundDxSelectTran: "Select a Transaction",
                inBoundDxSelTranType: "Transaction Type",
                inBoundDxTransactionDate: "Date",
                inBoundDxwarehouse: "Warehouse",
                inBoundErrorAmount: "Error in the total amount. Please check the values and correct them",
                inBoundErrorLabelRank: "The number of label must be a numeric",
                inBoundErrorNbrPallet: "The field Nbr*OF LAbel must be a numeric greater than 0",
                inBoundErrorPalletCreation: "Error during the pallet creation. Please chech your values.",
                inBoundErrorPalletEdition: "The current label creation is not fully updated. Update your row and after you can print.",
                inBoundErrorQtyLabel: "The QtyxLAbel must be a numeric.",
                inBoundErrorQuantity: "The field Label*Qty must be a numeric greater than 0",
                inBoundErrorQuantityTotal: "The total quantity must match the total in the transaction selected.",
                inBoundErrorReceiptDate: "The Expiry Date must be a valide date and time.",
                inBoundErrorUpdate: "An Error occurred during the update. Please check the values and if it persist ask apl team.",
                inBoundIntLabelRank: "Nr.Of Labels",
                inBoundIntQtyLabel: "Qty x Label",
                inBoundLitCouncil: "Fill text box and push search",
                inBoundLitLabelName: "Label Type : ",
                inBoundLitPrint: "Print",
                inBoundLitRecap: "Summary of the label creation. Label(s) Created and Printed : ",
                inBoundLnkAdd: "Add a new Line",
                inBoundStrCoilNr: "SU reference",
                inBoundStrVendorBatch: "Vendor Batch",
                inBoundStrWorkOrder: "WorkOrder ref",
                inBoundTotalLabelCreation: "Total",
                inBoundTransactionQuantity: "Qty.",
                inBoundTxtMatError: "The field material cannot be empty and must have at least 3 characters.",
                inBoundTxtTanDateError: "A valid Date is required",
                inBoundTxtwareError: "The field warhouse cannot be empty and cannot have more than 2 characters",
                initials: "Iniciales",
                initQty: "Cant Inic",
                input: "Entrada",
                insert: "Insert",
                insertNew: "Insert New Record",
                inValidDate: "Fecha no válida!Introducir fecha válida(dd/mm/aaaa).",
                invalideQuantity: "Cantidad devuelta en palet {0} es mayor que cantidad restante. error# w0026",
                inValidTime: "Hora no válida!Introducir hora válida(hh:mm).",
                inValidUser: "Usuario no válido! Acceder de nuevo.",
                inValidWorkOrderId: "Identidad OF/Línea no válida!! Verificar base de datos.",
                item: "Item",
                itemClass: "Item Class",
                labelCurrentActivityError:
                    "¡Error en Actividad en curso de esta Línea!                                                                    ¿Quieres seguir a otra línea?",
                labelDefaultTitle: "Labeling Current Activity",
                labelImSwitchQty: "Switch Quantity between full and Small",
                labellingPrintingComplete: "Printing Complete",
                labelName: "Nombre etiqueta",
                labelPalletCount2: "{0}/{1}",
                labels: "Etiquetas",
                lblConfiramtionReturn: "¿Confirmas devolución cantidad 0?",
                lblConfirmOff: "This pallet has 0 Qty ! you can t use it",
                lblDefaultSetting: "Cantidad para la caja de cartón {0}",
                lblErrbtnConsumeClick: "Wrong date. You can t consume pallet in the future. Change the date please!",
                lblErrbtnConsumeClickMissing: "Could not find SSCC. error# W0006",
                lblErrbtnConsumptionClick1: "Cannot add the material. {0} : error# {1}",
                lblErrbtnConsumptionClick1Else: "Could not consume SSCC invalid quantity. error# W0008.",
                lblErrbtnConsumptionClick1Exception: "Cannot add the material.  error# {0}",
                lblErrOI: "Return Quantity must be greater than 0! error# w0026",
                lblOIErrorDate: "wrong date!",
                lblRePrintInfoInnerHtml: "Select printer to reprint to?",
                leavingthispagewillstopprinting: "Salir de esta página detendrá la impresión",
                length: "Longitud",
                line: "Linea",
                linePrintAll: "imprimir etiquetas",
                litActQty: "Cantidad actual",
                litAllInOne: "Todo en una sola toma",
                litByProduct: "ByProduct 1 Material",
                litByProduct2: "ByProduct 2 Material",
                litCartonLabel: "Carton Label",
                litCopyNumber: "Number of copy",
                litCustCode: "Customer Code",
                litCustMat: "Customer material",
                litCustMatDesc: "Description",
                litCustomer: "Customer info",
                litEANGTAN: "EAN/Gtin",
                litLabelCreation: "Label Creation",
                litMain: "Main",
                litMainByProd: "By Prod 1",
                litMessWarn:
                    "La cantidad en el palé excede la cantidad m xima planificada en la OF. ¿Quieres cambiar la cantidad actual en el palé?",
                litModQtyMax: "Quantity for a full pallet",
                litModQtyMin: "Quantity for small pallet",
                litNameCust: "Name",
                litPalLabel: "Pallet Label",
                litPrintHistory: "Historial de impresión",
                litQtyReq: "Quantity Requested",
                litQuantityProd: "cantidad fabricada",
                litQuantitySchedule: "cantidad planificada",
                litSearch: "Search a new Workorder",
                litsearchWomField: "Search a new Workorder",
                litUserUpdate: "Changed by operator",
                litWait: "Por favor, espera",
                litWoMan: "Work order information",
                litWomDec1: "Desc1",
                litWomDec2: "Desc2",
                litWomMaterial: "Material",
                litWoOpe: "Work Order Operation",
                litWoOpeByProd2: "By Prod 2",
                litWoS: "Current work order status : ",
                loadShift: "Load shifts",
                loadShiftsTip: "Load shifts for line and Date selection.",
                logout: "Salir",
                lotNumber: "Lot",
                lot: "Lot",
                lstDefault: "None",
                mainDetails: "Datos principales",
                manning: "Manning",
                manningValidation: "* Manning must be numeric.",
                material: "Material",
                metalAndEnds: "Metal y Tapas",
                missingAPSDef: "Missing APS Import Default",
                multipleSelectionError: "Estado no coincide para las filas seleccionadas.Seleccionar filas con el mismo estado!!",
                negativeOEEWarning: "Error ID:31001 Break-down must be less that Run-time + Set-up.",
                new: "New",
                newPalletNumber: "New Pallet Number",
                next: "Siguiente",
                noAPSData: "No data for this activity!",
                noColours: "No. Colours",
                noColoursValidation: "* No. of Colours must be numeric.",
                noData: "No hay datos disponibles para esta línea!!",
                noOfCartons: "Nº de Cartones",
                noOfCoils: "Nº de Bobinas",
                noOfPallets: "Nº de Palets",
                noOfPalletsProduced: "Nº de Palets producidos en OF",
                noOfSheets: "Nº de Hojas",
                noPallets: "Nº de Palets",
                noShiftsToDisplay: "There are no shifts to display activity for",
                noUpdateAfterSAP: "You cannot update an entry after sending to SAP.",
                noWorkorder: "Falta Orden Fabricación",
                noWorkOrderOnConsumptionAndOneRunningForLa: "Ninguna OF en Consumo y una en curso en Etiquetado. Error# w0014:",
                noWorkOrderOnLabelingAndOneRunningOnConsum: "Ninguna OF en Etiquetado y una en curso en Consumo. Error# w0015:",
                numberOfCopies: "Nº de Copias",
                offlineCons: "Consumo Offline",
                oFFLINECONSUMPTION: "CONSUMO OFF-LINE",
                oFFLINECONSUMPTIONMETALANDENDS: "CONSUMO OFF-LINE de METAL y TAPAS",
                offLineMetalSSCCAway: "This SSCC Doesn t exist.",
                offlinePrint: "Imprimir Offline",
                offlinePrintingFailedException:
                    "Impresora no lista. Impresión detenida; seleccionar nueva impresora y pulsar INICIO IMPRESIÓN para seguir. Reanudar impresión en impresora seleccionada del menú deplegable.",
                okay: "OK",
                onLINECONSUMPTION: "CONSUMO ONLINE",
                oops: "Ocurrió un error inesperado. Disculpar molestia.  Este error ha sido regsitrado; si persiste, contactar Helpdesk.  Error# w0016",
                op: "Op ",
                openedWO: "Opened GPOs",
                openItems: "Open Items",
                operation: "Operación",
                operatorCode: "Operator Code",
                operatorName: "Operator Name",
                order: "Pedido",
                outisdeShiftTime: "Activity entry must be between {0} and {1}.",
                outOfShift: "",
                overProdHeader: "Overproduction",
                overProdText: "Creating this pallet, you will be overproducing on this WO. Do you want to continue anyway?",
                palletCreated: "Palet {0} ({1}) creado con éxito",
                palletDetail: "Datos del Palet",
                palletID: "ID palet",
                palletIdentify: "Identificador de pallet",
                palletRank: "Nº seq. Palet",
                pallets: "Palets",
                palletsProduced: "Palets prod.",
                palletsQty: "Palets (unidades)",
                palletsScheduled: "Palets planif.",
                palletStatus: "Estado del Palet",
                palletStatusEdit: "Editar esatdo Palet",
                palletStatusId: "ID estado",
                palSatDefaultTitle: "Pallet Status Management",
                palSatEditSelectPrinter: "Select printer to reprint to?",
                palStat_Default_Page_Load_Pallet_Status_Management: "Pallet Status Management",
                partCode: "Código artículo",
                partDescription: "Descripción artículo",
                pass: "Pase",
                passFirst: "Select Pass Number",
                passNumber: "Nº de pase",
                pausePrinting: "Pausar Impresión",
                pickingLblNumCopy: "Number of Copy :",
                pieces: "Pcs",
                pleaseSelectaLine: "Seleccionar línea",
                pleaseSelectaPrinter: "Seleccionar impresora para imprimir nueva etiqueta",
                popDown: "Pop Down",
                popLabelErrorCartonQty:
                    "Cantidad errónea para esta caja de cartón. Debe ser mayor que 0 y menor que la cantidad final del palé",
                popMaxcatonLimit: "El número total de cajas de cartón no puede exceder",
                print: "Imprimir",
                printAbort: "Falló impresión de nº {0}.  No respondió el servidor. Error# w0017.",
                printEngine: "Motor impresión",
                printer: "Impresora",
                printerName: "Nombre impresora",
                printFailed: "Falló impresión de nº {0}.  ¿Quieres vover a imprimir esta etiqueta?",
                printFailedAbr: "Fallo impresión. Error# w0018",
                printfailedselectanotherprinter: "Fallo imrpesión. Seleccionar otra impresora o volver a intentar. Error# w0019",
                printFailedWithException: "{0}.  Falló impresión de nº {1} Error# w0020.",
                printingComplete: "Impresión terminada",
                printLabels: "Imprimir etiquetas",
                printMod: "Modo de impresión",
                printPartiallyFailed:
                    "Falló impresión de nº {0} Error# w0021. Se imprimió solo {1} de {2} etiquetas. ¿Quieres intentar reimprimir las etiquetas que faltan?",
                printScreen: "Print Screen",
                printStatus: "Estado impresión",
                printSucceeded: "Impreso con éxito",
                printSuccessful: "Impreso con éxito",
                printUsingAlternatePrinterFailed: "Falló impresión con impresora alternativa también. ¿Quieres intentarlo de nuevo?",
                processFinished: "Process Finished",
                prodDate: "Fecha Prod",
                productionOrderRunning: "Orden fabricación en curso",
                prompt: "Apunte",
                qtyProduced: "cantidad fabricada",
                qtyScheduled: "cantidad planificada",
                quantity: "Cant.",
                quantityConsumed: "Cantidad consumida",
                quantityProduced: "Cantidad producida(Palet Consumido)",
                quantityRemaining: "Cantidad restante",
                quantityScrapped: "Quantity Scrapped",
                rank: "Nº seq.",
                reason: "Reason",
                reasonCode: "Reason Code",
                reasonCodeDescription: "Reason Code Description",
                rememberSave: "Remember to save defaults.",
                reprint: "Reimprimir",
                reprintFailed:
                    "Falló reimpresión de nº {0} Error# w0022. Se imprimió solo {1} de {2} etiquetas. ¿Quieres intentar reimprimir las etiquetas que faltan?",
                requiredFields: "Faltan datos requeridos señalados en rojo*",
                return: "Devolver",
                ringDiameter: "Diámetro anillo",
                runTime: "Run-Time",
                rxg__0__assigned_to__1_: "{0} asignado a {1}",
                rxg__0__units_returned_on_SSCC__1___When_all_pallets_are_consumed_returned__click_OK_again_to_close_the_job__dialog_w0005:
                    "{0} unidades devueltas en SSCC {1}. Cuando estén consumidos/devueltos todos los palets, pincha en OK de nuevo para cerrar el trabajo. dialog#w0001",
                rxg_Add_Defect: "Añadir Defecto",
                rxg_Back_to_current_activity: "Volver a actividad en curso",
                rxg_Back_to_labeling: "Volver a Etiquetado",
                rxg_Back_to_offline_consumption: "Volver a Consumo Offline",
                rxg_BeginPrint: "Inicio Impresión",
                rxg_Cannot_issue_the_material___0___error___1_: "No se puede emitir material. {0}: error# {1}",
                rxg_Consumption: "Consumo",
                rxg_Could_not_assign__0__to__1___Error___2___3_: "No pudo asignar {0} a {1}, Error#:{2}-{3}",
                rxg_Could_not_assign__0__to__1__Error____2_: "No pudo asignar {0} a {1} Error#: {2}",
                rxg_Could_not_assign_Work_Order___Error___0_: "No pudo asignar Orden Fabricación.  Error: {0}",
                rxg_Could_not_assign_Work_Order_Error___0____1_: "No pudo asignar Orden Fabricación. Error#:{0}: {1}",
                rxg_Could_not_close_job___Error___0__: "No pudo cerrar tarea: Error# {0}",
                rxg_Could_not_close_job__0___Error___1_: "No pudo cerrar tarea {0}: Error# {1}",
                rxg_CouldNotDeletePallet: "No pudo eliminar palet. Error#{0}:{1}",
                rxg_CouldNotDeletePallet1: "No pudo eliminar palet. Error#:{0}",
                rxg_Defect_Added: "Se cambió estado sin añadir defectos!!",
                rxg_Defect_comment_must_be_less_than_255_characters_: "Descripción Defecto debe ser menos de 255 caracteres.",
                rxg_Defects_Added: "Defecto añadido",
                rxg_Delete_Pallet: "Borrar Palet",
                rxg_DeleteFailedWithError: "Fallo Borrado con error:{0}",
                rxg_Failed_to_set_print_parameters_with_error___0_: "Fallo config. parámetros impresora con error: {0}",
                rxg_From: "Desde:",
                rxg_Is_the_previous_SSCC___0___completely_consumed___dialog__apl00002:
                    "¿Se ha consumido por completo el SSCC ({0}) anterior?",
                haveFollowingPalletsBeenFullyUsed: "Have following pallets been fully used?",
                rxg_Label_parameters: "Parámetros etiqueta",
                rxg_Label_paramters_save_successfully_: "Parámetros etiqueta guardados con éxito",
                rxg_Labeling_Pass_Number: "Nº de pase en Etiquetado",
                rxg_No: "No",
                rxg_No_Department_specified__Error__w0007: "No se ha especificdo Departamento. Error# w0025",
                rxg_OfflinePrintHeader: "Imprimir Offline",
                rxg_Open: "Abrir",
                rxg_Open_SSCC__0__on_the_following_line_s__: "Abrir SSCC {0} en la siguiente línea(s).",
                rxg_Please_enter_the_quantity_remaining_on_the_previous_pallet__input__APL00031:
                    "Introducir cantidad restante en palet anterior. input# APL00001",
                rxg_Please_select_a_defect: "Seleccionar por defecto",
                rxg_Please_select_the_pass_number_: "Seleccionar nº de pase?",
                rxg_Print: "Imprimir",
                rxg_PrintBoth: "Print Both",
                rxg_PrintDefect: "Print Defect",
                rxg_Quantity: "Cantidad",
                rxg_Scrap_failed_with_error__: "Fallo envío a chatarra con error:",
                rxg_Scrap_Pallet: "Enviar Pallet a chatarra",
                rxg_Select_work_order_for_consumption: "Seleccionar Orden Fabricación para Consumo",
                rxg_Select_work_order_for_labeling: "Seleccionar Orden Fabricación para Etiquetado",
                rxg_SSCC___0___has__1__quantity_and_cannot_be_consumed__error_4123:
                    "SSCC ({0}) tiene cantidad {1} y no puede consumirse. error#w0023",
                rxg_SSCC___0___was_not_found___error__00001: "SSCC ({0}) no encontrado.  error#:#w0024",
                rxg_ThereIsNoWorksOrderAssignedForThisLine: "No hay OF asignada a esta línea",
                rxg_Title: "Impresión Offline",
                rxg_Unable_to_consume_pallet__0____1__Error____2__: "No puede consumir palet {0}: {1} error#: {2}",
                rxg_Work_Order_Enquiry: "Consultar Ordenes Fabricación",
                rxg_Yes: "Sí",
                rxg_You_must_enter_a_comment_for_the_defect_s__: "Introducir comentario para el defecto(s).",
                rxg_You_must_enter_your_initials_to_add_a_defect: "Introducir tus iniciales para añadir defecto",
                save: "Guardar",
                saveDefaults: "Save Defaults",
                sAVESENDTOSAP: "SAVE and SEND TO SAP",
                saveShiftAreYouSure: "Are you sure?",
                saveShiftNotEqual: "The number of minutes booked is not equal to the total minutes.\r\n\r\nAre you sure?",
                scanExternalTag: "Orig/Ext Tag Identifier",
                scanNewMaterial: "Escanear nuevo Material",
                scheduledDateTime: "Fecha-Hora programadas",
                scheduledOrders: "Scheduled GPOs",
                scheduleWorkOrder: "GPO Scheduling",
                scrap: "A Chatarra",
                scrapped: "Enviado a Chatarra",
                search: "Buscar",
                select: "Seleccionar",
                selectAll: "Seleccionar todo",
                selectDefects: "Seleccionar defectos:",
                selectLines: "Seleccionar líneas",
                sendToSAP: "Enviar a SAP",
                seq: "Secuencia",
                seqnumber: "Número de secuencia",
                setUp: "Set-Up",
                shift: "Shift",
                shiftLength: "From {0} to {1} in total {2} hours",
                shiftNoWorkOrders: "There are no work orders for this line.",
                shiftTime: "Shift Time",
                showRawMaterial: "Mostrar Materia Prima",
                sqlTranslation: "Traducción SQL",
                sscc: "SSCC",
                ssccConsumed: "SSCC Consumido",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheck:
                    "SSCC {0} abierto ne la siguiente línea(s). Comprobar lineas que quieres cerrar.",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheckReturn:
                    "SSCC {0} abierto en la siguiente línea(s). Comprobar líneas que quieres devolver.",
                start: "Inicio",
                startDate: "Start Date",
                startDateIsLaterThanEndDate: "Fecha inicio posterior a fecha final",
                startDateTime: "StartDT",
                startingPalletRank: "Iniciar num. seq. palets-",
                startTime: "Start Time",
                status: "Estado",
                statusHistory: "Historial",
                stop: "Stop",
                string1: "",
                success: "Correcto",
                synoptic: "Sinóptico",
                thereIsNoWorkOrderConfiguredForThisLine: "Falta OF configurada para esta línea",
                thislinehasajobassignedClosethejob: "Esta línea tiene tarea configurada. ¿Cerrar tarea?",
                thisMethodRequiresAConfirmationAndNoneIsDe: "Estte método requiere confirmación y no hay ninguna definida.",
                time: "Hora",
                timeEnd: "Hora Fin",
                timeIn: "Hora Inic",
                titleWoMan: "Work order {0}",
                tKey: "TKey",
                tKeyActivity: "Activity Type",
                tKeyCode: "TKey code",
                tKeyDescription: "TKey Desciption",
                tNotConfigured: "Default Reason Codes for APS import are not properly configured for this Department",
                to: "A:",
                toolTipchkRaw: "Press update button to apply your filter(s)",
                toolTipEnter: "Press Enter to apply your filter(s)",
                totalImportedMinutes: "Imported T-Key Duration (min.)",
                totalMinutesBooked: "Total Minutes Booked",
                totalShiftDuration: "Shift Duration (min.)",
                totalShiftHours: "Total Shift Minutes",
                totalTimeGreaterThanShift: "Total activity time is greater than shift length.",
                transactionType: "Transaction Type",
                txtQuantityErr: "Invalide quantity",
                unableToAddOpenItemToLineX0ErrorX1: "No puede de añadir open item a línea {0} error#: {1}",
                unableToAddOpenItemToLineX0X1ErrorX2: "No puede de añadir open item a línea {0} {1} error#: {2}",
                unblock: "Desbloquear",
                unit: "Unidad",
                update: "Actualizar",
                userNotRecognised: "Usuario no reconocido",
                validationSummary: "The following must be reolved before the operation can complete.",
                wantToUseAlternatePrinter: "Impresora seleccionada no está lista!!  Pulsar SÍ para cambiar a impresos alternativa.",
                wCL: "WC/L",
                wO: "OF",
                wOAvailable: "List of GPOs Available",
                woMButton1: "Manage this work order",
                woMMAterialNameError: "this Material doesn t exist : ",
                woMPallFullQty: "Full",
                woMPallMinQty: "Small",
                woMPallQty: "Quantity X Pallet",
                woMPallTxtFullQty: "Standard",
                woMPallTxtModQty: "Changed by Operator",
                wOMTitle: "Workorder Management",
                workCenter: "WorkCenter",
                workOrder: "OrdenFabricación",
                workOrderOp: "OF  / OPER",
                woSApproved: "Approved",
                woSClosed: "Closed",
                wOSequenceScheduled: "GPO Sequence Scheduled",
                woSInUse: "In use (On line)",
                woSPlanned: "Planned",
                woSSuspended: "Suspended",
                x0OfX1PaletsBlocked: "{0} de {1} palets bloqueados",
                x0OfX1PaletsBlockedStoppedAtErrorForSSCCX2: "{0} de {1} palets bloqueados.  Detenido en error de   SSCC:{2} -{3}",
                x0OfX1PaletsDeleted: "{0} de {1} palets eliminados",
                x0OfX1PaletsDeletedStoppedAtErrorForSSCCX2: "{0} de {1} palets eliminados.  Detenido en error de   SSCC:{2} -{3}",
                x0OfX1PaletsScrapped: "{0} de {1} palets a chatarra",
                x0OfX1PaletsScrappedStoppedAtErrorForSSCCX: "{0} de {1} palets a chatarra.  Detenido en error de   SSCC:{2} -{3}",
                x0OfX1PaletsUnblocked1: "{0} de {1} palets desbloqueados",
                x0OfX1PaletsUnblockedStoppedAtErrorForPalletX21: "{0} de {1} palets desbloqueados.  Detenido en error de   SSCC:{2} -{3}",
                yourAccountIsLockedPleaseContactTheHelpdes: "Cuenta bloqueada. Contactar Helpdesk.",
                rxg_defectsTable_Defect: "Defect",
                rxg_defectsTable_Initials: "Initials",
                rxg_defectsTable_Comment: "Comment",
                mouldNo: "Moulds",
                mvtDesc: "Movement description",
                mvtDate: "Movement date",
                billOfBatches: "Bill Of Batches",
                batchNr: "Batch Nr",
                workorderAssignedPrinting: "Workorder was assigned for Label printing. Switch to activity?",
                workorderAssignedConsumption: "Workorder was assigned for consumption. Switch to activity?",
                jobIn: "Job In",
                statusChangeNotAllowed: "Status change not allowed",
                deselect: "Deselect",
                resetView: "Reset View",
                containerVolume: "Volumen",
                lineIn: "Line In",
                partPallet: "Part Pallet",
                manualEntry: "Manual Entry",
                consumed: "Consumed",
                issued: "Issued"
            }
        }
    },
    "fr-FR": {
        translation: {
            main: {
                palletConditionId00: "Info",
                palletConditionId01: "Produced – Not in Warehouse",
                palletConditionId02: "In Warehouse",
                palletConditionId03: "Resorted",
                palletConditionId04: "Picked",
                palletConditionId05: "Delivered",
                palletConditionId06: "Scrapped",
                palletConditionId07: "Put-Away via Storage UnitList",
                palletConditionId08: "Lost",
                palletConditionId09: "Deleted",
                palletConditionId10: "Stock Transfer",
                palletConditionId11: "Intermediate Pallet",
                palletConditionId12: "Quality Inspection",
                palletConditionId13: "Blocked Resort",
                palletConditionId94: "Allocated for Delivery",
                palletConditionId99: "Label Printed",
                palletStatusId00: "Label Printing",
                palletStatusId01: "Label Printed",
                palletStatusId02: "Label Printed_NIU",
                palletStatusId03: "Cus. Incubation",
                palletStatusId04: "Good",
                palletStatusId05: "Blocked",
                palletStatusId06: "Resorted",
                palletStatusId07: "Scrap",
                palletStatusId08: "Test Pallet",
                palletStatusId09: "Customer Return",
                palletStatusId10: "Blocked QI",
                palletStatusId11: "Saleable restricted",
                palletStatusId12: "Blocked Packaging",
                palletStatusId13: "Issued",
                palletStatusId14: "Consumed",
                palletStatusId15: "Returned",
                palletStatusId16: "Stock Received",
                palletStatusId17: "Good",
                palletStatusId18: "Deleted",
                palletStatusId19: "Repacking",
                palletStatusId20: "Loaded",
                palletStatusId21: "Shipped",
                palletStatusId22: "Scrap Warehouse",
                palletStatusId30: "PreBilled",
                palletStatusId90: "WIP",
                movementDescription11: "Label Printed - Pallet Produced",
                movementDescription10: "Return Pallet off line",
                movementDescription13: "Change pallet status from SAP",
                movementDescription12: "Label Printed - Pallet Produced (offline)",
                movementDescription15: "Block pallet QI",
                movementDescription14: "Change pallet Birth Date/Condition in APL from PLC ",
                movementDescription17: "Scrap pallet",
                movementDescription16: "Release pallet",
                movementDescription19: "User connection",
                movementDescription18: "Delete/Cancel pallet",
                movementDescription01: "Start WorkOrder Front End Line",
                movementDescription02: "Stop Workorder Front End line",
                movementDescription03: "Start Workorder Back End Line",
                movementDescription04: "Stop Workorder Back End line",
                movementDescription05: "Issue Pallet on line ",
                movementDescription06: "Consumed Pallet on line ",
                movementDescription07: "Return Pallet on line",
                movementDescription08: "Delete Consumption",
                movementDescription09: "Consumed Pallet off line ",
                movementDescription33: "Block pallet for Scrap",
                movementDescription32: "Pallet quantity change",
                movementDescription35: "Scrap in Warehouse",
                movementDescription34: "Block Pallet for Packaging",
                movementDescription22: "Open Item Return ",
                movementDescription23: "Block pallet for resorting",
                movementDescription20: "Open Item Issuing",
                movementDescription21: "Open Item Consumption",
                movementDescription26: "Remove defect on a pallet",
                movementDescription27: "Defect found",
                movementDescription24: "Open Item delete",
                movementDescription25: "Add Defects to Pallet",
                movementDescription28: "Defect not found",
                movementDescription55: "SU defect removed from SAP",
                movementDescription54: "SU defect added from SAP",
                movementDescription51: "SU Updated from SAP",
                movementDescription50: "SU Created from SAP",
                movementDescription53: "SU condition Updated from SAP",
                movementDescription52: "SU status Updated from SAP",
                movementDescription44: "Approve Pallet",
                movementDescription40: "Pallet Scanned for Repack",
                movementDescription41: "Remove Pallet from Repack",
                movementDescription42: "Pallet Splitting",
                movementDescription43: "Create pallet from other",
                movementDescription60: "Pallet Locked",
                movementDescription61: "Pallet Unlocked",
                movementDescription99: "SU Imported for Go Live",

                actions: "Actions",
                activity: "Activity",
                activityDefaultInstructions: "Default values for new activities",
                actQty: "Act Qté",
                addDefect: "Ajout défaut",
                addNewActivities: "Add New Activities",
                addUser: "Ajout utilisateur",
                admin: "Admin",
                adminView: "Administration des impressions",
                apply: "Appliquer",
                aPSImport: "APS Import",
                aPSImportHistory: "APS Import History",
                areYouSureBlock: "Etes vous sur de vouloir bloquer ces palettes?",
                areYouSureBlock1: "Etes vous sur de vouloir bloquer cette palette?",
                areYouSureDelete: "Etes vous sur de vouloir supprimer ces palettes?",
                areYouSureDelete1: "Etes vous sur de vouloir supprimer cette palette?",
                areYouSureScrap: "Etes vous sur de vouloir mettre aux rebuts ces palettes?",
                areYouSureScrap1: "Etes vous sur de vouloir mettre aux rebuts cette palette?",
                areYouSureUnblock: "Etes vous sur de vouloir debloquer ces palettes?",
                areyousureyouwanttoclosethejob: "Voulez vous arrêter cet OF?",
                areyousureyouwanttoconsumescrapSSCC: "Are you sure you want to consume and scrap SSCC",
                areyousureyouwanttodeleteSSCCX0X: "Voulez vous supprimer ce SSCC:{0}?",
                areyousureyouwanttoreturnSSCC: "Voulez vous faire un retour du SSCC",
                areyousureyouwishtoassignworkorder01toline3: "Voulez vous démarrer l`OF {0}({1}-{2}) sur la ligne {3}",
                article: "Article",
                assign: "démarrer un OF",
                assignedSuccessfully: "OF démarré",
                assignNewJob: "Démarrer un nouvel OF",
                back: "Retour",
                backToCurrentActivity: "Retour à l`activité en cours",
                backToOfflineHome: "Retour à Off line",
                baseProduct: "Base Product",
                batch: "Batch",
                batchEnd: "Batch End",
                batchStart: "Batch Start",
                beginPrinting: "démarrer impression",
                block: "Bloquage",
                blocked: "bloqué",
                blockFailedWithError: "Block failed with error: ",
                blockPackaging: "Block Packaging",
                blockPallet: "Bloque la palette",
                blockQi: "Block QI",
                blockResort: "Block Resort",
                bPNoOfCopies: "Nbre de Copie",
                bPQuantity: "Quantité",
                btnBack: "Fin",
                btnBackWo: "Retour",
                btnCancel: "Annuler",
                btnCartonDeleteConfirmation: "Etes-vous sûr de supprimer ce carton?",
                btnCartonDeleteLastDate: "Supprimer dernier carton",
                btnCloseOff: "Retour",
                btnDeleteLastOne: "Supprimmer dernier carton",
                btnGo: "Confirmer la création de(s) nouvelle(s) palette(s)",
                btnNo: "Non",
                btnNoReturn: "No i don't consume anything",
                btnNoWarn: "Non",
                btnPrintNextCarton: "Imprimer carton suivant",
                btnPrintPalletAndClose: "Palette terminée : imprimer étiquette palette",
                btnSeachWom: "Recherche OF",
                btnUnderstoodBack: "Retour",
                btnUpdateWoM: "Update",
                btnWoMan: "Gestion OF",
                btnYes: "Oui",
                btnYesReturn: "Yes i return {0} in quantity",
                btnYesReturn2: "I close the work order \n because i return 0 in quantity",
                btnYesReturnDetail: "I close this \n because i return 0 in quantity",
                btnYesWarn: "Oui",
                byProduct: "ByProduct",
                byProductDetails: "ByProduct Details",
                cancel: "Annuler",
                cannotConsumeInTheFuture: "Date de l'affectation > date actuelle. erreur# w0001",
                cantDelete: "Error Number: {0} Could not delete.",
                cantLoadShifts: "Could not load shifts: {0}",
                cartonCreateLastDate: "Date dernier carton",
                cartonDeleteLastDate: "Supprimer dernier carton",
                cartonError: "Qté totale différente de la qté de la palette",
                cartonQuantity: "Quantité",
                cartonSumQty: "Nombre de carton",
                cartonType: "Quantité par carton",
                changeCloseJob: "Changer / fermer l`OF",
                checkDatesfuture: "Cannot consume in the future",
                checkDateslater: "Start date is later than end date",
                checkSSCC: "Are you sure you want to remove consumption for ",
                chkDetails: "Information d’impression",
                chkEdit: "Edit",
                chkError: "Fichier erreurs",
                chkInPRogresse: "Impression en attente",
                ckBoxCartonSave: "With Carton",
                clickLoadShift: 'You have to click "Load Shift" before proceeding!',
                close: "Fermer",
                closeAndConsume: "Stop Consumption",
                closeLine: "Close Line(s)",
                closeReturn: "Close and return line(s)",
                closeWorksOrder: "Fermer l`OF",
                coilCutting: "Coil cutting",
                color: "Color",
                comment: "Commentaire",
                component: "Composant",
                condition: "Condition",
                conditionID: "ConditionID",
                confirm: "Confirmer",
                consume: "Affectation",
                consumeScrap: "ConsumeScrap",
                consumeSSCC: "Consomme SSCC",
                consumptionCannotBeDisplayedNoWO: "Affectation  impossible. Pas d`OF démarré. Démarré un Of sur cette ligne. erreur# w0002",
                consumptionCurrentActivity: "Affectation en cours",
                consumptionNbPallet: "Nb Palette",
                consumptionPageTitle: "Consumption Declaration",
                consumptionParameters: "Parametres d'affectation",
                consumptionQty: "Quantité",
                consumptionUnit: "Unité",
                couldNotBlockPalletErrorX0: "la palette ne peut être bloquée. Erreur# w0003: {0}",
                couldNotBlockPalletErrorX0X1: "la palette ne peut être bloquée.  Error#{0}:{1}",
                couldNotDeleteConsumtionX0: "l'affectation ne peut être supprimée. Erreur# w0004: {0}",
                couldNotDeleteConsumtionX0ErrorX1: "l'affectation ne peut être supprimée.  {0} Error# {1}",
                couldNotDeleteOpenItemX0: "open item ne peut être supprimée Error# w0005: {0}",
                couldNotDeleteOpenItemX0ErrorX1: "Il n`est pas possible de supprimée open item {0} Error# {1}",
                couldNotGetConsumptionPalletDetailsForJobE: "L'affectation ne peut se faire sur l`OF  Error# w0006: {0}",
                couldNotGetConsumptionPalletDetailsForJobX: "L'affectation ne peut se faire sur l`OF   {0}: Error# {1}",
                couldNotIssueConsumtionX0: "Could not issue consumtion. Error# w0007: {0}",
                couldNotIssueConsumtionX0ErrorX1: "Could not issue consumtion. {0} Error# {1}",
                couldNotLoadWorkOrderPleaseCheckTheOrderCo: "L`OF ne peut être lancé, vérifier l`OF et recommencer .error# w0008",
                couldNotScrapPalletErrorX0: "La palette ne peut être mise au rebuts. Error# w0009: {0}",
                couldNotScrapPalletErrorX0X1: "La palette ne peut être mise au rebuts. Error#{0}:{1}",
                couldNotUnblockPalletErrorX01: "la palette ne peut être débloquée. Error# w00010: {0}",
                couldNotUnblockPalletErrorX0X1: "La palette ne peut être débloquée. Error#{0}:{1}",
                created: "Créé",
                currentActivity: "Activité courante",
                currentPalletRank: "Rang palette",
                customerDesc: "Description client",
                cuttedSheetsBlocked: "Feuilles Métal bloquées",
                cuttedSheetsScrapped: "Feuilles Métal aux rebuts",
                date: "Date",
                dateEnd: "Jour fin",
                dateIn: "Jour début",
                dateStart: "DateStart",
                day: "Day",
                declarationOPENITEMS: "Declaration - Open Items",
                defaultActivityLabeling: "Etiquetage",
                defects: "Défauts",
                delete: "Suppression",
                deleteConsumption: "Suppression d'affectation",
                deleteTKeyGroupConfirm: "Are you sure you want to delete this TKey Group?",
                deleteTkeyReasonConfirm: "Are you sure you want to delete this TKey?",
                deliveryEmptyWorkorder: "no work order for this pallet. you can t print it",
                deliveryPalletLoaded: "Nr.Pallets Loaded",
                deliveryResult: "Result",
                deliverySelected: "Selected",
                deliveryTextNoteNr: "Delivery Note Nr.",
                deliveryTextPurchaseOrder: "Customer Purchase Order",
                deliveryTextPurchaseOrderLine: "Customer Purchase Order Line",
                deliveryTitle: "Printing  - JWO Delivery Label",
                deliveryTitleCustCode: "Customer code :",
                department: "Département",
                description: "Description",
                detail: "Détail",
                dicobtnCreatePallet: "Créer nouvelle palette",
                dicoCartonDetails: "Carton Details",
                dicoHtmlAddPallet: "Ajouter une nouvelle palette à créer",
                dicoHtmlConfirRepack: "Confirmer Repack",
                dicoHtmlLine: "Ligne",
                dicoHtmlMaterial: "Code Article",
                dicoHtmlOriginalQty: "Quantité originale",
                dicoHtmlProdDate: "Date de production",
                dicoHtmlQuantityUsed: "Quantité utilisée : ",
                dicoHtmlRemove: "Retirer",
                dicoHtmlRepack: "Article sélectionné pour le Repacking :",
                dicoHtmlRepackNew: "Date pour le nouvelle palette",
                dicoHtmlRepackProgress: "Article en cours de Repacking :",
                dicoHtmlRepackResult: "Résultat du repacking",
                dicoHtmlSapcode: "Code Article SAP",
                dicoHtmlScanSSCC: "Scannez nouveau SSCC :",
                dicoHtmlSelectMat: "Select this material",
                dicoHtmlSelectMatOnHold: "selected",
                dicoHtmlWo: "Ordre de fabrication",
                dicoJsPalletDate: "La palette ne peut pas avoir de date dans le futur",
                dicoJsPalletOrder: "La palette ne peut pas être daté dans le futur de la palette origine",
                dicoJsPalletquantity: "Impossible d'utiliser plus de ressource que le rapacking dispose",
                dicoJsPalletquantity2: "Quantité demandé pour le repacking supérieure à la quantité disponible",
                dicoRepackSummary: "Résumé du repacking en cours",
                dicoTotalQuantity: "Total Quantity",
                differentWOOnConsumptionAndLabeling: "OF Différent en entrée et sortie de ligne. Error# w0010",
                differentWOOnConsumptionAndLabeling2: "Active GPO in Labeling is different from Consumption one!",
                disable: "Disable",
                disabledOperators: "Show Disabled Operators Only:",
                display: "Display",
                done: "Done",
                downTime: "Down-Time",
                doYouSetWorkOrderDefaultDataCollection: "Would you like to set {0} as the Default work order for this shift?",
                doYouWantToActivate: "Voulez vous activez un nouvel OF?",
                duration: "Duration",
                durationMinutes: "Dur.(min.)",
                durationValidation: "* Duration must be numeric.",
                edit: "Info Palette",
                efficiencyoftheLine: "TRS ligne",
                empty: "Vide",
                emptyRowDelivery: "No data found with those parameters!",
                enable: "Enable",
                enabled: "Enabled",
                endBeforeStart: "End date ({1}) is earlier than or equal to start date({0}).",
                endDate: "Date de Fin",
                endDateTime: "EndDT",
                endTime: "End Time",
                error: "Erreur",
                errorCommandNotRecognised: "erreur: commande pas reconnu. Erreur# w0011",
                errorSavingActivity: "An error occured saving the Activity, Error:",
                exit: "Sortir",
                failedToConsumeSsccInDbX0: "Affectation impossible,SSCC .Error# w0012:  {0}",
                failedToConsumeSsccInDbX0ErrorX1: "Affectation impossible, SSCC . {0} Error# {1}",
                failedToReturnSsccInDbX0: "Retour matière impossible. Error# w0013: {0}",
                failedToReturnSsccInDbX0ErrorX1: "retour matière impossible, SSCC {0} Error# {1}",
                failureReason: "Raison de l’échec",
                finalPalletRank: "Dernier rang palette",
                finalPass: "Passe Finale",
                finished: "Finished",
                freeText1: "FreeText1",
                freeText2: "FreeText2",
                getData: "Get Data From APS",
                go: "Rechercher",
                goBack: "Ecran précédent",
                goBacktoCurrentActivity: "Retour à l`activité en cours",
                headerTextUser: "Utilisateur",
                importDataFromAPS: "Import Data from APS",
                inBoundBtnCancel: "Annuler",
                inBoundBtnCancel2: "Terminer",
                inBoundBtnConfirm: "Confirmer",
                inBoundBtnExit: "Sortie",
                inBoundBtnOk: "Ok",
                inBoundBtnReset: "Reset Date",
                deliveryNote: "Bon de livraison",
                inBoundConfirmCreation: "Etes-vous sûr? Le statut impression va être changé.",
                inBoundConfirmDelete: "Etes-vous sûr de supprimer cette ligne?",
                inBoundDateExpiryDate: "Date d expiration",
                inBoundDxColLocation: "Emplacement",
                inBoundDxColLotNumber: "Lot",
                inBoundDxColSeqNumber: "Rang",
                inBoundDxColunit: "Unité",
                inBoundDxComment: "Bon de livraison",
                inBoundDxDescription1: "Description",
                inBoundDxMaterialCode: "Code Article",
                inBoundDxPrintStatus: "Statut Impression",
                inBoundDxSelectTran: "Choisissez une transaction",
                inBoundDxSelTranType: "Type de transaction",
                inBoundDxTransactionDate: "Date",
                inBoundDxwarehouse: "Magasin",
                inBoundErrorAmount: "Quantité totale invalide : Vérifiez et corrigez les quantités.",
                inBoundErrorDate: "La date est incorrecte",
                inBoundErrorLabelRank: "Le nombre de pallete est incorrect.",
                inBoundErrorNbrPallet: "Le nombre de Palette doit être numérique et supérieur à 0",
                inBoundErrorPalletCreation: "Une erreur s est prosuite pendant la création des étiquettes : Vérifiez les données.",
                inBoundErrorPalletEdition: "la mise à jour n est pas complète: complèter les données",
                inBoundErrorQtyLabel: "La quantité par palette doit être numérique et supérieure à 0",
                inBoundErrorQuantity: "Le champ Quantité par Palette doit être numérique et supérieur à 0",
                inBoundErrorQuantityTotal: "La quantité totale doit être égale à la quantité de la transaction choisie.",
                inBoundErrorReceiptDate: "La date d expiration doit être une date valide",
                inBoundErrorUpdate:
                    "Une erreur s est produite pendant l enregistrement. Contrôler les données. Si le problème persiste: contacter l équipe APL",
                inBoundIntLabelRank: "Nb de palettes",
                inBoundIntQtyLabel: "Qté x Palette",
                inBoundLitCouncil: "Remplissez les cases et appuyer sur Rechercher",
                inBoundLitDescription: "Description",
                inBoundLitInfosTrans: "Vide = Tous, ou OO, U, UC, UT, UR, RT ",
                inBoundLitLabelName: "Format étiquette :",
                inBoundLitMat: "Code Article",
                inBoundLitPrint: "Imprimer",
                inBoundLitRecap: "Résumé de la création d étiquette(s) : ",
                inBoundLitTitre: "Etiquetage Réception",
                inBoundLitTranDate: "Date Reception",
                inBoundLitTrans: "Transaction",
                inBoundLitTransac: "Recherche de la transaction",
                inBoundLitWarehouse: "Magasin",
                inBoundLnkAdd: "Ajouter une ligne",
                inboundNo: "Non",
                inBoundsearch: "Rechercher",
                inBoundStrCoilNr: "SU reference",
                inBoundStrVendorBatch: "Vendor Batch",
                inBoundStrWorkOrder: "WorkOrder ref",
                inBoundTotalLabelCreation: "Total",
                inBoundTransactionQuantity: "Qté",
                inBoundTxtMatError: "Le champ Code Article doit contenir les 3 permiers caractères au minimum",
                inBoundTxtTanDateError: "Saisissez une date valide",
                inBoundTxtwareError: "Le champ magasin ne peut pas être vide et doit être de 2 caractères maximum",
                inboundYes: "Oui",
                initials: "Initiales",
                initQty: "Qté Initiale",
                input: "Entrée",
                insert: "Insert",
                insertNew: "Insert New Record",
                inValidDate: "Date invalide, entrée une date avec le format (dd/MM/yyyy).",
                invalideQuantity: "Quantité retournée supérieure à la quantité de la palette {0} error# w0026",
                inValidTime: "Heure Invalide, entrée l`heure avec le format (hh:mm).",
                inValidUser: "Login non valide! Essayer de nouveau",
                inValidWorkOrderId: "OF invalide pour la ligne!!!! Vérifiez SVP",
                item: "Article",
                itemClass: "Classe de l`article",
                labelCurrentActivityError: "Des erreurs pour l`activité en cours de cette ligne!!! Voulez vous changer de ligne?",
                labelDefaultTitle: "Labeling Current Activity",
                labelImSwitchQty: "Switch Quantity between full and Small",
                labellingPrintingComplete: "Impression envoyée à l imprimante",
                labelName: "Nom format étiquette",
                labelPalletCount: "Nb Palettes Produites : {0}",
                labelPalletCount2: "{0}/{1}",
                labelPalletInProgress: "Palette en cours : SSCC {0}",
                labels: "Etiquettes",
                lblConfiramtionReturn: "Do you confirm your Return 0 quantity?",
                lblConfirmOff: "This pallet has 0 Qty ! you can t use it",
                lblConfirmRepack: "Do you confirm the Repack of the selected Material?",
                lblConfirmRepackCondition: "La selectionpour le Repacking  va être changé",
                lblDefaultSetting: "Quantité Carton {0}",
                lblErrbtnConsumeClick: "Wrong date. You can t consume pallet in the future. Change the date please!",
                lblErrbtnConsumeClickMissing: "Could not find SSCC. error# W0006",
                lblErrbtnConsumptionClick1: "Cannot add the material. {0} : error# {1}",
                lblErrbtnConsumptionClick1Else: "Could not consume SSCC invalid quantity. error# W0008.",
                lblErrbtnConsumptionClick1Exception: "Cannot add the material.  error# {0}",
                lblErrOI: "Return Quantity must be greater than 0! error# w0026",
                lblFailErr: "Erreur :",
                lblFailSSCC: "SSCC {0} n'existe pas pour ce site",
                lblOIErrorDate: "wrong date!",
                lblRePrintInfo: "Choississez une imprimante",
                lblRePrintInfoInnerHtml: "Select printer to reprint to?",
                leavingthispagewillstopprinting: "En quittant cette page l`impression sera stoppé",
                length: "Longueur",
                line: "Ligne",
                linePrintAll: "Imprimer",
                litActQty: "Quantité actuelle",
                litAllInOne: "tous les cartons pour la palette",
                litByProduct: "ByProduct 1 Material",
                litByProduct2: "ByProduct 2 Material",
                litCartonLabel: "Carton Label",
                litCopyNumber: "Number of copy",
                litCustCode: "Customer Code",
                litCustMat: "Customer material",
                litCustMatDesc: "Description",
                litCustomer: "Customer info",
                litEANGTAN: "EAN/Gtin",
                litLabelCreation: "Création étiquette(s)",
                litMain: "Main",
                litMainByProd: "By Prod 1",
                litMessWarn:
                    "The quantity on the pallet exceed the max quantity schedule on work order. Do you want to change the current quantity on the pallet?",
                litModQtyMax: "Quantity for a full pallet",
                litModQtyMin: "Quantity for small pallet",
                litNameCust: "Name",
                litPalLabel: "Pallet Label",
                litPrintHistory: "Print History",
                litQtyReq: "Quantity Requested",
                litQuantityProd: "Quantité produite",
                litQuantitySchedule: "quantité prévue",
                litSearch: "Search a new Workorder",
                litsearchWomField: "Search a new Workorder",
                litTitre: "Etiquetage Réception",
                litUserUpdate: "Changed by operator",
                litWait: "Patientez",
                litWoMan: "Work order information",
                litWomDec1: "Desc1",
                litWomDec2: "Desc2",
                litWomMaterial: "Material",
                litWoOpe: "Work Order Operation",
                litWoOpeByProd2: "By Prod 2",
                litWoS: "Current work order status : ",
                loadShift: "Load shifts",
                loadShiftsTip: "Load shifts for line and Date selection.",
                logout: "Deconnexion",
                lotNumber: "Lot",
                lot: "Lot",
                lstDefault: "None",
                mainDetails: "Details principaux",
                manning: "Manning",
                manningValidation: "* Manning must be numeric.",
                material: "Code Article",
                metalAndEnds: "Métal et Fonds",
                missingAPSDef: "Missing APS Import Default",
                multipleSelectionError: "Les lignes selectionnées doivent être au même status",
                name: "value",
                negativeOEEWarning: "Error ID:31001 Break-down must be less that Run-time + Set-up.",
                new: "New",
                newPalletNumber: "New Pallet Number",
                next: "Suivant",
                noAPSData: "No data for this activity!",
                noColours: "No. Colours",
                noColoursValidation: "* No. of Colours must be numeric.",
                noData: "Pas de donnée pour cette ligne",
                noOfCartons: "Nbre de Cartons",
                noOfCoils: "Nbre de Bobines",
                noOfPallets: "Nbre de Palettes",
                noOfPalletsProduced: "Nbre de Palettes produites sur l`OF",
                noOfSheets: "Nbre de Feuilles",
                noPallets: "Nbre de Palettes",
                noShiftsToDisplay: "There are no shifts to display activity for",
                noUpdateAfterSAP: "You cannot update an entry after sending to SAP.",
                noWorkorder: "Pas d`OF",
                noWorkOrderOnConsumptionAndOneRunningForLa: "Pas d`OF en entrée ligne, 1 OF en sortie de Ligne. Error# w0014: ",
                noWorkOrderOnLabelingAndOneRunningOnConsum: "Pas d`OF en sortie de ligne, 1 OF en entrée de ligne. Error# w0015:",
                numberOfCopies: "Nbre de copies",
                offlineCons: "Affectation off line",
                oFFLINECONSUMPTION: "OFF LINE AFFECTATION",
                oFFLINECONSUMPTIONMETALANDENDS: "OFF LINE AFFECTATION METAL ET FONDS",
                offLineMetalSSCCAway: "This SSCC Doesn t exist.",
                offlinePrint: "Impression offline",
                offlinePrintingFailedException:
                    "L`imprimante n`est pas prête, l`impression est en pause, selectioner une nouvelle imprimate et clicquer sur démarrer impression pour continuer. Redémarrer l`impression en utilisant l`imprimante sélectionner dans la liste",
                okay: "OK",
                onLINECONSUMPTION: "ON LINE AFFECTATION",
                oops: "Erreur inattendue. Si l`erreur persiste contacter le help desk.  Error# w0016",
                op: "Op.",
                openedWO: "Opened GPOs",
                openItems: "Open Items",
                operation: "Operation",
                operatorCode: "Operator Code",
                operatorName: "Operator Name",
                order: "OF",
                outisdeShiftTime: "Activity entry must be between {0} and {1}.",
                outOfShift: "",
                overProdHeader: "Overproduction",
                overProdText: "Creating this pallet, you will be overproducing on this WO. Do you want to continue anyway?",
                palletCreated: "Palette {0} ({1}) créée.",
                palletDetail: "Details de la palette",
                palletID: "PaletteId",
                palletIdentify: "N° palette",
                palletRank: "Rang palette",
                pallets: "Palettes",
                palletsProduced: "Palettes prod.",
                palletsQty: "Palettes (Qté)",
                palletsScheduled: "Palettes prév.",
                palletStatus: "Status palette",
                palletStatusEdit: "editer palette",
                palletStatusId: "StatusId",
                palSatDefaultTitle: "Pallet Status Management",
                palSatEditSelectPrinter: "Select printer to reprint to?",
                palStat_Default_Page_Load_Pallet_Status_Management: "Status des palettes",
                partCode: "Code Article",
                partDescription: "Desc Article",
                pass: "Passe",
                passFirst: "Choisissez la passe",
                passNumber: "Numéro Passe",
                pausePrinting: "Impression en pause",
                pickingLblNumCopy: "Number of Copy :",
                pieces: "Pcs",
                pleaseSelectaLine: "Selection une ligne SVp",
                pleaseSelectaPrinter: "Selectionner une imprimante pour imprimer la nouvelle étiquette",
                popDown: "pop down",
                popLabelErrorCartonQty:
                    "Quantité du carton incorrecte. La quantité doit être positive, sans que la quantité totale dépasse la quantité prévue sur la palette.",
                popMaxcatonLimit: "Vous avez atteint le nombre de carton maximal autorisé sur une palette",
                print: "Imprimer",
                printAbort: "Echec impression pour le rang {0}. Le serveur ne répond pas. Error# w0017.",
                printEngine: "Genérateur d`étiquette",
                printer: "Imprimante",
                printerName: "Nom Imprimante",
                printFailed: "Echec impression pour le rang {0}.voulez vous réessayer?",
                printFailedAbr: "Echec impression. Error# w0018",
                printfailedselectanotherprinter: "Echec impression, selectionner une autre imprimante ou essayer de nouveau.Error# w0019",
                printFailedWithException: "{0}. Echec impression pour le rang {1} Erreur# w0020.",
                printingComplete: "Impression effectuée",
                printLabels: "Imprimer étiquette",
                printMod: "Mode d’impression",
                printPartiallyFailed:
                    "Echec impression pour le rang {0} Erreur# w0021. Seulement {1} des {2} étiquettes ont été imprimées.voulez vous réimprimer l`étiquette manquante?",
                printResult: "{0} label have been sent to the print list (see below for more information about its status).",
                printScreen: "Print Screen",
                printStatus: "Status impression",
                printSucceeded: "Impression effectuée",
                printSuccessful: "impression réussie",
                printUsingAlternatePrinterFailed:
                    "Echec impression sur imprimante de secours. Voulez vous réessayer?                                            Click OUI pour imprimer sur une autre imprimante ou click NO et alors cliquer sur imprimer pour imprimer sur l`imprimante par défaut.",
                processFinished: "Process Finished",
                prodDate: "Date de Prod.",
                productionOrderRunning: "OF en cours",
                prompt: "prompt",
                qtyProduced: "Quantité produite",
                qtyScheduled: "quantité prévue",
                quantity: "Qty",
                quantityConsumed: "Quantité consommée",
                quantityProduced: "Quantité produite",
                quantityRemaining: "Quantité restante",
                quantityScrapped: "Quantity Scrapped",
                rank: "Rang",
                reason: "Reason",
                reasonCode: "Reason Code",
                reasonCodeDescription: "Reason Code Description",
                rememberSave: "Remember to save defaults.",
                reprint: "Réimprimer",
                reprintFailed:
                    "Echec réimpression pour le rang {0} Erreur# w0022. Seulement {1} des {2} étiquettesont été imprimées. Voulez vous réimprimerl`étiquette manquante?.",
                requiredFields: "Données manquantes. Voir en rouge",
                return: "Retour palette",
                ringDiameter: "Diametre du Ring",
                runTime: "Run-Time",
                rxg__0__assigned_to__1_: "{0} assigné à {1}",
                rxg__0__units_returned_on_SSCC__1___When_all_pallets_are_consumed_returned__click_OK_again_to_close_the_job__dialog_w0005:
                    "{0} retourné sur le SSCC {1}.quand toutes les palettes sont consommées/retournées, click OK pour fermer l`OF. dialog#w0001",
                rxg_Add_Defect: "Ajouter défaut",
                rxg_Back_to_current_activity: "Retour à l`activité courante",
                rxg_Back_to_labeling: "retour à l`étiquetage",
                rxg_Back_to_offline_consumption: "retour à l'affectation off line",
                rxg_BeginPrint: "Démarrer impression",
                rxg_Cannot_issue_the_material___0___error___1_: "impossible d`alimenter . {0}: error# {1}",
                rxg_Consumption: "Affectation",
                rxg_Could_not_assign__0__to__1___Error___2___3_: " l`OF {0} ne peut être assigné à : {1}, Error#:{2}-{3}",
                rxg_Could_not_assign__0__to__1__Error____2_: " l`OF {0} ne peut être assigné à : {1}, Error#:{2}",
                rxg_Could_not_assign_Work_Order___Error___0_: "L`OF ne peut être lancé.  Error: {0}",
                rxg_Could_not_assign_Work_Order_Error___0____1_: "L`OF ne peut être lancé Error#:{0}: {1}",
                rxg_Could_not_close_job___Error___0__: "Impossible de fermer l`OF: Error# {0}",
                rxg_Could_not_close_job__0___Error___1_: "Impossible de fermer l`OF {0}: Error# {1}",
                rxg_CouldNotDeletePallet: "impossible de supprimer la palette. Error#{0}:{1}",
                rxg_CouldNotDeletePallet1: "impossible de supprimer la palette. Error#:{0}",
                rxg_Defect_Added: "Le status a été changé mais pas de défaut affecté",
                rxg_Defect_comment_must_be_less_than_255_characters_: "255 caractéres maximum",
                rxg_Defects_Added: "Défaut ajouter",
                rxg_Delete_Pallet: "Suppression palette",
                rxg_DeleteFailedWithError: "Echec Suppression palette , erreur:{0}",
                rxg_Failed_to_set_print_parameters_with_error___0_: "Echec connexion imprimante avec erreur : {0}",
                rxg_From: "de:",
                rxg_Is_the_previous_SSCC___0___completely_consumed___dialog__apl00002:
                    "La palette precedente ({0}) est-elle completement consommée?",
                haveFollowingPalletsBeenFullyUsed: "Have following pallets been fully used?",
                rxg_Label_parameters: "Parametres étiquette",
                rxg_Label_paramters_save_successfully_: "Parametres sauvegardés",
                rxg_Labeling_Pass_Number: "N° passe",
                rxg_No: "Non",
                rxg_No_Department_specified__Error__w0007: "vous devez sélectioner un département. Error# w0025",
                rxg_OfflinePrintHeader: "Impression offline",
                rxg_Open: "Ouvert",
                rxg_Open_SSCC__0__on_the_following_line_s__: "Alimentation  SSCC {0} sur la (les ) ligne(s).",
                rxg_Please_enter_the_quantity_remaining_on_the_previous_pallet__input__APL00031:
                    "Saisir la qté restante sur la palette précédente. input# APL00001",
                rxg_Please_select_a_defect: "Selectionner un défaut",
                rxg_Please_select_the_pass_number_: "Selectionner le numéro de passe",
                rxg_Print: "Imprimer",
                rxg_PrintBoth: "Print Both",
                rxg_PrintDefect: "Print Defect",
                rxg_Quantity: "Quantité",
                rxg_Scrap_failed_with_error__: "Echec Mise au rebuts avec erreur :",
                rxg_Scrap_Pallet: "Mise au rebuts palette",
                rxg_Select_work_order_for_consumption: "Selectionner OF pour l'affectation",
                rxg_Select_work_order_for_labeling: "Selectionner un OF pour l`impression",
                rxg_SSCC___0___has__1__quantity_and_cannot_be_consumed__error_4123:
                    "SSCC ({0}) a la qté {1} et ne peux être consommé. erreur#w0023",
                rxg_SSCC___0___was_not_found___error__00001: "SSCC ({0}) pas trouvé.  erreur#:#w0024",
                rxg_ThereIsNoWorksOrderAssignedForThisLine: "Il n`y a pas d`OF assigné à cette ligne",
                rxg_Title: "Impression offline",
                rxg_Unable_to_consume_pallet__0____1__Error____2__: "Impossible de consommer la palette {0}: {1} erreur#: {2}",
                rxg_Work_Order_Enquiry: "Liste d`OF",
                rxg_Yes: "Oui",
                rxg_You_must_enter_a_comment_for_the_defect_s__: "Vous devez saisr un commentaire pour le défaut",
                rxg_You_must_enter_your_initials_to_add_a_defect: "Vous devez entrer vos initiales",
                save: "Sauvegarder",
                saveDefaults: "Save Defaults",
                sAVESENDTOSAP: "SAVE and SEND TO SAP",
                saveShiftAreYouSure: "Are you sure?",
                saveShiftNotEqual: "The number of minutes booked is not equal to the total minutes.\r\n\r\nAre you sure?",
                scanExternalTag: "Orig/Ext Tag Identifier",
                scanNewMaterial: "Scan matières premières",
                scheduledDateTime: "Date/Heure prévue",
                scheduledOrders: "Scheduled GPOs",
                scheduleWorkOrder: "GPO Scheduling",
                scrap: "Déchets",
                scrapped: "Jeter",
                search: "Chercher",
                select: "Selectionner",
                selectAll: "Selectionner tout",
                selectDefects: "Selectionner un défaut:",
                selectLines: "Selectioner une ligne",
                sendToSAP: "Envoyer à SAP",
                seq: "Seq",
                seqnumber: "Seqnumber",
                setUp: "Set-Up",
                shift: "Shift",
                shiftLength: "From {0} to {1} in total {2} hours",
                shiftNoWorkOrders: "There are no work orders for this line.",
                shiftTime: "Shift Time",
                showRawMaterial: "Affichage composants",
                sqlTranslation: "Traduction des Messages d'erreur SQL",
                sscc: "SSCC",
                ssccConsumed: "SSCC consommé",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheck:
                    "SSCC {0} est sur la (les) ligne(s). Vérifier les lignes que vous voulez fermée.",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheckReturn:
                    "SSCC {0} is open on the following line(s). Please check lines you wish to return.",
                start: "Début",
                startDate: "Start Date",
                startDateIsLaterThanEndDate: "Date de début > date de fin",
                startDateTime: "StartDT",
                startingPalletRank: "début Rang palette",
                startTime: "Start Time",
                status: "Status",
                statusHistory: "Mouvements",
                stop: "Fin",
                string1: "Get only Error Logs",
                success: "Opération réussie",
                synoptic: "Synoptique",
                thereIsNoWorkOrderConfiguredForThisLine: "Il n`y a pas d`OF pour cette ligne",
                thislinehasajobassignedClosethejob: "Un OF est démarré sur cette ligne. Voulez vous le fermer?",
                thisMethodRequiresAConfirmationAndNoneIsDe: "Cette méthode requiert une confirmation et rien n`est défini",
                time: "Heure",
                timeEnd: "heure fin",
                timeIn: "Heure début",
                titleWoMan: "Work order {0}",
                tKey: "TKey",
                tKeyActivity: "Activity Type",
                tKeyCode: "TKey code",
                tKeyDescription: "TKey Desciption",
                tNotConfigured: "Default Reason Codes for APS import are not properly configured for this Department",
                to: "à:",
                toolTipchkRaw: "Press update button to apply your filter(s)",
                toolTipEnter: "Press Enter to apply your filter(s)",
                totalImportedMinutes: "Imported T-Key Duration (min.)",
                totalMinutesBooked: "Total Minutes Booked",
                totalShiftDuration: "Shift Duration (min.)",
                totalShiftHours: "Total Shift Minutes",
                totalTimeGreaterThanShift: "Total activity time is greater than shift length.",
                transactionType: "Transaction Type",
                txtQuantityErr: "Invalide quantity",
                unableToAddOpenItemToLineX0ErrorX1: "Impossible d`ajouter un open item sur cette ligne {0} erreur#: {1}",
                unableToAddOpenItemToLineX0X1ErrorX2: "Impossible d`ajouter un open item sur cette ligne {0} {1} erreur#: {2}",
                unblock: "Déblocage",
                unit: "Unité",
                update: "Mise à jour",
                userNotRecognised: "nom Utilisateur pas reconnu",
                validationSummary: "The following must be reolved before the operation can complete.",
                wantToUseAlternatePrinter: "l`imprimante n`est pas prête!!  Click OUI pour utiliser l`imprimante de secours{0}?",
                wCL: "WC/L",
                wO: "OF",
                wOAvailable: "List of GPOs Available",
                woMButton1: "Manage this work order",
                woMMAterialNameError: "this Material doesn t exist : ",
                woMPallFullQty: "Full",
                woMPallMinQty: "Small",
                woMPallQty: "Quantity X Pallet",
                woMPallTxtFullQty: "Standard",
                woMPallTxtModQty: "Changed by Operator",
                wOMTitle: "Workorder Management",
                workCenter: "WC/Ligne",
                workOrder: "OF",
                workOrderOp: "OF",
                woSApproved: "Approved",
                woSClosed: "Closed",
                wOSequenceScheduled: "GPO Sequence Scheduled",
                woSInUse: "In use (On line)",
                woSPlanned: "Planned",
                woSSuspended: "Suspended",
                x0OfX1PaletsBlocked: "{0} de {1} palette bloquée.",
                x0OfX1PaletsBlockedStoppedAtErrorForSSCCX2: "{0} de {1} palette bloquée. Erreur pour SSCC:{2} -{3}",
                x0OfX1PaletsDeleted: "{0} de {1} palette supprimée.",
                x0OfX1PaletsDeletedStoppedAtErrorForSSCCX2: "{0} de {1} palettes supprimée. Erreur pour SSCC:{2} -{3}",
                x0OfX1PaletsScrapped: "{0} de {1} palette au rebuts.",
                x0OfX1PaletsScrappedStoppedAtErrorForSSCCX: "{0} de {1} palette au rebuts. Erreur pour SSCC:{2} -{3}",
                x0OfX1PaletsUnblocked1: "{0} de {1} palette débloqué.",
                x0OfX1PaletsUnblockedStoppedAtErrorForPalletX21: "{0} de {1} palette débloqué. Erreur pour SSCC:{2} -{3}",
                yourAccountIsLockedPleaseContactTheHelpdes: "Votre compte est bloqué - contacter le help desk",
                rxg_defectsTable_Defect: "Defect",
                rxg_defectsTable_Initials: "Initials",
                rxg_defectsTable_Comment: "Comment",
                mouldNo: "Moulds",
                mvtDesc: "Movement description",
                mvtDate: "Movement date",
                billOfBatches: "Bill Of Batches",
                batchNr: "Batch Nr",
                workorderAssignedPrinting: "Workorder was assigned for Label printing. Switch to activity?",
                workorderAssignedConsumption: "Workorder was assigned for consumption. Switch to activity?",
                jobIn: "Job In",
                statusChangeNotAllowed: "Status change not allowed",
                deselect: "Deselect",
                resetView: "Reset View",
                containerVolume: "Volume",
                lineIn: "Line In",
                partPallet: "Part Pallet",
                manualEntry: "Manual Entry",
                consumed: "Consumed",
                issued: "Issued"
            }
        }
    },
    "en-US": {
        translation: {
            main: {
                palletConditionId00: "Info",
                palletConditionId01: "Produced – Not in Warehouse",
                palletConditionId02: "In Warehouse",
                palletConditionId03: "Resorted",
                palletConditionId04: "Picked",
                palletConditionId05: "Delivered",
                palletConditionId06: "Scrapped",
                palletConditionId07: "Put-Away via Storage UnitList",
                palletConditionId08: "Lost",
                palletConditionId09: "Deleted",
                palletConditionId10: "Stock Transfer",
                palletConditionId11: "Intermediate Pallet",
                palletConditionId12: "Quality Inspection",
                palletConditionId13: "Blocked Resort",
                palletConditionId94: "Allocated for Delivery",
                palletConditionId99: "Label Printed",
                palletStatusId00: "Label Printing",
                palletStatusId01: "Label Printed",
                palletStatusId02: "Label Printed_NIU",
                palletStatusId03: "Cus. Incubation",
                palletStatusId04: "Good",
                palletStatusId05: "Blocked",
                palletStatusId06: "Resorted",
                palletStatusId07: "Scrap",
                palletStatusId08: "Test Pallet",
                palletStatusId09: "Customer Return",
                palletStatusId10: "Blocked QI",
                palletStatusId11: "Saleable restricted",
                palletStatusId12: "Block for Repack",
                palletStatusId13: "Issued",
                palletStatusId14: "Consumed",
                palletStatusId15: "Returned",
                palletStatusId16: "Stock Received",
                palletStatusId17: "Good",
                palletStatusId18: "Deleted",
                palletStatusId19: "Repacking",
                palletStatusId20: "Loaded",
                palletStatusId21: "Shipped",
                palletStatusId22: "Scrap Warehouse",
                palletStatusId30: "PreBilled",
                palletStatusId90: "WIP",
                movementDescription11: "Label Printed - Pallet Produced",
                movementDescription10: "Return Pallet off line",
                movementDescription13: "Change pallet status from SAP",
                movementDescription12: "Label Printed - Pallet Produced (offline)",
                movementDescription15: "Block pallet QI",
                movementDescription14: "Change pallet Birth Date/Condition in APL from PLC ",
                movementDescription17: "Scrap pallet",
                movementDescription16: "Release pallet",
                movementDescription19: "User connection",
                movementDescription18: "Delete/Cancel pallet",
                movementDescription01: "Start WorkOrder Front End Line",
                movementDescription02: "Stop Workorder Front End line",
                movementDescription03: "Start Workorder Back End Line",
                movementDescription04: "Stop Workorder Back End line",
                movementDescription05: "Issue Pallet on line ",
                movementDescription06: "Consumed Pallet on line ",
                movementDescription07: "Return Pallet on line",
                movementDescription08: "Delete Consumption",
                movementDescription09: "Consumed Pallet off line ",
                movementDescription33: "Block pallet for Scrap",
                movementDescription32: "Pallet quantity change",
                movementDescription35: "Scrap in Warehouse",
                movementDescription34: "Block Pallet for Packaging",
                movementDescription22: "Open Item Return ",
                movementDescription23: "Block pallet for resorting",
                movementDescription20: "Open Item Issuing",
                movementDescription21: "Open Item Consumption",
                movementDescription26: "Remove defect on a pallet",
                movementDescription27: "Defect found",
                movementDescription24: "Open Item delete",
                movementDescription25: "Add Defects to Pallet",
                movementDescription28: "Defect not found",
                movementDescription55: "SU defect removed from SAP",
                movementDescription54: "SU defect added from SAP",
                movementDescription51: "SU Updated from SAP",
                movementDescription50: "SU Created from SAP",
                movementDescription53: "SU condition Updated from SAP",
                movementDescription52: "SU status Updated from SAP",
                movementDescription44: "Approve Pallet",
                movementDescription40: "Pallet Scanned for Repack",
                movementDescription41: "Remove Pallet from Repack",
                movementDescription42: "Pallet Splitting",
                movementDescription43: "Create pallet from other",
                movementDescription60: "Pallet Locked",
                movementDescription61: "Pallet Unlocked",
                movementDescription99: "SU Imported for Go Live",

                actions: "Actions",
                activity: "Activity",
                activityDefaultInstructions: "Default values for new activities",
                actQty: "Act Qty",
                addDefect: "Add Defect",
                addNewActivities: "Add New Activities",
                addUser: "Add User",
                admin: "Admin",
                adminView: "Get The Admin View",
                apply: "Apply",
                aPSImport: "APS Import",
                aPSImportHistory: "APS Import History",
                areYouSureBlock: "Are you sure you want to block these pallets?",
                areYouSureBlock1: "Are you sure you want to block this pallet?",
                areYouSureDelete: "Are you sure you want to delete these pallets?",
                areYouSureDelete1: "Are you sure you want to delete this pallet?",
                areYouSureScrap: "Are you sure you want to scrap these pallets?",
                areYouSureScrap1: "Are you sure you want to scrap this pallet?",
                areYouSureUnblock: "Are you sure you want to Unblock these pallets?",
                areyousureyouwanttoclosethejob: "Are you sure you want to close the job?",
                areyousureyouwanttoconsumescrapSSCC: "Are you sure you want to consume and scrap SSCC",
                areyousureyouwanttodeleteSSCCX0X: "Are you sure you want to delete SSCC:{0}?",
                areyousureyouwanttoreturnSSCC: "Are you sure you want to return SSCC",
                areyousureyouwishtoassignworkorder01toline3: "Are you sure you wish to assign work order {0}({1}-{2}) to line {3}",
                article: "Article",
                assign: "Assign",
                assignedSuccessfully: "Assigned Successfully",
                assignNewJob: "Assign New Job",
                back: "Back",
                backToCurrentActivity: "Back to Current Activity",
                backToOfflineHome: "Back to Offline home",
                baseProduct: "Base Product",
                batch: "Batch",
                batchEnd: "Batch End",
                batchStart: "Batch Start",
                beginPrinting: "Begin Printing",
                billOfMaterials: "Bill Of Materials",
                block: "Block",
                blocked: "Blocked",
                blockFailedWithError: "Block failed with error: ",
                blockPackaging: "Block for Repack",
                blockPallet: "Block Pallet",
                blockQi: "Block QI",
                blockResort: "Block Resort",
                bPNoOfCopies: "No. of Copies",
                bPQuantity: "Quantity",
                btnBack: "Finish",
                btnBackWo: "Bouton Back",
                btnCancel: "Cancel",
                btnCartonDeleteConfirmation: "Are you sure you want to delete this carton ?",
                btnCartonDeleteLastDate: "Delete Last one",
                btnCloseOff: "Aboard",
                btnDeleteLastOne: "Delete last carton",
                btnGo: "Confirm creation new pallet/s",
                btnNo: "No",
                btnNoReturn: "No i don't consume anything",
                btnNoWarn: "No",
                btnPrintNextCarton: "Print Next Carton",
                btnPrintPalletAndClose: "Print Pallet Label and Close it",
                btnSeachWom: "Search GPO",
                btnUnderstoodBack: "Back",
                btnUpdateWoM: "Update",
                btnWoMan: "Manage GPO",
                btnYes: "Yes",
                btnYesReturn: "I return {0} in quantity",
                btnYesReturn2: "I close the GPO \n because i return 0 in quantity",
                btnYesReturnDetail: "I close this \n because i return 0 in quantity",
                btnYesWarn: "Yes",
                byProduct: "ByProduct",
                byProduct1: "By Product 1",
                byProduct2: "By Product 2",
                byProductDetails: "ByProduct Details",
                byProductDuplicate: "You cannot set a byproduct to the same FP as the main FP or have two of the same byproduct",
                byProducts: "By Products",
                cancel: "Cancel",
                cannotConsumeInTheFuture: "Cannot consume in the future. error# w0001 ",
                cantDelete: "Error Number: {0} Could not delete.",
                cantLoadShifts: "Could not load shifts: {0}",
                cartonCreateLastDate: "Last Production Date",
                cartonDeleteLastDate: "Delete Last one",
                cartonError: "Total Quantity does not match the quantity of selected pallet!!",
                cartonProdResume: "Carton Production : Resume",
                cartonQty: "Carton Qty",
                cartonQuantity: "Quantity",
                cartonSumQty: "Number of Carton",
                cartonType: "Quantity per carton",
                changeCloseJob: "Change / Close Job",
                changeLog: "Change Log",
                changesNotSaved: "Changes will not be saved.",
                checkDatesfuture: "Cannot consume in the future",
                checkDateslater: "Start date is later than end date",
                checkSSCC: "Are you sure you want to remove consumption for ",
                chkDetails: "Print informations",
                chkEdit: "Edit",
                chkError: "Get only Error Logs",
                chkInPRogresse: "Get only Print Request in wait time",
                ckBoxCartonSave: "With Carton",
                clickLoadShift: 'You have to click "Load Shift" before proceeding!',
                close: "Close",
                closeAndConsume: "Stop Consumption",
                closeLine: "Close Line(s)",
                closeReturn: "Close and return lines",
                closeWorksOrder: "Close GPO",
                coilCutting: "CoilCutting",
                color: "Color",
                columnName: "Column Name",
                comment: "Comment",
                component: "Component",
                condition: "Condition",
                conditionID: "ConditionID",
                confirm: "Confirm",
                consume: "Consume",
                consumeScrap: "ConsumeScrap",
                consumeSSCC: "Consume SSCC",
                consumptionCannotBeDisplayedNoWO:
                    "Consumption cannot be displayed. No work order selected. Assign a job to this line instead.  error# w0002",
                consumptionCurrentActivity: "Consumption Current Activity",
                consumptionNbPallet: "Nb Pallet",
                consumptionPageTitle: "Consumption Declaration",
                consumptionParameters: "Consumption Parameters",
                consumptionQty: "Quantity",
                consumptionStatus: "Consumption Status",
                consumptionUnit: "Unit",
                couldNotBlockPalletErrorX0: "Could Not block pallet. Error# w0003: {0}",
                couldNotBlockPalletErrorX0X1: "Could Not block pallet. Error#{0}:{1}",
                couldNotDeleteConsumtionX0: "Could not delete consumtion. Error# w0004: {0} ",
                couldNotDeleteConsumtionX0ErrorX1: "Could not delete consumtion. {0} Error# {1}",
                couldNotDeleteOpenItemX0: "Could not delete open item Error# w0005: {0} ",
                couldNotDeleteOpenItemX0ErrorX1: "Could not delete open item {0} Error# {1}",
                couldNotGetConsumptionPalletDetailsForJobE: "Could not get consumption pallet details for job Error# w0006: {0} ",
                couldNotGetConsumptionPalletDetailsForJobX: "Could not get consumption pallet details for job {0}: Error# {1}",
                couldNotIssueConsumtionX0: "Could not issue consumtion. Error# w0007: {0} ",
                couldNotIssueConsumtionX0ErrorX1: "Could not issue consumtion. {0} Error# {1}",
                couldNotLoadWorkOrderPleaseCheckTheOrderCo:
                    "Could not load Work Order. Please check the Order Code and try again. error# w0008",
                couldNotScrapPalletErrorX0: "Could Not scrap pallet. Error# w0009: {0}",
                couldNotScrapPalletErrorX0X1: "Could Not scrap pallet. Error#{0}:{1}",
                couldNotUnblockPalletErrorX01: "Could Not unblock pallet. Error# w00010: {0}",
                couldNotUnblockPalletErrorX0X1: "Could Not unblock pallet. Error#{0}:{1}",
                created: "Created",
                currentActivity: "Current Activity",
                currentPalletRank: "Current Pallet Rank -",
                customerDesc: "Customer Description",
                customerDetails: "Customer Details",
                cuttedSheetsBlocked: "Cutted Sheets Blocked",
                cuttedSheetsScrapped: "Cutted Sheets Scrapped",
                dataCollection: "Data Collection",
                date: "Date",
                dateCreate: "Date Create",
                dateEnd: "Date End",
                dateIn: "Date In",
                dateRecorded: "Date Recorded",
                dateStart: "DateStart",
                day: "Day",
                declarationOPENITEMS: "Declaration - OPEN ITEMS",
                defaultActivityLabeling: "Labeling",
                defects: "Defects",
                delete: "Delete",
                deleteConsumption: "Delete Consumption",
                deleteLastOne: "Delete Last One",
                deleteTKeyGroupConfirm: "Are you sure you want to delete this TKey Group?",
                deleteTkeyReasonConfirm: "Are you sure you want to delete this TKey?",
                deliveryEmptyWorkorder: "no GPO for this pallet. you can t print it",
                deliveryPalletLoaded: "Nr.Pallets Loaded",
                deliveryResult: "Result",
                deliverySelected: "Selected",
                deliveryTextNoteNr: "Delivery Note Nr.",
                deliveryTextPurchaseOrder: "Customer Purchase Order",
                deliveryTextPurchaseOrderLine: "Customer Purchase Order Line",
                deliveryTitle: "Printing  - JWO Delivery Label",
                deliveryTitleCustCode: "Customer code :",
                department: "Department",
                desc: "Desc",
                description: "Description",
                detail: "Detail",
                dicobtnCreatePallet: "Create New Pallet",
                dicoCartonDetails: "Carton Details",
                dicoHtmlAddPallet: "Add a New Pallet to be Created",
                dicoHtmlConfirRepack: "Confirm Repack",
                dicoHtmlLine: "Line",
                dicoHtmlMaterial: "FP",
                dicoHtmlOriginalQty: "Original Qty",
                dicoHtmlProdDate: "Prod Date",
                dicoHtmlQuantityUsed: "Quantity used : ",
                dicoHtmlRemove: "Remove",
                dicoHtmlRepack: "FP selected for Repacking :",
                dicoHtmlRepackNew: " Date Repack of the new pallet",
                dicoHtmlRepackProgress: "RePacking FP in progress :",
                dicoHtmlRepackResult: "Repack Result",
                dicoHtmlSapcode: "FP SAP Code",
                dicoHtmlScanSSCC: "Scan New SSCC :",
                dicoHtmlSelectMat: "Select this FP",
                dicoHtmlSelectMatOnHold: "selected",
                dicoHtmlWo: "GPO",
                dicoJsPalletDate: "you can't create pallet in the future",
                dicoJsPalletOrder: "you can't create pallet before the mother pallet : ",
                dicoJsPalletquantity: "Can't use more ressources than the repack has",
                dicoJsPalletquantity2: "with those quantity you are over the quantity aviable. you have ",
                dicoRepackSummary: "Repack Summary",
                dicoTotalQuantity: "Total Quantity",
                differentWOOnConsumptionAndLabeling: "Different GPO on Consumption and Labeling. Error# w0010",
                differentWOOnConsumptionAndLabeling2: "Active GPO in Labeling is different from Consumption one!",
                disable: "Disable",
                disabledOperators: "Show Disabled Operators Only:",
                display: "Display",
                done: "Done",
                downTime: "Down-Time",
                doYouSetWorkOrderDefaultDataCollection: "Would you like to set {0} as the Default work order for this shift?",
                doYouWantToActivate: "Do you want to activate a new WorksOrder?",
                duration: "Duration",
                durationMinutes: "Dur.(min.)",
                durationValidation: "* Duration must be numeric.",
                edit: "Edit",
                efficiencyoftheLine: "Efficiency Of The Line",
                empty: "Empty",
                emptyRowDelivery: "No data found with those parameters!",
                enable: "Enable",
                enabled: "Enabled",
                endBeforeStart: "End date ({1}) is earlier than or equal to start date({0}).",
                endDate: "End Date",
                endDateTime: "EndDT",
                endTime: "End Time",
                error: "Error",
                errorCommandNotRecognised: "error: command not recognised. Error# w0011",
                errorSavingActivity: "An error occured saving the Activity, Error:",
                exit: "Exit",
                failedToConsumeSsccInDbX0: "Failed to consume sscc in db. Error# w0012:  {0} ",
                failedToConsumeSsccInDbX0ErrorX1: "Failed to consume sscc in db. {0} Error# {1}",
                failedToReturnSsccInDbX0: "Failed to return sscc in db. Error# w0013: {0} ",
                failedToReturnSsccInDbX0ErrorX1: "Failed to return sscc in db. {0} Error# {1}",
                failureReason: "Failure Reason",
                finalPalletRank: "Final Pallet Rank -",
                finalPass: "Final Pass",
                finished: "Finished",
                freeText1: "FreeText1",
                freeText2: "FreeText2",
                full: "Full",
                fullQtyGreaterThanSmall: "Full quantity must be greater or equal to small quantity",
                fullQtyNumeric: "Full qty must be an integer",
                getData: "Get Data From APS",
                go: "Go",
                goBack: "Go Back",
                goBacktoCurrentActivity: "Go Back to Current Activity",
                headerTextUser: "User",
                importDataFromAPS: "Import Data from APS",
                inBoundBtnCancel: "Cancel",
                inBoundBtnCancel2: "Finish",
                inBoundBtnConfirm: "Confirm",
                inBoundBtnExit: "Exit",
                inBoundBtnOk: "Ok",
                inBoundBtnReset: "Reset Date",
                deliveryNote: "Delivery Note",
                inBoundConfirmCreation: "are you sure to create those one? it ll change the transaction status to print.",
                inBoundConfirmDelete: "are you sure you want to delete this line?",
                inBoundDateExpiryDate: "Expiry Date",
                inBoundDxColLocation: "Location",
                inBoundDxColLotNumber: "Lot",
                inBoundDxColSeqNumber: "Seq",
                inBoundDxColunit: "Unit",
                inBoundDxComment: "Delivery Note",
                inBoundDxDescription1: "Decription",
                inBoundDxMaterialCode: "FP Code",
                inBoundDxPrintStatus: "Print Status",
                inBoundDxSelectTran: "Select a Transaction",
                inBoundDxSelTranType: "Transaction Type",
                inBoundDxTransactionDate: "Date",
                inBoundDxwarehouse: "Warehouse",
                inBoundErrorAmount: "Error in the total amount. Please check the values and correct them",
                inBoundErrorDate: "the date is not Correct",
                inBoundErrorLabelRank: "The number of label must be a numeric",
                inBoundErrorNbrPallet: "The field Nbr*OF LAbel must be a numeric greater than 0",
                inBoundErrorPalletCreation: "Error during the pallet creation. Please chech your values.",
                inBoundErrorPalletEdition: "The current label creation is not fully updated. Update your row and after you can print.",
                inBoundErrorQtyLabel: "The QtyxLAbel must be a numeric.",
                inBoundErrorQuantity: "The field Label*Qty must be a numeric greater than 0",
                inBoundErrorQuantityTotal: "The total quantity must match the total in the transaction selected.",
                inBoundErrorReceiptDate: "The Expiry Date must be a valide date and time.",
                inBoundErrorUpdate: "An Error occurred during the update. Please check the values and if it persist ask apl team.",
                inBoundIntLabelRank: "Nr.Of Labels",
                inBoundIntQtyLabel: "Qty x Label",
                inBoundLitCouncil: "Fill text box and push search",
                inBoundLitDescription: "Description",
                inBoundLitInfosTrans: "Blank = All,or OO,U,UC, UT, UR, RT ",
                inBoundLitLabelName: "Label Type : ",
                inBoundLitMat: "FP",
                inBoundLitPrint: "Print",
                inBoundLitRecap: "Summary of the label creation. Label(s) Created and Printed : ",
                inBoundLitTitre: "Inbound Label",
                inBoundLitTranDate: "Tansaction Date",
                inBoundLitTrans: "Transaction",
                inBoundLitTransac: "Transaction Selection",
                inBoundLitWarehouse: "Warehouse",
                inBoundLnkAdd: "Add a new Line",
                inboundNo: "No",
                inBoundsearch: "Search",
                inBoundStrCoilNr: "SU reference",
                inBoundStrVendorBatch: "Vendor Batch",
                inBoundStrWorkOrder: "GPO ref",
                inBoundTotalLabelCreation: "Total",
                inBoundTransactionQuantity: "Qty.",
                inBoundTxtMatError: "The field FP cannot be empty and must have at least 3 characters.",
                inBoundTxtTanDateError: "A valid Date is required",
                inBoundTxtwareError: "The field warhouse cannot be empty and cannot have more than 2 characters",
                inboundYes: "Yes",
                initials: "Initials",
                initQty: "Init Qty",
                input: "Input",
                insert: "Insert",
                insertNew: "Insert New Record",
                inValidDate: "Invalid Date!!Please enter valid date(dd/MM/yyyy).",
                invalideQuantity: "the return quantity set for the return pallet {0} is higher than remaining quantity error# w0026",
                inValidTime: "Invalid Time!!Please enter valid Time(hh:mm).",
                inValidUser: "Not a Valid User!Please try logging again..",
                inValidWorkOrderId: "InValid WorkOrderId/LineId!!Please check your database.",
                isActive: "Is Active",
                item: "Item",
                itemClass: "Item Class",
                key: "en-GB",
                labelCurrentActivityError:
                    "Some Error in CurrentActivity for this Line!!                                                                    Do you wish to continue moving onto another line?",
                labelDefaultTitle: "Labeling Current Activity",
                labelImSwitchQty: "Switch Quantity between full and Small",
                labellingPrintingComplete: "Printing Complete",
                labellingStatus: "Labelling Status",
                labelName: "Label Name",
                labelPalletCount: "Number of Pallet Procuced :<br/> <b>{0}</b>",
                labelPalletCount2: "{0}/{1}",
                labelPalletInProgress: "Pallet in progress : Current SSCC {0}",
                labels: "Labels",
                lblConfiramtionReturn: "Do you confirm your Return 0 quantity?",
                lblConfirmOff: "This pallet has 0 Qty ! you can t use it",
                lblConfirmRepack: "Do you confirm the Repack of the selected FP?",
                lblConfirmRepackCondition: "<br />The curent selection in RePacking will be changed",
                lblDefaultSetting: "Quantity for Carton {0}",
                lblErrbtnConsumeClick: "Wrong date. You can t consume pallet in the future. Change the date please!",
                lblErrbtnConsumeClickMissing: "Could not find SSCC. error# W0006",
                lblErrbtnConsumptionClick1: "Cannot add the FP. {0} : error# {1}",
                lblErrbtnConsumptionClick1Else: "Could not consume SSCC invalid quantity. error# W0008.",
                lblErrbtnConsumptionClick1Exception: "Cannot add the FP.  error# {0}",
                lblErrOI: "Return Quantity must be greater than 0! error# w0026",
                lblFailErr: "Error :",
                lblFailSSCC: "This SSCC {0} doesn't exist on this site.",
                lblOIErrorDate: "wrong date!",
                lblRePrintInfo: "Select Printer?",
                lblRePrintInfoInnerHtml: "Select printer to reprint to?",
                leavingthispagewillstopprinting: "Leaving this page will stop printing",
                length: "Length",
                line: "Line",
                linePrintAll: "Print all Labels",
                litActQty: "Actual Quantity",
                litAllInOne: "all in one shot",
                litByProduct: "ByProduct 1 FP",
                litByProduct2: "ByProduct 2 FP",
                litCartonLabel: "Carton Label",
                litCopyNumber: "Number of copy",
                litCustCode: "Customer Code",
                litCustMat: "Customer FP",
                litCustMatDesc: "Description",
                litCustomer: "Customer info",
                litEANGTAN: "EAN/Gtin",
                litLabelCreation: "Label Creation",
                litMain: "Main",
                litMainByProd: "By Prod 1",
                litMessWarn:
                    "The quantity on the pallet exceed the max quantity schedule on GPO. Do you want to change the current quantity on the pallet?",
                litModQtyMax: "Quantity for a full pallet",
                litModQtyMin: "Quantity for small pallet",
                litNameCust: "Name",
                litPalLabel: "Pallet Label",
                litPrintHistory: "Print History",
                litQtyReq: "Quantity Requested",
                litQuantityProd: "quantity produced",
                litQuantitySchedule: "quantity schedule",
                litSearch: "Search a new GPO",
                litsearchWomField: "Search a new GPO",
                litTitre: "Inbound Label",
                litUserUpdate: "Changed by operator",
                litWait: "Please Wait",
                litWoMan: "GPO information",
                litWomDec1: "Desc1",
                litWomDec2: "Desc2",
                litWomMaterial: "FP",
                litWoOpe: "GPO Operation",
                litWoOpeByProd2: "By Prod 2",
                litWoS: "Current GPO status : ",
                loadShift: "Load shifts",
                loadShiftsTip: "Load shifts for line and Date selection.",
                logout: "Log Out",
                lotNumber: "Lot",
                lot: "Lot",
                lstDefault: "None",
                main: "Main ",
                mainDetails: "Main Details",
                manning: "Manning",
                manningValidation: "* Manning must be numeric.",
                massIssue: "Mass Issue",
                material: "FP",
                metalAndEnds: "Metal And Ends",
                missingAPSDef: "Missing APS Import Default",
                multipleSelectionError: "Status does not match for selected rows.Please select again rows with same status!!",
                name: "value",
                negativeOEEWarning: "Error ID:31001 Break-down must be less that Run-time + Set-up.",
                new: "New",
                newPalletNumber: "New Pallet Number",
                newValue: "New Value",
                next: "Next",
                noAPSData: "No data for this activity!",
                noColours: "No. Colours",
                noColoursValidation: "* No. of Colours must be numeric.",
                noCopiesNumeric1to10: "No. Copies must be an integer between 1 and 10",
                noData: "There is no data to show for this Line!!",
                noOfCartons: "No. of Cartons",
                noOfCoils: "No. of Coils",
                noOfPallets: "No. of Pallets",
                noOfPalletsProduced: "No. of Pallets Produced on GPO",
                noOfSheets: "No. of Sheets",
                noPallets: "No. of Pallets",
                noShiftsToDisplay: "There are no shifts to display activity for",
                notUpdateByERP: "Fields not updated by ERP",
                noUpdateAfterSAP: "You cannot update an entry after sending to SAP.",
                noWorkorder: "No GPO",
                noWorkOrderOnConsumptionAndOneRunningForLa: "No GPO on consumption and one running for Labeling. Error# w0014:  ",
                noWorkOrderOnLabelingAndOneRunningOnConsum: "No GPO on labeling and one running on consumption. Error# w0015:",
                numberOfCopies: "No. of Copies",
                offlineCons: "Offline Consumption",
                oFFLINECONSUMPTION: "OFF-LINE CONSUMPTION",
                oFFLINECONSUMPTIONMETALANDENDS: "OFF-LINE CONSUMPTION METAL AND ENDS",
                offLineMetalSSCCAway: "This SSCC Doesn t exist.",
                offlinePrint: "Offline Print",
                offlinePrintingFailedException:
                    "The printer is not ready, printing has been paused, please select a new printer and press BEGIN PRINTING to continue.Restart printing using the selected printer from the drop down.",
                okay: "Okay",
                oldValue: "Old Value",
                onLINECONSUMPTION: "On-LINE CONSUMPTION",
                oops: "An unexpected error occurred, we apologise for the inconveniance.  This error has been logged, if this persists please contact the help desk.  Error# w0016",
                op: "Op ",
                open: "Open",
                openedWO: "Opened GPOs",
                openItems: "Open Items",
                operation: "Operation",
                operations: "Operations",
                operator: "Operator",
                operatorCode: "Operator Code",
                operatorName: "Operator Name",
                order: "Order",
                outisdeShiftTime: "Activity entry must be between {0} and {1}.",
                outOfShift: "",
                overProdHeader: "Overproduction",
                overProdText: "Creating this pallet, you will be overproducing on this WO. Do you want to continue anyway?",
                palletCreated: "Pallet {0} ({1}) successfully created.",
                palletDetail: "Pallet Details",
                palletID: "PalletID",
                palletIdentify: "Pallet Identify",
                palletRank: "Pallet Rank",
                pallets: "Pallets",
                palletsProduced: "pallets prod.",
                palletsQty: "Pallets (Qty)",
                palletsScheduled: "pallets sched.",
                palletStatus: "Pallet Status",
                palletStatusEdit: "Pallet Status Edit",
                palletStatusId: "StatusId",
                palSatDefaultTitle: "Pallet Status Management",
                palSatEditSelectPrinter: "Select printer to reprint to?",
                palStat_Default_Page_Load_Pallet_Status_Management: "Pallet Status Management",
                partCode: "FP",
                partDesc: "Part Desc",
                partDesc2: "Part Desc. 2",
                partDescription: "Part Description",
                pass: "Pass",
                passFirst: "Select Pass Number",
                passNumber: "Pass Number",
                pausePrinting: "Pause Printing",
                pickingLblNumCopy: "Number of Copy :",
                pieces: "Pcs",
                pleaseSelectaLine: "Please select a line.",
                pleaseSelectaPrinter: "Please select a printer to print the new label to?",
                popDown: "Pop Down",
                popLabelErrorCartonQty: "wrong Quantity for this carton. must be greater than 0 and less than final quantity pallet",
                popMaxcatonLimit: "the total number of carton can not exceed",
                preventERPUpdate: "Stop any update from ERP (SAP or BPCS)",
                print: "Print",
                printAbort: "Printing failed for rank {0}.  The server did not respond. Error# w0017.",
                printEngine: "Print Engine",
                printer: "Printer",
                printerName: "Printer Name",
                printFailed: "Printing failed for rank {0}.  Do you want to try to reprint this label?",
                printFailedAbr: "Print Failed. Error# w0018",
                printfailedselectanotherprinter: "Print failed, select another printer or try again. Error# w0019 ",
                printFailedWithException: "{0}.  Printing failed for rank {1} Error# w0020. ",
                printingComplete: "Printing Complete",
                printLabels: "Print Labels",
                printMod: "Print Mod",
                printPallet: "Print Pallet",
                printPartiallyFailed:
                    "Printing failed for rank {0} Error# w0021. Only {1} of {2} labels were printed. Do you want to try to reprint the missing labels?",
                printResult: "{0} label have been sent to the print list (see below for more information about its status).",
                printScreen: "Print Screen",
                printStatus: "Print Status",
                printSucceeded: "Print Succeeded",
                printSuccessful: "Print Successful",
                printUsingAlternatePrinterFailed:
                    "Print failed with Alternate printer too. Do you want to try printing again?                                            Click YES to print using alternate printer or click NO then press PRINT to retry the original printer.",
                processFinished: "Process Finished",
                prodDate: "Prod Date",
                productionOrderRunning: "Production Order Running",
                prompt: "Prompt",
                qtyProduced: "quantity produced",
                qtyReq: "Qty Req.",
                qtyScheduled: "quantity schedule",
                quantity: "Qty",
                quantityConsumed: "Quantity Consumed",
                quantityProduced: "Quantity Produced(Pallet Consumed)",
                quantityRemaining: "Quantity Remaining",
                quantityScrapped: "Quantity Scrapped",
                quantityXPallet: "Quantity X Pallet",
                rank: "Rank",
                reason: "Reason",
                reasonCode: "Reason Code",
                reasonCodeDescription: "Reason Code Description",
                refresh: "Refresh",
                rememberSave: "Remember to save defaults.",
                reprint: "Reprint",
                reprintFailed:
                    "Reprint failed for rank {0} Error# w0022. Only {1} of {2} labels were printed. Do you want to try to reprint the missing labels?.",
                requiredFields: "Missing required values highlighted in red*",
                reset: "Reset",
                return: "Return",
                ringDiameter: "Ring Diameter",
                runTime: "Run-Time",
                rxg__0__assigned_to__1_: "{0} assigned to {1}",
                rxg__0__units_returned_on_SSCC__1___When_all_pallets_are_consumed_returned__click_OK_again_to_close_the_job__dialog_w0005:
                    "{0} units returned on SSCC {1}. When all pallets are consumed/returned, click OK again to close the job. dialog#w0001",
                rxg_Add_Defect: "Add Defect",
                rxg_Back_to_current_activity: "Back to current activity",
                rxg_Back_to_labeling: "Back to labeling",
                rxg_Back_to_offline_consumption: "Back to offline consumption",
                rxg_BeginPrint: "Begin Printing",
                rxg_Cannot_issue_the_material___0___error___1_: "Cannot issue the material. {0}: error# {1}",
                rxg_Consumption: "Consumption",
                rxg_Could_not_assign__0__to__1___Error___2___3_: "Could not assign {0} to {1}, Error#:{2}-{3}",
                rxg_Could_not_assign__0__to__1__Error____2_: "Could not assign {0} to {1} Error#: {2}",
                rxg_Could_not_assign_Work_Order___Error___0_: "Could not assign Work Order.  Error: {0}",
                rxg_Could_not_assign_Work_Order_Error___0____1_: "Could not assign Work Order Error#:{0}: {1}",
                rxg_Could_not_close_job___Error___0__: "Could not close job : Error# {0} ",
                rxg_Could_not_close_job__0___Error___1_: "Could not close job {0}: Error# {1}",
                rxg_CouldNotDeletePallet: "Could Not delete pallet. Error#{0}:{1}",
                rxg_CouldNotDeletePallet1: "Could Not delete pallet. Error#:{0}",
                rxg_Defect_Added: "Status Changed but no defects added!!",
                rxg_Defect_comment_must_be_less_than_255_characters_: "Defect comment must be less than 255 characters.",
                rxg_Defects_Added: "Defects Added",
                rxg_Delete_Pallet: "Delete Pallet",
                rxg_DeleteFailedWithError: "Delete Failed With Error:{0}",
                rxg_Failed_to_set_print_parameters_with_error___0_: "Failed to set print parameters with error: {0}",
                rxg_From: "From:",
                rxg_Is_the_previous_SSCC___0___completely_consumed___dialog__apl00002: "Is the previous SSCC ({0}) completely consumed?",
                haveFollowingPalletsBeenFullyUsed: "Have following pallets been fully used?",
                rxg_Label_parameters: "Label parameters",
                rxg_Label_paramters_save_successfully_: "Label paramters save successfully ",
                rxg_Labeling_Pass_Number: "Labeling Pass Number",
                rxg_No: "No",
                rxg_No_Department_specified__Error__w0007: "No Department specified. Error# w0025",
                rxg_OfflinePrintHeader: "Offline Print",
                rxg_Open: "Open",
                rxg_Open_SSCC__0__on_the_following_line_s__: "Open SSCC {0} on the following line(s).",
                rxg_Please_enter_the_quantity_remaining_on_the_previous_pallet__input__APL00031:
                    "Please enter the quantity remaining on the previous pallet. input# APL00001",
                rxg_Please_select_a_defect: "Please select a defect",
                rxg_Please_select_the_pass_number_: "Please select the pass number?",
                rxg_Print: "Print",
                rxg_PrintBoth: "Print Both",
                rxg_PrintDefect: "Print Defect",
                rxg_Quantity: "Quantity",
                rxg_Scrap_failed_with_error__: "Scrap failed with error: ",
                rxg_Scrap_Pallet: "Scrap Pallet",
                rxg_Select_work_order_for_consumption: "Select GPO for consumption",
                rxg_Select_work_order_for_labeling: "Select GPO for labeling",
                rxg_SSCC___0___has__1__quantity_and_cannot_be_consumed__error_4123:
                    "SSCC ({0}) has {1} quantity and cannot be consumed. error#w0023",
                rxg_SSCC___0___was_not_found___error__00001: "SSCC ({0}) was not found.  error#:#w0024",
                rxg_ThereIsNoWorksOrderAssignedForThisLine: "There is no Works Order assigned for this line",
                rxg_Title: "Offline Printing",
                rxg_Unable_to_consume_pallet__0____1__Error____2__: "Unable to consume pallet {0}: {1} error#: {2} ",
                rxg_Work_Order_Enquiry: "GPO Enquiry",
                rxg_Yes: "Yes",
                rxg_You_must_enter_a_comment_for_the_defect_s__: "You must enter a comment for the defect(s).",
                rxg_You_must_enter_your_initials_to_add_a_defect: "You must enter your initials to add a defect",
                save: "Save",
                saveChanges: "Save Changes",
                saveDefaults: "Save Defaults",
                sAVESENDTOSAP: "SAVE and SEND TO SAP",
                saveShiftAreYouSure: "Are you sure?",
                saveShiftNotEqual: "The number of minutes booked is not equal to the total minutes.\r\n\r\nAre you sure?",
                scanExternalTag: "Orig/Ext Tag Identifier",
                scanNewMaterial: "Scan New Material",
                scheduledDateTime: "Schedule Date-Time",
                scheduledOrders: "Scheduled GPOs",
                scheduleWorkOrder: "GPO Scheduling",
                scrap: "Scrap",
                scrapped: "Scrapped",
                search: "Search",
                select: "Select",
                selectAll: "Select All",
                selectDefects: "Select Defects:",
                selectLines: "Select Lines",
                sendToSAP: "Sent To SAP",
                seq: "Seq",
                seqnumber: "Seqnumber",
                setUp: "Set-Up",
                shift: "Shift",
                shiftLength: "From {0} to {1} in total {2} hours",
                shiftNoWorkOrders: "There are no work orders for this line.",
                shiftPatterns: "Shift Patterns",
                shiftTime: "Shift Time",
                showRawMaterial: "Show Raw Material",
                small: "Small",
                smallQtyNumeric: "Small qty must be an integer",
                sqlTranslation: "SQL Translation",
                sscc: "SSCC",
                ssccConsumed: "SSCC Consumed",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheck:
                    "SSCC {0} is open on the following line(s). Please check lines you wish to close.",
                ssccX0IsOpenOnTheFollowingLineSPleaseCheckReturn:
                    "SSCC {0} is open on the following line(s). Please check lines you wish to return.",
                standard: "Standard",
                start: "Start",
                startDate: "Start Date",
                startDateIsLaterThanEndDate: "Start date is later than end date",
                startDateTime: "StartDT",
                startingPalletRank: "Starting Pallet Rank -",
                startTime: "Start Time",
                status: "Status",
                statusHistory: "Status History",
                stop: "Stop",
                string1: "",
                success: "Success",
                sumQty: "Sum Qty",
                synoptic: "Synoptic",
                tableName: "Table Name",
                thereIsNoWorkOrderConfiguredForThisLine: "There is no work order configured for this line",
                thislinehasajobassignedClosethejob: "This line has a job assigned. Close the job?",
                thisMethodRequiresAConfirmationAndNoneIsDe: "This method requires a confirmation and none is defined.",
                time: "Time",
                timeEnd: "Time End",
                timeIn: "Time In",
                titleWoMan: "GPO {0}",
                tKey: "TKey",
                tKeyActivity: "Activity Type",
                tKeyCode: "TKey code",
                tKeyDescription: "TKey Desciption",
                tKeys: "TKeys",
                tNotConfigured: "Default Reason Codes for APS import are not properly configured for this Department",
                to: "To:",
                toolTipchkRaw: "Press update button to apply your filter(s)",
                toolTipEnter: "Press Enter to apply your filter(s)",
                totalImportedMinutes: "Imported T-Key Duration (min.)",
                totalMinutesBooked: "Total Minutes Booked",
                totalShiftDuration: "Shift Duration (min.)",
                totalShiftHours: "Total Shift Minutes",
                totalTimeGreaterThanShift: "Total activity time is greater than shift length.",
                transactionType: "Transaction Type",
                txtQuantityErr: "Invalide quantity",
                unableToAddOpenItemToLineX0ErrorX1: "Unable to Add open item to Line {0} error#: {1}",
                unableToAddOpenItemToLineX0X1ErrorX2: "Unable to Add open item to Line {0} {1} error#: {2}",
                unblock: "Unblock",
                unit: "Unit",
                update: "Update",
                username: "Username",
                userNotRecognised: "User not recognised",
                validationSummary: "The following must be reolved before the operation can complete.",
                wantToUseAlternatePrinter: "The selected printer is not ready!!  Click YES to use alternate printer {0} for printing?",
                wCL: "WC/L",
                wO: "GPO",
                wOAvailable: "List of GPOs Available",
                woMButton1: "Manage this GPO",
                woMMAterialNameError: "this FP doesn t exist : ",
                woMPallFullQty: "Full",
                woMPallMinQty: "Small",
                woMPallQty: "Quantity X Pallet",
                woMPallTxtFullQty: "Standard",
                woMPallTxtModQty: "Changed by Operator",
                wOMTitle: "GPO Management",
                workCenter: "WorkCenter",
                workOrder: "GPO",
                workOrderOp: "GPO / OPE",
                woSApproved: "Approved",
                woSClosed: "Closed",
                wOSequenceScheduled: "GPO Sequence Scheduled",
                woSInUse: "In use (On line)",
                woSPlanned: "Planned",
                woSSuspended: "Suspended",
                x0OfX1PaletsBlocked: "{0} of {1} pallets blocked.",
                x0OfX1PaletsBlockedStoppedAtErrorForSSCCX2: "{0} of {1} pallets blocked.  Stopped at error for SSCC:{2} -{3}",
                x0OfX1PaletsDeleted: "{0} of {1} pallets deleted.",
                x0OfX1PaletsDeletedStoppedAtErrorForSSCCX2: "{0} of {1} pallets deleted. Stopped at error for SSCC:{2} -{3}",
                x0OfX1PaletsScrapped: "{0} of {1} pallets scrapped.",
                x0OfX1PaletsScrappedStoppedAtErrorForSSCCX: "{0} of {1} pallets scrapped. Stopped at error for SSCC:{2} -{3}",
                x0OfX1PaletsUnblocked1: "{0} of {1} pallets unblocked.",
                x0OfX1PaletsUnblockedStoppedAtErrorForPalletX21: "{0} of {1} pallets Unblocked.  Stopped at error for PalletId:{2} -{3}",
                yourAccountIsLockedPleaseContactTheHelpdes: "Your account is locked please contact the helpdesk.",
                rxg_defectsTable_Defect: "Defect",
                rxg_defectsTable_Initials: "Initials",
                rxg_defectsTable_Comment: "Comment",
                mouldNo: "Moulds",
                mvtDesc: "Movement description",
                mvtDate: "Movement date",
                billOfBatches: "Bill Of Batches",
                batchNr: "Batch Nr",
                workorderAssignedPrinting: "Workorder was assigned for Label printing. Switch to activity?",
                workorderAssignedConsumption: "Workorder was assigned for consumption. Switch to activity?",
                jobIn: "Job In",
                statusChangeNotAllowed: "Status change not allowed",
                deselect: "Deselect",
                selectPage: "Select Page",
                resetView: "Reset View",
                containerVolume: "Volume",
                youCanOnlyHaveNumberOfPalletsIssued: "You can only have {0} pallets issued",
                lineIn: "Line In",
                partPallet: "Part Pallet",
                manualEntry: "Manual Entry",
                consumed: "Consumed",
                issued: "Issued"
            }
        }
    }
};
export { resources };
